const css = `*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  scroll-behavior: smooth;
}

article,
aside,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section {
  display: block;
}

body {
  margin: 0;
  font-family: "FS Me", sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.6;
  color: #000;
  text-align: left;
  background-color: #fff;
}

[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  -webkit-text-decoration-skip-ink: none;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #3490dc;
  text-decoration: none;
  background-color: transparent;
}

a:hover {
  color: #1d68a7;
  text-decoration: underline;
}

a:not([href]):not([class]) {
  color: inherit;
  text-decoration: none;
}

a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #6c757d;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type=radio],
input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
}

textarea {
  overflow: auto;
  resize: vertical;
}

progress {
  vertical-align: baseline;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

img {
  width: 100%;
  height: 100%;
}

/* ####################### ergo colors ####################### */
/* DKV Colors */
@font-face {
  font-family: "FedraSerifA";
  src: url(../fonts/FedraSerifAPro-Normal.eot?6c7402a4e9fd2f0ea02cbf880bca0e7a);
  src: url(../fonts/FedraSerifAPro-Normal.eot?6c7402a4e9fd2f0ea02cbf880bca0e7a) format("embedded-opentype"), url(../fonts/FedraSerifAPro-Normal.woff2?4b1e5b7f424c2815efc6f15b30cbf779) format("woff2"), url(../fonts/FedraSerifAPro-Normal.woff?965d8c39b42a1df74533d341fffb09c1) format("woff"), url(../fonts/FedraSerifAPro-Normal.ttf?18355c867b6b500d8f2584e3ba9cd174) format("truetype"), url(../fonts/FedraSerifAPro-Normal.svg?f36cfbb9188bc98ca2ffd121ef8b598f) format("svg");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "FSMe";
  src: url(../fonts/FSMe.eot?94458352b91d8ab44d314719fc59684d);
  src: url(../fonts/FSMe.eot?94458352b91d8ab44d314719fc59684d) format("embedded-opentype"), url(../fonts/FSMe.woff2?d14620114255fed6d94720596e38c337) format("woff2"), url(../fonts/FSMe.woff?0c4f82195cba766444d46ed3403b3051) format("woff"), url(../fonts/FSMe.ttf?08b5d8d8e7bb28a52001f1fa683ba5b5) format("truetype"), url(../fonts/FSMe.svg?07b09c706e5f0a35c83ddad00849f14e) format("svg");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "FSMe";
  src: url(../fonts/FSMe-Bold.eot?1385854267171dcdc4c20c291e998c8d);
  src: url(../fonts/FSMe-Bold.eot?1385854267171dcdc4c20c291e998c8d) format("embedded-opentype"), url(../fonts/FSMe-Bold.woff2?306f305460cec7e98b1381aa8cd81408) format("woff2"), url(../fonts/FSMe-Bold.woff?c0b266117cc93449c6cfefd579a2db9d) format("woff"), url(../fonts/FSMe-Bold.ttf?4f7a5bce628cda0d261b924375a32ecb) format("truetype"), url(../fonts/FSMe-Bold.svg?204e8142939e9588a520aa6f4e51b1c9) format("svg");
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: "FSMeLight";
  src: url(../fonts/FSMeLight.eot?898266040dcb2e73405f0b53b31efea7);
  src: url(../fonts/FSMeLight.eot?898266040dcb2e73405f0b53b31efea7) format("embedded-opentype"), url(../fonts/FSMeLight.woff2?089c8c615c7dab4525e61ccd09a573bb) format("woff2"), url(../fonts/FSMeLight.woff?eeee1f051dfe7017271367fcb9100ad6) format("woff"), url(../fonts/FSMeLight.ttf?de5883afb141a0f090e439b2045d7820) format("truetype"), url(../fonts/FSMeLight.svg?fef4dd596bd2987a239cd6fac8fa553c) format("svg");
  font-weight: normal;
  font-style: normal;
}
/* TYPOGRAPHY */
html {
  font-size: 1rem;
}

body,
.font-sans {
  font-family: "FSMe";
  font-size: 1rem;
}

h1,
h2,
h3,
h4,
h5 {
  font-family: "FedraSerifA";
  line-height: 1.5 !important;
}

strong {
  font-weight: bold;
}

/* Mobile: */
h1,
.h1 {
  font-size: 1.5rem;
  color: #8e0038;
}

h1.h1--small {
  font-size: 1.375rem;
}
@media screen and (min-width: 1200px) {
  h1.h1--small {
    font-size: 2rem;
  }
}

h2,
.h2 {
  font-size: 1.375rem;
  color: #8e0038;
  font-weight: 500;
}

h3,
.h3 {
  font-size: 1.125rem;
  line-height: 1.75rem;
  color: #000;
  font-weight: bold;
  font-family: "FSMe";
}

h4,
.h4 {
  font-family: "FSMe";
  font-size: 1rem;
  font-weight: bold;
  color: #000;
  margin: 0;
}

h5,
.h5 {
  font-family: "FSMe";
  font-size: 0.875rem;
  font-weight: bold;
  color: #000;
  line-height: 140%;
}

.lead {
  font-size: 1.125rem;
  font-family: "FSMe";
  font-weight: 400;
  line-height: 140%;
}

p {
  font-size: 1rem;
  font-family: "FSMe";
  font-weight: 400;
  line-height: 140%;
}

.c1, .content-list ol li,
.content-list ul li {
  font-size: 1rem;
}

.c2, .coupon__form-checkbox .notice-container div.c2 p, .coupon__form-checkbox .notice-container .content-text__wrapper div.magic-text p, .content-text__wrapper .coupon__form-checkbox .notice-container div.magic-text p, .contact-appointment .notice p, .content-text__wrapper .magic-text {
  font-size: 0.875rem;
}

.c3, .content-icon-text-list__disclaimer .c3 p {
  font-size: 0.75rem;
}

a.text-link {
  color: #8e0038;
  font-weight: bold;
}

/* Mobile: Tabelet */
@media screen and (min-width: 576px) {
  .lead {
    font-size: 1.25rem;
  }
}
/* Tablet: */
@media screen and (min-width: 768px) {
  h1,
  .h1 {
    font-size: 1.625rem;
  }
  h2,
  .h2 {
    font-size: 1.5rem;
  }
  h3,
  .h3 {
    font-size: 1.25rem;
  }
  h4,
  .h4 {
    font-size: 1.125rem;
  }
  h5,
  .h5 {
    font-size: 1rem;
  }
  p {
    font-size: 1.125rem;
  }
  .c1, .content-list ol li,
  .content-list ul li {
    font-size: 1.125rem;
  }
  .c2, .coupon__form-checkbox .notice-container div.c2 p, .coupon__form-checkbox .notice-container .content-text__wrapper div.magic-text p, .content-text__wrapper .coupon__form-checkbox .notice-container div.magic-text p, .contact-appointment .notice p, .content-text__wrapper .magic-text {
    font-size: 1rem;
  }
  .c3, .content-icon-text-list__disclaimer .c3 p {
    font-size: 0.75rem;
  }
}
/* Tablet / Desktop: */
/* Desktop: */
@media screen and (min-width: 1200px) {
  h1,
  .h1 {
    font-size: 2rem;
  }
  h2,
  .h2 {
    font-size: 1.75rem;
  }
  h3,
  .h3 {
    font-size: 1.5rem;
  }
  h4,
  .h4 {
    font-size: 1.25rem;
  }
  .lead {
    font-size: 1.5rem;
  }
  p {
    font-size: 1.25rem;
  }
  .c1, .content-list ol li,
  .content-list ul li {
    font-size: 1.25rem;
  }
  .c2, .coupon__form-checkbox .notice-container div.c2 p, .coupon__form-checkbox .notice-container .content-text__wrapper div.magic-text p, .content-text__wrapper .coupon__form-checkbox .notice-container div.magic-text p, .contact-appointment .notice p, .content-text__wrapper .magic-text {
    font-size: 1rem;
  }
  .c3, .content-icon-text-list__disclaimer .c3 p {
    font-size: 0.75rem;
  }
}
.slide-out-blurred-top {
  -webkit-animation: slide-out-blurred-top 0.45s cubic-bezier(0.755, 0.05, 0.855, 0.06) both;
  animation: slide-out-blurred-top 0.45s cubic-bezier(0.755, 0.05, 0.855, 0.06) both;
}

.slide-out-blurred-left {
  -webkit-animation: slide-out-blurred-left 0.45s cubic-bezier(0.755, 0.05, 0.855, 0.06) both;
  animation: slide-out-blurred-left 0.45s cubic-bezier(0.755, 0.05, 0.855, 0.06) both;
}

.slide-out-blurred-right {
  -webkit-animation: slide-out-blurred-right 0.45s cubic-bezier(0.755, 0.05, 0.855, 0.06) both;
  animation: slide-out-blurred-right 0.45s cubic-bezier(0.755, 0.05, 0.855, 0.06) both;
}

.slide-out-blurred-bottom {
  -webkit-animation: slide-out-blurred-bottom 0.45s cubic-bezier(0.755, 0.05, 0.855, 0.06) both;
  animation: slide-out-blurred-bottom 0.45s cubic-bezier(0.755, 0.05, 0.855, 0.06) both;
}

.slide-in-blurred-top {
  -webkit-animation: slide-in-blurred-top 0.6s cubic-bezier(0.23, 1, 0.32, 1) both;
  animation: slide-in-blurred-top 0.6s cubic-bezier(0.23, 1, 0.32, 1) both;
}

.slide-in-blurred-left {
  -webkit-animation: slide-in-blurred-left 0.6s cubic-bezier(0.23, 1, 0.32, 1) both;
  animation: slide-in-blurred-left 0.6s cubic-bezier(0.23, 1, 0.32, 1) both;
}

.slide-in-blurred-right {
  -webkit-animation: slide-in-blurred-right 0.6s cubic-bezier(0.23, 1, 0.32, 1) both;
  animation: slide-in-blurred-right 0.6s cubic-bezier(0.23, 1, 0.32, 1) both;
}

.slide-in-blurred-bottom {
  -webkit-animation: slide-in-blurred-bottom 0.6s cubic-bezier(0.23, 1, 0.32, 1) both;
  animation: slide-in-blurred-bottom 0.6s cubic-bezier(0.23, 1, 0.32, 1) both;
}

/* ----------------------------------------------
 * Generated by Animista on 2023-4-15 16:25:15
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */
/**
 * ----------------------------------------
 * animation slide-in-blurred-bottom
 * ----------------------------------------
 */
@-webkit-keyframes slide-in-blurred-bottom {
  0% {
    -webkit-transform: translateY(1000px) scaleY(2.5) scaleX(0.2);
    transform: translateY(1000px) scaleY(2.5) scaleX(0.2);
    -webkit-transform-origin: 50% 100%;
    transform-origin: 50% 100%;
    -webkit-filter: blur(40px);
    filter: blur(40px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0) scaleY(1) scaleX(1);
    transform: translateY(0) scaleY(1) scaleX(1);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1;
  }
}
@keyframes slide-in-blurred-bottom {
  0% {
    -webkit-transform: translateY(1000px) scaleY(2.5) scaleX(0.2);
    transform: translateY(1000px) scaleY(2.5) scaleX(0.2);
    -webkit-transform-origin: 50% 100%;
    transform-origin: 50% 100%;
    -webkit-filter: blur(40px);
    filter: blur(40px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0) scaleY(1) scaleX(1);
    transform: translateY(0) scaleY(1) scaleX(1);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1;
  }
}
/* ----------------------------------------------
 * Generated by Animista on 2023-4-15 16:24:54
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */
/**
 * ----------------------------------------
 * animation slide-in-blurred-right
 * ----------------------------------------
 */
@-webkit-keyframes slide-in-blurred-right {
  0% {
    -webkit-transform: translateX(1000px) scaleX(2.5) scaleY(0.2);
    transform: translateX(1000px) scaleX(2.5) scaleY(0.2);
    -webkit-transform-origin: 0% 50%;
    transform-origin: 0% 50%;
    -webkit-filter: blur(40px);
    filter: blur(40px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0) scaleY(1) scaleX(1);
    transform: translateX(0) scaleY(1) scaleX(1);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1;
  }
}
@keyframes slide-in-blurred-right {
  0% {
    -webkit-transform: translateX(1000px) scaleX(2.5) scaleY(0.2);
    transform: translateX(1000px) scaleX(2.5) scaleY(0.2);
    -webkit-transform-origin: 0% 50%;
    transform-origin: 0% 50%;
    -webkit-filter: blur(40px);
    filter: blur(40px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0) scaleY(1) scaleX(1);
    transform: translateX(0) scaleY(1) scaleX(1);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1;
  }
}
/* ----------------------------------------------
 * Generated by Animista on 2023-4-15 16:24:32
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */
/**
 * ----------------------------------------
 * animation slide-in-blurred-left
 * ----------------------------------------
 */
@-webkit-keyframes slide-in-blurred-left {
  0% {
    -webkit-transform: translateX(-1000px) scaleX(2.5) scaleY(0.2);
    transform: translateX(-1000px) scaleX(2.5) scaleY(0.2);
    -webkit-transform-origin: 100% 50%;
    transform-origin: 100% 50%;
    -webkit-filter: blur(40px);
    filter: blur(40px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0) scaleY(1) scaleX(1);
    transform: translateX(0) scaleY(1) scaleX(1);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1;
  }
}
@keyframes slide-in-blurred-left {
  0% {
    -webkit-transform: translateX(-1000px) scaleX(2.5) scaleY(0.2);
    transform: translateX(-1000px) scaleX(2.5) scaleY(0.2);
    -webkit-transform-origin: 100% 50%;
    transform-origin: 100% 50%;
    -webkit-filter: blur(40px);
    filter: blur(40px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0) scaleY(1) scaleX(1);
    transform: translateX(0) scaleY(1) scaleX(1);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1;
  }
}
/* ----------------------------------------------
 * Generated by Animista on 2023-4-15 16:24:15
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */
/**
 * ----------------------------------------
 * animation slide-in-blurred-top
 * ----------------------------------------
 */
@-webkit-keyframes slide-in-blurred-top {
  0% {
    -webkit-transform: translateY(-1000px) scaleY(2.5) scaleX(0.2);
    transform: translateY(-1000px) scaleY(2.5) scaleX(0.2);
    -webkit-transform-origin: 50% 0%;
    transform-origin: 50% 0%;
    -webkit-filter: blur(40px);
    filter: blur(40px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0) scaleY(1) scaleX(1);
    transform: translateY(0) scaleY(1) scaleX(1);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1;
  }
}
@keyframes slide-in-blurred-top {
  0% {
    -webkit-transform: translateY(-1000px) scaleY(2.5) scaleX(0.2);
    transform: translateY(-1000px) scaleY(2.5) scaleX(0.2);
    -webkit-transform-origin: 50% 0%;
    transform-origin: 50% 0%;
    -webkit-filter: blur(40px);
    filter: blur(40px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0) scaleY(1) scaleX(1);
    transform: translateY(0) scaleY(1) scaleX(1);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1;
  }
}
/* ----------------------------------------------
 * Generated by Animista on 2023-4-15 16:23:53
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */
/**
 * ----------------------------------------
 * animation slide-out-blurred-bottom
 * ----------------------------------------
 */
@-webkit-keyframes slide-out-blurred-bottom {
  0% {
    -webkit-transform: translateY(0) scaleY(1) scaleX(1);
    transform: translateY(0) scaleY(1) scaleX(1);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateY(1000px) scaleY(2) scaleX(0.2);
    transform: translateY(1000px) scaleY(2) scaleX(0.2);
    -webkit-transform-origin: 50% 100%;
    transform-origin: 50% 100%;
    -webkit-filter: blur(40px);
    filter: blur(40px);
    opacity: 0;
  }
}
@keyframes slide-out-blurred-bottom {
  0% {
    -webkit-transform: translateY(0) scaleY(1) scaleX(1);
    transform: translateY(0) scaleY(1) scaleX(1);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateY(1000px) scaleY(2) scaleX(0.2);
    transform: translateY(1000px) scaleY(2) scaleX(0.2);
    -webkit-transform-origin: 50% 100%;
    transform-origin: 50% 100%;
    -webkit-filter: blur(40px);
    filter: blur(40px);
    opacity: 0;
  }
}
/* ----------------------------------------------
 * Generated by Animista on 2023-4-15 16:23:36
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */
/**
 * ----------------------------------------
 * animation slide-out-blurred-right
 * ----------------------------------------
 */
@-webkit-keyframes slide-out-blurred-right {
  0% {
    -webkit-transform: translateX(0) scaleY(1) scaleX(1);
    transform: translateX(0) scaleY(1) scaleX(1);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateX(1000px) scaleX(2) scaleY(0.2);
    transform: translateX(1000px) scaleX(2) scaleY(0.2);
    -webkit-transform-origin: 0% 50%;
    transform-origin: 0% 50%;
    -webkit-filter: blur(40px);
    filter: blur(40px);
    opacity: 0;
  }
}
@keyframes slide-out-blurred-right {
  0% {
    -webkit-transform: translateX(0) scaleY(1) scaleX(1);
    transform: translateX(0) scaleY(1) scaleX(1);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateX(1000px) scaleX(2) scaleY(0.2);
    transform: translateX(1000px) scaleX(2) scaleY(0.2);
    -webkit-transform-origin: 0% 50%;
    transform-origin: 0% 50%;
    -webkit-filter: blur(40px);
    filter: blur(40px);
    opacity: 0;
  }
}
/* ----------------------------------------------
 * Generated by Animista on 2023-4-15 16:23:12
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */
/**
 * ----------------------------------------
 * animation slide-out-blurred-left
 * ----------------------------------------
 */
@-webkit-keyframes slide-out-blurred-left {
  0% {
    -webkit-transform: translateX(0) scaleY(1) scaleX(1);
    transform: translateX(0) scaleY(1) scaleX(1);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateX(-1000px) scaleX(2) scaleY(0.2);
    transform: translateX(-1000px) scaleX(2) scaleY(0.2);
    -webkit-transform-origin: 100% 50%;
    transform-origin: 100% 50%;
    -webkit-filter: blur(40px);
    filter: blur(40px);
    opacity: 0;
  }
}
@keyframes slide-out-blurred-left {
  0% {
    -webkit-transform: translateX(0) scaleY(1) scaleX(1);
    transform: translateX(0) scaleY(1) scaleX(1);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateX(-1000px) scaleX(2) scaleY(0.2);
    transform: translateX(-1000px) scaleX(2) scaleY(0.2);
    -webkit-transform-origin: 100% 50%;
    transform-origin: 100% 50%;
    -webkit-filter: blur(40px);
    filter: blur(40px);
    opacity: 0;
  }
}
/* ----------------------------------------------
 * Generated by Animista on 2023-4-15 16:22:49
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */
/**
 * ----------------------------------------
 * animation slide-out-blurred-top
 * ----------------------------------------
 */
@-webkit-keyframes slide-out-blurred-top {
  0% {
    -webkit-transform: translateY(0) scaleY(1) scaleX(1);
    transform: translateY(0) scaleY(1) scaleX(1);
    -webkit-transform-origin: 50% 0%;
    transform-origin: 50% 0%;
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateY(-1000px) scaleY(2) scaleX(0.2);
    transform: translateY(-1000px) scaleY(2) scaleX(0.2);
    -webkit-transform-origin: 50% 0%;
    transform-origin: 50% 0%;
    -webkit-filter: blur(40px);
    filter: blur(40px);
    opacity: 0;
  }
}
@keyframes slide-out-blurred-top {
  0% {
    -webkit-transform: translateY(0) scaleY(1) scaleX(1);
    transform: translateY(0) scaleY(1) scaleX(1);
    -webkit-transform-origin: 50% 0%;
    transform-origin: 50% 0%;
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateY(-1000px) scaleY(2) scaleX(0.2);
    transform: translateY(-1000px) scaleY(2) scaleX(0.2);
    -webkit-transform-origin: 50% 0%;
    transform-origin: 50% 0%;
    -webkit-filter: blur(40px);
    filter: blur(40px);
    opacity: 0;
  }
}
/* ----------------------------------------------
 * Generated by Animista on 2023-8-1 16:44:23
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */
/**
 * ----------------------------------------
 * animation slide-in-bottom
 * ----------------------------------------
 */
@-webkit-keyframes slide-in-bottom {
  0% {
    -webkit-transform: translateY(1000px);
    transform: translateY(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes slide-in-bottom {
  0% {
    -webkit-transform: translateY(1000px);
    transform: translateY(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}
.margin {
  margin: 24px;
}
@media screen and (min-width: 768px) {
  .margin {
    margin: 42px;
  }
}
@media screen and (min-width: 992px) {
  .margin {
    margin: 80px;
  }
}
@media screen and (min-width: 1200px) {
  .margin {
    margin: 100px;
  }
}
.margin--lr {
  margin: 0 24px;
}
@media screen and (min-width: 768px) {
  .margin--lr {
    margin: 0 42px;
  }
}
@media screen and (min-width: 992px) {
  .margin--lr {
    margin: 0 80px;
  }
}
@media screen and (min-width: 1200px) {
  .margin--lr {
    margin: 0 100px;
  }
}
.margin--tb {
  margin: 24px 0;
}
@media screen and (min-width: 768px) {
  .margin--tb {
    margin: 0 42px;
  }
}
@media screen and (min-width: 992px) {
  .margin--tb {
    margin: 0 80px;
  }
}
@media screen and (min-width: 1200px) {
  .margin--tb {
    margin: 0 100px;
  }
}
.margin--bottom {
  margin-bottom: 1.25rem;
}
@media screen and (min-width: 768px) {
  .margin--bottom {
    margin-bottom: 42px;
  }
}
@media screen and (min-width: 992px) {
  .margin--bottom {
    margin-bottom: 80px;
  }
}
@media screen and (min-width: 1200px) {
  .margin--bottom {
    margin-bottom: 100px;
  }
}
.margin--top {
  margin-top: 24px;
}

.bg-green {
  background-color: #b5d5c1;
}

.bg-yellow {
  background-color: #f8e89d;
}

.bg-orange {
  background-color: #f7dcbb;
}

.bg-blue {
  background-color: #ccebed;
}

.bg-violet {
  background-color: #e4d6e4;
}

.bg-warmgrey {
  background-color: #d9d5c7;
}

.bg-white {
  background-color: #fff;
}

.bg-green--light {
  background-color: #e3f0e6;
}

.bg-yellow--light {
  background-color: #fff4b0;
}

.bg-orange--light {
  background-color: #ffeede;
}

.bg-blue--light {
  background-color: #e2f6fa;
}

.bg-grey--light {
  background-color: rgba(0, 0, 0, 0.062745098);
}

.bg-violet--light {
  background-color: #efe7ed;
}

.bg-warmgrey--light {
  background-color: #ebe6d8;
}

.bg-grey--light {
  background-color: rgba(0, 0, 0, 0.062745098);
}

.bg-green--dark {
  background-color: #8bc9ad;
}

.bg-yellow--dark {
  background-color: #f7db6f;
}

.bg-orange--dark {
  background-color: #f3c591;
}

.bg-blue--dark {
  background-color: #a9dae0;
}

.bg-violet--dark {
  background-color: #dbaccc;
}

.bg-green--dark2 {
  background-color: #5fb8a2;
}

.bg-yellow--dark2 {
  background-color: #fad73b;
}

.bg-orange--dark2 {
  background-color: #efa56d;
}

.bg-blue--dark2 {
  background-color: #47bcc5;
}

.bg-violet--dark2 {
  background-color: #ce5e92;
}

.bg-green--dark3 {
  background-color: #009284;
}

.bg-yellow--dark3 {
  background-color: #f6cb00;
}

.bg-orange--dark3 {
  background-color: #e87a16;
}

.bg-blue--dark3 {
  background-color: #0f94a7;
}

.bg-violet--dark3 {
  background-color: #b31767;
}

a.link {
  color: #6a0029;
  font-weight: 700;
  text-decoration: none;
}
a.link:hover, a.link:focus {
  text-decoration: underline;
}

.header {
  height: 45px;
  background-color: #fff;
  box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.15);
}
@media screen and (min-width: 768px) {
  .header {
    height: 80px;
  }
}
.header svg {
  height: 100%;
  width: auto;
}

input[type=email],
.input--email {
  padding: 1rem 0.625rem;
  border-radius: 5px 5px 0 0;
  margin-bottom: 1.625rem;
  border: none;
  border-bottom: 2px solid gray;
}

input[type=email].error,
.input--email.error {
  margin-bottom: 0;
}

input[type=email].error + .error,
.input--email.error + .error {
  margin-bottom: 13px;
}

.notice {
  margin-bottom: 1.25rem;
}

@media screen and (min-width: 768px) {
  .notice-container {
    max-width: 90%;
  }
}

input[type=checkbox] {
  position: absolute;
  opacity: 0;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.checkbox-container {
  display: inline-flex;
  align-items: flex-start;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}

.checkmark {
  position: relative;
  width: 24px;
  height: 24px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #545241;
  display: flex;
  align-items: center;
  justify-content: center;
}

.checkmark:after {
  content: "";
  width: 14px;
  height: 14px;
  display: none;
  background: center/cover no-repeat url("../../svgs/black_Haekchen.svg");
}

input[type=checkbox]:checked + .checkmark:after {
  display: block;
}

input[type=checkbox]:focus + .checkmark {
  outline: 2px solid #3c74f8;
  outline-offset: 2px;
}

.visible {
  display: block;
}

.hidden {
  display: none;
}

.magic-text {
  margin-bottom: 1.875rem;
}
.magic-text ul li:not(:last-child),
.magic-text ol li:not(:last-child) {
  padding-bottom: 10px;
}
.magic-text a {
  color: #8e0038;
  font-weight: 700;
}

.font-red {
  color: #8e0038;
}

.bg-green {
  background-color: #b5d5c1;
}

.bg-yellow {
  background-color: #f8e89d;
}

.bg-orange {
  background-color: #f7dcbb;
}

.bg-blue {
  background-color: #ccebed;
}

.bg-violet {
  background-color: #e4d6e4;
}

.bg-warmgrey {
  background-color: #d9d5c7;
}

.bg-white {
  background-color: #fff;
}

.bg-green--light {
  background-color: #e3f0e6;
}

.bg-yellow--light {
  background-color: #fff4b0;
}

.bg-orange--light {
  background-color: #ffeede;
}

.bg-blue--light {
  background-color: #e2f6fa;
}

.bg-grey--light {
  background-color: rgba(0, 0, 0, 0.062745098);
}

.bg-violet--light {
  background-color: #efe7ed;
}

.bg-warmgrey--light {
  background-color: #ebe6d8;
}

.bg-grey--light {
  background-color: rgba(0, 0, 0, 0.062745098);
}

.bg-green--dark {
  background-color: #8bc9ad;
}

.bg-yellow--dark {
  background-color: #f7db6f;
}

.bg-orange--dark {
  background-color: #f3c591;
}

.bg-blue--dark {
  background-color: #a9dae0;
}

.bg-violet--dark {
  background-color: #dbaccc;
}

.bg-green--dark2 {
  background-color: #5fb8a2;
}

.bg-yellow--dark2 {
  background-color: #fad73b;
}

.bg-orange--dark2 {
  background-color: #efa56d;
}

.bg-blue--dark2 {
  background-color: #47bcc5;
}

.bg-violet--dark2 {
  background-color: #ce5e92;
}

.bg-green--dark3 {
  background-color: #009284;
}

.bg-yellow--dark3 {
  background-color: #f6cb00;
}

.bg-orange--dark3 {
  background-color: #e87a16;
}

.bg-blue--dark3 {
  background-color: #0f94a7;
}

.bg-violet--dark3 {
  background-color: #b31767;
}

a.link {
  color: #6a0029;
  font-weight: 700;
  text-decoration: none;
}
a.link:hover, a.link:focus {
  text-decoration: underline;
}

.header {
  height: 45px;
  background-color: #fff;
  box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.15);
}
@media screen and (min-width: 768px) {
  .header {
    height: 80px;
  }
}
.header svg {
  height: 100%;
  width: auto;
}

input[type=email],
.input--email {
  padding: 1rem 0.625rem;
  border-radius: 5px 5px 0 0;
  margin-bottom: 1.625rem;
  border: none;
  border-bottom: 2px solid gray;
}

input[type=email].error,
.input--email.error {
  margin-bottom: 0;
}

input[type=email].error + .error,
.input--email.error + .error {
  margin-bottom: 13px;
}

.notice {
  margin-bottom: 1.25rem;
}

@media screen and (min-width: 768px) {
  .notice-container {
    max-width: 90%;
  }
}

input[type=checkbox] {
  position: absolute;
  opacity: 0;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.checkbox-container {
  display: inline-flex;
  align-items: flex-start;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}

.checkmark {
  position: relative;
  width: 24px;
  height: 24px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #545241;
  display: flex;
  align-items: center;
  justify-content: center;
}

.checkmark:after {
  content: "";
  width: 14px;
  height: 14px;
  display: none;
  background: center/cover no-repeat url("../../svgs/black_Haekchen.svg");
}

input[type=checkbox]:checked + .checkmark:after {
  display: block;
}

input[type=checkbox]:focus + .checkmark {
  outline: 2px solid #3c74f8;
  outline-offset: 2px;
}

.visible {
  display: block;
}

.hidden {
  display: none;
}

.magic-text {
  margin-bottom: 1.875rem;
}
.magic-text ul li:not(:last-child),
.magic-text ol li:not(:last-child) {
  padding-bottom: 10px;
}
.magic-text a {
  color: #8e0038;
  font-weight: 700;
}

.font-red {
  color: #8e0038;
}

/*!
 * Bootstrap Grid v5.2.3 (https://getbootstrap.com/)
 * Copyright 2011-2022 The Bootstrap Authors
 * Copyright 2011-2022 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-bg: #fff;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-2xl: 2rem;
  --bs-border-radius-pill: 50rem;
  --bs-link-color: #0d6efd;
  --bs-link-hover-color: #0a58ca;
  --bs-code-color: #d63384;
  --bs-highlight-bg: #fff3cd;
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 0;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container {
    padding-right: calc(var(--bs-gutter-x) * 0.5);
    padding-left: calc(var(--bs-gutter-x) * 0.5);
  }
  .container-sm, .container {
    max-width: 552px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 656px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 847px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1252px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1300px;
  }
}
@media (min-width: 1920px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1640px;
  }
}
.row {
  display: flex;
  flex-wrap: wrap;
  --bs-gutter-x: 30px;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}

.row > * {
  box-sizing: border-box;
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0 0%;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0 0%;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0 0%;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0 0%;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0 0%;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0 0%;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

@media (min-width: 576px) {
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
}
@media (min-width: 768px) {
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
}
@media (min-width: 992px) {
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
}
@media (min-width: 1200px) {
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
}
@media (min-width: 1400px) {
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}

.btn {
  width: 100%;
  height: 2.75rem;
  padding: 0.625rem 1rem;
  display: flex;
  border: 2px solid #8e0038;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  margin: 0 auto;
  font-size: 1rem;
  line-height: 1.2rem;
  word-break: keep-all;
  font-weight: 700;
  text-align: center;
  text-decoration: none;
}
@media screen and (min-width: 768px) {
  .btn {
    font-size: 1.25rem;
    line-height: 1.5rem;
    padding: 0.625rem 2.5rem;
  }
}
.btn--download svg {
  width: 36px;
  margin-right: 5px;
  height: 36px;
}
.btn--download svg path {
  fill: #8e0038;
}
.btn--download.btn--primary svg path {
  fill: #fff;
}
.btn--download.btn--secondary svg path {
  fill: #8e0038;
}
.btn--download.btn--secondary:hover path, .btn--download.btn--secondary:focus path {
  fill: #fff;
}
.btn .btn-logo {
  width: 1.875rem;
  height: 1.875rem;
  margin-right: 0.625rem;
  display: inline-block;
}
.btn--primary {
  color: #fff;
  background: #8e0038;
}
.btn--primary .btn-logo {
  filter: contrast(0) brightness(4);
}
.btn--primary-on-desktop {
  background: #fff;
  border: 0.125rem solid #8e0038;
  color: #8e0038;
}
.btn--primary-on-desktop .btn-logo {
  filter: invert(6%) sepia(98%) saturate(6603%) hue-rotate(330deg) brightness(85%) contrast(103%);
}
@media screen and (max-width: 992px) {
  .btn--primary-on-desktop:disabled {
    color: #d4a2b6 !important;
    background-color: #fff !important;
  }
}
@media screen and (min-width: 992px) {
  .btn--primary-on-desktop {
    color: #fff;
    background: #8e0038;
  }
  .btn--primary-on-desktop .btn-logo {
    filter: contrast(0) brightness(4);
  }
}
.btn--secondary {
  background: #fff;
  border: 0.125rem solid #8e0038;
  color: #8e0038;
}
.btn--secondary .btn-logo {
  filter: invert(6%) sepia(98%) saturate(6603%) hue-rotate(330deg) brightness(85%) contrast(103%);
}
.btn:hover, .btn:focus {
  background: #6a0029;
  border: 0.125rem solid #6a0029;
  color: #fff;
  box-shadow: none;
  text-decoration: none;
}
@media screen and (min-width: 768px) {
  .btn {
    max-width: fit-content;
    height: 3rem;
  }
}
.btn[disabled] {
  color: #fff;
  background: #d4a2b6;
  border-color: #d4a2b6;
}

.btn.sticky {
  position: fixed;
  width: 90vw;
  bottom: 0.5rem;
  display: block;
  z-index: 2;
  left: 50%;
  transform: translate(-50%, -50%);
}
.btn.sticky--hidden {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}
@media screen and (min-width: 768px) {
  .btn.sticky {
    height: 3rem;
    max-width: fit-content;
  }
}
@media screen and (min-width: 992px) {
  .btn.sticky {
    position: relative;
    width: inherit;
    bottom: inherit;
    left: 0;
    transform: translate(0);
  }
  .btn.sticky--hidden {
    display: block;
  }
}

@media screen and (min-width: 992px) {
  .read-more-link + .btn.sticky {
    margin-top: 1rem;
  }
  .popup .btn--primary-on-desktop {
    color: #fff;
    background: #8e0038;
  }
}
.sticky-button-wrapper {
  transition: all 0.3s ease;
  height: 45px;
}

@media screen and (max-width: 768px) {
  .css-sticky {
    position: fixed;
    bottom: 20px;
    left: auto;
    right: auto;
    z-index: 1000;
  }
}

.read-more-link {
  color: #8e0038;
  text-decoration: none;
  font-weight: bold;
  border: none;
  background: none;
  margin: 0 auto;
  grid-column: 1/-1;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.read-more-link:hover, .read-more-link:focus {
  color: #8e0038;
  text-decoration: underline;
  text-underline-offset: 0.25rem;
}
.read-more-link__logo {
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  min-height: 1.5rem;
}
.read-more-link__logo .rotated {
  transform: rotate(180deg);
}

.seal-placeholder {
  display: flex;
  justify-content: start;
  flex-wrap: wrap;
  margin-bottom: 1.875rem;
  gap: 1rem;
}
@media screen and (max-width: 768px) {
  .seal-placeholder {
    justify-content: center;
  }
}
.seal-placeholder img {
  max-width: 335px;
  padding: 0;
}

.card {
  padding: 1.5rem;
  flex-grow: 1;
}
.card__headline {
  margin-bottom: 1.5rem;
}
.card__price {
  color: #8e0038;
}
@media screen and (min-width: 768px) {
  .card.col-md-6 {
    margin-right: 1%;
    width: 49%;
  }
}
@media screen and (min-width: 1200px) {
  .card.col-xl-3 {
    margin-right: 1%;
    width: 24%;
  }
}

.disturber {
  width: 6.25rem;
  height: 6.25rem;
}
@media screen and (min-width: 768px) {
  .disturber {
    width: 7.5rem;
    height: 7.5rem;
  }
}

.disturber.disturber--dynamic {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  text-align: center;
  background-color: #8e0038;
  color: #fff;
  rotate: -15deg;
  border-radius: 50%;
}
.disturber.disturber--dynamic .disturber-text p {
  margin-bottom: 0;
  line-height: 100%;
}

.disturber-text .d1 {
  font-size: 1.5rem;
}
@media screen and (min-width: 768px) {
  .disturber-text .d1 {
    font-size: 1.625rem;
  }
}
.disturber-text .d2 {
  font-size: 1.375rem;
}
@media screen and (min-width: 768px) {
  .disturber-text .d2 {
    font-size: 1.5rem;
  }
}
.disturber-text .d3 {
  font-size: 1.25rem;
}
@media screen and (min-width: 768px) {
  .disturber-text .d3 {
    font-size: 1.375rem;
  }
}
.disturber-text .d4 {
  font-size: 1.125rem;
}
@media screen and (min-width: 768px) {
  .disturber-text .d4 {
    font-size: 1.25rem;
  }
}
.disturber-text .d5 {
  font-size: 0.875rem;
}
@media screen and (min-width: 768px) {
  .disturber-text .d5 {
    font-size: 1rem;
  }
}
.disturber-text .d6 {
  font-size: 0.75rem;
}
@media screen and (min-width: 768px) {
  .disturber-text .d6 {
    font-size: 0.875rem;
  }
}

.content-list {
  margin-bottom: 2.5rem;
}
.content-list__title {
  margin-bottom: 1.25rem;
}
.content-list ol,
.content-list ul {
  list-style: none;
  padding: 0;
  display: grid;
  gap: 0.625rem;
}
.content-list ol li,
.content-list ul li {
  counter-increment: my-awesome-counter;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.content-list ol {
  counter-reset: my-awesome-counter;
  margin-bottom: 0;
}
.content-list ol li:before {
  content: counter(my-awesome-counter) ".";
  color: #8e0038;
  min-width: 1.875rem;
  width: 1.875rem;
  max-height: 1.875rem;
  height: 1.875rem;
  line-height: 1.875rem;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
  margin-right: 0.625rem;
  font-weight: 800;
  padding-left: 0.2rem;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
}
@media screen and (min-width: 768px) {
  .content-list ol li:before {
    min-width: 2.5rem;
    width: 2.5rem;
    max-height: 2.5rem;
    height: 2.5rem;
    line-height: 2.5rem;
    padding-left: 0.25rem;
  }
}
.content-list ul {
  margin-bottom: 0;
}
.content-list ul li:before {
  content: url(../../svgs/black_Haekchen.svg);
  width: 2.5rem;
  height: 2.5rem;
  aspect-ratio: 1;
  display: inline-block;
  line-height: 3rem;
  text-align: center;
  border-radius: 50%;
}
.content-list ul li:last-child {
  margin-bottom: 0;
}
.content-list .blue-light ol li:before,
.content-list .blue-light ul li:before {
  background-color: #e2f6fa;
}
.content-list .green-light ol li:before,
.content-list .green-light ul li:before {
  background-color: #e3f0e6;
}
.content-list .yellow-light ol li:before,
.content-list .yellow-light ul li:before {
  background-color: #fff4b0;
}
.content-list .violet-light ol li:before,
.content-list .violet-light ul li:before {
  background-color: #efe7ed;
}
.content-list .orange-light ol li:before,
.content-list .orange-light ul li:before {
  background-color: #ffeede;
}
.content-list .white ol li:before,
.content-list .white ul li:before {
  background-color: #fff;
}
.content-list .transparent ol li:before,
.content-list .transparent ul li:before {
  background-color: transparent;
}

.content-list-icon {
  margin-bottom: 1.875rem;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
@media screen and (min-width: 992px) {
  .content-list-icon {
    flex-direction: row;
    gap: 1.875rem;
    margin-bottom: 2.5rem;
  }
}
.content-list-icon__text {
  align-self: center;
}
.content-list-icon__icon {
  width: 64px;
  height: 64px;
  min-width: 64px;
  border-radius: 50%;
  padding: 8px;
  margin: 0 auto 1.875rem auto;
}
.content-list-icon__icon img {
  margin: 0 auto;
}
@media screen and (min-width: 992px) {
  .content-list-icon__icon {
    width: 80px;
    height: 80px;
    min-width: 80px;
  }
}
.content-list-icon h4 {
  margin-bottom: 1.25rem;
  text-align: center;
}
.content-list-icon__img {
  height: 220px;
  width: 100%;
  margin-bottom: 1.875rem;
}
@media screen and (min-width: 576px) {
  .content-list-icon__img {
    height: 300px;
  }
}
@media screen and (min-width: 768px) {
  .content-list-icon__img {
    height: 350px;
  }
}
@media screen and (min-width: 992px) {
  .content-list-icon__img {
    height: 220px;
  }
}
.content-list-icon__img img {
  object-fit: cover;
}
.content-list-icon--aligned-left {
  flex-direction: row;
  gap: 10px;
}
.content-list-icon--aligned-left .content-list-icon__icon {
  margin: 0;
}

.section {
  margin-bottom: 0.9375rem;
}
@media screen and (min-width: 768px) {
  .section {
    margin-bottom: 3.125rem;
  }
}
.section-margin--big {
  margin-bottom: 1.875rem;
}
@media screen and (min-width: 768px) {
  .section-margin--big {
    margin-bottom: 6.25rem;
  }
}

.accordion {
  margin-bottom: 0.5rem;
}
.accordion .icon {
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  min-height: 1.5rem;
}
@media screen and (min-width: 768px) {
  .accordion .icon--small {
    width: 2rem;
    height: 2rem;
    min-width: 2rem;
    min-height: 2rem;
  }
}
@media screen and (min-width: 768px) {
  .accordion .icon--big {
    width: 2.875rem;
    height: 2.875rem;
    min-width: 2.875rem;
    min-height: 2.875rem;
  }
}
.accordion__item {
  padding: 1rem 1.625rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.accordion.bg-white .accordion__item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1019607843);
}
.accordion__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}
.accordion__header-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
@media screen and (min-width: 992px) {
  .accordion__header-title {
    gap: 1rem;
  }
}
.accordion__header:hover, .accordion__header__item:focus {
  cursor: pointer;
}
.accordion__title {
  margin: 0.25rem 0;
}
.accordion__content {
  margin-top: 1rem;
  display: grid;
  grid-template-rows: 1fr;
  transition: grid-template-rows 300ms ease-in-out;
}
.accordion__content--hidden {
  grid-template-rows: 0fr;
}
.accordion__contentContainer {
  overflow: hidden;
}
@media screen and (min-width: 768px) {
  .accordion__content--offset {
    margin-left: 2.625rem;
  }
}
@media screen and (min-width: 768px) {
  .accordion__content--offset-large {
    margin-left: 3.375rem;
  }
}
@media screen and (min-width: 992px) {
  .accordion__content--offset-large {
    margin-left: 3.75rem;
  }
}
.accordion__text {
  margin-bottom: 1.25rem;
}
.accordion .arrow {
  width: 1.25rem;
  height: 1.25rem;
  min-width: 1.25rem;
  min-height: 1.25rem;
}
.accordion__flex-container {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
}
.accordion__category {
  border-bottom: 2px solid #bbb9ad;
}
.accordion__category .tab h3 {
  margin-bottom: 0;
}
.accordion__wrapper .magic-text {
  padding: 1rem 1.625rem;
}
.accordion .section:has(.accordion) {
  padding: 0;
}

.quiz_results .accordion .accordion-wrapper-content__title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.quiz_results .accordion .accordion-wrapper-content__title p {
  font-weight: inherit;
}
.quiz_results .accordion__no-header .accordion__content {
  margin-top: 0;
}
.quiz_results .accordion__no-header .accordion-wrapper-content {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin-top: 1.25rem;
}
.quiz_results .accordion__no-header .accordion-wrapper-content:last-child {
  border-bottom: 0;
}
.quiz_results .accordion__no-header .accordion-wrapper-content:first-child {
  margin-top: var(--bs-gutter-y);
}

.video-modal, .detail-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  overflow: hidden;
  z-index: 9999;
}
.video-modal__content, .detail-modal__content {
  position: relative;
  text-align: center;
  max-width: 80%;
}
.video-modal__content video, .detail-modal__content video {
  width: 100%;
}
.video-modal__close {
  color: #fff;
  font-size: 24px;
  position: absolute;
  top: -40px;
  right: 10px;
  cursor: pointer;
}
.video-modal .btn, .detail-modal .btn {
  position: absolute;
  right: 0;
}

.detail-modal__content {
  background-color: #fff;
  color: #000;
}
.detail-modal__content-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
.detail-modal__content-wrapper {
  margin: 30px 15px;
  gap: 20px;
  justify-content: center;
  text-align: left;
  max-height: calc(100vh - 100px);
  overflow-y: auto;
}
.detail-modal__content-wrapper > * {
  margin-bottom: 0;
}
.detail-modal__content-wrapper table td {
  text-align: right;
  width: 50%;
  padding-right: 0.375rem;
  font-size: 1.125rem;
  font-weight: 700;
}
.detail-modal__content-wrapper table th {
  text-align: left;
  width: 50%;
  font-size: 0.625rem;
}
.detail-modal__content-bulb {
  display: flex;
}
.detail-modal__content-bulb-text {
  width: 100%;
  padding-left: 10px;
  line-height: 2.25rem;
  font-weight: 700;
}
.detail-modal__content-bulb-icon {
  padding: 5px;
}
.detail-modal__content-info {
  font-size: 10px;
  font-weight: 400;
  line-height: 1rem;
}
.detail-modal__content-info span {
  display: block;
}
.detail-modal__content-info span:first-child {
  margin-bottom: 10px;
}
.detail-modal__content-info span:last-child {
  margin-bottom: 0;
}
.detail-modal__table--unfall {
  color: #8e0038;
}
.detail-modal__table--unfall-small {
  font-size: 10px;
  font-weight: 400;
  text-align: center !important;
}
.detail-modal__table--unfall tr.and th {
  font-size: 12px;
  font-weight: 400;
  color: #000;
  text-align: center;
}
.detail-modal__table-line td svg {
  transform: translateX(100px);
}
.detail-modal__close {
  cursor: pointer;
  position: absolute;
  border: 1px solid black;
  border-radius: 50%;
  padding: 1px 6px 0 6px;
  margin: 0 auto;
  font-size: 16px;
  right: 10px;
  top: 10px;
  line-height: 20px;
}
.detail-modal .btn {
  position: relative;
}

/* Additional styles for the play/pause button */
.carousel-item {
  display: inline-block;
  width: 100%;
  max-width: 100svw;
  transition: all 0.3s linear;
  filter: blur(1px);
  border-radius: 8px;
  opacity: 0.2;
}
.carousel-item:hover, .carousel-item:focus {
  cursor: grabbing;
}
.carousel-item.active {
  filter: none;
  opacity: 1;
}
.carousel-item.active:hover, .carousel-item.active:focus {
  cursor: initial;
}
.carousel-item__image-wrapper {
  height: 180px;
  position: relative;
  padding: 0;
}
@media screen and (min-width: 576px) {
  .carousel-item__image-wrapper {
    height: 300px;
  }
}
@media screen and (min-width: 768px) {
  .carousel-item__image-wrapper {
    height: 580px;
  }
}
@media screen and (min-width: 992px) {
  .carousel-item__image-wrapper {
    height: 400px;
  }
}
.carousel-item__image {
  object-fit: cover;
  border-radius: 8px 8px 0 0;
}
@media screen and (min-width: 768px) {
  .carousel-item__image {
    border-radius: 8px 0 0 8px;
  }
}
.carousel-item .disturber {
  position: absolute;
  top: 68%;
  right: 5%;
}
@media screen and (min-width: 576px) and (max-width: 767px) {
  .carousel-item .disturber {
    top: 72%;
  }
}
@media screen and (min-width: 768px) {
  .carousel-item .disturber {
    right: -7%;
    top: 2%;
  }
}
.carousel-item__text-content {
  padding: 1.875rem 1.25rem;
}
@media screen and (min-width: 992px) {
  .carousel-item__text-content {
    padding: 3.75rem 2.5rem;
  }
}
.carousel-item .text-area {
  translate: 0 -105%;
  width: 800%;
  margin: auto;
  text-align: center;
  padding: 1.25rem;
}
@media screen and (min-width: 768px) {
  .carousel-item .text-area {
    padding: 1.875rem;
  }
}
@media screen and (min-width: 992px) {
  .carousel-item .text-area {
    width: 95%;
  }
}
.carousel-item__text-content--visual {
  text-align: center;
  padding: 3.03125rem 1.25rem;
  border-radius: 0 8px;
}
.carousel-item__image-wrapper--visual {
  height: 300px;
  position: relative;
}
@media screen and (min-width: 576px) {
  .carousel-item__image-wrapper--visual {
    height: 500px;
  }
}
.carousel-item__image-wrapper--visual .text-area {
  top: 100%;
  height: 500px;
  width: 100%;
  padding: 30px 20px;
  border-radius: 0 0 8px 8px;
  margin: 0;
}
@media screen and (min-width: 576px) {
  .carousel-item__image-wrapper--visual .text-area {
    padding: 30px 60px;
    translate: 0 calc(-100% + 1px);
    height: auto;
  }
}
@media screen and (min-width: 768px) {
  .carousel-item__image-wrapper--visual .text-area {
    padding: 30px 60px;
  }
}
@media screen and (min-width: 1200px) {
  .carousel-item__image-wrapper--visual .text-area h2 {
    font-size: 1.5rem;
  }
}
@media screen and (min-width: 576px) {
  .carousel-item__image--visual {
    border-radius: 8px;
  }
}

.popup {
  position: fixed;
  z-index: 9999;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
}
.popup__content {
  position: relative;
  width: 85%;
  text-align: center;
  background: white;
  padding: 3.5625rem 0.8125rem 1.875rem 0.9375rem;
  border-radius: 4px;
}
.popup__content--confirm .popup__icon-wrapper {
  width: 160px;
  height: 130px;
  margin-bottom: 1.875rem;
}
.popup__content--confirm .popup__icon-wrapper img {
  width: inherit;
  margin: 0;
}
.popup__content--confirm .popup__content-notice {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: start;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
  width: 70%;
}
.popup__content--confirm .popup__content-notice:last-child p {
  font-weight: 700;
}
@media screen and (min-width: 768px) {
  .popup__content--confirm .popup__content-notice {
    margin-left: auto;
    margin-right: auto;
    width: auto;
  }
}
.popup__content--confirm .popup__content-notice .c2, .popup__content--confirm .popup__content-notice .coupon__form-checkbox .notice-container div.c2 p, .coupon__form-checkbox .notice-container div.c2 .popup__content--confirm .popup__content-notice p, .popup__content--confirm .popup__content-notice .coupon__form-checkbox .notice-container .content-text__wrapper div.magic-text p, .coupon__form-checkbox .notice-container .content-text__wrapper div.magic-text .popup__content--confirm .popup__content-notice p, .popup__content--confirm .popup__content-notice .content-text__wrapper .coupon__form-checkbox .notice-container div.magic-text p, .content-text__wrapper .coupon__form-checkbox .notice-container div.magic-text .popup__content--confirm .popup__content-notice p, .popup__content--confirm .popup__content-notice .contact-appointment .notice p, .contact-appointment .notice .popup__content--confirm .popup__content-notice p, .popup__content--confirm .popup__content-notice .content-text__wrapper .magic-text, .content-text__wrapper .popup__content--confirm .popup__content-notice .magic-text {
  margin-bottom: 0;
  text-align: left;
}
.popup__content--confirm .popup__content-notice-icon {
  width: 27px;
  height: 27px;
  min-width: 27px;
  min-height: 27px;
  max-width: 27px;
  max-height: 27px;
  margin-right: 2px;
}
.popup__content--confirm .popup__content-notice-icon svg {
  width: 100%;
  height: 100%;
}
.popup__close-icon {
  position: absolute;
  right: 0.9375rem;
  top: 0.9375rem;
}
.popup__close-icon:hover, .popup__close-icon:focus {
  cursor: pointer;
}
.popup__content-box {
  padding-top: 0.625rem;
}
.popup__icon {
  width: 5rem;
  margin: 0 auto 1.875rem auto;
}
.popup__icon--small {
  width: 24px;
  margin-bottom: 0;
}
.popup h3 {
  margin-bottom: 1.25rem;
}
.popup p {
  margin-bottom: 1.25rem;
}
.popup__graphic-wrapper {
  width: 250px;
  height: 150px;
  margin-bottom: 20px;
  position: relative;
}
.popup .disturber {
  position: absolute;
  width: 100px;
  top: -10%;
  left: -10%;
}
.popup__email {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
}
.popup__email p {
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
}
.popup__email .popup__icon--small {
  width: 28px;
  margin-bottom: 0;
}

.success__banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #009284;
  width: 100%;
  color: #fff;
  padding: 0.625rem;
}
@media screen and (min-width: 992px) {
  .success__banner {
    padding: 1.25rem;
  }
}
.success__banner-wrapper {
  display: inline-flex;
  align-items: center;
}
.success__banner-icon {
  width: 48px;
  height: 48px;
  min-width: 48px;
  min-height: 48px;
  -webkit-filter: invert(100%);
  filter: invert(100%);
}
.success__banner-close {
  background-color: transparent;
}
.success__banner p {
  margin: 0;
}

.content-offer {
  width: 100%;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: column;
}
@media screen and (min-width: 768px) {
  .content-offer {
    min-height: 350px;
    justify-content: center;
  }
}
.content-offer__image {
  padding: 0;
}
.content-offer__image-desktop {
  position: absolute;
  width: 100%;
  height: 100%;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  padding: 0;
}
@media screen and (min-width: 768px) {
  .content-offer__image-desktop::after {
    content: "";
    background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 40%, rgb(255, 255, 255) 80%);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
.content-offer__image-desktop img {
  object-fit: cover;
  object-position: left center;
}
.content-offer__image-mobile {
  padding: 0;
  height: 200px;
  overflow: hidden;
}
@media screen and (min-width: 576px) {
  .content-offer__image-mobile {
    height: 300px;
  }
}
@media screen and (min-width: 768px) {
  .content-offer__image-mobile {
    display: none;
  }
}
.content-offer__image-mobile img {
  height: auto;
}
.content-offer__text {
  z-index: 1;
  padding: 0 26px;
}
@media screen and (min-width: 576px) {
  .content-offer__text {
    padding: 0 30px;
  }
}
@media screen and (min-width: 768px) {
  .content-offer__text {
    padding: 0 40px 0 0;
  }
}
@media screen and (min-width: 992px) {
  .content-offer__text {
    padding: 0 30px 0 0;
  }
}
@media screen and (min-width: 1200px) {
  .content-offer__text {
    padding: 0 60px 0 0;
  }
}
.content-offer__text .content-text__wrapper .seal-placeholder img {
  max-width: 275px;
  max-height: 170px;
  width: auto;
  height: auto;
}
@media screen and (min-width: 768px) {
  .content-offer__text .content-text__wrapper .seal-placeholder img {
    max-height: 200px;
  }
}
@media screen and (min-width: 1200px) {
  .content-offer__text .content-text__wrapper .seal-placeholder img {
    max-width: 251px;
  }
}
.content-offer__text .content-text__wrapper .content-list-icon {
  flex-direction: row;
  gap: 8px;
  margin-bottom: 0.625rem;
}
.content-offer__text .content-text__wrapper .content-list-icon:last-of-type {
  margin-bottom: 2.5rem;
}
.content-offer__text .content-text__wrapper .content-list-icon__icon {
  margin: 0;
  padding: 0.25rem;
  max-width: 32px;
  max-height: 32px;
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.content-offer .btn {
  margin: 0;
}
@media screen and (min-width: 768px) {
  .content-offer .btn {
    max-width: unset;
  }
}
.content-offer .btn:not(:last-child) {
  margin-bottom: 20px;
}

.content-text h2,
.content-text h3 {
  color: #8e0038;
  margin-bottom: 1.25rem;
}
.content-text__wrapper {
  position: relative;
  padding: 1.875rem 0;
}
.content-text__wrapper p {
  margin-bottom: 2.5rem;
}
@media screen and (min-width: 768px) {
  .content-text__wrapper {
    padding: 3.125rem 0;
  }
}
.content-text__wrapper .disturber {
  position: absolute;
  top: -80px;
  right: 0;
}
@media screen and (min-width: 768px) {
  .content-text__wrapper .disturber {
    top: -80px;
  }
}
@media screen and (min-width: 992px) {
  .content-text__wrapper .disturber {
    top: -80px;
  }
}
@media screen and (min-width: 1200px) {
  .content-text__wrapper .disturber {
    top: -80px;
  }
}

.content-download__content {
  padding: 1.25rem 1.625rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}
@media screen and (min-width: 992px) {
  .content-download__content a {
    margin: 0;
  }
}
.content-download__content .btn svg {
  width: 36px;
  margin-right: 5px;
  height: 36px;
}
.content-download__content .btn--secondary path {
  fill: #8e0038;
}
.content-download__content .btn--secondary:hover path, .content-download__content .btn--secondary:focus path {
  fill: #fff;
}
.content-download__content .btn--primary path {
  fill: #fff;
}
@media screen and (min-width: 768px) {
  .content-download__content .btn {
    max-width: unset;
  }
}
@media screen and (min-width: 992px) {
  .content-download__content .btn {
    max-width: fit-content;
  }
}
.content-download__image {
  width: 125px;
  height: 125px;
}
@media screen and (min-width: 992px) {
  .content-download__image {
    width: 175px;
    height: 175px;
  }
}
.content-download__image-container {
  padding: 3.125rem 0;
}

.content-headline-block {
  position: relative;
  text-align: left;
  padding: 30px 26px;
}
@media screen and (min-width: 768px) {
  .content-headline-block {
    padding: 50px 40px;
  }
}
@media screen and (min-width: 1200px) {
  .content-headline-block {
    padding: 50px 95px;
  }
}
.content-headline-block--disturber {
  margin-top: 80px;
}
.content-headline-block h1 {
  margin-bottom: 0.625rem;
}
.content-headline-block h3 {
  margin-bottom: 1.25rem;
}
.content-headline-block p {
  margin-bottom: 1.875rem;
}
.content-headline-block a {
  color: #8e0038;
  font-weight: bold;
}
.content-headline-block .btn-wrapper {
  gap: 0.625rem;
  width: 100%;
  min-width: 350px;
}
@media screen and (min-width: 576px) {
  .content-headline-block .btn-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin: auto;
  }
}
.content-headline-block .btn-wrapper :last-child {
  margin-bottom: 0;
}
.content-headline-block .btn-wrapper .content-text__wrapper {
  padding: 0;
}
.content-headline-block .btn-wrapper .content-text__wrapper .disturber {
  position: absolute;
  top: -100px;
  right: 5%;
}
@media screen and (min-width: 768px) {
  .content-headline-block .btn-wrapper .content-text__wrapper .disturber {
    top: -130px;
  }
}
.content-headline-block .btn-wrapper .seal-placeholder {
  justify-content: center;
  align-items: center;
  flex-basis: 100%;
}
.content-headline-block .btn-wrapper .magic-text {
  margin: 0;
}
.content-headline-block .btn-wrapper .magic-text p {
  margin: 0;
}
@media screen and (min-width: 768px) {
  .content-headline-block {
    text-align: center;
  }
  .content-headline-block p {
    margin-bottom: 2.5rem;
  }
}
.content-headline-block .btn-wrapper > div > button {
  width: 100%;
  min-width: 350px;
}
@media screen and (min-width: 992px) {
  .content-headline-block .btn-wrapper > div > button {
    min-width: auto;
  }
}
.content-headline-block .disturber {
  position: absolute;
  top: -85px;
  right: 5%;
}
@media screen and (min-width: 768px) {
  .content-headline-block .disturber {
    top: -90px;
  }
}

.contact-appointment {
  --icon-width: 64px;
  margin-bottom: 3.875rem;
}
@media screen and (min-width: 576px) {
  .contact-appointment {
    margin-inline: 33px;
  }
}
@media screen and (min-width: 768px) {
  .contact-appointment {
    --icon-width: 80px;
    margin-inline: 0 39px;
    position: relative;
  }
}
@media screen and (min-width: 992px) {
  .contact-appointment {
    --icon-width: 96px;
    margin-top: 100px;
    margin-inline: 0 32px;
  }
}
@media screen and (min-width: 1200px) {
  .contact-appointment {
    margin-inline: 0 45px;
  }
}
.contact-appointment .icon {
  width: var(--icon-width);
  height: var(--icon-width);
}
@media screen and (min-width: 992px) {
  .contact-appointment .offset-by-icon {
    margin-left: var(--icon-width);
  }
}
.contact-appointment .form {
  text-align: left;
}
.contact-appointment__form-container {
  padding: 30px 26px 50px;
}
@media screen and (min-width: 576px) {
  .contact-appointment__form-container {
    padding: 30px 30px 50px;
  }
}
@media screen and (min-width: 768px) {
  .contact-appointment__form-container {
    border-radius: 0 8px 8px 0;
    padding: 30px 30px 50px 40px;
  }
}
@media screen and (min-width: 992px) {
  .contact-appointment__form-container {
    padding: 50px 30px 30px;
  }
}
@media screen and (min-width: 1200px) {
  .contact-appointment__form-container {
    padding: 1.875rem 1.875rem 3.125rem;
  }
}
@media screen and (min-width: 992px) {
  .contact-appointment--expanded .contact-appointment__form-container {
    padding: 1.875rem 1.625rem 6.25rem;
  }
}
@media screen and (min-width: 768px) {
  .contact-appointment--expanded .contact-appointment__form-container .data-protection-container {
    max-width: 66%;
  }
}
@media screen and (min-width: 1200px) {
  .contact-appointment--expanded .contact-appointment__form-container .data-protection-container {
    max-width: unset;
  }
}
.contact-appointment__icon-wrapper {
  margin-bottom: 1.25rem;
}
@media screen and (min-width: 992px) {
  .contact-appointment__icon-wrapper {
    margin-bottom: 0.625rem;
  }
}
@media screen and (min-width: 768px) {
  .contact-appointment__content-wrapper {
    max-width: 52%;
  }
}
.contact-appointment h2 {
  margin-bottom: 1.25rem;
}
.contact-appointment .lead {
  margin-bottom: 1.25rem;
}
.contact-appointment__telephone-container {
  margin: auto;
  transform: translateY(-15%);
  margin-bottom: -15%;
  width: calc(100% - 52px);
  border-radius: 10px;
  padding: 1.875rem 1.25rem;
}
@media screen and (min-width: 576px) {
  .contact-appointment__telephone-container {
    width: calc(100% - 60px);
    padding: 1.875rem;
  }
}
.contact-appointment__telephone-container.bg-green--light {
  background-color: #e3f0e6;
}
.contact-appointment h4 {
  margin-bottom: 10px;
}
.contact-appointment h4:last-of-type {
  margin-bottom: 1.875rem;
}
.contact-appointment .error {
  color: #bf1528;
}
.contact-appointment .error:last-of-type {
  margin-bottom: 1.875rem;
}
.contact-appointment input[type=email] {
  padding: 1rem 0.625rem;
  border-radius: 5px 5px 0 0;
  margin-bottom: 1.625rem;
  border: none;
  border-bottom: 2px solid gray;
}
.contact-appointment input[type=email].error {
  margin-bottom: 0;
}
.contact-appointment input[type=email].error + .error {
  margin-bottom: 13px;
}
.contact-appointment .notice {
  margin-bottom: 1.25rem;
}
.contact-appointment .notice a {
  color: #8e0038;
  font-weight: bold;
}
.contact-appointment .notice-container {
  margin-left: 10px;
  z-index: 1;
}
@media screen and (min-width: 768px) {
  .contact-appointment .notice-container {
    max-width: 90%;
  }
}
@media screen and (min-width: 1200px) {
  .contact-appointment .notice-container {
    max-width: 65%;
  }
}
.contact-appointment__appointment-cta {
  margin-top: 1.875rem;
  margin-bottom: 3.125rem;
  margin-left: 0;
}
@media screen and (min-width: 768px) {
  .contact-appointment__appointment-cta {
    margin-top: 2.5rem;
  }
}
.contact-appointment__appointment-cta[type=submit] {
  margin-bottom: 1.875rem;
}
.contact-appointment h4.notice--email-send {
  margin-bottom: 1.875rem;
}
@media screen and (min-width: 992px) {
  .contact-appointment h4.notice--email-send {
    max-width: 90%;
  }
}
.contact-appointment .mobile-phone {
  position: absolute;
  display: none;
  top: -85px;
  right: -30px;
}
@media screen and (min-width: 768px) {
  .contact-appointment .mobile-phone {
    display: flex;
  }
}
@media screen and (min-width: 992px) {
  .contact-appointment .mobile-phone {
    right: -50px;
  }
}
@media screen and (min-width: 1200px) {
  .contact-appointment .mobile-phone {
    right: -90px;
  }
}
.contact-appointment .mobile-phone__image {
  height: 636px;
  min-width: 445px;
  max-width: 445px;
}
.contact-appointment .mobile-phone__content {
  width: 220px;
  text-align: center;
  position: absolute;
  top: 20%;
  padding: 0 10px;
}
.contact-appointment .mobile-phone__content > h4 {
  margin-bottom: 0;
}
.contact-appointment .mobile-phone__avatar {
  margin-bottom: 1.875rem;
}
.contact-appointment .mobile-phone {
  overflow: hidden;
}
.contact-appointment .mobile-phone__content {
  width: 220px;
  text-align: center;
  position: absolute;
  top: 20%;
}
.contact-appointment .mobile-phone__text {
  font-size: 14px;
}
.contact-appointment .mobile-phone__avatar {
  margin-bottom: 1.875rem;
}
.contact-appointment .mobile-phone__image {
  height: 636px;
  width: 445px;
}
.contact-appointment .mobile-phone__image[data-bg-color=bg-orange--light] g path {
  fill: #ffeede;
}
.contact-appointment .mobile-phone__image[data-bg-color=bg-blue--light] g path {
  fill: #e2f6fa;
}
.contact-appointment .mobile-phone__image[data-bg-color=bg-green--light] g path {
  fill: #e3f0e6;
}
.contact-appointment .mobile-phone__image[data-bg-color=bg-violet--light] g path {
  fill: #efe7ed;
}
.contact-appointment .mobile-phone__image[data-bg-color=bg-yellow--light] g path {
  fill: #fff4b0;
}
.contact-appointment .mobile-phone__image[data-bg-color=bg-warmgrey] g path {
  fill: #d9d5c7;
}
.contact-appointment .mobile-phone__image[data-bg-color=bg-warmgrey--light] g path {
  fill: #ebe6d8;
}
.contact-appointment .mobile-phone__image[data-bg-color=bg-orange--light] g rect[rx="28.8"] {
  fill: #f3c591;
}
.contact-appointment .mobile-phone__image[data-bg-color=bg-blue--light] g rect[rx="28.8"] {
  fill: #a9dae0;
}
.contact-appointment .mobile-phone__image[data-bg-color=bg-green--light] g rect[rx="28.8"] {
  fill: #8bc9ad;
}
.contact-appointment .mobile-phone__image[data-bg-color=bg-violet--light] g rect[rx="28.8"] {
  fill: #dbaccc;
}
.contact-appointment .mobile-phone__image[data-bg-color=bg-yellow--light] g rect[rx="28.8"] {
  fill: #f7db6f;
}
.contact-appointment .mobile-phone__image[data-bg-color=bg-warmgrey] g rect[rx="28.8"] {
  fill: #fff;
}
.contact-appointment .mobile-phone__image[data-bg-color=bg-warmgrey--light] g rect[rx="28.8"] {
  fill: #fff;
}
.contact-appointment .mobile-phone__image g path:last-of-type {
  fill: black;
}
.contact-appointment .data-protection-container {
  margin-top: 30px;
}
@media screen and (min-width: 992px) {
  .contact-appointment .data-protection-container {
    margin-top: 40px;
  }
}
@media screen and (min-width: 1200px) {
  .contact-appointment .data-protection-container {
    margin-top: 30px;
  }
}
@media screen and (min-width: 768px) {
  .contact-appointment--success:not(.contact-appointment--expanded), .contact-appointment--appointed {
    --icon-width: 96px;
  }
}
@media screen and (min-width: 992px) {
  .contact-appointment--success:not(.contact-appointment--expanded), .contact-appointment--appointed {
    --icon-width: 135px;
    border-radius: 0 8px 8px 0;
    overflow: hidden;
  }
}
.contact-appointment--success:not(.contact-appointment--expanded) .mobile-phone,
.contact-appointment--success:not(.contact-appointment--expanded) .contact-appointment__telephone-container, .contact-appointment--appointed .mobile-phone,
.contact-appointment--appointed .contact-appointment__telephone-container {
  display: none;
}
.contact-appointment--success:not(.contact-appointment--expanded) .offset-by-icon, .contact-appointment--appointed .offset-by-icon {
  margin-left: 0;
}
@media screen and (min-width: 1200px) {
  .contact-appointment--success:not(.contact-appointment--expanded) .offset-by-icon, .contact-appointment--appointed .offset-by-icon {
    margin-left: var(--icon-width);
  }
}
@media screen and (min-width: 768px) {
  .contact-appointment--success:not(.contact-appointment--expanded) .contact-appointment__content-wrapper, .contact-appointment--appointed .contact-appointment__content-wrapper {
    max-width: 66%;
  }
}
@media screen and (min-width: 1200px) {
  .contact-appointment--success:not(.contact-appointment--expanded) .contact-appointment__content-wrapper, .contact-appointment--appointed .contact-appointment__content-wrapper {
    max-width: calc(66% - var(--icon-width, 0px));
  }
}
@media screen and (min-width: 768px) {
  .contact-appointment--success:not(.contact-appointment--expanded) .contact-appointment__icon-wrapper, .contact-appointment--appointed .contact-appointment__icon-wrapper {
    position: absolute;
    left: 82.5%;
    top: 50%;
    translate: -50% -50%;
  }
}
.contact-appointment--appointed .contact-appointment__content-wrapper {
  max-width: unset;
}
@media screen and (min-width: 768px) {
  .contact-appointment--appointed .contact-appointment__content-wrapper {
    max-width: 66%;
  }
}
@media screen and (min-width: 768px) {
  .contact-appointment--appointed .contact-appointment__form-container {
    border-radius: 0 8px 8px 0;
    padding: 30px 30px 10px 40px;
  }
}
@media screen and (min-width: 992px) {
  .contact-appointment--appointed .contact-appointment__form-container {
    padding: 50px 30px 30px;
  }
}

.content-colorplane {
  position: relative;
}
.content-colorplane__image {
  position: relative;
  height: 220px;
  padding: 0 2.625rem;
}
@media screen and (min-width: 576px) {
  .content-colorplane__image {
    height: 300px;
    padding: 0 16px;
  }
}
@media screen and (min-width: 768px) {
  .content-colorplane__image {
    height: 350px;
  }
}
@media screen and (min-width: 992px) {
  .content-colorplane__image {
    width: 50%;
  }
}
@media screen and (min-width: 1200px) {
  .content-colorplane__image {
    min-height: 400px;
  }
}
.content-colorplane__image img {
  object-fit: cover;
  border-radius: 0.5rem;
}
.content-colorplane__image .disturber {
  position: absolute;
  right: 30px;
  bottom: -20px;
  z-index: 1;
}
@media screen and (min-width: 992px) {
  .content-colorplane__image .disturber {
    right: 30px;
    top: -30px;
  }
}
.content-colorplane__image-color-box {
  position: absolute;
  top: 100px;
  bottom: 0;
  left: -200px;
  right: -200px;
  width: auto;
  z-index: -1;
}
@media screen and (min-width: 768px) {
  .content-colorplane__image-color-box {
    top: 120px;
  }
}
@media screen and (min-width: 992px) {
  .content-colorplane__image-color-box {
    height: 550px;
    top: -100px;
    right: 120px;
    left: -100%;
  }
}
@media screen and (min-width: 1200px) {
  .content-colorplane__image-color-box {
    height: 500px;
    top: -50px;
    right: 120px;
  }
}
.content-colorplane__image .bg-full {
  top: 0;
}
@media screen and (min-width: 992px) {
  .content-colorplane__image .bg-full {
    top: -100px;
  }
}
@media screen and (min-width: 1200px) {
  .content-colorplane__image .bg-full {
    top: -50px;
  }
}
.content-colorplane__image .bg-full + img {
  object-fit: contain;
}
.content-colorplane__text {
  position: relative;
  z-index: 0;
}
.content-colorplane__text-wrapper {
  padding: 0 1.625rem;
}
@media screen and (min-width: 576px) {
  .content-colorplane__text-wrapper {
    padding: 0;
  }
}
@media screen and (min-width: 576px) {
  .content-colorplane__text-wrapper .content-list__wrapper .content-list ul,
  .content-colorplane__text-wrapper .content-list__wrapper .content-list ol {
    grid-template-columns: repeat(1, 1fr);
  }
}
.content-colorplane__text-wrapper .magic-text {
  margin-bottom: 0;
}
.content-colorplane__text-wrapper .magic-text span {
  line-height: 1.4em;
}
@media screen and (min-width: 992px) {
  .content-colorplane__text {
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 550px;
  }
}
@media screen and (min-width: 1200px) {
  .content-colorplane__text {
    min-height: 500px;
    padding-right: 40px;
  }
}
.content-colorplane__text-color-box {
  position: absolute;
  top: 0;
  bottom: 0;
  right: -200px;
  left: -200px;
  width: auto;
  z-index: -1;
}
@media screen and (min-width: 992px) {
  .content-colorplane__text-color-box {
    display: none;
  }
}
.content-colorplane__text .content-text__wrapper {
  padding: 1.875rem 0;
}
@media screen and (min-width: 768px) {
  .content-colorplane__text .content-text__wrapper {
    padding: 3.125rem 0;
  }
}
.content-colorplane__text .content-text__wrapper .content-text__red-sticker {
  right: 1.5rem;
  top: -5rem;
}
@media screen and (min-width: 992px) {
  .content-colorplane__text .content-text__wrapper .content-text__red-sticker {
    right: 0rem;
    top: -2.25rem;
  }
}
.content-colorplane__text .content-text__wrapper .content-list:last-child {
  margin-bottom: 0;
}
.content-colorplane .content-list__wrapper .content-list__headline h2 {
  text-align: left;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: bold;
  margin-bottom: 1rem;
}
@media screen and (min-width: 768px) {
  .content-colorplane .content-list__wrapper .content-list__headline h2 {
    font-size: 1.25rem;
  }
}
@media screen and (min-width: 1200px) {
  .content-colorplane .content-list__wrapper .content-list__headline h2 {
    font-size: 1.5rem;
  }
}
.content-colorplane .content-list__wrapper .content-list__headline .content-list__text {
  text-align: left;
}
.content-colorplane .content-list__wrapper .content-list__items .magic-text {
  grid-column: 1/-1;
}
.content-colorplane .btn {
  margin: 0;
}
@media screen and (min-width: 992px) {
  .content-colorplane .flew-row .content-text__wrapper .disturber {
    top: 50px;
    left: -30%;
  }
}
@media screen and (min-width: 1200px) {
  .content-colorplane .flew-row .content-text__wrapper .disturber {
    top: 5%;
  }
}
@media screen and (min-width: 992px) {
  .content-colorplane .flex-row-reverse .content-colorplane__image {
    padding-right: 30px;
    padding-left: 30px;
  }
  .content-colorplane .flex-row-reverse .content-colorplane__image-color-box {
    right: -200%;
    left: 120px;
  }
  .content-colorplane .flex-row-reverse .content-colorplane__text {
    padding-left: 40px;
  }
}

@media screen and (max-width: 992px) {
  .main-container--hasSticky .footer__bar {
    padding-top: 24px;
    padding-bottom: 112px;
  }
}

.footer__disclaimer {
  margin-bottom: 1.875rem;
  padding: 1.875rem 1.625rem;
}
@media screen and (min-width: 576px) {
  .footer__disclaimer span {
    padding: 0;
  }
}
@media screen and (min-width: 768px) {
  .footer__disclaimer {
    margin-bottom: 3.125rem;
  }
}
.footer__disclaimer .c3 p, .content-icon-text-list__disclaimer .c3 .footer__disclaimer p p {
  margin-bottom: 0;
  font-size: inherit;
}
.footer__disclaimer .c3 p a, .content-icon-text-list__disclaimer .c3 .footer__disclaimer p p a {
  color: #8e0038;
  font-weight: 700;
}
.footer__contact {
  margin-bottom: 1.875rem;
}
.footer__contact-wrapper {
  padding: 1.875rem 1.625rem;
}
@media screen and (min-width: 576px) {
  .footer__contact-wrapper {
    padding: initial;
  }
}
@media screen and (min-width: 992px) {
  .footer__contact-wrapper {
    padding-left: 16px;
  }
}
@media screen and (min-width: 576px) {
  .footer__contact {
    padding: 0 45px;
  }
}
@media screen and (min-width: 768px) {
  .footer__contact {
    margin-bottom: 3.125rem;
  }
}
.footer__contact-headline {
  color: #8e0038;
  margin-bottom: 1.875rem;
}
@media screen and (min-width: 768px) {
  .footer__contact-headline {
    margin-bottom: 1.25rem;
  }
}
.footer__contact-headline p {
  font-weight: 700;
}
.footer__contact p {
  margin-bottom: 0;
}
.footer__contact .row {
  gap: 1.875rem;
}
@media screen and (min-width: 768px) {
  .footer__contact .row {
    gap: 0;
  }
}
.footer__bar {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  min-height: 58px;
  text-align: center;
  background-color: rgba(217, 213, 199, 0.3);
  color: #000;
  padding: 6px 0;
}
@media screen and (max-width: 992px) {
  .footer__bar--when-sticky-cta-is-there {
    padding-top: 24px;
    padding-bottom: 112px;
  }
}
.footer__bar a {
  color: #000;
}
.footer__bar *:not(:last-child):after {
  content: "|";
  margin: 0 0.3125rem;
}

.stage__content-video {
  position: absolute;
  bottom: 20px;
  left: 20px;
  width: 100px;
  height: 100px;
  cursor: pointer;
}
@media screen and (min-width: 576px) {
  .stage__content-video {
    width: 150px;
    height: 150px;
    bottom: 30px;
    left: 30px;
  }
}
.stage__content-video svg {
  width: 100%;
  height: 100%;
}
.stage__content-video svg path {
  transition: fill 0.5s ease;
}
.stage__content-video:focus svg > path:nth-of-type(1), .stage__content-video:hover svg > path:nth-of-type(1) {
  fill: #fff;
}
.stage__content-blocks {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
@media screen and (min-width: 1200px) {
  .stage__content-blocks {
    flex-direction: row;
  }
}
.stage__content-text-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-size: cover;
  padding: 1.875rem 1.625rem;
}
@media screen and (min-width: 576px) {
  .stage__content-text-wrapper {
    padding: 1.875rem;
  }
}
@media screen and (min-width: 768px) {
  .stage__content-text-wrapper {
    padding: 3.75rem;
  }
}
@media screen and (min-width: 992px) {
  .stage__content-text-wrapper {
    height: 100%;
    min-height: 500px;
    padding: 3.75rem 2.5rem;
  }
}
@media screen and (min-width: 1200px) {
  .stage__content-text-wrapper {
    padding: 5rem 3.75rem;
    max-width: 990px;
  }
}
.stage__content-text-wrapper .h1 {
  font-weight: 500;
  margin-bottom: 0.625rem;
}
.stage__content-text-wrapper .lead {
  margin-bottom: 1.25rem;
}
.stage__content-text-wrapper .h4 {
  margin-bottom: 1.25rem;
}
@media screen and (min-width: 992px) {
  .stage__content-text-wrapper .c1, .stage__content-text-wrapper .content-list ol li, .content-list ol .stage__content-text-wrapper li,
  .stage__content-text-wrapper .content-list ul li,
  .content-list ul .stage__content-text-wrapper li {
    margin-bottom: 2.5rem;
  }
}
.stage__content-text-wrapper .btn {
  margin: 0;
}
@media screen and (min-width: 768px) {
  .stage__content-text-wrapper .btn {
    max-width: unset;
  }
}
@media screen and (min-width: 992px) {
  .stage__content-text-wrapper .btn {
    max-width: fit-content;
  }
}
.stage__content-text-wrapper .btn.sticky {
  width: 90vw;
  max-width: 100%;
}
@media screen and (min-width: 992px) {
  .stage__content-text-wrapper .btn.sticky {
    width: 100%;
    min-width: 250px;
  }
}
.stage__content-text-wrapper .read-more-link {
  margin: 0 auto;
}
@media screen and (min-width: 768px) {
  .stage__content-text-wrapper .read-more-link {
    margin-top: 20px;
  }
}
@media screen and (min-width: 1200px) {
  .stage__content-text-wrapper .read-more-link {
    margin: auto;
    margin-top: 30px;
  }
}
.stage__content-text-wrapper .content-list-icon {
  flex-direction: row;
  gap: 8px;
}
.stage__content-text-wrapper .content-list-icon__icon {
  margin: 0;
  padding: 0.25rem;
  max-width: 32px;
  max-height: 32px;
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.stage__content-image-wrapper {
  position: relative;
  padding: 0;
  height: 220px;
}
@media screen and (min-width: 576px) {
  .stage__content-image-wrapper {
    height: 300px;
  }
}
@media screen and (min-width: 768px) {
  .stage__content-image-wrapper {
    height: 350px;
  }
}
@media screen and (min-width: 992px) {
  .stage__content-image-wrapper {
    max-height: inherit;
    height: auto;
    min-height: 500px;
  }
}
.stage__content-image-wrapper img {
  overflow: hidden;
  -o-object-fit: cover;
  object-fit: cover;
  height: 100%;
  width: 100%;
}
.stage__content-image-wrapper .disturber {
  position: absolute;
  right: 30px;
  bottom: -20px;
  z-index: 1;
}
@media screen and (min-width: 992px) {
  .stage__content-image-wrapper .disturber {
    right: -20px;
    top: 20px;
  }
}

.content-composition {
  display: grid;
  --gutter-width: 26px;
  --overlap: 180px;
  grid-template-columns: var(--gutter-width) 1fr var(--gutter-width);
  grid-template-rows: auto var(--overlap) auto;
}
.content-composition__heading {
  margin-bottom: 1.25rem;
}
.content-composition__heading .lead {
  padding-top: 0.625rem;
}
.content-composition .c2 > p, .content-composition .coupon__form-checkbox .notice-container div.c2 p > p, .coupon__form-checkbox .notice-container div.c2 .content-composition p > p, .content-composition .coupon__form-checkbox .notice-container .content-text__wrapper div.magic-text p > p, .coupon__form-checkbox .notice-container .content-text__wrapper div.magic-text .content-composition p > p, .content-composition .content-text__wrapper .coupon__form-checkbox .notice-container div.magic-text p > p, .content-text__wrapper .coupon__form-checkbox .notice-container div.magic-text .content-composition p > p, .content-composition .content-text__wrapper .magic-text > p, .content-text__wrapper .content-composition .magic-text > p, .content-composition .contact-appointment .notice p > p, .contact-appointment .notice .content-composition p > p {
  font-size: inherit;
}
.content-composition .c2 > p:last-child, .content-composition .coupon__form-checkbox .notice-container div.c2 p > p:last-child, .coupon__form-checkbox .notice-container div.c2 .content-composition p > p:last-child, .content-composition .coupon__form-checkbox .notice-container .content-text__wrapper div.magic-text p > p:last-child, .coupon__form-checkbox .notice-container .content-text__wrapper div.magic-text .content-composition p > p:last-child, .content-composition .content-text__wrapper .coupon__form-checkbox .notice-container div.magic-text p > p:last-child, .content-text__wrapper .coupon__form-checkbox .notice-container div.magic-text .content-composition p > p:last-child, .content-composition .content-text__wrapper .magic-text > p:last-child, .content-text__wrapper .content-composition .magic-text > p:last-child, .content-composition .contact-appointment .notice p > p:last-child, .contact-appointment .notice .content-composition p > p:last-child {
  margin-bottom: 0;
}
.content-composition-icon {
  width: 64px;
  height: 64px;
  background-color: #fff;
  padding: 0.5rem;
  border-radius: 50%;
  margin: 0 auto 1.875rem auto;
}
.content-composition__big {
  grid-column: 1/-1;
  grid-row: 1/3;
  padding-inline: var(--gutter-width);
  padding-block: 30px 180px;
}
.content-composition__big-list {
  padding-top: 1.875rem;
}
.content-composition__big-outroText {
  padding-block: 40px 30px;
}
.content-composition__highlight {
  grid-column: 2;
  grid-row: 2/4;
  display: grid;
  grid-template-rows: auto 20px auto;
}
.content-composition__highlight-img {
  width: fit-content;
  margin: 15px auto;
}
.content-composition__highlight-content {
  border-radius: 8px;
  padding: 30px;
  grid-column: 1;
  grid-row: 2/4;
}
.content-composition__highlight-disturber {
  grid-row: 1/3;
  grid-column: 1;
  justify-self: flex-end;
  z-index: 1;
  margin-inline-end: 20px;
}
.content-composition__highlight-disturber img {
  object-fit: cover;
}
.content-composition__highlight h5,
.content-composition__highlight h2,
.content-composition__highlight h3 {
  margin-bottom: 1.25rem;
}
.content-composition__highlight .content-list {
  padding-top: 1.875rem;
}
.content-composition__highlight .seal-placeholder {
  justify-content: center;
  margin-top: 1.25rem;
  margin-bottom: 0;
}
.content-composition__highlight .btn {
  margin-top: 1.875rem;
}
.content-composition .content-list-icon__text__headline {
  text-align: left;
}
.content-composition .content-list-icon--aligned-left {
  margin-bottom: 1.25rem;
  gap: 1rem;
}
.content-composition .content-list-icon--aligned-left .content-list-icon__icon {
  align-self: center;
  padding: 0.25rem;
  margin: 0;
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  max-width: 32px;
  max-height: 32px;
}
.content-composition .content-list-icon--aligned-left .content-list-icon__icon > img {
  vertical-align: baseline;
}
@media screen and (min-width: 992px) {
  .content-composition {
    --overlap: 50px;
    --highlight-width: 370px;
    grid-template-columns: auto var(--overlap) calc(var(--highlight-width) - var(--overlap));
    grid-template-rows: auto;
    align-items: center;
  }
  .content-composition__big {
    grid-row: 1;
    grid-column: 1/3;
    padding-block: 50px;
    padding-inline: 50px calc(50px + var(--overlap));
    border-radius: 8px;
  }
  .content-composition__highlight {
    position: relative;
    grid-row: 1;
    grid-column: 2/4;
  }
  .content-composition__highlight-content {
    padding: 50px 30px;
  }
  .content-composition__highlight-disturber {
    position: absolute;
    top: 20px;
    translate: 0 -100%;
  }
  .content-composition__highlight .seal-placeholder {
    margin-top: 2.5rem;
  }
  .content-composition__highlight a.btn {
    margin-top: 2.5rem;
  }
  .content-composition--bigRight {
    grid-template-columns: calc(var(--highlight-width) - var(--overlap)) var(--overlap) auto;
  }
  .content-composition--bigRight .content-composition__big {
    grid-column: 2/4;
    padding-inline: calc(50px + var(--overlap)) 50px;
  }
  .content-composition--bigRight .content-composition__highlight {
    grid-column: 1/3;
  }
}
@media screen and (min-width: 1200px) {
  .content-composition {
    --highlight-width: 445px;
    --overlap: 65px;
  }
  .content-composition__highlight-content {
    padding: 50px;
  }
}

.content-card__icon {
  height: 126px;
}
@media screen and (min-width: 768px) {
  .content-card__icon {
    height: 176px;
  }
}
.content-card__content {
  padding: 1.875rem 1.625rem;
}
.content-card__content-container {
  border-radius: 0 0 8px 8px;
}
@media screen and (min-width: 992px) {
  .content-card__content-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .content-card__content-container.border-radius-left {
    border-radius: 8px 0 0 8px;
  }
  .content-card__content-container.border-radius-right {
    border-radius: 0 8px 8px 0;
  }
}
.content-card__content .btn {
  margin: 0;
}
.content-card__headline {
  margin-bottom: 0.625rem;
}
.content-card__sub-headline {
  margin-bottom: 1.25rem;
  font-weight: normal;
}
.content-card__text {
  margin-bottom: 0;
}
.content-card__text ~ .btn {
  margin-top: 1.875rem;
}
@media screen and (min-width: 992px) {
  .content-card__text ~ .btn {
    margin-top: 2.5rem;
  }
}
.content-card .disturber {
  position: absolute;
  top: calc(100% + 10px);
  translate: 0 -100%;
}
.content-card .disturber--image-right, .content-card .disturber--image-left {
  right: 5%;
}
@media screen and (min-width: 768px) {
  .content-card .disturber {
    top: calc(100% + 20px);
  }
}
@media screen and (min-width: 992px) {
  .content-card .disturber {
    translate: 0 0;
    top: 20px;
  }
  .content-card .disturber--image-right {
    right: 72.5%;
  }
  .content-card .disturber--image-left {
    left: 72.5%;
  }
}
@media screen and (min-width: 1200px) {
  .content-card .disturber--image-right {
    right: 80%;
  }
  .content-card .disturber--image-left {
    left: 80%;
  }
}
@media screen and (min-width: 1920px) {
  .content-card .disturber--image-right {
    right: 85%;
  }
  .content-card .disturber--image-left {
    left: 85%;
  }
}
.content-card button {
  margin-left: 0;
}
.content-card__image-container {
  position: relative;
  height: 220px;
  padding-left: 0;
  padding-right: 0;
  border-radius: 8px 8px 0 0;
}
@media screen and (min-width: 576px) {
  .content-card__image-container {
    height: 300px;
  }
}
@media screen and (min-width: 768px) {
  .content-card__image-container {
    height: 350px;
  }
}
@media screen and (min-width: 992px) {
  .content-card__image-container {
    height: auto;
  }
  .content-card__image-container.border-radius-left {
    border-radius: 8px 0 0 8px;
  }
  .content-card__image-container.border-radius-right {
    border-radius: 0 8px 8px 0;
  }
}
.content-card__image {
  object-fit: cover;
  border-radius: 8px 8px 0 0;
}
@media screen and (min-width: 992px) {
  .content-card__image.border-radius-left {
    border-radius: 8px 0 0 8px;
  }
  .content-card__image.border-radius-right {
    border-radius: 0 8px 8px 0;
  }
}
.content-card__image--big {
  height: 320px;
}
@media screen and (min-width: 576px) {
  .content-card__image--big {
    height: 300px;
  }
}
@media screen and (min-width: 768px) {
  .content-card__image--big {
    height: 350px;
  }
}
.content-card__image--letterboxed {
  object-fit: contain;
}
@media screen and (min-width: 1200px) {
  .content-card__image--letterboxed {
    padding: 1rem;
  }
}
@media screen and (min-width: 1200px) {
  .content-card__image--letterboxed {
    padding: 1.5rem;
  }
}
@media screen and (min-width: 1200px) {
  .content-card__image--letterboxed {
    padding: 2rem;
  }
}
.content-card__graphic {
  width: 70%;
}
@media screen and (min-width: 992px) {
  .content-card__graphic {
    width: 100%;
  }
}

.bg-orange--dark3 {
  color: white;
}
.bg-orange--dark3 .btn.btn--primary {
  background-color: #e87a16;
  border: 2px solid white;
}
.bg-orange--dark3 .btn.btn--secondary {
  background-color: white;
  border: 2px solid #e87a16;
  color: #e87a16;
}
.bg-orange--dark3 .btn:hover,
.bg-orange--dark3 .btn:focus {
  color: #fff;
  background: #8e0038;
  border: 2px solid #8e0038;
}
.bg-orange--dark3 h1,
.bg-orange--dark3 .h1,
.bg-orange--dark3 h2,
.bg-orange--dark3 .h2,
.bg-orange--dark3 h3,
.bg-orange--dark3 .h3,
.bg-orange--dark3 h4,
.bg-orange--dark3 .h4 {
  color: white;
}

.bg-blue--dark3 {
  color: white;
}
.bg-blue--dark3 .btn.btn--primary {
  background-color: #0f94a7;
  border: 2px solid white;
}
.bg-blue--dark3 .btn.btn--secondary {
  background-color: white;
  border: 2px solid #0f94a7;
  color: #0f94a7;
}
.bg-blue--dark3 .btn:hover,
.bg-blue--dark3 .btn:focus {
  color: #fff;
  background: #8e0038;
  border: 2px solid #8e0038;
}
.bg-blue--dark3 h1,
.bg-blue--dark3 .h1,
.bg-blue--dark3 h2,
.bg-blue--dark3 .h2,
.bg-blue--dark3 h3,
.bg-blue--dark3 .h3,
.bg-blue--dark3 h4,
.bg-blue--dark3 .h4 {
  color: white;
}

.bg-green--dark3 {
  color: white;
}
.bg-green--dark3 .btn.btn--primary {
  background-color: #009284;
  border: 2px solid white;
}
.bg-green--dark3 .btn.btn--secondary {
  background-color: white;
  border: 2px solid #009284;
  color: #009284;
}
.bg-green--dark3 .btn:hover,
.bg-green--dark3 .btn:focus {
  color: #fff;
  background: #8e0038;
  border: 2px solid #8e0038;
}
.bg-green--dark3 h1,
.bg-green--dark3 .h1,
.bg-green--dark3 h2,
.bg-green--dark3 .h2,
.bg-green--dark3 h3,
.bg-green--dark3 .h3,
.bg-green--dark3 h4,
.bg-green--dark3 .h4 {
  color: white;
}

.bg-violet--dark3 {
  color: white;
}
.bg-violet--dark3 .btn.btn--primary {
  background-color: #b31767;
  border: 2px solid white;
}
.bg-violet--dark3 .btn.btn--secondary {
  background-color: white;
  border: 2px solid #b31767;
  color: #b31767;
}
.bg-violet--dark3 .btn:hover,
.bg-violet--dark3 .btn:focus {
  color: #fff;
  background: #8e0038;
  border: 2px solid #8e0038;
}
.bg-violet--dark3 h1,
.bg-violet--dark3 .h1,
.bg-violet--dark3 h2,
.bg-violet--dark3 .h2,
.bg-violet--dark3 h3,
.bg-violet--dark3 .h3,
.bg-violet--dark3 h4,
.bg-violet--dark3 .h4 {
  color: white;
}

.bg-yellow--dark3 {
  color: white;
}
.bg-yellow--dark3 .btn.btn--primary {
  background-color: #f6cb00;
  border: 2px solid white;
}
.bg-yellow--dark3 .btn.btn--secondary {
  background-color: white;
  border: 2px solid #f6cb00;
  color: #f6cb00;
}
.bg-yellow--dark3 .btn:hover,
.bg-yellow--dark3 .btn:focus {
  color: #fff;
  background: #8e0038;
  border: 2px solid #8e0038;
}
.bg-yellow--dark3 h1,
.bg-yellow--dark3 .h1,
.bg-yellow--dark3 h2,
.bg-yellow--dark3 .h2,
.bg-yellow--dark3 h3,
.bg-yellow--dark3 .h3,
.bg-yellow--dark3 h4,
.bg-yellow--dark3 .h4 {
  color: white;
}

.cutoutvisual__text {
  position: relative;
}
.cutoutvisual__text-wrapper {
  padding: 1.875rem 1.625rem;
}
.cutoutvisual__text-wrapper h3, .cutoutvisual__text-wrapper p, .cutoutvisual__text-wrapper ul, .cutoutvisual__text-wrapper ol {
  margin-bottom: 2rem;
}
.cutoutvisual__text-wrapper .disturber {
  position: absolute;
  top: -35px;
  right: 20px;
}
.cutoutvisual__img-mobile {
  width: 200px;
  margin: 0 auto 1.875rem auto;
}

@media screen and (min-width: 1200px) {
  .cutoutvisual {
    display: flex;
    flex-wrap: nowrap;
  }
  .cutoutvisual__text {
    padding: 0;
    height: 100%;
  }
  .cutoutvisual__text-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 450px;
    padding: 3.125rem 3.125rem 3.125rem 5.9375rem;
  }
  .cutoutvisual__text-wrapper .btn {
    margin: 0;
  }
  .cutoutvisual__img-desktop {
    z-index: 1;
  }
  .cutoutvisual__img-desktop img {
    max-height: 500px;
    width: auto;
    margin: 0 auto;
  }
  .cutoutvisual.flex-row-reverse .cutoutvisual__img-desktop {
    z-index: 1;
  }
  .cutoutvisual.flex-row-reverse .cutoutvisual__text {
    transform: translateX(12.5%);
  }
}
.interaction__wrapper {
  padding: 20px;
  margin: 1.25rem 0;
  background: rgba(255, 255, 255, 0.45);
  border-radius: 8px;
}
.interaction__wrapper:has(form[data-type=txnder-card]) {
  background: transparent;
}
@media screen and (min-width: 576px) {
  .interaction__wrapper {
    padding: 20px 30px;
  }
}
@media screen and (min-width: 768px) {
  .interaction__wrapper {
    padding: 30px 60px;
  }
}
@media screen and (min-width: 1200px) {
  .interaction__wrapper {
    padding: 30px 95px;
  }
}
.interaction__wrapper .interaction__img {
  max-width: 400px;
  padding-bottom: 1.25rem;
}
.interaction__wrapper .form__headline {
  color: #8e0038;
}
.interaction__wrapper form[data-type=dropdown] {
  text-align: center;
}
.interaction__wrapper form[data-type=dropdown] .selectWrapper {
  position: relative;
}
.interaction__wrapper form[data-type=dropdown] select,
.interaction__wrapper form[data-type=dropdown] .select {
  width: 100%;
  margin: 10px 0;
  border: 0;
  border-bottom: 2px solid;
  border-radius: 0;
  font-size: 1rem;
  font-weight: bold;
  height: 50px;
  padding: 12px 10px 0;
  border-color: black !important;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-image: url(./../../svgs/arrow-closed.svg);
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 1em;
  background-color: #fff;
}
@media screen and (min-width: 576px) {
  .interaction__wrapper form[data-type=dropdown] select,
  .interaction__wrapper form[data-type=dropdown] .select {
    font-size: 1.25rem;
  }
}
.interaction__wrapper form[data-type=dropdown] select:focus, .interaction__wrapper form[data-type=dropdown] select:valid, .interaction__wrapper form[data-type=dropdown] select:hover,
.interaction__wrapper form[data-type=dropdown] .select:focus,
.interaction__wrapper form[data-type=dropdown] .select:valid,
.interaction__wrapper form[data-type=dropdown] .select:hover {
  box-shadow: none;
  outline: none;
}
.interaction__wrapper form[data-type=dropdown] select option,
.interaction__wrapper form[data-type=dropdown] .select option {
  display: block;
  min-height: 1.2em;
  padding: 0px 2px 1px;
  white-space: nowrap;
}
.interaction__wrapper form[data-type=dropdown] .selectWrapper--fancy .select {
  display: flex;
  flex-direction: column;
  height: auto;
  text-align: start;
  gap: 2px;
  padding: 8px 10px;
}
.interaction__wrapper form[data-type=dropdown] .selectWrapper--fancy .selectLabel__top {
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  z-index: 2;
}
.interaction__wrapper form[data-type=dropdown] .selectWrapper--fancy .selectLabel__value {
  font-size: 1rem;
  line-height: 1.1;
  font-weight: 400;
}
.interaction__wrapper form[data-type=dropdown] .selectWrapper--fancy .selectLabel__valueHint {
  font-size: 0.75rem;
}
.interaction__wrapper form[data-type=dropdown] .selectWrapper--fancy select {
  position: absolute;
  inset: 0;
  z-index: 1;
}
.interaction__wrapper form[data-type=dropdown] .more-text {
  text-align: start;
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.625rem;
}
.interaction__wrapper form[data-type=dropdown] .option--extended {
  display: flex;
  flex-direction: column;
}
.interaction__wrapper form[data-type=txnder-card] {
  min-height: 100svh;
}
@media screen and (min-width: 1200px) {
  .interaction__wrapper form[data-type=txnder-card] .txnder-headline {
    width: 70%;
    margin: 0 auto;
  }
}
.interaction__wrapper form[data-type=txnder-card] .txnder-image {
  position: relative;
  max-height: 480px;
}
.interaction__wrapper form[data-type=txnder-card] .txnder-image__container {
  width: 100%;
  height: 100%;
}
@media screen and (min-width: 992px) {
  .interaction__wrapper form[data-type=txnder-card] .txnder-image__container {
    max-width: 420px;
    margin: 0 auto;
  }
}
.interaction__wrapper form[data-type=txnder-card] .txnder-image__wrapper {
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  overflow: hidden;
  touch-action: none;
}
.interaction__wrapper form[data-type=txnder-card] .txnder-image__wrapper > * {
  pointer-events: none;
}
.interaction__wrapper form[data-type=txnder-card] .txnder-image:before {
  display: block;
  content: "";
  width: 100%;
  padding-top: 116.9230769231%;
}
@media screen and (min-width: 992px) {
  .interaction__wrapper form[data-type=txnder-card] .txnder-image:before {
    padding-top: 114.2857142857%;
  }
}
.interaction__wrapper form[data-type=txnder-card] .txnder-image > .txnder-img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.interaction__wrapper form[data-type=txnder-card] .txnder-image__info {
  position: absolute;
  bottom: 0;
  z-index: 2;
  margin: 0 auto;
  left: 0;
  right: 0;
  padding: 1rem;
  width: calc(100% - 4rem);
  background: #fff;
  border-radius: 0.25rem 0.25rem 0 0;
}
.interaction__wrapper form[data-type=txnder-card] .txnder-image__info .c1, .interaction__wrapper form[data-type=txnder-card] .txnder-image__info .content-list ol li, .content-list ol .interaction__wrapper form[data-type=txnder-card] .txnder-image__info li,
.interaction__wrapper form[data-type=txnder-card] .txnder-image__info .content-list ul li,
.content-list ul .interaction__wrapper form[data-type=txnder-card] .txnder-image__info li {
  margin-bottom: 0.5rem;
}
.interaction__wrapper form[data-type=multiple-choice-icons] .interaction__icons-img {
  width: 125px;
  height: 125px;
  margin-bottom: 2rem;
}
.interaction__wrapper form[data-type=multiple-choice-icons] .img-checkboxes {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: flex-start;
}
.interaction__wrapper form[data-type=multiple-choice-icons] .img-checkboxes .col {
  padding: 0;
}
@media screen and (min-width: 576px) {
  .interaction__wrapper form[data-type=multiple-choice-icons] .img-checkboxes .col {
    padding: inherit;
  }
}
.interaction__wrapper form[data-type=multiple-choice-icons] .img-checkbox {
  position: relative;
}
.interaction__wrapper form[data-type=multiple-choice-icons] .img-checkbox input {
  position: absolute;
  opacity: 0;
  z-index: -1;
}
.interaction__wrapper form[data-type=multiple-choice-icons] .img-checkbox input + label {
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  margin: 0;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.interaction__wrapper form[data-type=multiple-choice-icons] .img-checkbox input.alternate + label img {
  margin: auto;
  max-width: 120px;
  background: #ebe6d8;
  border-radius: 50%;
  aspect-ratio: 1;
  width: 90%;
  min-width: 1px;
}
@media screen and (min-width: 576px) {
  .interaction__wrapper form[data-type=multiple-choice-icons] .img-checkbox input.alternate + label img {
    width: 100%;
    min-width: 100px;
  }
}
.interaction__wrapper form[data-type=multiple-choice-icons] .img-checkbox input.alternate + label span {
  font-size: 1rem;
  margin-top: 1rem;
  align-items: center;
  line-height: 1.3;
  padding: 0.5rem;
  width: 100%;
  color: #000;
}
@media screen and (min-width: 576px) {
  .interaction__wrapper form[data-type=multiple-choice-icons] .img-checkbox input.alternate + label span {
    font-size: 1.1rem;
  }
}
@media screen and (min-width: 768px) {
  .interaction__wrapper form[data-type=multiple-choice-icons] .img-checkbox input.alternate + label span {
    font-size: 1.2rem;
  }
}
@media screen and (min-width: 992px) {
  .interaction__wrapper form[data-type=multiple-choice-icons] .img-checkbox input.alternate + label span {
    font-size: 1.3rem;
  }
}
@media screen and (min-width: 1200px) {
  .interaction__wrapper form[data-type=multiple-choice-icons] .img-checkbox input.alternate + label span {
    font-size: 1.5rem;
  }
}
.interaction__wrapper form[data-type=multiple-choice-icons] .img-checkbox input[type=radio]:checked + label img {
  background: #f7db6f;
}
.interaction__wrapper form[data-type=multiple-choice-slider] .interaction__slider-image {
  width: 190px;
  border-radius: 50%;
  height: 190px;
  margin: auto;
}
.interaction__wrapper form[data-type=multiple-choice-slider] .interaction__slider-image img {
  border-radius: 50% !important;
  background: #f5f2eb;
}
.interaction__wrapper .interaction__slider-image.visible {
  animation: pop 0.3s;
  opacity: 1;
  z-index: 2;
}
.interaction__wrapper .interaction__slider-wrapper {
  position: relative;
  height: 60px;
  margin-top: 20px;
}
.interaction__wrapper .interaction__slider-wrapper input[type=range] {
  position: absolute;
  margin: 0 auto;
  width: 100%;
  left: 0;
  appearance: none;
  background-color: #d2cecc;
  border-radius: 6px;
  height: 11px;
  background-image: linear-gradient(to right, #47bcca 45%, #d2cecc 45%);
}
.interaction__wrapper .interaction__slider-wrapper input[type=range]::-webkit-slider-runnable-track {
  height: 11px;
  color: #47bcca;
  z-index: 0;
}
.interaction__wrapper .interaction__slider-wrapper input[type=range]::-webkit-slider-thumb {
  display: block;
  z-index: 2;
  width: 40px;
  height: 40px;
  cursor: pointer;
  background: #8e0038;
  color: transparent;
  border: 10px #8e0038;
  border-radius: 50%;
  margin-top: -20px;
}
.interaction__wrapper .interaction__slider-wrapper input[type=range]::-moz-range-progress {
  background-color: #47bcca;
}
.interaction__wrapper .interaction__slider-wrapper input[type=range]::-moz-range-track {
  background-color: #d2cecc;
}
.interaction__wrapper .interaction__slider-wrapper input[type=range]::-ms-fill-lower {
  background-color: #47bcca;
}
.interaction__wrapper .interaction__slider-wrapper input[type=range]::-ms-fill-upper {
  background-color: #d2cecc;
}
.interaction__wrapper form[data-type=multiple-choice-pictures] .text__headline {
  font-family: "FSMe";
  color: #000;
  line-height: 1.4;
  font-weight: bold;
}
@media screen and (min-width: 992px) {
  .interaction__wrapper form[data-type=multiple-choice-pictures] .row {
    flex-direction: row;
  }
}
.interaction__wrapper form[data-type=multiple-choice-pictures] .img-picture {
  position: relative;
}
.interaction__wrapper form[data-type=multiple-choice-pictures] .img-picture input[type=radio] + label {
  cursor: pointer;
  font-weight: bold;
  margin: 0;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  max-height: 160px;
  border-radius: 6px;
  color: #8e0038;
}
@media screen and (min-width: 576px) {
  .interaction__wrapper form[data-type=multiple-choice-pictures] .img-picture input[type=radio] + label {
    max-height: 200px;
  }
}
@media screen and (min-width: 992px) {
  .interaction__wrapper form[data-type=multiple-choice-pictures] .img-picture input[type=radio] + label {
    max-height: 100%;
  }
}
.interaction__wrapper form[data-type=multiple-choice-pictures] .img-picture input[type=radio] + label img {
  aspect-ratio: 1;
  display: block;
  object-fit: cover;
  pointer-events: none;
  width: 100%;
  background: #ebe6d8;
  transform: translateY(-20%);
}
@media screen and (min-width: 992px) {
  .interaction__wrapper form[data-type=multiple-choice-pictures] .img-picture input[type=radio] + label img {
    transform: translateY(0);
  }
}
.interaction__wrapper form[data-type=multiple-choice-pictures] .img-picture input[type=radio] + label:hover span, .interaction__wrapper form[data-type=multiple-choice-pictures] .img-picture input[type=radio] + label:focus span {
  background: rgba(255, 255, 255, 0.85);
}
.interaction__wrapper form[data-type=multiple-choice-pictures] .img-picture input[type=radio] + label span {
  padding: 0.5rem 2.5rem;
  align-items: center;
  background: rgba(255, 255, 255, 0.75);
  bottom: 0;
  display: flex;
  height: 3.5rem;
  justify-content: center;
  left: 0;
  line-height: 1.3;
  padding: 0.5rem;
  position: absolute;
  transition: 0.15s background;
  width: 100%;
}
.interaction__wrapper form[data-type=multiple-choice-pictures] .img-picture input[type=radio].alternate {
  position: absolute;
  opacity: 0;
  z-index: -1;
}
.interaction__wrapper form[data-type=multiple-choice-pictures] .img-picture input.alternate:checked + label span {
  background: rgba(142, 0, 56, 0.8) !important;
  color: #fff;
}
.interaction__wrapper form[data-type=multiple-choice-pictures] .img-picture input.alternate:checked + label span::before {
  background: url(../../svgs/black_Haekchen.svg) no-repeat;
  background-size: contain;
  content: "";
  height: 15px;
  left: 15px;
  position: absolute;
  top: 18px;
  width: 18px;
  color: #fff;
}
.interaction__wrapper form[data-type=multiple-choice-pictures] .img-picture input.alternate:checked + label span::before svg path {
  fill: white;
}
.interaction__wrapper .answer-validation {
  animation: fadeIn 1s ease-in-out;
  display: flex;
  margin-bottom: 1.25rem;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.9375rem;
}
.interaction__wrapper form .next-btn {
  margin-top: 1.25rem;
}
.interaction__background {
  height: 100%;
}
.interaction__background .row {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.interaction--margin-big {
  margin-bottom: 1.875rem;
}
@media screen and (min-width: 768px) {
  .interaction--margin-big {
    margin-bottom: 6.25rem;
  }
}
.interaction__outro {
  min-height: 100svh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.interaction__outro .interaction__wrapper {
  padding: 0;
  margin: 0;
}
@media screen and (min-width: 576px) {
  .interaction__outro .interaction__wrapper {
    padding: 1.875rem;
    margin: 1.25rem 0;
  }
}

.intro-cover {
  height: 100vh;
  text-align: center;
  padding: 0 1.25rem;
  margin-top: 6.25rem;
}

aside.progress-bar {
  background: rgba(255, 255, 255, 0.7);
  text-align: left;
  height: 20px;
  width: 100%;
  display: flex;
  align-items: stretch;
}
aside.progress-bar span {
  background: #8e0038;
  color: #fff;
  display: inline-block;
  font-size: 10px;
  font-weight: bold;
  min-width: 112px;
  height: 100%;
  transition: 0.5s width;
  padding: 0.25rem 1rem;
  white-space: nowrap;
}

.hidden-step {
  display: none;
  transition: display 0.5s ease, transform 0.3s ease;
}

.current-step {
  display: block;
  transition: display 0.5s ease, transform 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
form {
  animation: fadeIn 1s ease-in-out;
  text-align: center;
}

@keyframes pop {
  0% {
    -moz-transform: scale(1.1);
    transform: scale(1.1);
  }
  100% {
    -moz-transform: none;
    transform: none;
  }
}
.txnder-focus {
  position: relative;
}
.txnder-focus .txnder-button--desktop {
  position: absolute;
  top: 50%;
  right: 0;
  z-index: 2;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-left: 2rem;
  display: inline-flex;
  transform: translateY(-50%);
}
.txnder-focus .txnder-button--desktop .btn-logo {
  margin: -0.375rem 0;
}
@media screen and (min-width: 992px) {
  .txnder-focus .txnder-button--desktop .btn-logo {
    margin: 0;
    width: 2.5rem;
    height: 2.5rem;
  }
}
.txnder-focus .txnder-button--desktop-left {
  margin-left: 0;
  left: 0;
  margin-right: 2rem;
  right: auto;
}
.txnder-focus .txnder-button--desktop-left:active {
  background-color: #fff;
  color: #ff0000;
}
.txnder-focus .txnder-button--desktop-left:active .btn-logo {
  filter: invert(19%) sepia(95%) saturate(6395%) hue-rotate(357deg) brightness(100%) contrast(113%);
}
@media screen and (min-width: 1200px) {
  .txnder-focus .txnder-button--desktop-left {
    left: 10vw;
  }
}
.txnder-focus .txnder-button--desktop-right:active {
  background-color: #fff;
  color: #00a660;
}
.txnder-focus .txnder-button--desktop-right:active .btn-logo {
  filter: invert(42%) sepia(54%) saturate(1210%) hue-rotate(117deg) brightness(96%) contrast(104%);
}
@media screen and (min-width: 1200px) {
  .txnder-focus .txnder-button--desktop-right {
    right: 10vw;
  }
}

.txnder-button {
  width: 4.25rem;
  height: 4.25rem;
  background-color: #fff;
  border: unset;
  color: #545241;
  padding: 1.5rem;
}
@media screen and (min-width: 992px) {
  .txnder-button {
    padding: 2rem;
    width: 7.5rem;
    height: 7.5rem;
  }
}
.txnder-button.disabled {
  pointer-events: none;
}
.txnder-button .btn-logo {
  filter: none;
  width: 2.1875rem;
  height: 2.1875rem;
}
@media screen and (min-width: 992px) {
  .txnder-button .btn-logo {
    width: 1.875rem;
    height: 1.875rem;
  }
}
.txnder-button span {
  font-size: 11px;
}
@media screen and (min-width: 992px) {
  .txnder-button span {
    font-size: 16px;
  }
}
.txnder-button:hover, .txnder-button:focus {
  padding: 2rem;
  border: unset;
  background: rgba(255, 255, 255, 0.7);
  color: #000;
}
.txnder-button:hover .btn-logo, .txnder-button:focus .btn-logo {
  filter: invert(0);
}

.txnder-card__end {
  height: 100%;
  max-height: 100%;
}
.txnder-card__end-first {
  margin-bottom: -5rem;
  z-index: 1;
}
.txnder-card__end-second {
  margin-top: -1rem;
  z-index: 1;
}
.txnder-card__end .icon-cards--desktop {
  display: none;
}
@media screen and (min-width: 992px) {
  .txnder-card__end {
    display: flex;
    align-items: center;
  }
  .txnder-card__end .icon-cards--mobile {
    display: none;
  }
  .txnder-card__end .icon-cards--desktop {
    display: block;
  }
}
@media screen and (min-width: 992px) and (min-width: 1200px) {
  .txnder-card__end .icon-cards--desktop {
    min-width: 420px;
  }
}
@media screen and (min-width: 992px) {
  .txnder-card__end-first {
    margin-bottom: 0;
    margin-right: -4rem;
    z-index: 1;
  }
  .txnder-card__end-second {
    margin-top: 0;
    margin-left: -4rem;
    z-index: 1;
  }
}
.txnder-card__end-card {
  border-radius: 8px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 2;
  height: fit-content;
}
@media screen and (min-width: 992px) {
  .txnder-card__end-card {
    width: 100%;
  }
}
.txnder-card__end-card .btn {
  max-width: fit-content;
}
.txnder-card__end-card .icon {
  margin: 0 auto 20px auto;
  max-width: 70px;
  max-height: 70px;
}
.txnder-card__end-card .headline {
  font-weight: bold;
}
.txnder-card__end-card * {
  text-align: center;
}

.interaction-decision-tree-quiz__question__txnder-question-wrapper, .interaction-decision-tree-quiz__question__txnder-image-wrapper, .interaction-decision-tree-quiz__question__txnder-card {
  min-width: 325px;
  width: 325px;
  height: 380px;
  max-width: 325px;
  max-height: 60svh;
}

.interaction-decision-tree-quiz {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem 1.875rem;
  margin: 0;
  gap: 1.5rem;
  transition: background-color 0.2s ease;
  min-height: 100svh;
}
@media screen and (min-width: 576px) {
  .interaction-decision-tree-quiz {
    gap: 2rem;
  }
}
.interaction-decision-tree-quiz--bg-green {
  background-color: #b5d5c1;
}
.interaction-decision-tree-quiz--bg-blue {
  background-color: #ccebed;
}
.interaction-decision-tree-quiz--bg-yellow {
  background-color: #f8e89d;
}
.interaction-decision-tree-quiz--bg-orange {
  background-color: #f7dcbb;
}
.interaction-decision-tree-quiz--bg-violet {
  background-color: #e4d6e4;
}
.interaction-decision-tree-quiz__instruction,
.interaction-decision-tree-quiz__instruction p {
  margin: 0;
  text-align: center;
  color: #000;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  font-size: 1rem;
}
.interaction-decision-tree-quiz__raffle-instruction {
  text-align: center;
}
.interaction-decision-tree-quiz__questions {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.interaction-decision-tree-quiz__question {
  display: none;
  transition: display 0.2s ease, transform 0.2s ease;
  flex-direction: column;
  gap: 2rem;
}
@media screen and (min-width: 576px) {
  .interaction-decision-tree-quiz__question {
    gap: 2.5rem;
  }
}
.interaction-decision-tree-quiz__question--current {
  display: flex;
}
.interaction-decision-tree-quiz__question__buttons {
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 1rem;
}
.interaction-decision-tree-quiz__question__button {
  background: rgba(255, 255, 255, 0.7);
  border: 0;
  color: #545241;
  margin: 0;
  flex-grow: 1;
}
.interaction-decision-tree-quiz__question__button .btn-logo {
  margin: 0;
}
.interaction-decision-tree-quiz__question__button--desktop {
  display: none;
}
@media screen and (min-width: 992px) {
  .interaction-decision-tree-quiz__question__button--desktop {
    border-radius: 50%;
    position: absolute;
    top: 50%;
    width: 120px;
    min-width: 120px;
    height: 120px;
    z-index: 1;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
.interaction-decision-tree-quiz__question__button--desktop-left {
  left: 10vw;
  right: auto;
}
@media screen and (min-width: 1200px) {
  .interaction-decision-tree-quiz__question__button--desktop-left {
    left: 20vw;
  }
}
@media screen and (min-width: 1920px) {
  .interaction-decision-tree-quiz__question__button--desktop-left {
    left: 30vw;
  }
}
.interaction-decision-tree-quiz__question__button--desktop-left > .btn-logo--left {
  filter: brightness(0) saturate(100%) invert(31%) sepia(7%) saturate(1274%) hue-rotate(16deg) brightness(91%) contrast(84%);
}
.interaction-decision-tree-quiz__question__button--desktop-left:hover, .interaction-decision-tree-quiz__question__button--desktop-left:focus {
  background: rgba(255, 255, 255, 0.5);
  border: 0;
  color: #000;
  box-shadow: none;
  text-decoration: none;
}
.interaction-decision-tree-quiz__question__button--desktop-left:hover > .btn-logo--left, .interaction-decision-tree-quiz__question__button--desktop-left:focus > .btn-logo--left {
  filter: brightness(0) saturate(100%) invert(0%) sepia(100%) saturate(0%) hue-rotate(113deg) brightness(106%) contrast(106%);
}
.interaction-decision-tree-quiz__question__button--desktop-left:active {
  background: #fff;
  border: 0;
  color: #ff0000;
  box-shadow: none;
  text-decoration: none;
}
.interaction-decision-tree-quiz__question__button--desktop-left:active > .btn-logo--left {
  filter: brightness(0) saturate(100%) invert(27%) sepia(95%) saturate(7487%) hue-rotate(358deg) brightness(96%) contrast(118%);
}
.interaction-decision-tree-quiz__question__button--desktop-right {
  right: 10vw;
  left: auto;
  flex-direction: column-reverse;
}
@media screen and (min-width: 1200px) {
  .interaction-decision-tree-quiz__question__button--desktop-right {
    right: 20vw;
  }
}
@media screen and (min-width: 1920px) {
  .interaction-decision-tree-quiz__question__button--desktop-right {
    right: 30vw;
  }
}
.interaction-decision-tree-quiz__question__button--desktop-right > .btn-logo--right {
  filter: brightness(0) saturate(100%) invert(33%) sepia(99%) saturate(736%) hue-rotate(136deg) brightness(100%) contrast(104%);
}
.interaction-decision-tree-quiz__question__button--desktop-right:hover, .interaction-decision-tree-quiz__question__button--desktop-right:focus {
  background: rgba(255, 255, 255, 0.5);
  border: 0;
  color: #009284;
  box-shadow: none;
  text-decoration: none;
}
.interaction-decision-tree-quiz__question__button--desktop-right:active {
  background: #fff;
  border: 0;
  color: #009284;
  box-shadow: none;
  text-decoration: none;
}
.interaction-decision-tree-quiz__question__button--mobile {
  max-width: 50%;
  width: 50%;
  padding: 1rem;
}
@media screen and (min-width: 992px) {
  .interaction-decision-tree-quiz__question__button--mobile {
    display: none;
  }
}
.interaction-decision-tree-quiz__question__button--mobile-left {
  /*mobile breakpoint on desktop device*/
  /*mobile breakpoint on mobile device*/
}
.interaction-decision-tree-quiz__question__button--mobile-left > .btn-logo--left {
  filter: brightness(0) saturate(100%) invert(31%) sepia(7%) saturate(1274%) hue-rotate(16deg) brightness(91%) contrast(84%);
}
.interaction-decision-tree-quiz__question__button--mobile-left:hover, .interaction-decision-tree-quiz__question__button--mobile-left:focus {
  background: rgba(255, 255, 255, 0.5);
  border: 0;
  color: #000;
  box-shadow: none;
  text-decoration: none;
}
.interaction-decision-tree-quiz__question__button--mobile-left:hover > .btn-logo--left, .interaction-decision-tree-quiz__question__button--mobile-left:focus > .btn-logo--left {
  filter: brightness(0) saturate(100%) invert(0%) sepia(100%) saturate(0%) hue-rotate(113deg) brightness(106%) contrast(106%);
}
.interaction-decision-tree-quiz__question__button--mobile-left:focus, .interaction-decision-tree-quiz__question__button--mobile-left:active {
  background: #fff;
  border: 0;
  color: #ff0000;
  box-shadow: none;
  text-decoration: none;
}
.interaction-decision-tree-quiz__question__button--mobile-left:focus > .btn-logo--left, .interaction-decision-tree-quiz__question__button--mobile-left:active > .btn-logo--left {
  filter: brightness(0) saturate(100%) invert(27%) sepia(95%) saturate(7487%) hue-rotate(358deg) brightness(96%) contrast(118%);
}
.interaction-decision-tree-quiz__question__button--mobile-right {
  /*mobile breakpoint on desktop device*/
  /*mobile breakpoint on mobile device*/
}
.interaction-decision-tree-quiz__question__button--mobile-right > .btn-logo--right {
  filter: brightness(0) saturate(100%) invert(33%) sepia(99%) saturate(736%) hue-rotate(136deg) brightness(100%) contrast(104%);
}
.interaction-decision-tree-quiz__question__button--mobile-right:hover, .interaction-decision-tree-quiz__question__button--mobile-right:focus {
  background: rgba(255, 255, 255, 0.5);
  border: 0;
  color: #009284;
  box-shadow: none;
  text-decoration: none;
}
.interaction-decision-tree-quiz__question__button--mobile-right:focus, .interaction-decision-tree-quiz__question__button--mobile-right:active {
  background: #fff;
  border: 0;
  color: #009284;
  box-shadow: none;
  text-decoration: none;
}
.interaction-decision-tree-quiz__question__txnder-card {
  aspect-ratio: 3/4;
  overflow: hidden;
  position: relative;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.25);
  border-radius: 0.5rem;
}
.interaction-decision-tree-quiz__question__txnder-image-wrapper {
  position: relative;
  border-radius: 0.5rem;
  overflow: hidden;
  touch-action: none;
}
.interaction-decision-tree-quiz__question__txnder-image-element {
  pointer-events: none;
  object-fit: cover;
  object-position: center;
  height: 100%;
  width: 100%;
}
.interaction-decision-tree-quiz__question__txnder-question-wrapper {
  position: relative;
  border-radius: 0.5rem;
}
.interaction-decision-tree-quiz__question__txnder-question-element {
  position: absolute;
  bottom: 0;
  background-color: #fff;
  left: 0;
  right: 0;
  padding: 1.25rem 0.75rem;
  color: #000;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  margin: 0 1.5rem;
  border-radius: 0.25rem 0.25rem 0 0;
  hyphens: auto;
}

.interaction__pension {
  padding-bottom: 1px;
}
.interaction__pension .stages {
  margin: 1.25rem 0;
}
@media screen and (min-width: 576px) {
  .interaction__pension .stages {
    margin: 2.5rem 0;
  }
}
.interaction__pension .stages .step {
  border-radius: 6px;
  padding: 1.875rem 0;
}
.interaction__pension .stages .step .row {
  width: 90%;
  margin: 0 auto;
}
@media screen and (min-width: 768px) {
  .interaction__pension .stages .step .row {
    width: 100%;
  }
}
.interaction__pension .stages .step-1 img {
  width: 100%;
  max-width: 450px;
}
.interaction__pension .stages .step-1 label {
  display: inline-block;
  cursor: pointer;
  height: 44px;
  padding: 10px 40px;
  margin: 0 auto;
  font-size: 16px;
  line-height: 24px;
  word-break: keep-all;
  font-weight: 700;
  border-radius: 150px;
  text-align: center;
  color: #fff;
  background: #8e0038;
  transition: background-color 0.3s ease;
  width: 80%;
  max-width: 450px;
  margin-bottom: 20px;
}
@media screen and (min-width: 768px) {
  .interaction__pension .stages .step-1 label {
    width: 100%;
  }
}
.interaction__pension .stages .step-1 input[type=radio] {
  display: none;
}
.interaction__pension .stages .step-1 input[type=radio]:checked + label {
  background-color: #fff;
  border: 1px solid #8e0038;
}
.interaction__pension .stages .step-1 label[for=yes] {
  border: 2px solid #8e0038;
}
.interaction__pension .stages .step-1 label[for=yes]:hover, .interaction__pension .stages .step-1 label[for=yes]:focus {
  color: #8e0038;
  background: #fff;
}
.interaction__pension .stages .step-1 label[for=no] {
  background-color: #fff;
  color: #8e0038;
  border: 2px solid #8e0038;
}
.interaction__pension .stages .step-1 label[for=no]:hover, .interaction__pension .stages .step-1 label[for=no]:focus {
  color: #fff;
  background: #8e0038;
}
.interaction__pension .stages .step-2 img {
  width: 100%;
  max-width: 235px;
  height: 100%;
}
.interaction__pension .stages .step-2 .euro-wrapper {
  margin-top: 1.25rem;
}
.interaction__pension .stages h3 {
  color: #8e0038;
}
.interaction__pension .stages .step-3 {
  padding: 1.875rem 1.25rem;
}

.interaction__pension.bg-green form .step {
  background-color: #e3f0e6;
}
.interaction__pension.bg-orange form .step {
  background-color: #ffeede;
}
.interaction__pension.bg-blue form .step {
  background-color: #e2f6fa;
}
.interaction__pension.bg-violet form .step {
  background-color: #efe7ed;
}
.interaction__pension.bg-yellow form .step {
  background-color: #fff4b0;
}

.select-wrap {
  border-radius: 4px;
  width: 100%;
  max-width: 400px;
  position: relative;
  margin: 0 auto 20px auto;
}
.select-wrap label {
  color: #777;
  padding: 0 8px;
  position: absolute;
  top: 6px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
}
.select-wrap select {
  outline: none;
  border: none;
  border-bottom: rgba(51, 51, 51, 0.7) solid 2px;
  border-width: 1px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  height: 48px;
  font-size: 16px;
  width: 100%;
  padding: 20px 0px 0 4px;
  line-height: 30px;
  text-indent: 4px;
  background-color: #fff !important;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: url('data:image/svg+xml,<svg width="18" height="18" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.0239 21.1547L7.29012 8.96094H5.12012L14.6014 22.1997C14.9134 22.6825 15.449 22.974 16.0239 22.974C16.5987 22.974 17.1343 22.6825 17.4464 22.1997L26.9264 8.96094H24.7576L16.0239 21.1547Z" fill="black"/></svg>') no-repeat;
  background-position-x: 98%;
  background-position-y: 15px;
}
.select-wrap .error-message {
  color: #ff003e;
  font-size: 14px;
  display: block;
  text-align: left;
}

.euro-wrapper input {
  outline: none;
  border: none;
  border-bottom: rgba(51, 51, 51, 0.7) solid 2px;
  border-width: 1px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  height: 48px;
  font-size: 16px;
  width: 100%;
  padding: 20px 0px 0 4px;
  line-height: 30px;
  text-indent: 4px;
  background: #fff;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.euro-wrapper:after {
  content: "EUR";
  font-size: 16px;
  height: 60%;
  pointer-events: none;
  position: absolute;
  right: 26px;
  top: 29%;
  width: 15px;
}

.step-three-text {
  padding: 0 1.5rem;
}

.result-stage__table {
  position: relative;
}
.result-stage__table-text {
  padding: 0;
  text-align: center;
  border-radius: 8px;
  margin-top: -4.0625rem;
  background: transparent;
}
@media screen and (min-width: 1200px) {
  .result-stage__table-text {
    margin-top: 0;
  }
}
.result-stage__table-text .accordion {
  background-color: transparent;
  border-radius: 6px;
  width: 100%;
  margin: 0 auto;
  padding: 1.25rem 0.625rem;
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
}
@media screen and (min-width: 1200px) {
  .result-stage__table-text .accordion {
    padding: 1.25rem 3.75rem 50px;
    justify-content: space-around;
  }
}
.result-stage__table-text .accordion__main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 10px 10px;
  position: relative;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 16px 37px 1px rgba(0, 0, 0, 0.4);
}
@media screen and (min-width: 1200px) {
  .result-stage__table-text .accordion__main {
    margin: auto 0;
    padding: 1.875rem;
  }
}
.result-stage__table-text .accordion__main h3 {
  color: #8e0038;
}
.result-stage__table-text .accordion__main span {
  font-family: "FSMe", sans-serif;
  font-size: 35px;
  font-weight: 700;
  line-height: 45px;
  color: #8e0038;
}
.result-stage__table-text .accordion__main .line-preis {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 20%;
  text-align: center;
}
@media screen and (min-width: 1200px) {
  .result-stage__table-text .accordion__main .line-preis {
    background-color: transparent;
  }
}
.result-stage__table-text .accordion__main .disturber {
  position: absolute;
  top: 0;
  left: 100%;
  translate: -100% -80px;
  background-color: #8e0038;
  border-radius: 50%;
  height: 100px;
  width: 100px;
  aspect-ratio: 1/1;
}
.result-stage__table-text .accordion__main .disturber__text {
  color: #fff;
  font-size: 0.75rem;
  line-height: 0.975rem;
  font-weight: 700;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  translate: -50% -50%;
  rotate: -15deg;
  width: 100%;
}
.result-stage__table-text .accordion__main .disturber__text--rate {
  font-size: 0.875rem;
  line-height: 1.1375rem;
  color: #fff;
}
.result-stage__table-text .accordion__content {
  background-color: transparent;
  margin: auto;
  padding: 15px 0 30px;
}
@media screen and (min-width: 1200px) {
  .result-stage__table-text .accordion__content {
    margin: 1.875rem 0 0 -5rem;
    border-radius: 6px;
  }
}
.result-stage__table-text .accordion__content table {
  width: 100%;
  font-family: "FSMe", sans-serif;
  margin-bottom: 1rem;
}
.result-stage__table-text .accordion__content table thead th {
  text-align: center;
  padding: 10px 0;
  font-weight: 700;
}
.result-stage__table-text .accordion__content table td {
  width: 45%;
  text-align: right;
  font-size: 20px;
}
.result-stage__table-text .accordion__content table th {
  text-align: left;
  font-size: 14px;
  line-height: 20px;
  font-family: "FSMe", sans-serif;
  font-weight: 400;
}
.result-stage__table-text .accordion__content table tbody tr > * {
  padding: 10px 0;
}
.result-stage__table-text .accordion__content .read-more-link {
  padding: 8px;
}
.result-stage__table-text .accordion .btn-berechnen {
  transform: translateY(-170%);
}
.result-stage__table-text table td {
  padding-right: 10px !important;
}
@media screen and (min-width: 768px) {
  .result-stage__table-text table td {
    padding-right: 30px !important;
  }
}
.result-stage__table-image {
  padding: 0;
  aspect-ratio: 21/10;
}
@media screen and (min-width: 1200px) {
  .result-stage__table-image {
    aspect-ratio: unset;
  }
}
.result-stage__table-image img {
  object-fit: cover;
}
@media screen and (min-width: 768px) {
  .result-stage__table-sticky-btn {
    margin-top: 1.875rem;
  }
}
.result-stage__table .result-data-day {
  color: #8e0038;
  line-height: 1.4;
}
@media screen and (min-width: 992px) {
  .result-stage__table .result-data-day {
    margin-top: 1.875rem;
  }
}
.result-stage__table .result-data-disclaimer {
  font-size: 12px;
  margin-top: 8px;
  text-align: center;
}

.rotate {
  transform: rotate(180deg);
}

.result-stage__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 3rem;
}
.result-stage__headline {
  margin-bottom: 1.5rem;
}
.result-stage__text {
  margin-bottom: 2rem;
}
.result-stage__image {
  padding: 3rem;
}
.result-stage__image img {
  object-fit: contain;
  margin: 0 auto;
  max-width: 500px;
}
@media screen and (min-width: 768px) {
  .result-stage__image img {
    margin: 0 0 0 auto;
  }
}
@media screen and (min-width: 768px) {
  .result-stage .btn {
    margin-left: 0;
  }
}

.content-videovisual__thumbnail {
  position: relative;
}
@media screen and (min-width: 576px) {
  .content-videovisual__thumbnail {
    padding-right: 1.625rem;
    padding-left: 1.625rem;
  }
}
@media screen and (min-width: 768px) {
  .content-videovisual__thumbnail {
    padding-right: calc(var(--bs-gutter-x) * 0.5);
    padding-left: calc(var(--bs-gutter-x) * 0.5);
  }
}
.content-videovisual__thumbnail-img {
  height: 220px;
  margin: 0 -26px;
  cursor: pointer;
  overflow: hidden;
}
@media screen and (min-width: 576px) {
  .content-videovisual__thumbnail-img {
    height: 300px;
    margin: 0;
    border-radius: 8px;
  }
}
@media screen and (min-width: 768px) {
  .content-videovisual__thumbnail-img {
    height: 340px;
  }
}
@media screen and (min-width: 1200px) {
  .content-videovisual__thumbnail-img {
    height: 400px;
  }
}
.content-videovisual__thumbnail-img img {
  object-fit: cover;
  transition: transform 1s;
  transform: scale(1);
}
.content-videovisual__thumbnail-img img:hover, .content-videovisual__thumbnail-img img:focus {
  transform: scale(1.1);
  transform-origin: 50% 50%;
}
.content-videovisual__thumbnail-link {
  width: -moz-fit-content;
  width: fit-content;
  display: block;
  cursor: pointer;
  margin: 0.625rem 0 0 1.625rem;
}
@media screen and (min-width: 576px) {
  .content-videovisual__thumbnail-link {
    margin-left: 0;
  }
}
.content-videovisual__thumbnail-btn {
  position: absolute;
  right: 30px;
  bottom: 0;
  cursor: pointer;
}
@media screen and (min-width: 576px) {
  .content-videovisual__thumbnail-btn {
    right: 25px;
  }
}
@media screen and (min-width: 992px) {
  .content-videovisual__thumbnail-btn {
    bottom: 0px;
    right: 15px;
  }
}
.content-videovisual__thumbnail-btn svg path {
  transition: fill 0.5s ease;
}
.content-videovisual__thumbnail-btn:focus svg > path:nth-of-type(1), .content-videovisual__thumbnail-btn:hover svg > path:nth-of-type(1) {
  fill: #8e0038;
}
.content-videovisual__text {
  display: flex;
  align-items: center;
}
@media screen and (min-width: 576px) {
  .content-videovisual__text {
    padding-right: 1.625rem;
    padding-left: 1.625rem;
  }
}
.content-videovisual__text .content-text__wrapper {
  padding: 1.25rem 1.625rem;
}
@media screen and (min-width: 576px) {
  .content-videovisual__text .content-text__wrapper {
    padding: 1.25rem 0;
  }
}
.content-videovisual__text .content-text__wrapper button {
  margin: 0;
}

.content-list-icon__wrapper {
  padding: 1.875rem;
}
@media screen and (min-width: 992px) {
  .content-list-icon__wrapper {
    padding: 3.125rem;
  }
}
.content-list-icon__wrapper-flex {
  display: flex;
  flex-direction: column;
}
@media screen and (min-width: 992px) {
  .content-list-icon__wrapper-flex {
    flex-direction: row;
    gap: 1.875rem;
  }
}
.content-list-icon__wrapper-flex .content-list-icon {
  flex: 1 1 0;
  flex-direction: column;
  gap: 0;
}
.content-list-icon__wrapper-flex .content-list-icon__img img {
  border-radius: 8px;
}
.content-list-icon__wrapper-flex .content-list-icon__text--left {
  text-align: left;
}
.content-list-icon__wrapper-flex .content-list-icon__text--center {
  text-align: center;
}
.content-list-icon__wrapper-flex .content-list-icon__text--right {
  text-align: right;
}
.content-list-icon__wrapper-headline {
  margin-bottom: 1.875rem;
}
@media screen and (min-width: 1200px) {
  .content-list-icon__wrapper-headline {
    text-align: center;
  }
}

.content-list__wrapper {
  padding: 1.875rem 1.625rem;
  position: relative;
}
.content-list__wrapper .content-list ul,
.content-list__wrapper .content-list ol {
  display: grid;
  gap: 1.25rem;
}
.content-list__wrapper .content-list ul li p:last-child,
.content-list__wrapper .content-list ol li p:last-child {
  margin-bottom: 0;
}
@media screen and (min-width: 992px) {
  .content-list__wrapper .content-list ul,
  .content-list__wrapper .content-list ol {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (min-width: 992px) {
  .content-list__wrapper .content-list ul li,
  .content-list__wrapper .content-list ol li {
    width: 50%;
  }
}
.content-list__wrapper .content-list__items {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1rem;
}
@media screen and (min-width: 768px) {
  .content-list__wrapper .content-list__items {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (min-width: 992px) {
  .content-list__wrapper .content-list__items {
    max-width: 1200px;
    margin: 0 auto;
  }
}
@media screen and (min-width: 768px) {
  .content-list__wrapper .content-list__items--singleCol {
    grid-template-columns: repeat(1, 1fr);
  }
}
.content-list__wrapper .content-list__items button {
  margin-top: 1rem;
  grid-column: 1/-1;
}
.content-list__wrapper .content-list__items .content-list {
  grid-column: 1/-1;
  margin-bottom: 0.5rem;
}
.content-list__wrapper .content-list__items .content-list li {
  width: 100%;
}
.content-list__wrapper .content-list-icon {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin: 0;
}
.content-list__wrapper .content-list-icon__icon {
  min-width: 32px;
  width: 32px;
  max-width: 32px;
  min-height: 32px;
  height: 32px;
  max-height: 32px;
  padding: 0;
  margin: 0;
}
.content-list__wrapper .content-list__headline {
  margin-bottom: 20px;
}
@media screen and (min-width: 992px) {
  .content-list__wrapper .content-list__headline {
    text-align: center;
  }
}
.content-list__wrapper .content-list__headline-icon {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #fff;
  width: 70px;
  height: 70px;
  margin: 0px auto 30px auto;
}
.content-list__wrapper .content-list__headline-icon img {
  width: 48px;
  height: 48px;
}
.content-list__wrapper .content-list__disturber {
  height: 6.25rem;
  position: absolute;
  right: 1.5rem;
  top: -4.5rem;
  width: 6.25rem;
}
@media screen and (min-width: 576px) {
  .content-list__wrapper .content-list__disturber {
    right: 1.25rem;
    top: -1.5rem;
  }
}
@media screen and (min-width: 768px) {
  .content-list__wrapper .content-list__disturber {
    right: 3rem;
    top: -2.5rem;
  }
}
@media screen and (min-width: 992px) {
  .content-list__wrapper .content-list__disturber {
    height: 7.5rem;
    width: 7.5rem;
    right: 5rem;
    top: -2.5rem;
  }
}
@media screen and (min-width: 1200px) {
  .content-list__wrapper .content-list__disturber {
    right: 7.5rem;
    top: -2.5rem;
  }
}

.content-carousel {
  position: relative;
  height: 100%;
  max-height: 650px;
  max-width: calc(100svw - 60px);
  flex-wrap: nowrap;
  margin-bottom: 7rem;
  margin-left: auto;
  margin-right: auto;
}
@media screen and (min-width: 576px) {
  .content-carousel {
    max-width: calc(100svw - 120px);
  }
}
@media screen and (min-width: 768px) {
  .content-carousel {
    max-width: calc(100svw - 160px);
    height: 580px;
  }
}
@media screen and (min-width: 992px) {
  .content-carousel {
    max-width: calc(100svw - 200px);
    height: 400px;
  }
}
@media screen and (min-width: 1200px) {
  .content-carousel {
    width: 1110px;
    height: 400px;
  }
}
.content-carousel--visual {
  height: 580px;
}
@media screen and (min-width: 576px) {
  .content-carousel--visual {
    height: 500px;
    width: 420px;
  }
}
@media screen and (min-width: 768px) {
  .content-carousel--visual {
    width: 570px;
  }
}
@media screen and (min-width: 992px) {
  .content-carousel--visual {
    width: 920px;
  }
}
.content-carousel__control-buttons {
  position: absolute;
  bottom: 53%;
  z-index: 1;
}
.content-carousel__control-button {
  position: absolute;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.content-carousel__control-button:before {
  content: "";
  display: block;
  position: absolute;
  height: 400px;
  width: 200px;
  translate: -50% -50%;
}
.content-carousel__control-button:after {
  content: "";
  background-color: rgba(252, 252, 252, 0.38);
  width: 40px;
  height: 40px;
  margin-left: -0.4rem;
  margin-top: -0.4rem;
  border-radius: 50%;
  display: none;
}
.content-carousel__control-button--prev {
  background-image: url("../../svgs/pfeil_links.svg");
  left: -7%;
}
@media screen and (min-width: 992px) {
  .content-carousel__control-button--prev {
    left: -9%;
  }
}
.content-carousel__control-button--next {
  background-image: url("../../svgs/pfeil_rechts.svg");
  right: -7%;
}
@media screen and (min-width: 992px) {
  .content-carousel__control-button--next {
    right: -9%;
  }
}
.content-carousel__control-button--next:before {
  left: 100%;
}
.content-carousel__control-pagination {
  position: absolute;
  bottom: -2rem;
  display: flex;
  justify-content: center;
}
.content-carousel__control-pagination-indicator {
  background-color: #bbb9ad;
  border: none;
  border-radius: 50%;
  width: 0.5rem;
  height: 0.5rem;
  margin: 0 0.75rem;
  padding: 0;
  cursor: pointer;
}
.content-carousel__control-pagination-indicator.active {
  background-color: #8e0038;
}
.content-carousel__control-button:hover::after {
  display: block;
  transform: translateY(-1000%);
}
.content-carousel__pagination-indicator.active {
  background-color: #8e0038;
}

.cc_dialog.interstitial .cc_b_ok, .cc_dialog.interstitial .cc_cp_f_save {
  background: #8e0038 !important;
}

.cc_dialog.interstitial .cc_b_ok:hover, .cc_dialog.interstitial .cc_cp_f_save:hover {
  background: #71022e !important;
}

.cc_dialog.interstitial .cc_b_cp {
  border-color: #8e0038 !important;
  color: #8e0038 !important;
}

.cc_dialog.interstitial a:not([class]) {
  color: #8e0038 !important;
  font-weight: bold;
  text-decoration: underline;
}

.cookie-consent-preferences-overlay .cookie-consent-preferences-dialog a:not([class]) {
  color: #8e0038 !important;
  font-weight: bold;
  text-decoration: underline;
}

.cookie-consent-preferences-overlay .cookie-consent-preferences-dialog .cc_cp_f_save button {
  background: #8e0038 !important;
}

.cookie-consent-preferences-overlay .cookie-consent-preferences-dialog .cc_cp_f_save button:hover {
  background: #71022e !important;
}

.cookie-consent-preferences-overlay .cookie-consent-preferences-dialog .cc_cp_f_save button.secondary {
  background: none !important;
  border: 2px solid #8e0038;
  color: #8e0038 !important;
}

.cookie-consent-preferences-overlay .cookie-consent-preferences-dialog .cc_cp_head_title h2 {
  color: #8e0038 !important;
}

.cookie-consent-preferences-overlay .cookie-consent-preferences-dialog .cc_cp_head_title::before {
  background: url("../img/ergo.svg") no-repeat;
  background-size: contain;
  content: "";
  height: 28px;
  margin-right: 20px;
  margin-top: -7px;
  width: 100px;
}

.cookie-consent-preferences-overlay .cookie-consent-preferences-dialog .cc_cp_m_menu {
  background-color: #efe7ed !important;
}

.cookie-consent-preferences-overlay .cookie-consent-preferences-dialog .cc_cp_m_menu li {
  background: none !important;
  border-bottom: 1px solid #fff !important;
}

.cookie-consent-preferences-overlay .cookie-consent-preferences-dialog .cc_cp_m_menu li[active=true] {
  background: #fff !important;
}

.cookie-consent-preferences-overlay .cookie-consent-preferences-dialog .cc_cp_m_menu li[active=true] a {
  border-left-color: #8e0038 !important;
}

/* ####################### cookie notice ####################### */
.cc_overlay_lock {
  background: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(5px);
  box-shadow: 0 0 50px rgba(0, 0, 0, 0.075);
  height: auto !important;
  z-index: 999 !important;
}

.cc_overlay_lock.hidden {
  display: none !important;
}

.cc_overlay_lock .cc_dialog.interstitial {
  background: none !important;
  left: 0 !important;
  margin: auto;
  max-width: 1158px !important;
  padding: 1.5rem !important;
  position: static !important;
  right: 0 !important;
  top: 0 !important;
}

@media (max-width: 767px) {
  .cc_overlay_lock .cc_dialog.interstitial {
    max-width: 90% !important;
    padding: 1.9rem;
  }
}
@media (max-width: 575px) {
  .cc_overlay_lock .cc_dialog.interstitial .cc_dialog_headline {
    font-size: 18px !important;
  }
  .cc_overlay_lock .cc_dialog.interstitial .cc_dialog_text {
    font-size: 14px !important;
  }
}
@media (max-width: 321px) {
  .cc_overlay_lock .cc_dialog.interstitial {
    padding: 1.5rem;
  }
}
.cc_overlay_lock .cc_dialog.interstitial button, .cc_overlay_lock .cc_dialog.interstitial p, .cc_overlay_lock .cc_dialog.interstitial h1 {
  font-family: "FSMe";
}

@media (max-width: 991px) {
  .cc_overlay_lock .cc_dialog.interstitial button {
    font-size: 18px !important;
  }
}
@media (max-width: 767px) {
  .cc_overlay_lock .cc_dialog.interstitial button {
    font-size: 16px !important;
    padding: 0 20px !important;
  }
}
@media (max-width: 321px) {
  .cc_overlay_lock .cc_dialog.interstitial button {
    font-size: 14px !important;
    padding: 0 5px !important;
  }
}
.cc_overlay_lock .cc_dialog.interstitial .cc_dialog_text {
  margin-bottom: 25px;
}

.cc_overlay_lock .cc_dialog.interstitial .cc_dialog_headline ~ div:last-child {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
}

@media (max-width: 575px) {
  .cc_overlay_lock .cc_dialog.interstitial .cc_dialog_headline ~ div:last-child {
    flex-direction: column-reverse;
  }
}
.cc_overlay_lock .cc_dialog.interstitial .cc_b_ok {
  border-radius: 25px;
  font-weight: bold;
  font-size: 20px;
  height: 54px;
  margin-left: 30px;
  padding: 12px 40px;
}

@media (max-width: 767px) {
  .cc_overlay_lock .cc_dialog.interstitial .cc_b_ok {
    margin-left: 15px;
  }
}
@media (max-width: 575px) {
  .cc_overlay_lock .cc_dialog.interstitial .cc_b_ok {
    margin: 15px 0 0 0;
  }
}
.cc_overlay_lock .cc_dialog.interstitial .cc_b_cp {
  background: none !important;
  border-radius: 25px;
  border: 2px solid #000;
  font-weight: bold;
  font-size: 20px;
  height: 54px;
  padding: 11px 40px;
  margin-left: 0 !important;
}

@media (max-height: 699px) {
  .cookie-consent-preferences-overlay {
    overflow-y: scroll;
  }
}
.cookie-consent-preferences-overlay.visible {
  display: block;
}

@media (min-height: 700px) and (min-width: 992px) {
  .cookie-consent-preferences-overlay.visible {
    align-items: center;
    display: flex;
  }
}
.cookie-consent-preferences-overlay:not(.visible) {
  display: none !important;
}

.cookie-consent-preferences-overlay .cookie-consent-preferences-dialog {
  max-width: 720px !important;
}

@media (min-height: 640px) and (min-width: 992px) {
  .cookie-consent-preferences-overlay .cookie-consent-preferences-dialog {
    position: relative !important;
  }
}
@media (max-width: 767px) {
  .cookie-consent-preferences-overlay .cookie-consent-preferences-dialog {
    max-width: 90% !important;
  }
}
@media (max-width: 575px) {
  .cookie-consent-preferences-overlay .cookie-consent-preferences-dialog .cc_cp_content .cc_cp_m_content h1 {
    font-size: 18px !important;
  }
}
.cookie-consent-preferences-overlay .cookie-consent-preferences-dialog button, .cookie-consent-preferences-overlay .cookie-consent-preferences-dialog p, .cookie-consent-preferences-overlay .cookie-consent-preferences-dialog h1 {
  font-family: "FSMe";
}

.cookie-consent-preferences-overlay .cookie-consent-preferences-dialog .cc_cp_f_save button {
  border-radius: 25px;
  font-weight: bold;
  font-size: 20px !important;
  height: 54px !important;
  margin-left: 30px;
  opacity: 1 !important;
  padding: 12px 40px;
}

.cookie-consent-preferences-overlay .cookie-consent-preferences-dialog .cc_cp_f_save button.secondary {
  background: none !important;
  border: 2px solid #000;
  margin-right: 0 !important;
  padding: 10px 40px;
}

@media (max-width: 767px) {
  .cookie-consent-preferences-overlay .cookie-consent-preferences-dialog .cc_cp_f_save button.secondary {
    padding: 10px 20px !important;
  }
}
@media (max-width: 600px) {
  .cookie-consent-preferences-overlay .cookie-consent-preferences-dialog .cc_cp_f_save button.secondary {
    margin-bottom: 15px !important;
  }
}
@media (max-width: 991px) {
  .cookie-consent-preferences-overlay .cookie-consent-preferences-dialog .cc_cp_f_save button {
    font-size: 18px !important;
  }
}
@media (max-width: 767px) {
  .cookie-consent-preferences-overlay .cookie-consent-preferences-dialog .cc_cp_f_save button {
    font-size: 16px !important;
    padding: 12px 20px !important;
  }
}
@media (max-width: 321px) {
  .cookie-consent-preferences-overlay .cookie-consent-preferences-dialog .cc_cp_f_save button {
    font-size: 14px;
  }
}
.cookie-consent-preferences-overlay .cc_cp_f_powered_by, .cookie-consent-preferences-overlay .cc_cp_head_lang_selector, .cookie-consent-preferences-overlay [t=content_functionality], .cookie-consent-preferences-overlay [t=content_targeting] {
  display: none !important;
}

.cookie-consent-preferences-overlay .cc_cp_footer {
  background: none !important;
  border: none !important;
  justify-content: flex-end !important;
  padding: 2rem;
}

@media (max-width: 600px) {
  .cookie-consent-preferences-overlay .cc_cp_footer {
    padding: 0 1.5rem 1.5rem;
  }
  .cookie-consent-preferences-overlay .cc_cp_footer .cc_cp_f_save {
    width: 100%;
  }
  .cookie-consent-preferences-overlay .cc_cp_footer .cc_cp_f_save button {
    margin: 0 !important;
    width: 100%;
  }
}
.cookie-consent-preferences-overlay .cc_cp_content, .cookie-consent-preferences-overlay .cc_cp_m_content {
  background: none !important;
  border: none !important;
}

.cookie-consent-preferences-overlay .cc_cp_content p, .cookie-consent-preferences-overlay .cc_cp_m_content p {
  font-size: 14px !important;
}

@media (min-width: 601px) {
  .cookie-consent-preferences-overlay .cc_cp_m_content {
    width: calc(100% - 240px);
  }
}
.cookie-consent-preferences-overlay .cc_cp_m_content .cc_cp_m_content_entry[active=true] {
  display: flex !important;
  flex-direction: column;
}

.cookie-consent-preferences-overlay .cc_cp_m_content .cc_cp_m_content_entry[active=true] h1 {
  order: -2;
}

.cookie-consent-preferences-overlay .cc_cp_m_content .cc_cp_m_content_entry[active=true] div:not([class]) {
  order: -1;
}

.cookie-consent-preferences-overlay .cc_cp_m_menu {
  min-width: 220px !important;
}

@media (min-width: 601px) {
  .cookie-consent-preferences-overlay .cc_cp_m_menu {
    width: 220px !important;
  }
}
.cookie-consent-preferences-overlay .cc_cp_m_menu li {
  border-right: 0 !important;
}

.cookie-consent-preferences-overlay .cc_cp_m_menu li a {
  border-left: 5px solid transparent;
  color: #000 !important;
  font-family: "FSMe";
  font-size: 15px !important;
  padding: 15px !important;
}

@media (max-width: 600px) {
  .cookie-consent-preferences-overlay .cc_cp_m_menu li a {
    padding: 10px 15px !important;
  }
}
.cookie-consent-preferences-overlay .cc_cp_head_title {
  align-items: center !important;
  flex-direction: row !important;
  padding: 2rem 0 1.5rem 1rem !important;
  width: 100%;
}

@media (max-width: 600px) {
  .cookie-consent-preferences-overlay .cc_cp_head_title {
    padding: 15px 15px 10px 20px !important;
  }
}
.cookie-consent-preferences-overlay .cc_cp_head_title h2 {
  font-family: "FedraSerifA";
  font-size: 25px !important;
  padding-right: 3rem;
}

@media (max-width: 767px) {
  .cookie-consent-preferences-overlay .cc_cp_head_title h2 {
    font-size: 23px !important;
    padding-right: 5rem;
  }
}
@media (max-width: 600px) {
  .cookie-consent-preferences-overlay .cc_cp_head_title h2 {
    font-size: 16px !important;
  }
}
.cookie-consent-preferences-overlay .cc_cp_head_title h2::after {
  background: url("../img/close-black.svg") no-repeat;
  background-size: contain;
  content: "";
  cursor: pointer;
  display: inline-block;
  height: 28px;
  position: absolute;
  right: 2rem;
  top: 2rem;
  width: 28px;
}

@media (max-width: 600px) {
  .cookie-consent-preferences-overlay .cc_cp_head_title h2::after {
    right: 1rem;
    top: 1rem;
  }
}
.cookie-consent-preferences-overlay .cc_cp_head_title h2::after:hover {
  opacity: 0.7;
}

.cookie-details {
  cursor: pointer;
  display: flex !important;
  flex-wrap: wrap;
  position: relative;
}

.cookie-details strong:first-child {
  padding-right: 20px;
  pointer-events: none;
  width: 100%;
}

.cookie-details > aside {
  display: none;
  width: 100%;
}

.cookie-details > aside span {
  display: block;
  margin-right: 10px;
}

.cookie-details > aside span em {
  font-style: normal;
  margin-right: 3px;
  opacity: 0.6;
}

.cookie-details::after {
  content: "+";
  font-size: 25px;
  font-weight: bold;
  line-height: 1;
  position: absolute;
  right: 0;
  top: 0;
}

.cookie-details.active::after {
  content: "-";
  right: 4px;
}

.cookie-details + .cookie-details {
  border-top: 1px solid #ddd;
  margin-top: 8px;
  padding-top: 4px;
}

#openCookieSettings {
  cursor: pointer;
}

.result-stage__overview {
  position: relative;
}
.result-stage__overview .disturber {
  position: absolute;
  width: auto;
  height: auto;
  top: 120px;
  right: 5%;
}
.result-stage__overview .disturber img {
  max-height: 120px;
  width: auto;
}
@media screen and (min-width: 768px) {
  .result-stage__overview .disturber {
    top: -80px;
  }
}
.result-stage__overview-image {
  padding: 0;
  max-height: 220px;
}
.result-stage__overview-image img {
  object-fit: cover;
}
.result-stage__overview-text {
  padding: 1.875rem 1.625rem;
}
@media screen and (min-width: 576px) {
  .result-stage__overview-text {
    padding: 1.875rem;
  }
}
@media screen and (min-width: 768px) {
  .result-stage__overview-text {
    padding: 3.75rem;
  }
}
@media screen and (min-width: 992px) {
  .result-stage__overview-text {
    padding: 3.75rem 2.5rem;
  }
}
@media screen and (min-width: 1200px) {
  .result-stage__overview-text {
    padding: 5rem 3.75rem;
  }
}
@media screen and (min-width: 576px) {
  .result-stage__overview-text-wrapper.no-image .result-stage__overview-text {
    padding: 1.875rem 1.875rem 0 1.875rem;
  }
}
@media screen and (min-width: 768px) {
  .result-stage__overview-text-wrapper.no-image .result-stage__overview-text {
    padding: 1.875rem 3.75rem 0 3.75rem;
  }
}
@media screen and (min-width: 992px) {
  .result-stage__overview-text-wrapper.no-image .result-stage__overview-text {
    padding: 1.875rem 2.5 0 2.5rem;
  }
}
@media screen and (min-width: 1200px) {
  .result-stage__overview-text-wrapper.no-image .result-stage__overview-text {
    padding: 1.875rem 3.75rem 0 3.75rem;
  }
}
@media screen and (min-width: 1200px) {
  .result-stage__overview-wrapper-items {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 1.5rem;
  }
}
.result-stage__overview-wrapper-items a {
  grid-column: span 3;
}
.result-stage__overview-wrapper--tablet {
  background-color: #fdfdfd;
}
.result-stage__overview-item {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  overflow: hidden;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  margin-bottom: 20px;
  padding: 0;
  border-radius: 6px;
}
@media screen and (min-width: 992px) {
  .result-stage__overview-item-wrapper {
    display: flex;
    column-gap: 20px;
  }
}
.result-stage__overview-item_image {
  width: 60px;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}
.result-stage__overview-item_image img {
  width: 40px;
  height: 40px;
}
.result-stage__overview-item_text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2rem 1rem;
  width: 100%;
}
.result-stage__overview-item_text p {
  margin-bottom: 0;
}
.result-stage__overview-item svg {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
.result-stage__overview-item svg path {
  fill: #000;
}
.result-stage__overview .detail-modal__table {
  position: relative;
}
.result-stage__overview .detail-modal__table--KT {
  width: 100%;
}
.result-stage__overview .detail-modal__table--KT tr:last-child > * {
  padding-top: 30px;
}
.result-stage__overview .detail-modal__table--BU {
  width: 100%;
}
.result-stage__overview .detail-modal__table--BU tr:last-child > * {
  padding-top: 30px;
}
.result-stage__overview .detail-modal__table--unfall {
  width: 100%;
}
.result-stage__overview .detail-modal__table-line {
  position: absolute;
  bottom: 25%;
  left: 20%;
}
@media screen and (min-width: 576px) {
  .result-stage__overview .detail-modal__table-line {
    left: 33%;
  }
}
@media screen and (min-width: 768px) {
  .result-stage__overview .detail-modal__table-line {
    left: 37%;
  }
}
@media screen and (min-width: 1200px) {
  .result-stage__overview .detail-modal__table-line {
    left: 40%;
  }
}
.result-stage__overview + .btn {
  margin: 3rem auto;
}

.coupon {
  margin: auto;
  max-width: 1000px;
  padding: 1.875rem 1.625rem;
}
@media screen and (min-width: 768px) {
  .coupon {
    padding: 1.875rem;
  }
}
@media screen and (min-width: 992px) {
  .coupon {
    padding: 3.125rem 1.875rem;
  }
}
.coupon__form {
  position: relative;
  text-align: left;
  justify-content: center;
}
.coupon__form-headline {
  font-weight: bold;
}
.coupon__form-img-wrapper {
  display: flex;
  justify-content: flex-start;
  position: relative;
}
.coupon__form-img-wrapper .disturber {
  position: absolute;
  right: 0;
  top: -15px;
}
.coupon__form-img {
  max-width: 520px;
  max-height: 300px;
  min-width: 128px;
  width: auto;
  margin: auto;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  object-fit: cover;
}
.coupon__form-text {
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 1.25rem;
}
@media screen and (min-width: 992px) {
  .coupon__form-text {
    margin-top: 0;
  }
}
.coupon__form-text .content-list-icon--aligned-left {
  align-items: center;
}
.coupon__form-text .content-list-icon__icon {
  height: 48px;
  width: 48px;
  min-width: 48px;
}
.coupon__form-text .c2, .coupon__form-text .coupon__form-checkbox .notice-container div.c2 p, .coupon__form-checkbox .notice-container div.c2 .coupon__form-text p, .coupon__form-text .coupon__form-checkbox .notice-container .content-text__wrapper div.magic-text p, .coupon__form-checkbox .notice-container .content-text__wrapper div.magic-text .coupon__form-text p, .coupon__form-text .content-text__wrapper .coupon__form-checkbox .notice-container div.magic-text p, .content-text__wrapper .coupon__form-checkbox .notice-container div.magic-text .coupon__form-text p, .coupon__form-text .content-text__wrapper .magic-text, .content-text__wrapper .coupon__form-text .magic-text, .coupon__form-text .contact-appointment .notice p, .contact-appointment .notice .coupon__form-text p {
  font-weight: bold;
}
.coupon__form-email input[type=email] {
  width: 100%;
  padding: 1rem 0.625rem;
  border-radius: 5px 5px 0 0;
  margin-bottom: 1.625rem;
  border: none;
  border-bottom: 2px solid gray;
}
.coupon__form-email .notice {
  text-align: left;
}
.coupon__form-checkbox {
  margin-top: 1.25rem;
}
@media screen and (min-width: 992px) {
  .coupon__form-checkbox {
    margin-top: 1.875rem;
  }
}
.coupon__form-checkbox .d-flex {
  justify-content: center;
}
.coupon__form-checkbox label {
  margin-left: 5px;
}
.coupon__form-checkbox .notice-container {
  text-align: left;
  margin-left: 0.5rem;
  margin-bottom: 2rem;
}
.coupon__form-checkbox .notice-container div.c2 p a, .coupon__form-checkbox .notice-container .content-text__wrapper div.magic-text p a, .content-text__wrapper .coupon__form-checkbox .notice-container div.magic-text p a {
  color: #8e0038;
  font-weight: bold;
}
.coupon__form .error {
  color: #ff003e;
  font-size: 10px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0px;
}
.coupon__footnote {
  text-align: left;
  padding: 0;
}
.coupon__email {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}
.coupon__email-disturber {
  margin: 0 auto;
  width: 120px;
  height: 120px;
}
.coupon__success {
  display: flex;
  flex-direction: column;
}
.coupon__success-img {
  margin: 0 auto;
  width: 6.25rem;
}

.verlosung .coupon {
  margin: 0;
  max-width: unset;
}
@media screen and (min-width: 992px) {
  .verlosung .coupon__form {
    width: 70%;
    margin: auto;
  }
}
.verlosung .coupon .read-more-link {
  margin-top: 2.6563rem;
}

.file-request-multiple {
  padding: 30px 26px;
}
@media screen and (min-width: 992px) {
  .file-request-multiple {
    padding: 50px 0 50px;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }
  .file-request-multiple__intro, .file-request-multiple__form {
    grid-column: 2/12;
  }
}
.file-request-multiple.bg-green .file-request-multiple__stepCounter {
  background-color: #fff;
  color: #8e0038;
}
.file-request-multiple.bg-white .file-request-multiple__stepCounter {
  background-color: #009284;
  color: #fff;
}
.file-request-multiple__intro {
  margin-bottom: 30px;
}
.file-request-multiple__form {
  text-align: start;
}
.file-request-multiple .error {
  color: #ff003e;
  font-size: 10px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0px;
}
.file-request-multiple__step {
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin: 30px 0;
  --icon-size: 4rem;
  --icon-gap: 30px;
}
.file-request-multiple__step--second {
  gap: 20px;
}
.file-request-multiple__stepHeading {
  display: flex;
  flex-direction: column;
  gap: var(--icon-gap);
}
@media screen and (min-width: 992px) {
  .file-request-multiple__stepHeading {
    flex-direction: row;
    align-items: center;
  }
}
.file-request-multiple__stepHeadline {
  margin-bottom: 0;
  font-weight: 700;
}
.file-request-multiple__stepCounter {
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--icon-size);
  height: var(--icon-size);
  aspect-ratio: 1/1;
  border-radius: 50%;
  font-size: 2.125rem;
  margin: 0 auto;
}
@media screen and (min-width: 992px) {
  .file-request-multiple__stepCounter {
    margin: 0;
  }
}
@media screen and (min-width: 992px) {
  .file-request-multiple__control {
    margin-left: calc(var(--icon-size) + var(--icon-gap));
  }
}
@media screen and (min-width: 992px) {
  .file-request-multiple__selectAll {
    margin: 0;
  }
}
.file-request-multiple__check {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: baseline;
  gap: 10px;
}
.file-request-multiple__check input {
  height: 24px;
  width: 24px;
  visibility: visible;
  position: relative;
  z-index: 1;
  opacity: 0;
}
.file-request-multiple__check label {
  text-align: start;
  margin-bottom: 0;
}
.file-request-multiple__check label p {
  margin-bottom: 0;
}
.file-request-multiple__input input {
  width: 100%;
}

.result-diagram .btn {
  max-width: none;
}
@media screen and (min-width: 992px) {
  .result-diagram .btn {
    width: fit-content;
  }
}
.result-diagram .result-stage__text.lead {
  margin-bottom: 0;
}
@media screen and (min-width: 992px) {
  .result-diagram .result-stage__text.lead {
    margin-bottom: 2rem;
  }
}
.result-diagram .result-stage__text.lead p {
  margin-bottom: 0;
}
.result-diagram .result-stage__headline {
  margin-bottom: 1rem;
}
.result-diagram .result-stage__headline h2,
.result-diagram .result-stage__headline h3 {
  margin-bottom: 0;
}

.donut-chart {
  position: relative;
  width: 100%;
  max-width: 450px;
  height: auto;
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}
@media screen and (min-width: 576px) {
  .donut-chart {
    width: 70%;
  }
}
@media screen and (min-width: 768px) {
  .donut-chart {
    width: 100%;
  }
}
.donut-chart-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 65px;
  position: relative;
}
@media screen and (min-width: 576px) {
  .donut-chart-container {
    padding: 45px;
  }
}
.donut-default {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #a9dae0;
}
.donut-white {
  position: absolute;
  width: 35%;
  height: 35%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #e2f6fa;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  border: 4px solid #fff;
}
.donut-white svg {
  height: 49px;
}
@media screen and (min-width: 576px) {
  .donut-white svg {
    height: 70px;
  }
}
.donut-line {
  position: absolute;
  width: 100%;
  height: 100%;
}
.donut-line::before, .donut-line::after {
  content: "";
  position: absolute;
  background: #fff;
  z-index: 1;
}
.donut-line::before {
  width: 4px;
  height: 100%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}
.donut-line::after {
  width: 100%;
  height: 4px;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
.donut-segment {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.donut-case {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
}
.donut-icon {
  position: absolute;
  width: 3rem;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
}
@media screen and (min-width: 576px) {
  .donut-icon {
    width: 4rem;
    height: 4rem;
  }
}
@media screen and (min-width: 768px) {
  .donut-icon {
    width: 5rem;
    height: 5rem;
  }
}
.donut-text {
  position: absolute;
  font-size: 0.9rem;
  font-weight: bold;
  color: #807e6f;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: 49%;
  -webkit-hyphens: auto;
  hyphens: auto;
}
@media screen and (min-width: 576px) {
  .donut-text {
    font-size: 1.1rem;
    max-width: 200px;
    -webkit-hyphens: unset;
    hyphens: unset;
  }
}
.donut-text-container {
  position: absolute;
  width: 100%;
  max-width: 650px;
  height: 100%;
  top: 50%;
  transform: translateY(-50%);
}
.donut-text-container :nth-child(1) {
  text-align: right;
  right: 0;
  top: 5%;
}
.donut-text-container :nth-child(2) {
  text-align: right;
  right: 0;
  bottom: 5%;
}
.donut-text-container :nth-child(3) {
  text-align: left;
  left: 0;
  bottom: 5%;
}
.donut-text-container :nth-child(4) {
  text-align: left;
  left: 0;
  top: 5%;
  max-width: 135px;
}

.segment-1 {
  /* Top Right */
  clip-path: polygon(50% 50%, 100% 50%, 100% 0, 50% 0);
}
.segment-1 .donut-icon {
  top: 25%;
  left: 75%;
  transform: translate(-50%, -50%);
}

.segment-2 {
  /* Bottom Right */
  clip-path: polygon(50% 50%, 100% 50%, 100% 100%, 50% 100%);
}
.segment-2 .donut-icon {
  bottom: 25%;
  left: 75%;
  transform: translate(-50%, 50%);
}

.segment-3 {
  /* Bottom Left */
  clip-path: polygon(50% 50%, 0% 50%, 0% 100%, 50% 100%);
}
.segment-3 .donut-icon {
  bottom: 25%;
  left: 25%;
  transform: translate(-50%, 50%);
}

.segment-4 {
  /* Top Left */
  clip-path: polygon(50% 50%, 0% 50%, 0% 0%, 50% 0%);
}
.segment-4 .donut-icon {
  top: 25%;
  left: 25%;
  transform: translate(-50%, -50%);
}

.highlighted-segment {
  background-color: #b31767;
}

.highlighted-segment + .donut-icon {
  filter: invert(1);
}

.highlighted-text {
  color: black;
  font-weight: bold;
}

.content-icon-text-list {
  padding: 1.875rem 1.625rem 0.25rem;
}
@media screen and (min-width: 576px) {
  .content-icon-text-list {
    padding: 1.875rem 1.875rem 0.25rem;
  }
}
@media screen and (min-width: 768px) {
  .content-icon-text-list {
    padding: 1.875rem 3.75rem 0.25rem;
  }
}
@media screen and (min-width: 992px) {
  .content-icon-text-list {
    padding: 1.875rem 2.5rem 0.25rem;
  }
}
@media screen and (min-width: 1200px) {
  .content-icon-text-list {
    padding: 5rem 3.75rem 2.5rem;
  }
}
.content-icon-text-list__content-text {
  margin-bottom: 10px;
}
.content-icon-text-list ul {
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
}
@media screen and (min-width: 576px) {
  .content-icon-text-list ul {
    gap: 30px;
  }
}
@media screen and (min-width: 1200px) {
  .content-icon-text-list ul {
    flex-direction: row;
  }
}
.content-icon-text-list li {
  position: relative;
  width: 100%;
}
@media screen and (min-width: 1200px) {
  .content-icon-text-list li {
    width: 33.3333333333%;
  }
}
.content-icon-text-list__item {
  display: flex;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  width: 100%;
  height: 100%;
}
.content-icon-text-list__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  flex-shrink: 0;
  width: 65px;
}
.content-icon-text-list__icon img {
  max-width: 100%;
  height: auto;
}
.content-icon-text-list__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px;
}
@media screen and (min-width: 576px) {
  .content-icon-text-list__content {
    padding: 15px;
  }
}
.content-icon-text-list__text {
  display: flex;
  justify-content: space-between;
  align-items: center;
  word-break: break-word;
}
.content-icon-text-list__text :last-child {
  margin-bottom: 0;
}
.content-icon-text-list__headline * {
  font-size: 24px;
  margin-bottom: 0;
}
@media screen and (min-width: 1200px) {
  .content-icon-text-list__headline * {
    font-size: 32px;
  }
}
.content-background-container {
  padding-bottom: 1.875rem;
}
@media screen and (min-width: 1200px) {
  .content-background-container {
    padding-bottom: 5rem;
  }
}
.content-background-container .stage__content {
  margin-left: 0;
  margin-right: 0;
  padding-left: 0;
  padding-right: 0;
}
@media screen and (max-width: 992px) {
  .content-background-container .row-reset > * {
    padding-right: 0;
    padding-left: 0;
  }
}

.content-image-text {
  display: flex;
  flex-direction: column;
  padding: 0 1.625rem;
}
@media screen and (min-width: 576px) {
  .content-image-text {
    padding: 0 1.875rem;
  }
}
@media screen and (min-width: 768px) {
  .content-image-text {
    padding: 0 3.75rem;
  }
}
@media screen and (min-width: 992px) {
  .content-image-text {
    padding: 0 2.5rem;
  }
}
@media screen and (min-width: 1200px) {
  .content-image-text {
    padding: 0 3.75rem;
  }
}
.content-image-text__content {
  padding: 20px;
}
@media screen and (min-width: 1200px) {
  .content-image-text__content {
    display: flex;
    flex-direction: row;
    gap: 40px;
    padding: 0 40px;
    align-items: center;
    justify-content: space-between;
  }
}
.content-image-text__image {
  max-width: 50%;
  margin-bottom: 20px;
  margin: 0 auto;
}
@media screen and (min-width: 1200px) {
  .content-image-text__image {
    max-width: 266px;
    margin-bottom: 0;
  }
}
.content-image-text__text {
  margin-bottom: 20px;
}
@media screen and (min-width: 1200px) {
  .content-image-text__text {
    max-width: 545px;
    margin-bottom: 0;
    padding: 40px 0;
  }
}
@media screen and (min-width: 1200px) {
  .content-image-text__content-box {
    width: 100%;
  }
}
.content-image-text .btn {
  max-width: 100%;
}
@media screen and (min-width: 992px) {
  .content-image-text .btn {
    max-width: max-content;
  }
}

.two_steps_module {
  padding: 1.875rem 1.625rem;
  max-width: 730px;
  margin: 50px auto;
}
.two_steps_module__image {
  position: relative;
  max-width: 540px;
  margin: 0 auto;
}
.two_steps_module__image .disturber {
  position: absolute;
  right: 30px;
  top: 0;
  z-index: 1;
}
.two_steps_module__step {
  border-radius: 50%;
  width: 80px;
  text-align: center;
  margin-bottom: 30px;
}
.two_steps_module__step span {
  font-size: 50px;
  color: #fff;
  margin: 0 auto;
}
.two_steps_module__content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.two_steps_module__content.first_step {
  margin-bottom: 100px;
}
.two_steps_module__content .coupon {
  padding: 0;
}
.two_steps_module .disabled {
  opacity: 0.3;
  cursor: not-allowed;
  pointer-events: none;
}

.interaction-tile-quest {
  position: relative;
}
.interaction-tile-quest__bg {
  height: calc(100svh - 65px);
  width: 100%;
}
.interaction-tile-quest__bg img {
  object-fit: cover;
  object-position: center;
}
.interaction-tile-quest__content {
  position: absolute;
  top: 50%;
  translate: 0 -50%;
  left: 0;
  right: 0;
  margin: 0 1.625rem;
  padding: 1rem;
  background: radial-gradient(77.95% 77.95% at 49.85% 3.12%, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0) 100%), rgba(255, 255, 255, 0.2);
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);
  border-radius: 8px;
  text-align: center;
}
@media screen and (min-width: 576px) {
  .interaction-tile-quest__content {
    width: 460px;
    margin: 0 auto;
  }
}
.interaction-tile-quest__content-intro, .interaction-tile-quest__content-question {
  max-width: 800px;
  margin: 0 auto;
}
.interaction-tile-cta.inactive {
  cursor: not-allowed;
}
.interaction-tile .tiles {
  display: grid;
  grid-template-columns: repeat(2, 8.375rem);
  gap: 16px;
  margin: 1.5rem 0;
  justify-content: center;
}
.interaction-tile .tiles--expanded {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
@media screen and (min-width: 576px) {
  .interaction-tile .tiles--expanded {
    max-width: 300px;
    margin: 1.5rem auto;
  }
}
.interaction-tile .tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 134px;
  padding: 1rem;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 8px;
  font-weight: 700;
  line-height: 1.3;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
}
.interaction-tile .tile.visited {
  border-color: #ebe6d8;
  opacity: 0.5;
}
.interaction-tile .tile img {
  max-width: 64px;
}
.interaction-tile .tile-expanded {
  position: relative;
  padding: 1.5rem;
  background: #fff;
  border-radius: 8px;
}
.interaction-tile .tile-expanded .close {
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  cursor: pointer;
  width: 24px;
  height: 24px;
  padding: 0;
}
.interaction-tile .tile-expanded .close svg {
  width: 100%;
  height: 100%;
}
.interaction-tile .tile-expanded .tile-back-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto;
}
.interaction-tile .tile-expanded .tile-back-title {
  margin-bottom: 1.25rem;
}
.interaction-tile .tile-expanded .tile-back-title.green {
  color: #009284;
}
.interaction-tile .tile-expanded .tile-back-title.red {
  color: #6a0029;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvamVua2lucy93b3Jrc3BhY2UvRVJHT01CSy9QaXBlbGluZUNhbXBhaWduVG9UYXJnZXQvcHJvamVjdC1mZS9zcmMiLCJzb3VyY2VzIjpbImFzc2V0cy9zdHlsZXMvbGliL19yZXNldC5zY3NzIiwiYXNzZXRzL3N0eWxlcy9saWIvX3ZhcmlhYmxlcy5zY3NzIiwiYXNzZXRzL3N0eWxlcy9saWIvX2ZvbnRzLnNjc3MiLCJhc3NldHMvc3R5bGVzL2xpYi9fdGV4dC5zY3NzIiwiYXNzZXRzL3N0eWxlcy9saWIvYW5pbWF0aW9ucy5zY3NzIiwiYXNzZXRzL3N0eWxlcy9saWIvbWFyZ2lucy5zYXNzIiwiYXNzZXRzL3N0eWxlcy9saWIvY29tbW9uLnNjc3MiLCJhc3NldHMvc3R5bGVzL2xpYi9ncmlkLW92ZXJ3cml0ZXMuc2NzcyIsImFzc2V0cy9zdHlsZXMvYXRvbXMvYnV0dG9uLnNjc3MiLCJhc3NldHMvc3R5bGVzL2F0b21zL3JlYWQtbW9yZS1saW5rLnNjc3MiLCJhc3NldHMvc3R5bGVzL2F0b21zL3NlYWwtcGxhY2Vob2xkZXIuc2NzcyIsImFzc2V0cy9zdHlsZXMvYXRvbXMvY2FyZC5zY3NzIiwiYXNzZXRzL3N0eWxlcy9hdG9tcy9kaXN0dXJiZXIuc2NzcyIsImFzc2V0cy9zdHlsZXMvZWxlbWVudHMvbGlzdC5zY3NzIiwiYXNzZXRzL3N0eWxlcy9lbGVtZW50cy9zZWN0aW9uLnNjc3MiLCJhc3NldHMvc3R5bGVzL2VsZW1lbnRzL2FjY29yZGlvbi5zY3NzIiwiYXNzZXRzL3N0eWxlcy9lbGVtZW50cy9tb2RhbC5zY3NzIiwiYXNzZXRzL3N0eWxlcy9lbGVtZW50cy9jYXJvdXNlbC1pdGVtLnNjc3MiLCJhc3NldHMvc3R5bGVzL2VsZW1lbnRzL3BvcHVwLXN0YW5kYXJkLnNjc3MiLCJhc3NldHMvc3R5bGVzL2VsZW1lbnRzL3N1Y2Nlc3MtYmFubmVyLnNjc3MiLCJhc3NldHMvc3R5bGVzL21vZHVsZXMvY29udGVudC1vZmZlci5zY3NzIiwiYXNzZXRzL3N0eWxlcy9tb2R1bGVzL2NvbnRlbnQtdGV4dC5zY3NzIiwiYXNzZXRzL3N0eWxlcy9tb2R1bGVzL2NvbnRlbnQtZG93bmxvYWQuc2NzcyIsImFzc2V0cy9zdHlsZXMvbW9kdWxlcy9jb250ZW50LWhlYWRsaW5lLWJsb2NrLnNjc3MiLCJhc3NldHMvc3R5bGVzL21vZHVsZXMvY29udGFjdC1hcHBvaW50bWVudC5zY3NzIiwiYXNzZXRzL3N0eWxlcy9tb2R1bGVzL2NvbnRlbnQtY29sb3JwbGFuZS5zY3NzIiwiYXNzZXRzL3N0eWxlcy9tb2R1bGVzL2Zvb3Rlci5zY3NzIiwiYXNzZXRzL3N0eWxlcy9tb2R1bGVzL3N0YWdlLWNvbnRlbnQuc2NzcyIsImFzc2V0cy9zdHlsZXMvbW9kdWxlcy9jb250ZW50LWNvbXBvc2l0aW9uLnNjc3MiLCJhc3NldHMvc3R5bGVzL21vZHVsZXMvY29udGVudC1jYXJkLnNjc3MiLCJhc3NldHMvc3R5bGVzL2xpYi9taXhpbnMuc2NzcyIsImFzc2V0cy9zdHlsZXMvbW9kdWxlcy9jb250ZW50LWN1dG91dHZpc3VhbC5zY3NzIiwiYXNzZXRzL3N0eWxlcy9tb2R1bGVzL2ludGVyYWN0aW9uLnNjc3MiLCJhc3NldHMvc3R5bGVzL21vZHVsZXMvaW50ZXJhY3Rpb24tZGVjaXNpb24tdHJlZS1xdWl6LnNjc3MiLCJhc3NldHMvc3R5bGVzL21vZHVsZXMvaW50ZXJhY3Rpb24tcGVuc2lvbi5zY3NzIiwiYXNzZXRzL3N0eWxlcy9tb2R1bGVzL3Jlc3VsdC1zdGFnZS10YWJsZS5zY3NzIiwiYXNzZXRzL3N0eWxlcy9tb2R1bGVzL3Jlc3VsdC1zdGFnZS5zY3NzIiwiYXNzZXRzL3N0eWxlcy9tb2R1bGVzL2NvbnRlbnQtdmlkZW92aXN1YWwuc2NzcyIsImFzc2V0cy9zdHlsZXMvbW9kdWxlcy9jb250ZW50LWxpc3Quc2NzcyIsImFzc2V0cy9zdHlsZXMvbW9kdWxlcy9jb250ZW50LWNhcm91c2VsLnNjc3MiLCJhc3NldHMvc3R5bGVzL21vZHVsZXMvY29va2llLnNjc3MiLCJhc3NldHMvc3R5bGVzL21vZHVsZXMvcmVzdWx0LXN0YWdlLW92ZXJ2aWV3LnNjc3MiLCJhc3NldHMvc3R5bGVzL21vZHVsZXMvY291cG9uLnNjc3MiLCJhc3NldHMvc3R5bGVzL21vZHVsZXMvZmlsZS1yZXF1ZXN0LW11bHRpcGxlLnNjc3MiLCJhc3NldHMvc3R5bGVzL21vZHVsZXMvcmVzdWx0LWRpYWdyYW0uc2NzcyIsImFzc2V0cy9zdHlsZXMvbW9kdWxlcy9jb250ZW50LWljb24tdGV4dC1saXN0LnNjc3MiLCJhc3NldHMvc3R5bGVzL21vZHVsZXMvY29udGVudC1iYWNrZ3JvdW5kLWNvbnRhaW5lci5zY3NzIiwiYXNzZXRzL3N0eWxlcy9tb2R1bGVzL2NvbnRlbnQtaW1hZ2UtdGV4dC5zY3NzIiwiYXNzZXRzL3N0eWxlcy9tb2R1bGVzL3R3by1zdGVwcy1tb2R1bGUuc2NzcyIsImFzc2V0cy9zdHlsZXMvbW9kdWxlcy9pbnRlcmFjdGlvbi10aWxlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0E7QUFBQTtBQUFBO0VBR0U7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7RUFVRTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTs7O0FBR0Y7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0VBTUU7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtBQUFBO0VBRUU7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBOzs7QUFHRjtBQUFBO0FBQUE7RUFHRTtFQUNBOzs7QUFHRjtBQUFBO0FBQUE7QUFBQTtFQUlFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7OztBQUdGO0FBQUE7RUFFRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7QUFBQTtFQUVFO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7QUFBQTtBQUFBO0FBQUE7RUFJRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7QUFBQTtBQUFBO0FBQUE7QUFBQTtFQUtFO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtBQUFBO0VBRUU7OztBQUdGO0FBQUE7RUFFRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBSUY7QUFBQTtBQUFBO0FBQUE7RUFJRTs7O0FBR0Y7QUFBQTtBQUFBO0FBQUE7RUFJRTtFQUNBOzs7QUFHRjtBQUFBO0VBRUU7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFJRjtFQUNFOzs7QUFHRjtBQUFBO0VBRUU7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7OztBQ25URjtBQTZDQTtBQzdDQTtFQUNFO0VBQ0E7RUFDQTtFQUtBO0VBQ0E7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFLQTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBS0E7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUtBO0VBQ0E7O0FDN0NGO0FBRUE7RUFDRTs7O0FBR0Y7QUFBQTtFQUVFO0VBQ0E7OztBQUdGO0FBQUE7QUFBQTtBQUFBO0FBQUE7RUFLRTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtBQUNBO0FBQUE7RUFFRTtFQUNBLE9GekJVOzs7QUU0Qlo7RUFDRTs7QUFDQTtFQUZGO0lBR0k7Ozs7QUFJSjtBQUFBO0VBRUU7RUFDQSxPRnRDVTtFRXVDVjs7O0FBR0Y7QUFBQTtFQUVFO0VBQ0E7RUFDQSxPRmhEVztFRWlEWDtFQUNBOzs7QUFHRjtBQUFBO0VBRUU7RUFDQTtFQUNBO0VBQ0EsT0YxRFc7RUUyRFg7OztBQUdGO0FBQUE7RUFFRTtFQUNBO0VBQ0E7RUFDQSxPRm5FVztFRW9FWDs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7QUFBQTtFQUNFOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFHRjtFQUNFLE9GOUZVO0VFK0ZWOzs7QUFHRjtBQUNBO0VBQ0U7SUFDRTs7O0FBSUo7QUFDQTtFQUNFO0FBQUE7SUFFRTs7RUFFRjtBQUFBO0lBRUU7O0VBRUY7QUFBQTtJQUVFOztFQUVGO0FBQUE7SUFFRTs7RUFFRjtBQUFBO0lBRUU7O0VBRUY7SUFDRTs7RUFFRjtBQUFBO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOzs7QUFJSjtBQUlBO0FBQ0E7RUFDRTtBQUFBO0lBRUU7O0VBRUY7QUFBQTtJQUVFOztFQUVGO0FBQUE7SUFFRTs7RUFFRjtBQUFBO0lBRUU7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0FBQUE7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7OztBQ3BMSjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBSUY7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBT0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUtBO0VBQ0U7SUFDRTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBOzs7QUFJSjtFQUNFO0lBQ0U7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7O0VBRUY7SUFDRTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTs7O0FBS0o7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBT0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUtBO0VBQ0U7SUFDRTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBOzs7QUFJSjtFQUNFO0lBQ0U7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7O0VBRUY7SUFDRTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTs7O0FBS0o7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBT0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUtBO0VBQ0U7SUFDRTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBOzs7QUFJSjtFQUNFO0lBQ0U7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7O0VBRUY7SUFDRTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTs7O0FBS0o7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBT0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUtBO0VBQ0U7SUFDRTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBOzs7QUFJSjtFQUNFO0lBQ0U7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7O0VBRUY7SUFDRTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTs7O0FBS0o7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBT0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUtBO0VBQ0U7SUFDRTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBOzs7QUFJSjtFQUNFO0lBQ0U7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7O0VBRUY7SUFDRTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTs7O0FBS0o7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBT0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUtBO0VBQ0U7SUFDRTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBOzs7QUFJSjtFQUNFO0lBQ0U7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7O0VBRUY7SUFDRTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTs7O0FBS0o7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBT0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUtBO0VBQ0U7SUFDRTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBOzs7QUFJSjtFQUNFO0lBQ0U7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7O0VBRUY7SUFDRTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTs7O0FBS0o7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBT0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUtBO0VBQ0U7SUFDRTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBOzs7QUFJSjtFQUNFO0lBQ0U7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7O0VBRUY7SUFDRTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTs7O0FBS0o7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBT0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUtBO0VBQ0U7SUFDRTtJQUNBO0lBQ0E7O0VBRUY7SUFDRTtJQUNBO0lBQ0E7OztBQUlKO0VBQ0U7SUFDRTtJQUNBO0lBQ0E7O0VBRUY7SUFDRTtJQUNBO0lBQ0E7OztBQ25nQko7RUFDRTs7QUFFQTtFQUhGO0lBSUk7OztBQUVGO0VBTkY7SUFPSTs7O0FBRUY7RUFURjtJQVVJOzs7QUFFRjtFQUNFOztBQUVBO0VBSEY7SUFJSTs7O0FBRUY7RUFORjtJQU9JOzs7QUFFRjtFQVRGO0lBVUk7OztBQUVKO0VBQ0U7O0FBRUE7RUFIRjtJQUlJOzs7QUFFRjtFQU5GO0lBT0k7OztBQUVGO0VBVEY7SUFVSTs7O0FBRUo7RUFDRTs7QUFFQTtFQUhGO0lBSUk7OztBQUVGO0VBTkY7SUFPSTs7O0FBRUY7RUFURjtJQVVJOzs7QUFFSjtFQUNFOzs7QUN0Q0Y7RUFDRSxrQkFWRjs7O0FBU0E7RUFDRSxrQkFWRjs7O0FBU0E7RUFDRSxrQkFWRjs7O0FBU0E7RUFDRSxrQkFWRjs7O0FBU0E7RUFDRSxrQkFWRjs7O0FBU0E7RUFDRSxrQkFWRjs7O0FBU0E7RUFDRSxrQkFWRjs7O0FBMEJBO0VBQ0Usa0JBWEY7OztBQVVBO0VBQ0Usa0JBWEY7OztBQVVBO0VBQ0Usa0JBWEY7OztBQVVBO0VBQ0Usa0JBWEY7OztBQVVBO0VBQ0Usa0JBWEY7OztBQVVBO0VBQ0Usa0JBWEY7OztBQVVBO0VBQ0Usa0JBWEY7OztBQVVBO0VBQ0Usa0JBWEY7OztBQXdCQTtFQUNFLGtCQVJGOzs7QUFPQTtFQUNFLGtCQVJGOzs7QUFPQTtFQUNFLGtCQVJGOzs7QUFPQTtFQUNFLGtCQVJGOzs7QUFPQTtFQUNFLGtCQVJGOzs7QUFvQkE7RUFDRSxrQkFSRjs7O0FBT0E7RUFDRSxrQkFSRjs7O0FBT0E7RUFDRSxrQkFSRjs7O0FBT0E7RUFDRSxrQkFSRjs7O0FBT0E7RUFDRSxrQkFSRjs7O0FBb0JBO0VBQ0Usa0JBUkY7OztBQU9BO0VBQ0Usa0JBUkY7OztBQU9BO0VBQ0Usa0JBUkY7OztBQU9BO0VBQ0Usa0JBUkY7OztBQU9BO0VBQ0Usa0JBUkY7OztBQVlGO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBRUU7OztBQXVCSjtFQUNFO0VBQ0Esa0JMeEdXO0VLeUdYOztBQUNBO0VBSkY7SUFLSTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFLSjtBQUFBO0VBRUU7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7QUFBQTtFQUVFOzs7QUFHRjtBQUFBO0VBRUU7OztBQUdGO0VBQ0U7OztBQUlBO0VBREY7SUFFSTs7OztBQUlKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0Esa0JMdktXO0VLd0tYO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOztBQUlFO0FBQUE7RUFDRTs7QUFHSjtFQUNFLE9ML01RO0VLZ05SOzs7QUFJSjtFQUNFLE9Mck5VOzs7QUtPVjtFQUNFLGtCQVZGOzs7QUFTQTtFQUNFLGtCQVZGOzs7QUFTQTtFQUNFLGtCQVZGOzs7QUFTQTtFQUNFLGtCQVZGOzs7QUFTQTtFQUNFLGtCQVZGOzs7QUFTQTtFQUNFLGtCQVZGOzs7QUFTQTtFQUNFLGtCQVZGOzs7QUEwQkE7RUFDRSxrQkFYRjs7O0FBVUE7RUFDRSxrQkFYRjs7O0FBVUE7RUFDRSxrQkFYRjs7O0FBVUE7RUFDRSxrQkFYRjs7O0FBVUE7RUFDRSxrQkFYRjs7O0FBVUE7RUFDRSxrQkFYRjs7O0FBVUE7RUFDRSxrQkFYRjs7O0FBVUE7RUFDRSxrQkFYRjs7O0FBd0JBO0VBQ0Usa0JBUkY7OztBQU9BO0VBQ0Usa0JBUkY7OztBQU9BO0VBQ0Usa0JBUkY7OztBQU9BO0VBQ0Usa0JBUkY7OztBQU9BO0VBQ0Usa0JBUkY7OztBQW9CQTtFQUNFLGtCQVJGOzs7QUFPQTtFQUNFLGtCQVJGOzs7QUFPQTtFQUNFLGtCQVJGOzs7QUFPQTtFQUNFLGtCQVJGOzs7QUFPQTtFQUNFLGtCQVJGOzs7QUFvQkE7RUFDRSxrQkFSRjs7O0FBT0E7RUFDRSxrQkFSRjs7O0FBT0E7RUFDRSxrQkFSRjs7O0FBT0E7RUFDRSxrQkFSRjs7O0FBT0E7RUFDRSxrQkFSRjs7O0FBWUY7RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFFRTs7O0FBdUJKO0VBQ0U7RUFDQSxrQkx4R1c7RUt5R1g7O0FBQ0E7RUFKRjtJQUtJOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUtKO0FBQUE7RUFFRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtBQUFBO0VBRUU7OztBQUdGO0FBQUE7RUFFRTs7O0FBR0Y7RUFDRTs7O0FBSUE7RUFERjtJQUVJOzs7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQSxrQkx2S1c7RUt3S1g7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7O0FBSUU7QUFBQTtFQUNFOztBQUdKO0VBQ0UsT0wvTVE7RUtnTlI7OztBQUlKO0VBQ0UsT0xyTlU7OztBTUpaO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQU1BO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtFQU9FO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFLRjtFQUNFO0lBQ0U7SUFDQTs7RUFHRjtJQUNFOzs7QUFJSjtFQUNFO0lBQ0U7OztBQUlKO0VBQ0U7SUFDRTs7O0FBSUo7RUFDRTtJQUNFOzs7QUFJSjtFQUNFO0lBQ0U7OztBQUlKO0VBQ0U7SUFDRTs7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtBQUFBO0VBRUU7OztBQUdGO0FBQUE7RUFFRTs7O0FBR0Y7QUFBQTtFQUVFOzs7QUFHRjtBQUFBO0VBRUU7OztBQUdGO0FBQUE7RUFFRTs7O0FBR0Y7QUFBQTtFQUVFOzs7QUFHRjtBQUFBO0VBRUU7OztBQUdGO0FBQUE7RUFFRTs7O0FBR0Y7QUFBQTtFQUVFOzs7QUFHRjtBQUFBO0VBRUU7OztBQUdGO0FBQUE7RUFFRTs7O0FBR0Y7QUFBQTtFQUVFOzs7QUFHRjtFQUNFO0lBQ0U7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtBQUFBO0lBRUU7O0VBRUY7QUFBQTtJQUVFOztFQUVGO0FBQUE7SUFFRTs7RUFFRjtBQUFBO0lBRUU7O0VBRUY7QUFBQTtJQUVFOztFQUVGO0FBQUE7SUFFRTs7RUFFRjtBQUFBO0lBRUU7O0VBRUY7QUFBQTtJQUVFOztFQUVGO0FBQUE7SUFFRTs7RUFFRjtBQUFBO0lBRUU7O0VBRUY7QUFBQTtJQUVFOztFQUVGO0FBQUE7SUFFRTs7O0FBSUo7RUFDRTtJQUNFOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7QUFBQTtJQUVFOztFQUVGO0FBQUE7SUFFRTs7RUFFRjtBQUFBO0lBRUU7O0VBRUY7QUFBQTtJQUVFOztFQUVGO0FBQUE7SUFFRTs7RUFFRjtBQUFBO0lBRUU7O0VBRUY7QUFBQTtJQUVFOztFQUVGO0FBQUE7SUFFRTs7RUFFRjtBQUFBO0lBRUU7O0VBRUY7QUFBQTtJQUVFOztFQUVGO0FBQUE7SUFFRTs7RUFFRjtBQUFBO0lBRUU7OztBQUlKO0VBQ0U7SUFDRTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0FBQUE7SUFFRTs7RUFFRjtBQUFBO0lBRUU7O0VBRUY7QUFBQTtJQUVFOztFQUVGO0FBQUE7SUFFRTs7RUFFRjtBQUFBO0lBRUU7O0VBRUY7QUFBQTtJQUVFOztFQUVGO0FBQUE7SUFFRTs7RUFFRjtBQUFBO0lBRUU7O0VBRUY7QUFBQTtJQUVFOztFQUVGO0FBQUE7SUFFRTs7RUFFRjtBQUFBO0lBRUU7O0VBRUY7QUFBQTtJQUVFOzs7QUFJSjtFQUNFO0lBQ0U7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtBQUFBO0lBRUU7O0VBRUY7QUFBQTtJQUVFOztFQUVGO0FBQUE7SUFFRTs7RUFFRjtBQUFBO0lBRUU7O0VBRUY7QUFBQTtJQUVFOztFQUVGO0FBQUE7SUFFRTs7RUFFRjtBQUFBO0lBRUU7O0VBRUY7QUFBQTtJQUVFOztFQUVGO0FBQUE7SUFFRTs7RUFFRjtBQUFBO0lBRUU7O0VBRUY7QUFBQTtJQUVFOztFQUVGO0FBQUE7SUFFRTs7O0FBSUo7RUFDRTtJQUNFOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7QUFBQTtJQUVFOztFQUVGO0FBQUE7SUFFRTs7RUFFRjtBQUFBO0lBRUU7O0VBRUY7QUFBQTtJQUVFOztFQUVGO0FBQUE7SUFFRTs7RUFFRjtBQUFBO0lBRUU7O0VBRUY7QUFBQTtJQUVFOztFQUVGO0FBQUE7SUFFRTs7RUFFRjtBQUFBO0lBRUU7O0VBRUY7QUFBQTtJQUVFOztFQUVGO0FBQUE7SUFFRTs7RUFFRjtBQUFBO0lBRUU7OztBQUlKO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7O0FBSUo7RUFDRTtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7OztBQUlKO0VBQ0U7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOzs7QUFJSjtFQUNFO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7O0FBSUo7RUFDRTtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7OztBQUlKO0VBQ0U7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7OztBQ25qSUo7RUFFRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFqQkY7SUFrQkk7SUFDQTtJQUNBOzs7QUFJQTtFQUNFO0VBQ0E7RUFDQTs7QUFDQTtFQUNFLE1QekJJOztBT2dDTjtFQUNFLE1QcENLOztBTzBDUDtFQUNFLE1QeENJOztBTzZDTjtFQUNFLE1QakRLOztBT3NEWDtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUdGO0VBQ0UsT1A5RFM7RU8rRFQsWVA1RFE7O0FPOERSO0VBQ0U7O0FBR0Y7RUFDRSxZUHRFTztFT3VFUDtFQUNBLE9QckVNOztBT3VFTjtFQUNFOztBQUtBO0VBREY7SUFFSTtJQUNBOzs7QUFJSjtFQWpCRjtJQWtCSSxPUHZGSztJT3dGTCxZUHJGSTs7RU91Rko7SUFDRTs7O0FBTVI7RUFDRSxZUGxHUztFT21HVDtFQUNBLE9QakdROztBT21HUjtFQUNFOztBQUtKO0VBRUUsWVB2R1c7RU93R1g7RUFDQSxPUGhIUztFT2lIVDtFQUNBOztBQUdGO0VBdEhGO0lBdUhJO0lBQ0E7OztBQUdGO0VBQ0UsT1AzSFM7RU80SFQsWVB0SFU7RU91SFYsY1B2SFU7OztBTzJIZDtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBOztBQUdGO0VBZkY7SUFnQkk7SUFDQTs7O0FBR0Y7RUFwQkY7SUFxQkk7SUFDQTtJQUNBO0lBQ0E7SUFDQTs7RUFFQTtJQUNFOzs7O0FBS047RUFDRTtJQUNFOztFQUlBO0lBQ0UsT1B6S087SU8wS1AsWVB2S007OztBTzRLWjtFQUNFO0VBQ0E7OztBQUlBO0VBREY7SUFFSTtJQUNBO0lBQ0E7SUFDQTtJQUNBOzs7O0FDM0xKO0VBQ0UsT1JHVTtFUUZWO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFLE9SVFE7RVFVUjtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTs7O0FDekJOO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQVBGO0lBUUk7OztBQUdGO0VBQ0U7RUFDQTs7O0FDYko7RUFDRTtFQUNBOztBQUVBO0VBQ0U7O0FBR0Y7RUFDRSxPVkxROztBVVNSO0VBREY7SUFFSTtJQUNBOzs7QUFLRjtFQURGO0lBRUk7SUFDQTs7OztBQ3RCTjtFQUNFO0VBQ0E7O0FBQ0E7RUFIRjtJQUlJO0lBQ0E7Ozs7QUFHSjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQSxrQlhWVTtFV1dWLE9YZFc7RVdlWDtFQUNBOztBQUNBO0VBQ0U7RUFDQTs7O0FBS0Y7RUFDRTs7QUFDQTtFQUZGO0lBR0k7OztBQUdKO0VBQ0U7O0FBQ0E7RUFGRjtJQUdJOzs7QUFHSjtFQUNFOztBQUNBO0VBRkY7SUFHSTs7O0FBR0o7RUFDRTs7QUFDQTtFQUZGO0lBR0k7OztBQUdKO0VBQ0U7O0FBQ0E7RUFGRjtJQUdJOzs7QUFHSjtFQUNFOztBQUNBO0VBRkY7SUFHSTs7OztBQzFETjtFQUNFOztBQUVBO0VBQ0U7O0FBR0Y7QUFBQTtFQUVFO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0FBQUE7RUFFRTtFQUNBO0VBQ0E7RUFDQTs7QUFJSjtFQUNFO0VBQ0E7O0FBRUE7RUFDRTtFQUNBLE9aekJNO0VZMEJOO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQWhCRjtJQWlCSTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7OztBQU1OO0VBQ0U7O0FBRUU7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUdGO0VBQ0U7O0FBTUo7QUFBQTtFQUVFLGtCWjFDWTs7QVkrQ2Q7QUFBQTtFQUVFLGtCWmhFYTs7QVlxRWY7QUFBQTtFQUVFLGtCWmxFYzs7QVl1RWhCO0FBQUE7RUFFRSxrQlpuRmM7O0FZd0ZoQjtBQUFBO0VBRUUsa0JaM0VjOztBWWdGaEI7QUFBQTtFQUVFLGtCWmhITzs7QVlvSFQ7QUFBQTtFQUVFOzs7QUFLTjtFQUVFO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBUEY7SUFRSTtJQUNBO0lBQ0E7OztBQUdGO0VBQ0U7O0FBU0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTs7QUFHRjtFQVpGO0lBYUk7SUFDQTtJQUNBOzs7QUFJSjtFQUNFO0VBQ0E7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFMRjtJQU1JOzs7QUFHRjtFQVRGO0lBVUk7OztBQUdGO0VBYkY7SUFjSTs7O0FBR0Y7RUFDRTs7QUFJSjtFQUNFO0VBQ0E7O0FBRUE7RUFDRTs7O0FDdE1OO0VBQ0U7O0FBQ0E7RUFGRjtJQUdJOzs7QUFFRjtFQUNFOztBQUNBO0VBRkY7SUFHSTs7OztBQ1JOO0VBQ0U7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFJQTtFQURGO0lBRUk7SUFDQTtJQUNBO0lBQ0E7OztBQUtGO0VBREY7SUFFSTtJQUNBO0lBQ0E7SUFDQTs7O0FBSUo7RUFDRTtFQUNBOztBQUdGO0VBQ0U7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUxGO0lBTUk7OztBQUlKO0VBRUU7O0FBSUo7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUdGO0VBQ0U7O0FBR0Y7RUFDRTs7QUFJQTtFQURGO0lBRUk7OztBQUtGO0VBREY7SUFFSTs7O0FBRUY7RUFKRjtJQUtJOzs7QUFJSjtFQUNFOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTs7QUFHRTtFQUNFOztBQU1KO0VBQ0U7O0FBSUo7RUFDRTs7O0FBS0Y7RUFDRTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTs7QUFJRjtFQUNFOztBQUVGO0VBQ0U7RUFDQTs7QUFFRjtFQUNFOztBQUVGO0VBQ0U7OztBQ3hKTjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTs7QUFHSjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFRjtFQUNFO0VBQ0E7OztBQVFGO0VBRUU7RUFDQSxPZnZDUzs7QWV3Q1Q7RUFDRTtFQUNBO0VBQ0E7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTs7QUFHQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7O0FBS047RUFDRTs7QUFDQTtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUVGO0VBQ0U7O0FBR0o7RUFDRTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTs7QUFDQTtFQUNFOztBQUVGO0VBQ0U7O0FBTU47RUFDRSxPZmxHTTs7QWVtR047RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0EsT2Y3R0s7RWU4R0w7O0FBS0E7RUFDRTs7QUFNUjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVGO0VBQ0U7OztBQUtKO0FDOUlBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFFRTs7QUFHRjtFQUNFO0VBQ0E7O0FBR0Y7RUFFRTs7QUFFRjtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUxGO0lBTUk7OztBQUdGO0VBVEY7SUFVSTs7O0FBR0Y7RUFiRjtJQWNJOzs7QUFJSjtFQUNFO0VBQ0E7O0FBRUE7RUFKRjtJQUtJOzs7QUFJSjtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUxGO0lBTUk7OztBQUdGO0VBVEY7SUFVSTtJQUNBOzs7QUFJSjtFQUNFOztBQUNBO0VBRkY7SUFHSTs7O0FBSUo7RUFFRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBUkY7SUFTSTs7O0FBR0Y7RUFaRjtJQWFJOzs7QUFJSjtFQUNFO0VBQ0E7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7O0FBRUE7RUFKRjtJQUtJOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQVJGO0lBU0k7SUFDQTtJQUNBOzs7QUFHRjtFQWRGO0lBZUk7OztBQUdGO0VBQ0U7SUFDRTs7O0FBT047RUFERjtJQUVJOzs7O0FDbklOO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBR0U7RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBOztBQUlKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFHRTtFQUNFOztBQUlKO0VBaEJGO0lBaUJJO0lBQ0E7SUFDQTs7O0FBR0Y7RUFDRTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBOztBQU9WO0VBQ0U7RUFDQTtFQUNBOztBQUdGO0VBRUU7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7O0FBR0Y7RUFDRTtFQUNBOztBQUdGO0VBQ0U7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7OztBQ3ZJTjtFQUNFO0VBQ0E7RUFDQTtFQUNBLGtCbEJvQmlCO0VrQm5CakI7RUFDQSxPbEJMVztFa0JNWDs7QUFDQTtFQVJGO0lBU0k7OztBQUVGO0VBQ0U7RUFDQTs7QUFFRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFRjtFQUNFOztBQUVGO0VBQ0U7OztBQzNCSjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFQRjtJQVFJO0lBQ0E7OztBQUdGO0VBQ0U7O0FBQ0E7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0VBQ0U7SUFDRTtJQUNBO0lBTUE7SUFDQTtJQUNBO0lBQ0E7SUFDQTs7O0FBR0o7RUFDRTtFQUNBOztBQUdKO0VBQ0U7RUFDQTtFQUNBOztBQUNBO0VBSkY7SUFLSTs7O0FBRUY7RUFQRjtJQVFJOzs7QUFHRjtFQUNFOztBQUlOO0VBQ0U7RUFDQTs7QUFFQTtFQUpGO0lBS0k7OztBQUdGO0VBUkY7SUFTSTs7O0FBR0Y7RUFaRjtJQWFJOzs7QUFHRjtFQWhCRjtJQWlCSTs7O0FBS0U7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQU5GO0lBT0k7OztBQUdGO0VBVkY7SUFXSTs7O0FBS047RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFNUjtFQUNFOztBQUVBO0VBSEY7SUFJSTs7O0FBR0Y7RUFDRTs7O0FDcElKO0FBQUE7RUFFRSxPcEJDUTtFb0JBUjs7QUFFRjtFQUNFO0VBQ0E7O0FBRUE7RUFDRTs7QUFPRjtFQVpGO0lBYUk7OztBQUdGO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBTEY7SUFNSTs7O0FBR0Y7RUFURjtJQVVJOzs7QUFHRjtFQWJGO0lBY0k7Ozs7QUNuQ047RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFFRTtFQURGO0lBRUk7OztBQUlGO0VBQ0U7RUFDQTtFQUNBOztBQUlBO0VBQ0UsTXJCaEJFOztBcUJvQkY7RUFDRSxNckJ4QkM7O0FxQjhCTDtFQUNFLE1yQi9CRzs7QXFCbUNQO0VBekJGO0lBMEJJOzs7QUFFRjtFQTVCRjtJQTZCSTs7O0FBSU47RUFDRTtFQUNBOztBQUNBO0VBSEY7SUFJSTtJQUNBOzs7QUFFRjtFQUNFOzs7QUNwRE47RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFMRjtJQU1JOzs7QUFHRjtFQVRGO0lBVUk7OztBQUdGO0VBQ0U7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFOztBQUdGO0VBQ0U7O0FBR0Y7RUFDRSxPdEIxQlE7RXNCMkJSOztBQUdGO0VBQ0U7RUFDQTtFQUNBOztBQUNBO0VBSkY7SUFLSTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7OztBQUVGO0VBQ0U7O0FBR0Y7RUFDRTs7QUFFQTtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUxGO0lBTUk7OztBQUtOO0VBQ0U7RUFDQTtFQUNBOztBQUdGO0VBQ0U7O0FBRUE7RUFDRTs7QUFLTjtFQS9FRjtJQWdGSTs7RUFDQTtJQUNFOzs7QUFHSjtFQUNFO0VBQ0E7O0FBQ0E7RUFIRjtJQUlJOzs7QUFHSjtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUxGO0lBTUk7Ozs7QUNsR047RUFDRTtFQUVBOztBQUVBO0VBTEY7SUFNSTs7O0FBR0Y7RUFURjtJQVVJO0lBRUE7SUFDQTs7O0FBR0Y7RUFoQkY7SUFpQkk7SUFDQTtJQUNBOzs7QUFHRjtFQXRCRjtJQXVCSTs7O0FBR0Y7RUFDRTtFQUNBOztBQUlBO0VBREY7SUFFSTs7O0FBSUo7RUFDRTs7QUFHRjtFQUNFOztBQUVBO0VBSEY7SUFJSTs7O0FBR0Y7RUFQRjtJQVFJO0lBQ0E7OztBQUdGO0VBWkY7SUFhSTs7O0FBR0Y7RUFoQkY7SUFpQkk7OztBQUtGO0VBREY7SUFFSTs7O0FBSUE7RUFERjtJQUVJOzs7QUFFRjtFQUpGO0lBS0k7OztBQUtOO0VBQ0U7O0FBRUE7RUFIRjtJQUlJOzs7QUFLRjtFQURGO0lBRUk7OztBQUlKO0VBQ0U7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQVJGO0lBU0k7SUFDQTs7O0FBSUo7RUFDRSxrQnZCN0ZlOztBdUJnR2pCO0VBQ0U7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFLE92QnpITzs7QXVCNEhUO0VBQ0U7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUdGO0VBQ0U7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFOztBQUlBO0VBQ0UsT3ZCdkpNO0V1QndKTjs7QUFJSjtFQUNFO0VBQ0E7O0FBQ0E7RUFIRjtJQUlJOzs7QUFFRjtFQU5GO0lBT0k7OztBQUlKO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBTEY7SUFNSTs7O0FBSUo7RUFDRTs7QUFHRjtFQUNFOztBQUNBO0VBRkY7SUFHSTs7O0FBTUo7RUFDRTtFQUNBO0VBRUE7RUFFQTs7QUFFQTtFQVJGO0lBU0k7OztBQUdGO0VBWkY7SUFhSTs7O0FBR0Y7RUFoQkY7SUFpQkk7OztBQUdGO0VBQ0U7RUFDQTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFOztBQUlKO0VBQ0U7O0FBU0o7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUdGO0VBQ0U7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7O0FBa0JBO0VBQ0UsTUFWRjs7QUFTQTtFQUNFLE1BVkY7O0FBU0E7RUFDRSxNQVZGOztBQVNBO0VBQ0UsTUFWRjs7QUFTQTtFQUNFLE1BVkY7O0FBU0E7RUFDRSxNQVZGOztBQVNBO0VBQ0UsTUFWRjs7QUF5QkE7RUFDRSxNQVZGOztBQVNBO0VBQ0UsTUFWRjs7QUFTQTtFQUNFLE1BVkY7O0FBU0E7RUFDRSxNQVZGOztBQVNBO0VBQ0UsTUFWRjs7QUFTQTtFQUNFLE1BVkY7O0FBU0E7RUFDRSxNQVZGOztBQWNGO0VBQ0U7O0FBR0Y7RUFDRTs7QUFFQTtFQUhGO0lBSUk7OztBQUdGO0VBUEY7SUFRSTs7O0FBTUY7RUFGRjtJQUdJOzs7QUFHRjtFQU5GO0lBT0k7SUFDQTtJQUNBOzs7QUFHRjtBQUFBO0FBQUE7RUFFRTs7QUFHRjtFQUNFOztBQUVBO0VBSEY7SUFJSTs7O0FBS0Y7RUFERjtJQUVJOzs7QUFHRjtFQUxGO0lBTUk7OztBQUtGO0VBREY7SUFFSTtJQUNBO0lBQ0E7SUFDQTs7O0FBTUo7RUFDRTs7QUFFQTtFQUhGO0lBSUk7OztBQUtGO0VBREY7SUFFSTtJQUNBOzs7QUFHRjtFQU5GO0lBT0k7Ozs7QUMzWFI7RUFDRTs7QUFDQTtFQUNFO0VBQ0E7RUFDQTs7QUFDQTtFQUpGO0lBS0k7SUFDQTs7O0FBRUY7RUFSRjtJQVNJOzs7QUFFRjtFQVhGO0lBWUk7OztBQUVGO0VBZEY7SUFlSTs7O0FBR0Y7RUFDRTtFQUNBOztBQUVGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFMRjtJQU1JO0lBQ0E7OztBQUlKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFSRjtJQVNJOzs7QUFFRjtFQVhGO0lBWUk7SUFDQTtJQUNBO0lBQ0E7OztBQUVGO0VBakJGO0lBa0JJO0lBQ0E7SUFDQTs7O0FBR0o7RUFDRTs7QUFDQTtFQUZGO0lBR0k7OztBQUVGO0VBTEY7SUFNSTs7O0FBRUY7RUFDRTs7QUFLTjtFQUNFO0VBQ0E7O0FBRUE7RUFDRTs7QUFDQTtFQUZGO0lBR0k7OztBQUdGO0VBR007QUFBQTtJQUVFOzs7QUFNUjtFQUNFOztBQUVBO0VBQ0U7O0FBS047RUE5QkY7SUErQkk7SUFDQTtJQUNBO0lBQ0E7SUFDQTs7O0FBRUY7RUFyQ0Y7SUFzQ0k7SUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQVJGO0lBU0k7OztBQUlKO0VBQ0U7O0FBQ0E7RUFGRjtJQUdJOzs7QUFHRjtFQUNFO0VBQ0E7O0FBRUE7RUFKRjtJQUtJO0lBQ0E7OztBQUdKO0VBQ0U7O0FBTUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBUEY7SUFRSTs7O0FBR0Y7RUFYRjtJQVlJOzs7QUFJSjtFQUNFOztBQUlGO0VBQ0U7O0FBS047RUFDRTs7QUFLQTtFQUNFO0lBQ0U7SUFDQTs7O0FBR0o7RUFDRTtJQUNFOzs7QUFPSjtFQUNFO0lBQ0U7SUFDQTs7RUFFQTtJQUNFO0lBQ0E7O0VBR0o7SUFDRTs7OztBQzlNSjtFQURGO0lBRUk7SUFDQTs7OztBQU1KO0VBQ0U7RUFFQTs7QUFFRTtFQURGO0lBRUk7OztBQUdKO0VBVEY7SUFVSTs7O0FBR0E7RUFDRTtFQUNBOztBQUNBO0VBQ0UsT3pCdkJFO0V5QndCRjs7QUFNUjtFQUNFOztBQUNBO0VBQ0U7O0FBQ0E7RUFGRjtJQUdJOzs7QUFFRjtFQUxGO0lBTUk7OztBQUdKO0VBWEY7SUFZSTs7O0FBRUY7RUFkRjtJQWVJOzs7QUFFRjtFQUNFLE96QmhETTtFeUJpRE47O0FBQ0E7RUFIRjtJQUlJOzs7QUFFRjtFQUNFOztBQUdKO0VBQ0U7O0FBRUY7RUFDRTs7QUFDQTtFQUZGO0lBR0k7OztBQUlOO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBLE96QjlFUztFeUIrRVQ7O0FBR0U7RUFERjtJQUVJO0lBQ0E7OztBQUdKO0VBQ0UsT3pCeEZPOztBeUIwRlQ7RUFDRTtFQUNBOzs7QUM1RkY7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFQRjtJQVFJO0lBQ0E7SUFDQTtJQUNBOzs7QUFFRjtFQUNFO0VBQ0E7O0FBRUY7RUFDRTs7QUFJQTtFQUNFLE0xQnhCRzs7QTBCNEJUO0VBQ0U7RUFDQTtFQUNBOztBQUNBO0VBSkY7SUFLSTs7O0FBR0o7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBUEY7SUFRSTs7O0FBR0Y7RUFYRjtJQVlJOzs7QUFHRjtFQWZGO0lBZ0JJO0lBQ0E7SUFDQTs7O0FBR0Y7RUFyQkY7SUFzQkk7SUFDQTs7O0FBR0Y7RUFDRTtFQUNBOztBQUdGO0VBQ0U7O0FBR0Y7RUFDRTs7QUFJQTtFQURGO0FBQUE7QUFBQTtJQUVJOzs7QUFJSjtFQUNFOztBQUVBO0VBSEY7SUFJSTs7O0FBRUY7RUFORjtJQU9JOzs7QUFJSjtFQUNFO0VBQ0E7O0FBQ0E7RUFIRjtJQUlJO0lBQ0E7OztBQUlKO0VBQ0U7O0FBRUE7RUFIRjtJQUlJOzs7QUFFRjtFQU5GO0lBT0k7SUFDQTs7O0FBSUo7RUFDRTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUlOO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBTEY7SUFNSTs7O0FBR0Y7RUFURjtJQVVJOzs7QUFHRjtFQWJGO0lBY0k7SUFDQTtJQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQUxGO0lBTUk7SUFDQTs7OztBQ3ZLVjtFQUVFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTs7QUFFQTtFQUNFOztBQUlKO0VBQ0U7O0FBRUE7RUFDRTs7QUFJSjtFQUNFO0VBQ0E7RUFDQSxrQjNCMUJTO0UyQjJCVDtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFOztBQUdGO0VBQ0U7O0FBSUo7RUFDRTtFQUNBO0VBRUE7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTs7QUFJSjtBQUFBO0FBQUE7RUFHRTs7QUFHRjtFQUNFOztBQUlGO0VBQ0U7RUFDQTtFQUNBOztBQUdGO0VBQ0U7O0FBSUo7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7O0FBQ0E7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTs7QUFLTjtFQTVIRjtJQTZISTtJQUNBO0lBRUEsdUJBQ0U7SUFHRjtJQUNBOztFQUVBO0lBQ0U7SUFDQTtJQUNBO0lBQ0E7SUFDQTs7RUFHRjtJQUNFO0lBQ0E7SUFDQTs7RUFFQTtJQUNFOztFQUdGO0lBQ0U7SUFDQTtJQUNBOztFQUdGO0lBQ0U7O0VBRUY7SUFDRTs7RUFJSjtJQUNFLHVCQUNFOztFQUlGO0lBQ0U7SUFDQTs7RUFFRjtJQUNFOzs7QUFLTjtFQXRMRjtJQXVMSTtJQUNBOztFQUdFO0lBQ0U7Ozs7QUMzTE47RUFDRTs7QUFDQTtFQUZGO0lBR0k7OztBQUlKO0VBQ0U7O0FBRUE7RUFDRTs7QUFFQTtFQUhGO0lBSUk7SUFDQTtJQUNBOztFQ1JOO0lBQ0U7O0VBR0Y7SUFDRTs7O0FEUUE7RUFDRTs7QUFJSjtFQUNFOztBQUdGO0VBQ0U7RUFDQTs7QUFHRjtFQUNFOztBQUVBO0VBQ0U7O0FBRUE7RUFIRjtJQUlJOzs7QUFLTjtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUVFOztBQUdGO0VBVkY7SUFXSTs7O0FBR0Y7RUFkRjtJQXNCSTtJQUNBOztFQVJBO0lBQ0U7O0VBR0Y7SUFDRTs7O0FBTUo7RUFDRTtJQUNFOztFQUdGO0lBQ0U7OztBQUlKO0VBQ0U7SUFDRTs7RUFHRjtJQUNFOzs7QUFLTjtFQUNFOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQVBGO0lBUUk7OztBQUdGO0VBWEY7SUFZSTs7O0FBR0Y7RUFmRjtJQWdCSTs7RUMxR0o7SUFDRTs7RUFHRjtJQUNFOzs7QUQwR0Y7RUFDRTtFQUNBOztBQUVBO0VDbkhGO0lBQ0U7O0VBR0Y7SUFDRTs7O0FEaUhBO0VBQ0U7O0FBRUE7RUFIRjtJQUlJOzs7QUFHRjtFQVBGO0lBUUk7OztBQUlKO0VBQ0U7O0FBRUE7RUFIRjtJQUlJOzs7QUFHRjtFQVBGO0lBUUk7OztBQUdGO0VBWEY7SUFZSTs7O0FBS047RUFDRTs7QUFDQTtFQUZGO0lBR0k7Ozs7QUFjSjtFQUNFOztBQUVBO0VBQ0Usa0JBWEo7RUFZSTs7QUFHRjtFQUNFO0VBQ0E7RUFDQSxPQWxCSjs7QUFxQkU7QUFBQTtFQUVFLE81QjVMTztFNEI2TFAsWTVCMUxNO0U0QjJMTjs7QUFHRjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0VBUUU7OztBQTdCSjtFQUNFOztBQUVBO0VBQ0Usa0JBWEo7RUFZSTs7QUFHRjtFQUNFO0VBQ0E7RUFDQSxPQWxCSjs7QUFxQkU7QUFBQTtFQUVFLE81QjVMTztFNEI2TFAsWTVCMUxNO0U0QjJMTjs7QUFHRjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0VBUUU7OztBQTdCSjtFQUNFOztBQUVBO0VBQ0Usa0JBWEo7RUFZSTs7QUFHRjtFQUNFO0VBQ0E7RUFDQSxPQWxCSjs7QUFxQkU7QUFBQTtFQUVFLE81QjVMTztFNEI2TFAsWTVCMUxNO0U0QjJMTjs7QUFHRjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0VBUUU7OztBQTdCSjtFQUNFOztBQUVBO0VBQ0Usa0JBWEo7RUFZSTs7QUFHRjtFQUNFO0VBQ0E7RUFDQSxPQWxCSjs7QUFxQkU7QUFBQTtFQUVFLE81QjVMTztFNEI2TFAsWTVCMUxNO0U0QjJMTjs7QUFHRjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0VBUUU7OztBQTdCSjtFQUNFOztBQUVBO0VBQ0Usa0JBWEo7RUFZSTs7QUFHRjtFQUNFO0VBQ0E7RUFDQSxPQWxCSjs7QUFxQkU7QUFBQTtFQUVFLE81QjVMTztFNEI2TFAsWTVCMUxNO0U0QjJMTjs7QUFHRjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0VBUUU7OztBRXpNSjtFQUNFOztBQUVBO0VBQ0U7O0FBRUE7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTs7QUFNSjtFQUNFO0VBQ0E7OztBQUtOO0VBQ0U7SUFDRTtJQUNBOztFQUVBO0lBQ0U7SUFDQTs7RUFFQTtJQUNFO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7O0VBRUE7SUFDRTs7RUFLTjtJQUNFOztFQUVBO0lBQ0U7SUFDQTtJQUNBOztFQUtKO0lBQ0U7O0VBR0Y7SUFDRTs7O0FDOURKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTs7QUFHRjtFQVRGO0lBVUk7OztBQUdGO0VBYkY7SUFjSTs7O0FBR0Y7RUFqQkY7SUFrQkk7OztBQUdGO0VBQ0U7RUFDQTs7QUFJQTtFQUNFLE8vQjNCSTs7QStCK0JSO0VBQ0U7O0FBRUE7RUFDRTs7QUFHRjtBQUFBO0VBRUU7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBLGtCL0I1REs7O0ErQjhETDtFQXJCRjtBQUFBO0lBc0JJOzs7QUFHRjtBQUFBO0FBQUE7QUFBQTtFQUdFO0VBQ0E7O0FBR0Y7QUFBQTtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUtGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUdFO0VBQ0U7RUFDQTtFQUNBO0VBQ0EsTy9CckRBO0UrQnNEQTs7QUFFRjtFQUNFO0VBQ0E7RUFDQTs7QUFFRjtFQUNFOztBQUtOO0VBQ0U7RUFDQTtFQUNBOztBQUlKO0VBQ0U7RUFDQSxPL0I1RU07RStCNkVOOztBQU1GO0VBQ0U7RUFDQTs7QUFJSjtFQUNFOztBQUVFO0VBREY7SUFFSTtJQUNBOzs7QUFHSjtFQUNFO0VBQ0E7O0FBRUE7RUFDRTtFQUNBOztBQUNBO0VBSEY7SUFJSTtJQUNBOzs7QUFJSjtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQUxGO0lBTUk7OztBQUlKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0FBQUE7QUFBQTtFQUNFOztBQU9OO0VBQ0U7RUFDQTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTs7QUFFQTtFQUhGO0lBSUk7OztBQUtOO0VBQ0U7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBSUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQVRGO0lBVUk7SUFDQTs7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQVRGO0lBVUk7OztBQUdGO0VBYkY7SUFjSTs7O0FBR0Y7RUFqQkY7SUFrQkk7OztBQUdGO0VBckJGO0lBc0JJOzs7QUFLTjtFQUNFOztBQU1KO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBOztBQUtOO0VBQ0U7RUFDQTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBLFkvQm5WRTtFK0JvVkY7RUFDQTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFOztBQUdGO0VBQ0U7O0FBR0Y7RUFDRTs7QUFNSjtFQUNFO0VBQ0EsTy9CalhLO0UrQmtYTDtFQUNBOztBQUlBO0VBREY7SUFFSTs7O0FBSUo7RUFDRTs7QUFFQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUZ4WVI7RUVtWlEsTy9CaFpFOztBK0J1WUY7RUFWRjtJQVdJOzs7QUFHRjtFQWRGO0lBZUk7OztBQU1GO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFURjtJQVVJOzs7QUFNRjtFQUNFOztBQUlKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7O0FBT1Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFHRjtFQUNFOztBQUlKO0VBQ0U7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFJSjtFQUNFOztBQUVBO0VBSEY7SUFJSTs7O0FBR0o7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQUNFO0VBQ0E7O0FBQ0E7RUFIRjtJQUlJO0lBQ0E7Ozs7QUFNUjtFQUNFO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFJSjtFQUNFO0VBQ0EsWUFDRTs7O0FBSUo7RUFDRTtFQUNBLFlBQ0U7OztBQUlKO0VBQ0U7SUFDRTs7RUFFRjtJQUNFOzs7QUFJSjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7SUFDRTtJQUNBOztFQUdGO0lBQ0U7SUFDQTs7O0FBS0o7RUFDRTs7QUFFQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTs7QUFDQTtFQUZGO0lBR0k7SUFDQTtJQUNBOzs7QUFLTjtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0VBQ0Usa0IvQi9tQk87RStCZ25CUDs7QUFDQTtFQUNFOztBQUlKO0VBYkY7SUFjSTs7O0FBSUY7RUFDRSxrQi9CNW5CTztFK0I2bkJQOztBQUNBO0VBQ0U7O0FBSUo7RUFURjtJQVVJOzs7O0FBS047RUFDRTtFQUNBO0VBQ0Esa0IvQjVvQlc7RStCNm9CWDtFQUNBLE8vQmpvQm9CO0UrQmtvQnBCOztBQUVBO0VBUkY7SUFTSTtJQUNBO0lBQ0E7OztBQUdGO0VBQ0U7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7O0FBQ0E7RUFKRjtJQUtJO0lBQ0E7OztBQUdKO0VBQ0U7O0FBQ0E7RUFGRjtJQUdJOzs7QUFJSjtFQUVFO0VBQ0E7RUFDQTtFQUNBLE8vQi9xQlM7O0ErQmlyQlQ7RUFDRTs7O0FBS047RUFDRTtFQUNBOztBQUVBO0VBQ0U7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7O0FBR0Y7RUFDRTs7QUFHRjtFQWxCRjtJQW1CSTtJQUNBOztFQUVBO0lBQ0U7O0VBR0Y7SUFDRTs7O0FBRUE7RUFIRjtJQUlJOzs7QUFaTjtFQWdCRTtJQUNFO0lBQ0E7SUFDQTs7RUFHRjtJQUNFO0lBQ0E7SUFDQTs7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQVJGO0lBU0k7OztBQUdGO0VBQ0U7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFOzs7QUNud0JOO0VBQ0U7RUFFQTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFYRjtJQVlJOzs7QUFJQTtFQUNFLGtCaENOTzs7QWdDU1Q7RUFDRSxrQmhDS007O0FnQ0ZSO0VBQ0Usa0JoQ1RROztBZ0NZVjtFQUNFLGtCaENSUTs7QWdDV1Y7RUFDRSxrQmhDM0JROztBZ0NnQ1Y7QUFBQTtFQUVFO0VBQ0E7RUFDQSxPaENqRE87RWdDa0RQO0VBQ0E7RUFDQTtFQUNBOztBQWFKO0VBQ0U7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUdGO0VBQ0U7RUFDQSxZQUNFO0VBRUY7RUFDQTs7QUFFQTtFQVJGO0lBU0k7OztBQUdGO0VBQ0U7O0FBZUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTs7QUFHRjtFQUNFOztBQUNBO0VBRkY7SUFHSTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBOzs7QUFHRjtFQUNFO0VBQ0E7O0FBQ0E7RUFIRjtJQUlJOzs7QUFFRjtFQU5GO0lBT0k7OztBQUdGO0VBQ0U7O0FBSUY7RUFFRTtFQUNBO0VBQ0EsT2hDL0pDO0VnQ2dLRDtFQUNBOztBQUVBO0VBQ0U7O0FBS0o7RUFDRSxZaEMzS0M7RWdDNEtEO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7O0FBT047RUFDRTtFQUNBO0VBQ0E7O0FBQ0E7RUFKRjtJQUtJOzs7QUFFRjtFQVBGO0lBUUk7OztBQUdGO0VBQ0U7O0FBSUY7RUFFRTtFQUNBO0VBQ0EsT2hDdExPO0VnQ3VMUDtFQUNBOztBQUdGO0VBQ0UsWWhDbk5DO0VnQ29ORDtFQUNBLE9oQzlMTztFZ0MrTFA7RUFDQTs7QUFLTjtFQUNFO0VBQ0E7RUFDQTs7QUFDQTtFQUpGO0lBS0k7OztBQUdGO0FBTUU7QUFlQTs7QUFwQkE7RUFDRTs7QUFLRjtFQUVFO0VBQ0E7RUFDQSxPaEM5T0M7RWdDK09EO0VBQ0E7O0FBRUE7RUFDRTs7QUFNSjtFQUVFLFloQzVQQztFZ0M2UEQ7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTs7QUFPTjtBQU1FO0FBVUE7O0FBZkE7RUFDRTs7QUFLRjtFQUVFO0VBQ0E7RUFDQSxPaEM5UE87RWdDK1BQO0VBQ0E7O0FBSUY7RUFFRSxZaEM3UkM7RWdDOFJEO0VBQ0EsT2hDeFFPO0VnQ3lRUDtFQUNBOztBQU9OO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFTQTtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUlGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFLRjtFQUNFO0VBQ0E7O0FBSUY7RUFDRTtFQUNBO0VBQ0Esa0JoQ2pWRztFZ0NrVkg7RUFDQTtFQUNBO0VBQ0EsT2hDcFZHO0VnQ3FWSDtFQUNBLHVCQUNFO0VBRUY7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQ2hXUjtFQUNFOztBQUNBO0VBQ0U7O0FBQ0E7RUFGRjtJQUdJOzs7QUFFRjtFSlBKO0VJU007O0FBQ0E7RUFDRTtFQUNBOztBQUNBO0VBSEY7SUFJSTs7O0FBS0o7RUFDRTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBLE9qQ3BDRztFaUNxQ0gsWWpDbENFO0VpQ21DRjtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQWxCRjtJQW1CSTs7O0FBSUo7RUFDRTs7QUFHRjtFQUNFLGtCakNwREc7RWlDcURIOztBQUdGO0VBQ0U7O0FBQ0E7RUFFRSxPakN6REE7RWlDMERBLFlqQzdEQzs7QWlDaUVMO0VBQ0Usa0JqQ2xFRztFaUNtRUgsT2pDaEVFO0VpQ2lFRjs7QUFFQTtFQUVFLE9qQ3hFQztFaUN5RUQsWWpDdEVBOztBaUMyRUo7RUFDRTtFQUNBO0VBQ0E7O0FBRUY7RUFDRTs7QUFHSjtFQUNFLE9qQ3JGSTs7QWlDdUZOO0VBQ0U7OztBQU9KO0VBQ0Usa0JqQy9FYTs7QWlDbUZmO0VBQ0Usa0JqQzFFYzs7QWlDOEVoQjtFQUNFLGtCakMxRVk7O0FpQzhFZDtFQUNFLGtCakNuR2M7O0FpQ3VHaEI7RUFDRSxrQmpDOUZjOzs7QWlDa0dwQjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFFQTtFQUNBO0VBQ0E7RUFDQTtFQUVBO0VBQ0E7O0FBR0Y7RUFDRSxPakNqS1M7RWlDa0tUO0VBQ0E7RUFDQTs7O0FBS0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQSxZakMzTFM7RWlDNExUO0VBQ0E7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUlKO0VBQ0U7OztBQy9NRjtFQUNFOztBQUVBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQVBGO0lBUUk7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQVRGO0lBVUk7SUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQSxrQmxDbENLO0U2QkFYO0VBSUE7O0FLa0NNO0VBWEY7SUFZSTtJQUNBOzs7QUFFRjtFQUNFLE9sQ3hDRTs7QWtDMENKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQSxPbEMvQ0U7O0FrQ2lESjtFQUVFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQVJGO0lBU0k7OztBQUlKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFFQSxrQmxDcEVFO0VrQ3FFRjtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFLE9sQzlFQztFa0MrRUQ7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0EsT2xDN0ZEOztBa0NrR1A7RUFDRTtFQUNBO0VBQ0E7O0FBQ0E7RUFKRjtJQUtJO0lMdkdSOzs7QUswR007RUFDRTtFQUNBO0VBQ0E7O0FBRUU7RUFDRTtFQUNBO0VBQ0E7O0FBR0o7RUFDRTtFQUNBO0VBQ0E7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUtFO0VBQ0U7O0FBUVI7RUFDRTs7QUFHSjtFQUNFOztBQUlKO0VBQ0U7O0FBQ0E7RUFGRjtJQUdJOzs7QUFLTjtFQUNFO0VBQ0E7O0FBRUE7RUFKRjtJQUtJOzs7QUFHRjtFQUNFOztBQUtGO0VBREY7SUFFSTs7O0FBSUo7RUFDRSxPbEMvS1E7RWtDZ0xSOztBQUVBO0VBSkY7SUFLSTs7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7OztBQUlKO0VBQ0U7OztBQ2xNQTtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUdGO0VBQ0U7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFOztBQUVBO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBTEY7SUFNSTs7O0FBTUo7RUFERjtJQUVJOzs7O0FDekJKO0VBQ0U7O0FBQ0E7RUFGRjtJQUlJO0lBQ0E7OztBQUVGO0VBUEY7SUFRSTtJQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBTkY7SUFPSTtJQUNBO0lBQ0E7OztBQUdGO0VBWkY7SUFhSTs7O0FBR0Y7RUFoQkY7SUFpQkk7OztBQUdGO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBRUU7RUFDQTs7QUFJTjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFORjtJQU9JOzs7QUFHSjtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0VBTEY7SUFNSTs7O0FBRUY7RUFSRjtJQVNJO0lBQ0E7OztBQUVGO0VBQ0U7O0FBSUE7RUFDRTs7QUFLUjtFQUNFO0VBQ0E7O0FBQ0E7RUFIRjtJQUlJO0lBQ0E7OztBQUdGO0VBQ0U7O0FBQ0E7RUFGRjtJQUdJOzs7QUFFRjtFQUNFOzs7QUNsR1I7RUFDRTs7QUFDQTtFQUZGO0lBR0k7OztBQUdGO0VBQ0U7RUFDQTs7QUFDQTtFQUhGO0lBSUk7SUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7O0FBR0U7RUFDRTs7QUFLRjtFQUNFOztBQUdGO0VBQ0U7O0FBR0Y7RUFDRTs7QUFNUjtFQUNFOztBQUNBO0VBRkY7SUFHSTs7OztBQUtOO0VBQ0U7RUFDQTs7QUFHRTtBQUFBO0VBRUU7RUFDQTs7QUFFQTtBQUFBO0VBQ0U7O0FBR0Y7RUFURjtBQUFBO0lBVUk7OztBQUlBO0VBREY7QUFBQTtJQUVJOzs7QUFLTjtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUxGO0lBTUk7OztBQUdGO0VBVEY7SUFVSTtJQUNBOzs7QUFJQTtFQURGO0lBRUk7OztBQUlKO0VBQ0U7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7O0FBRUE7RUFDRTs7QUFLTjtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFJSjtFQUNFOztBQUNBO0VBRkY7SUFHSTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0Esa0JyQzFJSztFcUMySUw7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTs7QUFLTjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFQRjtJQVFJO0lBQ0E7OztBQUdGO0VBWkY7SUFhSTtJQUNBOzs7QUFHRjtFQWpCRjtJQWtCSTtJQUNBO0lBQ0E7SUFDQTs7O0FBR0Y7RUF4QkY7SUF5Qkk7SUFDQTs7OztBQ2pMUjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFWRjtJQVdJOzs7QUFHRjtFQWRGO0lBZUk7SUFDQTs7O0FBR0Y7RUFuQkY7SUFxQkk7SUFDQTs7O0FBR0Y7RUF6QkY7SUEwQkk7SUFDQTs7O0FBR0Y7RUFDRTs7QUFFQTtFQUhGO0lBSUk7SUFDQTs7O0FBR0Y7RUFSRjtJQVNJOzs7QUFHRjtFQVpGO0lBYUk7OztBQUlGO0VBQ0U7RUFDQTtFQUNBOztBQUVGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVGO0VBQ0U7RUFDQTs7QUFFQTtFQUpGO0lBS0k7OztBQUdKO0VBQ0U7RUFDQTs7QUFFQTtFQUpGO0lBS0k7OztBQUVGO0VBQ0U7O0FBSU47RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFLGtCdEMxRmM7RXNDMkZkO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0VBQ0Usa0J0QzNHRTs7QXNDaUhWO0VBQ0U7RUFDQTs7QUFHRjtFQUNFLGtCdEN2SFE7OztBdUNIWjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBdUNGO0FBQ0E7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7SUFDRTtJQUNBOzs7QUFJSjtFQUNFO0lBQ0U7O0VBR0Y7SUFDRTs7O0FBSUo7RUFDRTtJQUNFOzs7QUFJSjtFQUNFOzs7QUFHRjtFQUNFO0lBQ0U7OztBQUlKO0VBQ0U7SUFDRTtJQUNBOzs7QUFJSjtFQUNFO0lBQ0U7SUFDQTs7O0FBSUo7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7SUFDRTs7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7SUFDRTs7O0FBSUo7RUFDRTtJQUNFOzs7QUFJSjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7SUFDRTs7O0FBSUo7RUFDRTs7O0FBR0Y7RUFDRTtJQUNFO0lBQ0E7OztBQUlKO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7SUFDRTs7O0FBSUo7RUFDRTtJQUNFOzs7QUFJSjtFQUNFO0lBQ0U7OztBQUlKO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7SUFDRTs7O0FBSUo7RUFDRTtJQUNFOzs7QUFJSjtFQUNFO0lBQ0U7OztBQUlKO0VBQ0U7SUFDRTtJQUNBOzs7QUFJSjtFQUNFO0lBQ0U7OztBQUlKO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7SUFDRTs7RUFHRjtJQUNFOztFQUdGO0lBQ0U7SUFDQTs7O0FBSUo7RUFDRTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFO0lBQ0U7OztBQUlKO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTtJQUNFOzs7QUFJSjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7SUFDRTs7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtJQUNFOzs7QUFJSjtFQUNFO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtJQUNFO0lBQ0E7OztBQUlKO0VBQ0U7SUFDRTs7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtJQUNFO0lBQ0E7OztBQUlKO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7OztBQzlmRjtFQUNFOztBQUVBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7O0FBR0Y7RUFaRjtJQWFJOzs7QUFJSjtFQUNFO0VBQ0E7O0FBRUE7RUFDRTs7QUFJSjtFQUNFOztBQUNBO0VBRkY7SUFHSTs7O0FBRUY7RUFMRjtJQU1JOzs7QUFFRjtFQVJGO0lBU0k7OztBQUVGO0VBWEY7SUFZSTs7O0FBS0k7RUFERjtJQUVJOzs7QUFFRjtFQUpGO0lBS0k7OztBQUVGO0VBUEY7SUFRSTs7O0FBRUY7RUFWRjtJQVdJOzs7QUFTTjtFQURGO0lBRUk7SUFDQTtJQUNBOzs7QUFHRjtFQUNFOztBQUlKO0VBQ0U7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFWDFGRjs7QVc4Rkk7RUFERjtJQUVJO0lBQ0E7OztBQUlKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTs7QUFJSjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTs7QUFJSjtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUNFLE14Q25JSzs7QXdDeUlUO0VBQ0U7O0FBRUE7RUFDRTs7QUFHRTtFQUNFOztBQUtOO0VBQ0U7O0FBR0U7RUFDRTs7QUFLTjtFQUNFOztBQUdGO0VBQ0U7RUFDQTtFQUNBOztBQUNBO0VBSkY7SUFLSTs7O0FBRUY7RUFQRjtJQVFJOzs7QUFFRjtFQVZGO0lBV0k7OztBQU1SO0VBQ0U7OztBQ3hMSjtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUxGO0lBTUk7OztBQUVGO0VBUkY7SUFTSTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7RUFDQTs7QUFJSjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFORjtJQU9JOzs7QUFJQTtFQUNFOztBQUVGO0VBQ0U7RUFDQTtFQUNBOztBQUlKO0VBQ0U7O0FBS0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTs7QUFJSjtFQUNFOztBQUVBO0VBSEY7SUFJSTs7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFOztBQUdGO0VBQ0U7RUFDQTtFQUNBOztBQU1JO0VBQ0UsT3pDM0dGO0V5QzRHRTs7QUFPVjtFQUNFLE96Q2xITztFeUNtSFA7RUFDQTtFQUNBO0VBQ0E7O0FBSUo7RUFDRTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBOztBQUdKO0VBQ0U7RUFDQTs7QUFDQTtFQUNFO0VBQ0E7OztBQU1KO0VBQ0U7RUFDQTs7QUFHRTtFQURGO0lBRUk7SUFDQTs7O0FBR0o7RUFDRTs7O0FDdEtOO0VBRUU7O0FBRUE7RUFKRjtJQUtJO0lBQ0E7SUFDQTs7RUFFQTtJQUVFOzs7QUFLRjtFQUNFLGtCMUNoQk87RTBDaUJQLE8xQ2RNOztBMENrQlI7RUFDRSxrQjFDQ2E7RTBDQWIsTzFDdkJPOztBMEMyQlg7RUFDRTs7QUFHRjtFQUNFOztBQUdGO0VBQ0UsTzFDL0JTO0UwQ2dDVDtFQUNBO0VBQ0E7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBTUE7RUFDQTs7QUFMQTtFQUNFOztBQU1GO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBTEY7SUFNSTtJQUNBOzs7QUFJSjtFQUNFO0VBQ0E7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFYRjtJQVlJOzs7QUFNSjtFQURGO0lBRUk7OztBQUtGO0VBREY7SUFFSTs7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUdGO0VBQ0U7RUFDQTs7QUFFQTtFQUNFOztBQU1KO0VBQ0U7OztBQ2pJSjtFQUNFOztBQUNBO0VBRkY7SUFHSTs7O0FBR0o7RUFDRTs7QUFDQTtFQUZGO0lBR0k7OztBQUVGO0VBQ0U7O0FBR0o7RUFDRTs7QUFDQTtBQUFBO0VBRUU7OztBQUtKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0VBVkY7SUFXSTs7O0FBRUY7RUFiRjtJQWNJOzs7QUFFRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQVBGO0lBUUk7OztBQUlOO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0VBQ0U7O0FBQ0E7RUFGRjtJQUdJOzs7QUFJTjtFQUNFO0VBQ0E7RUFDQTs7QUFDQTtFQUVFO0VBQ0E7RUFDQSxZM0N4Rk87RTJDeUZQOztBQUVGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBR0o7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFFRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFSRjtJQVNJO0lBQ0E7OztBQUVGO0VBWkY7SUFhSTtJQUNBOzs7QUFHSjtFQUNFO0VBQ0E7RUFDQTtFQUNBLE8zQ2xJa0I7RTJDbUlsQjtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0VBVkY7SUFXSTtJQUNBO0lBQ0E7SUFDQTs7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTtFQUNBO0VBQ0E7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7O0FBTVI7QUFDRTtFQUNBOztBQUNBO0VBQ0U7RUFDQTtFQUNBOzs7QUFHSjtBQUNFO0VBQ0E7O0FBQ0E7RUFDRTtFQUNBO0VBQ0E7OztBQUdKO0FBQ0U7RUFDQTs7QUFDQTtFQUNFO0VBQ0E7RUFDQTs7O0FBR0o7QUFDRTtFQUNBOztBQUNBO0VBQ0U7RUFDQTtFQUNBOzs7QUFJSjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7OztBQ3pPRjtFQUNFOztBQUVBO0VBSEY7SUFJSTs7O0FBR0Y7RUFQRjtJQVFJOzs7QUFHRjtFQVhGO0lBWUk7OztBQUdGO0VBZkY7SUFnQkk7OztBQUVGO0VBQ0U7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQVJGO0lBU0k7OztBQUVGO0VBWEY7SUFZSTs7O0FBSUo7RUFDRTtFQUNBOztBQUNBO0VBSEY7SUFJSTs7O0FBSUo7RUFDRTtFQUNBLFk1QzlDUztFNEMrQ1Q7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQUxGO0lBTUk7OztBQUdKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTs7QUFHSjtFQUNFO0VBQ0E7O0FBQ0E7RUFIRjtJQUlJOzs7QUMzRk47RUFDRTs7QUFDQTtFQUZGO0lBR0k7OztBQUVGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBR0E7RUFERjtJQUVJO0lBQ0E7Ozs7QUNkTjtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUxGO0lBTUk7OztBQUdGO0VBVEY7SUFVSTs7O0FBR0Y7RUFiRjtJQWNJOzs7QUFHRjtFQWpCRjtJQWtCSTs7O0FBRUY7RUFDRTs7QUFDQTtFQUZGO0lBR0k7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBOzs7QUFHSjtFQUNFO0VBQ0E7RUFDQTs7QUFDQTtFQUpGO0lBS0k7SUFDQTs7O0FBR0o7RUFDRTs7QUFFQTtFQUhGO0lBSUk7SUFDQTtJQUNBOzs7QUFJRjtFQURGO0lBRUk7OztBQUdKO0VBQ0U7O0FBQ0E7RUFGRjtJQUdJOzs7O0FDekROO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBR0o7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFO0VBQ0EsTy9DeEJPO0UrQ3lCUDs7QUFHSjtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUNFOztBQUVGO0VBQ0U7O0FBR0o7RUFDRTtFQUNBO0VBQ0E7OztBQzNDRjtFQUNFOztBQUNBO0VBQ0U7RUFDQTs7QUFDQTtFQUNFO0VBQ0E7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBTUE7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFsQkY7SUFtQkk7SUFDQTs7O0FBR0Y7RUFFRTtFQUNBOztBQU1KO0VBQ0U7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0VBQ0U7RUFDQTtFQUNBOztBQUNBO0VBSkY7SUFLSTtJQUNBOzs7QUFLTjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBLFloRHhFUztFZ0R5RVQ7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0VBQ0UsY2hEdEVnQjtFZ0R1RWhCOztBQUVGO0VBQ0U7O0FBSUo7RUFDRTtFQUNBO0VBQ0EsWWhEM0ZTO0VnRDRGVDs7QUFFQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQUNFO0VBQ0E7O0FBSUY7RUFDRTtFQUNBO0VBQ0E7O0FBRUY7RUFDRTs7QUFDQTtFQUNFLE9oRC9GUzs7QWdEaUdYO0VBQ0UsT2hEbEhLIiwic291cmNlc0NvbnRlbnQiOlsiXG4qLFxuKjo6YmVmb3JlLFxuKjo6YWZ0ZXIge1xuICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xufVxuXG5odG1sIHtcbiAgZm9udC1mYW1pbHk6IHNhbnMtc2VyaWY7XG4gIGxpbmUtaGVpZ2h0OiAxLjE1O1xuICAtd2Via2l0LXRleHQtc2l6ZS1hZGp1c3Q6IDEwMCU7XG4gIC13ZWJraXQtdGFwLWhpZ2hsaWdodC1jb2xvcjogcmdiYSgwLCAwLCAwLCAwKTtcbiAgc2Nyb2xsLWJlaGF2aW9yOiBzbW9vdGg7XG59XG5cbmFydGljbGUsXG5hc2lkZSxcbmZpZ2NhcHRpb24sXG5maWd1cmUsXG5mb290ZXIsXG5oZWFkZXIsXG5oZ3JvdXAsXG5tYWluLFxubmF2LFxuc2VjdGlvbiB7XG4gIGRpc3BsYXk6IGJsb2NrO1xufVxuXG5ib2R5IHtcbiAgbWFyZ2luOiAwO1xuICBmb250LWZhbWlseTogXCJGUyBNZVwiLCBzYW5zLXNlcmlmO1xuICBmb250LXNpemU6IDAuOXJlbTtcbiAgZm9udC13ZWlnaHQ6IDQwMDtcbiAgbGluZS1oZWlnaHQ6IDEuNjtcbiAgY29sb3I6ICMwMDA7XG4gIHRleHQtYWxpZ246IGxlZnQ7XG4gIGJhY2tncm91bmQtY29sb3I6ICNmZmY7XG59XG5cblt0YWJpbmRleD1cIi0xXCJdOmZvY3VzOm5vdCg6Zm9jdXMtdmlzaWJsZSkge1xuICBvdXRsaW5lOiAwICFpbXBvcnRhbnQ7XG59XG5cbmhyIHtcbiAgYm94LXNpemluZzogY29udGVudC1ib3g7XG4gIGhlaWdodDogMDtcbiAgb3ZlcmZsb3c6IHZpc2libGU7XG59XG5cbmgxLFxuaDIsXG5oMyxcbmg0LFxuaDUsXG5oNiB7XG4gIG1hcmdpbi10b3A6IDA7XG4gIG1hcmdpbi1ib3R0b206IDAuNXJlbTtcbn1cblxucCB7XG4gIG1hcmdpbi10b3A6IDA7XG4gIG1hcmdpbi1ib3R0b206IDFyZW07XG59XG5cbmFiYnJbdGl0bGVdLFxuYWJicltkYXRhLW9yaWdpbmFsLXRpdGxlXSB7XG4gIHRleHQtZGVjb3JhdGlvbjogdW5kZXJsaW5lO1xuICAtd2Via2l0LXRleHQtZGVjb3JhdGlvbjogdW5kZXJsaW5lIGRvdHRlZDtcbiAgdGV4dC1kZWNvcmF0aW9uOiB1bmRlcmxpbmUgZG90dGVkO1xuICBjdXJzb3I6IGhlbHA7XG4gIGJvcmRlci1ib3R0b206IDA7XG4gIC13ZWJraXQtdGV4dC1kZWNvcmF0aW9uLXNraXAtaW5rOiBub25lO1xuICB0ZXh0LWRlY29yYXRpb24tc2tpcC1pbms6IG5vbmU7XG59XG5cbmFkZHJlc3Mge1xuICBtYXJnaW4tYm90dG9tOiAxcmVtO1xuICBmb250LXN0eWxlOiBub3JtYWw7XG4gIGxpbmUtaGVpZ2h0OiBpbmhlcml0O1xufVxuXG5vbCxcbnVsLFxuZGwge1xuICBtYXJnaW4tdG9wOiAwO1xuICBtYXJnaW4tYm90dG9tOiAxcmVtO1xufVxuXG5vbCBvbCxcbnVsIHVsLFxub2wgdWwsXG51bCBvbCB7XG4gIG1hcmdpbi1ib3R0b206IDA7XG59XG5cbmR0IHtcbiAgZm9udC13ZWlnaHQ6IDcwMDtcbn1cblxuZGQge1xuICBtYXJnaW4tYm90dG9tOiAwLjVyZW07XG4gIG1hcmdpbi1sZWZ0OiAwO1xufVxuXG5ibG9ja3F1b3RlIHtcbiAgbWFyZ2luOiAwIDAgMXJlbTtcbn1cblxuYixcbnN0cm9uZyB7XG4gIGZvbnQtd2VpZ2h0OiBib2xkZXI7XG59XG5cbnNtYWxsIHtcbiAgZm9udC1zaXplOiA4MCU7XG59XG5cbnN1YixcbnN1cCB7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgZm9udC1zaXplOiA3NSU7XG4gIGxpbmUtaGVpZ2h0OiAwO1xuICB2ZXJ0aWNhbC1hbGlnbjogYmFzZWxpbmU7XG59XG5cbnN1YiB7XG4gIGJvdHRvbTogLTAuMjVlbTtcbn1cblxuc3VwIHtcbiAgdG9wOiAtMC41ZW07XG59XG5cbmEge1xuICBjb2xvcjogIzM0OTBkYztcbiAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB0cmFuc3BhcmVudDtcbn1cblxuYTpob3ZlciB7XG4gIGNvbG9yOiAjMWQ2OGE3O1xuICB0ZXh0LWRlY29yYXRpb246IHVuZGVybGluZTtcbn1cblxuYTpub3QoW2hyZWZdKTpub3QoW2NsYXNzXSkge1xuICBjb2xvcjogaW5oZXJpdDtcbiAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xufVxuXG5hOm5vdChbaHJlZl0pOm5vdChbY2xhc3NdKTpob3ZlciB7XG4gIGNvbG9yOiBpbmhlcml0O1xuICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG59XG5cbnByZSxcbmNvZGUsXG5rYmQsXG5zYW1wIHtcbiAgZm9udC1mYW1pbHk6IFNGTW9uby1SZWd1bGFyLCBNZW5sbywgTW9uYWNvLCBDb25zb2xhcywgXCJMaWJlcmF0aW9uIE1vbm9cIiwgXCJDb3VyaWVyIE5ld1wiLCBtb25vc3BhY2U7XG4gIGZvbnQtc2l6ZTogMWVtO1xufVxuXG5wcmUge1xuICBtYXJnaW4tdG9wOiAwO1xuICBtYXJnaW4tYm90dG9tOiAxcmVtO1xuICBvdmVyZmxvdzogYXV0bztcbiAgLW1zLW92ZXJmbG93LXN0eWxlOiBzY3JvbGxiYXI7XG59XG5cbmZpZ3VyZSB7XG4gIG1hcmdpbjogMCAwIDFyZW07XG59XG5cbmltZyB7XG4gIHZlcnRpY2FsLWFsaWduOiBtaWRkbGU7XG4gIGJvcmRlci1zdHlsZTogbm9uZTtcbn1cblxuc3ZnIHtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgdmVydGljYWwtYWxpZ246IG1pZGRsZTtcbn1cblxudGFibGUge1xuICBib3JkZXItY29sbGFwc2U6IGNvbGxhcHNlO1xufVxuXG5jYXB0aW9uIHtcbiAgcGFkZGluZy10b3A6IDAuNzVyZW07XG4gIHBhZGRpbmctYm90dG9tOiAwLjc1cmVtO1xuICBjb2xvcjogIzZjNzU3ZDtcbiAgdGV4dC1hbGlnbjogbGVmdDtcbiAgY2FwdGlvbi1zaWRlOiBib3R0b207XG59XG5cbnRoIHtcbiAgdGV4dC1hbGlnbjogaW5oZXJpdDtcbiAgdGV4dC1hbGlnbjogLXdlYmtpdC1tYXRjaC1wYXJlbnQ7XG59XG5cbmxhYmVsIHtcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICBtYXJnaW4tYm90dG9tOiAwLjVyZW07XG59XG5cbmJ1dHRvbiB7XG4gIGJvcmRlci1yYWRpdXM6IDA7XG59XG5cbmJ1dHRvbjpmb2N1czpub3QoOmZvY3VzLXZpc2libGUpIHtcbiAgb3V0bGluZTogMDtcbn1cblxuaW5wdXQsXG5idXR0b24sXG5zZWxlY3QsXG5vcHRncm91cCxcbnRleHRhcmVhIHtcbiAgbWFyZ2luOiAwO1xuICBmb250LWZhbWlseTogaW5oZXJpdDtcbiAgZm9udC1zaXplOiBpbmhlcml0O1xuICBsaW5lLWhlaWdodDogaW5oZXJpdDtcbn1cblxuYnV0dG9uLFxuaW5wdXQge1xuICBvdmVyZmxvdzogdmlzaWJsZTtcbn1cblxuYnV0dG9uLFxuc2VsZWN0IHtcbiAgdGV4dC10cmFuc2Zvcm06IG5vbmU7XG59XG5cbltyb2xlPWJ1dHRvbl0ge1xuICBjdXJzb3I6IHBvaW50ZXI7XG59XG5cbnNlbGVjdCB7XG4gIHdvcmQtd3JhcDogbm9ybWFsO1xufVxuXG5cbmJ1dHRvbjpub3QoOmRpc2FibGVkKSxcblt0eXBlPWJ1dHRvbl06bm90KDpkaXNhYmxlZCksXG5bdHlwZT1yZXNldF06bm90KDpkaXNhYmxlZCksXG5bdHlwZT1zdWJtaXRdOm5vdCg6ZGlzYWJsZWQpIHtcbiAgY3Vyc29yOiBwb2ludGVyO1xufVxuXG5idXR0b246Oi1tb3otZm9jdXMtaW5uZXIsXG5bdHlwZT1idXR0b25dOjotbW96LWZvY3VzLWlubmVyLFxuW3R5cGU9cmVzZXRdOjotbW96LWZvY3VzLWlubmVyLFxuW3R5cGU9c3VibWl0XTo6LW1vei1mb2N1cy1pbm5lciB7XG4gIHBhZGRpbmc6IDA7XG4gIGJvcmRlci1zdHlsZTogbm9uZTtcbn1cblxuaW5wdXRbdHlwZT1yYWRpb10sXG5pbnB1dFt0eXBlPWNoZWNrYm94XSB7XG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gIHBhZGRpbmc6IDA7XG59XG5cbnRleHRhcmVhIHtcbiAgb3ZlcmZsb3c6IGF1dG87XG4gIHJlc2l6ZTogdmVydGljYWw7XG59XG5cblxucHJvZ3Jlc3Mge1xuICB2ZXJ0aWNhbC1hbGlnbjogYmFzZWxpbmU7XG59XG5cblt0eXBlPW51bWJlcl06Oi13ZWJraXQtaW5uZXItc3Bpbi1idXR0b24sXG5bdHlwZT1udW1iZXJdOjotd2Via2l0LW91dGVyLXNwaW4tYnV0dG9uIHtcbiAgaGVpZ2h0OiBhdXRvO1xufVxuXG5bdHlwZT1zZWFyY2hdOjotd2Via2l0LXNlYXJjaC1kZWNvcmF0aW9uIHtcbiAgLXdlYmtpdC1hcHBlYXJhbmNlOiBub25lO1xufVxuXG46Oi13ZWJraXQtZmlsZS11cGxvYWQtYnV0dG9uIHtcbiAgZm9udDogaW5oZXJpdDtcbiAgLXdlYmtpdC1hcHBlYXJhbmNlOiBidXR0b247XG59XG5cbm91dHB1dCB7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbn1cblxuc3VtbWFyeSB7XG4gIGRpc3BsYXk6IGxpc3QtaXRlbTtcbiAgY3Vyc29yOiBwb2ludGVyO1xufVxuXG50ZW1wbGF0ZSB7XG4gIGRpc3BsYXk6IG5vbmU7XG59XG5cbltoaWRkZW5dIHtcbiAgZGlzcGxheTogbm9uZSAhaW1wb3J0YW50O1xufVxuXG5pbWcge1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDAlO1xufVxuIiwiLyogIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMgZXJnbyBjb2xvcnMgIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMgKi9cbiRlcmdvLXdoaXRlOiAjZmZmO1xuJGVyZ28tYmxhY2s6ICMwMDA7XG4kZXJnby1ibGFjay1yZ2I6IHJnYigwLCAwLCAwKTtcbiRlcmdvLW1haW46ICM4ZTAwMzg7XG4kZXJnby1yZWQ6ICNiZjE1Mjg7XG4kZXJnby1lcnJvcjogI2ZmMDAzZTtcbiRlcmdvLWFjY2VudDogI2Q0YTJiNjtcbiRlcmdvLWFjY2VudDI6ICM2YTAwMjk7XG4kZXJnby1ncmV5LWxpZ2h0OiAjMDAwMDAwMTA7XG4kZXJnby13YXJtZ3JleTogI2Q5ZDVjNztcbiRlcmdvLXdhcm1ncmV5LWxpZ2h0OiAjZWJlNmQ4O1xuJGVyZ28td2FybWdyZXktZGFyazE6ICNiYmI5YWQ7XG4kZXJnby13YXJtZ3JleS1kYXJrMjogIzgwN2U2ZjtcbiRlcmdvLXdhcm1ncmV5LWRhcmszOiAjNTQ1MjQxO1xuJGVyZ28tdmlvbGV0OiAjZTRkNmU0O1xuJGVyZ28tdmlvbGV0LWxpZ2h0OiAjZWZlN2VkO1xuJGVyZ28tdmlvbGV0LWRhcmsxOiAjZGJhY2NjO1xuJGVyZ28tdmlvbGV0LWRhcmsyOiAjY2U1ZTkyO1xuJGVyZ28tdmlvbGV0LWRhcmszOiAjYjMxNzY3O1xuJGVyZ28tZ3JlZW46ICNiNWQ1YzE7XG4kZXJnby1ncmVlbi1saWdodDogI2UzZjBlNjtcbiRlcmdvLWdyZWVuLWRhcmsxOiAjOGJjOWFkO1xuJGVyZ28tZ3JlZW4tZGFyazI6ICM1ZmI4YTI7XG4kZXJnby1ncmVlbi1kYXJrMzogIzAwOTI4NDtcbiRlcmdvLXllbGxvdzogI2Y4ZTg5ZDtcbiRlcmdvLXllbGxvdy1saWdodDogI2ZmZjRiMDtcbiRlcmdvLXllbGxvdy1kYXJrMTogI2Y3ZGI2ZjtcbiRlcmdvLXllbGxvdy1kYXJrMjogI2ZhZDczYjtcbiRlcmdvLXllbGxvdy1kYXJrMzogI2Y2Y2IwMDtcbiRlcmdvLW9yYW5nZTogI2Y3ZGNiYjtcbiRlcmdvLW9yYW5nZS1saWdodDogI2ZmZWVkZTtcbiRlcmdvLW9yYW5nZS1kYXJrMTogI2YzYzU5MTtcbiRlcmdvLW9yYW5nZS1kYXJrMjogI2VmYTU2ZDtcbiRlcmdvLW9yYW5nZS1kYXJrMzogI2U4N2ExNjtcbiRlcmdvLWJsdWU6ICNjY2ViZWQ7XG4kZXJnby1ibHVlLWxpZ2h0OiAjZTJmNmZhO1xuJGVyZ28tYmx1ZS1kYXJrMTogI2E5ZGFlMDtcbiRlcmdvLWJsdWUtZGFyazI6ICM0N2JjYzU7XG4kZXJnby1ibHVlLWRhcmszOiAjMGY5NGE3O1xuXG4kZXJnby1pbnB1dDogcmdiYSg4NCwgODIsIDY1LCAxKTtcbiRlcmdvLWlucHV0MjogcmdiYSg4NCwgODIsIDY1LCAwLjQpO1xuJGVyZ28taW5wdXQzOiByZ2JhKDAsIDAsIDAsIDAuNik7XG5cbi8qIERLViBDb2xvcnMgKi9cbi8vICRka3YtZ3J1ZW46ICM5OGE5MmE7XG4vLyAkZGt2LWR1bmtlbGdydWVuOiAjMDk1NzUxO1xuLy8gJGRrdi13ZWlzczogI2ZmZmZmZjtcbi8vICRka3YtZ3JhdTogIzZhNjI1YTtcbi8vICRka3YtZ2VsYjogI2Y5Y2MyNTtcbi8vICRka3Ytcm90OiAjOGUwMDM4O1xuXG4vL0JyZWFrcG9pbnRzXG4kc206IDU3NnB4OyAvLyA8bW9iaWxlXG4kbWQ6IDc2OHB4OyAvLyA8dGFibGV0XG4kbGc6IDk5MnB4OyAvLyA8dGFibGV0XG4keGw6IDEyMDBweDsgLy8gPGRlc2t0b3BcbiR4eGw6IDE5MjBweDsgLy8gPHdpZGUgZGVza3RvcFxuIiwiQGZvbnQtZmFjZSB7XG4gIGZvbnQtZmFtaWx5OiBcIkZlZHJhU2VyaWZBXCI7XG4gIHNyYzogdXJsKC4uL2ZvbnRzL0ZlZHJhU2VyaWZBUHJvLU5vcm1hbC5lb3Q/NmM3NDAyYTRlOWZkMmYwZWEwMmNiZjg4MGJjYTBlN2EpO1xuICBzcmM6IHVybCguLi9mb250cy9GZWRyYVNlcmlmQVByby1Ob3JtYWwuZW90PzZjNzQwMmE0ZTlmZDJmMGVhMDJjYmY4ODBiY2EwZTdhKSBmb3JtYXQoXCJlbWJlZGRlZC1vcGVudHlwZVwiKSxcbiAgdXJsKC4uL2ZvbnRzL0ZlZHJhU2VyaWZBUHJvLU5vcm1hbC53b2ZmMj80YjFlNWI3ZjQyNGMyODE1ZWZjNmYxNWIzMGNiZjc3OSkgZm9ybWF0KFwid29mZjJcIiksXG4gIHVybCguLi9mb250cy9GZWRyYVNlcmlmQVByby1Ob3JtYWwud29mZj85NjVkOGMzOWI0MmExZGY3NDUzM2QzNDFmZmZiMDljMSkgZm9ybWF0KFwid29mZlwiKSxcbiAgdXJsKC4uL2ZvbnRzL0ZlZHJhU2VyaWZBUHJvLU5vcm1hbC50dGY/MTgzNTVjODY3YjZiNTAwZDhmMjU4NGUzYmE5Y2QxNzQpIGZvcm1hdChcInRydWV0eXBlXCIpLFxuICB1cmwoLi4vZm9udHMvRmVkcmFTZXJpZkFQcm8tTm9ybWFsLnN2Zz9mMzZjZmJiOTE4OGJjOThjYTJmZmQxMjFlZjhiNTk4ZikgZm9ybWF0KFwic3ZnXCIpO1xuICBmb250LXdlaWdodDogbm9ybWFsO1xuICBmb250LXN0eWxlOiBub3JtYWw7XG59XG5cbkBmb250LWZhY2Uge1xuICBmb250LWZhbWlseTogXCJGU01lXCI7XG4gIHNyYzogdXJsKC4uL2ZvbnRzL0ZTTWUuZW90Pzk0NDU4MzUyYjkxZDhhYjQ0ZDMxNDcxOWZjNTk2ODRkKTtcbiAgc3JjOiB1cmwoLi4vZm9udHMvRlNNZS5lb3Q/OTQ0NTgzNTJiOTFkOGFiNDRkMzE0NzE5ZmM1OTY4NGQpIGZvcm1hdChcImVtYmVkZGVkLW9wZW50eXBlXCIpLFxuICB1cmwoLi4vZm9udHMvRlNNZS53b2ZmMj9kMTQ2MjAxMTQyNTVmZWQ2ZDk0NzIwNTk2ZTM4YzMzNykgZm9ybWF0KFwid29mZjJcIiksXG4gIHVybCguLi9mb250cy9GU01lLndvZmY/MGM0ZjgyMTk1Y2JhNzY2NDQ0ZDQ2ZWQzNDAzYjMwNTEpIGZvcm1hdChcIndvZmZcIiksXG4gIHVybCguLi9mb250cy9GU01lLnR0Zj8wOGI1ZDhkOGU3YmIyOGE1MjAwMWYxZmE2ODNiYTViNSkgZm9ybWF0KFwidHJ1ZXR5cGVcIiksXG4gIHVybCguLi9mb250cy9GU01lLnN2Zz8wN2IwOWM3MDZlNWYwYTM1YzgzZGRhZDAwODQ5ZjE0ZSkgZm9ybWF0KFwic3ZnXCIpO1xuICBmb250LXdlaWdodDogbm9ybWFsO1xuICBmb250LXN0eWxlOiBub3JtYWw7XG59XG5cbkBmb250LWZhY2Uge1xuICBmb250LWZhbWlseTogXCJGU01lXCI7XG4gIHNyYzogdXJsKC4uL2ZvbnRzL0ZTTWUtQm9sZC5lb3Q/MTM4NTg1NDI2NzE3MWRjZGM0YzIwYzI5MWU5OThjOGQpO1xuICBzcmM6IHVybCguLi9mb250cy9GU01lLUJvbGQuZW90PzEzODU4NTQyNjcxNzFkY2RjNGMyMGMyOTFlOTk4YzhkKSBmb3JtYXQoXCJlbWJlZGRlZC1vcGVudHlwZVwiKSxcbiAgdXJsKC4uL2ZvbnRzL0ZTTWUtQm9sZC53b2ZmMj8zMDZmMzA1NDYwY2VjN2U5OGIxMzgxYWE4Y2Q4MTQwOCkgZm9ybWF0KFwid29mZjJcIiksXG4gIHVybCguLi9mb250cy9GU01lLUJvbGQud29mZj9jMGIyNjYxMTdjYzkzNDQ5YzZjZmVmZDU3OWEyZGI5ZCkgZm9ybWF0KFwid29mZlwiKSxcbiAgdXJsKC4uL2ZvbnRzL0ZTTWUtQm9sZC50dGY/NGY3YTViY2U2MjhjZGEwZDI2MWI5MjQzNzVhMzJlY2IpIGZvcm1hdChcInRydWV0eXBlXCIpLFxuICB1cmwoLi4vZm9udHMvRlNNZS1Cb2xkLnN2Zz8yMDRlODE0MjkzOWU5NTg4YTUyMGFhNmY0ZTUxYjFjOSkgZm9ybWF0KFwic3ZnXCIpO1xuICBmb250LXdlaWdodDogYm9sZDtcbiAgZm9udC1zdHlsZTogbm9ybWFsO1xufVxuXG5AZm9udC1mYWNlIHtcbiAgZm9udC1mYW1pbHk6IFwiRlNNZUxpZ2h0XCI7XG4gIHNyYzogdXJsKC4uL2ZvbnRzL0ZTTWVMaWdodC5lb3Q/ODk4MjY2MDQwZGNiMmU3MzQwNWYwYjUzYjMxZWZlYTcpO1xuICBzcmM6IHVybCguLi9mb250cy9GU01lTGlnaHQuZW90Pzg5ODI2NjA0MGRjYjJlNzM0MDVmMGI1M2IzMWVmZWE3KSBmb3JtYXQoXCJlbWJlZGRlZC1vcGVudHlwZVwiKSxcbiAgdXJsKC4uL2ZvbnRzL0ZTTWVMaWdodC53b2ZmMj8wODljOGM2MTVjN2RhYjQ1MjVlNjFjY2QwOWE1NzNiYikgZm9ybWF0KFwid29mZjJcIiksXG4gIHVybCguLi9mb250cy9GU01lTGlnaHQud29mZj9lZWVlMWYwNTFkZmU3MDE3MjcxMzY3ZmNiOTEwMGFkNikgZm9ybWF0KFwid29mZlwiKSxcbiAgdXJsKC4uL2ZvbnRzL0ZTTWVMaWdodC50dGY/ZGU1ODgzYWZiMTQxYTBmMDkwZTQzOWIyMDQ1ZDc4MjApIGZvcm1hdChcInRydWV0eXBlXCIpLFxuICB1cmwoLi4vZm9udHMvRlNNZUxpZ2h0LnN2Zz9mZWY0ZGQ1OTZiZDI5ODdhMjM5Y2Q2ZmFjOGZhNTUzYykgZm9ybWF0KFwic3ZnXCIpO1xuICBmb250LXdlaWdodDogbm9ybWFsO1xuICBmb250LXN0eWxlOiBub3JtYWw7XG59IiwiLyogVFlQT0dSQVBIWSAqL1xuXG5odG1sIHtcbiAgZm9udC1zaXplOiAxcmVtO1xufVxuXG5ib2R5LFxuLmZvbnQtc2FucyB7XG4gIGZvbnQtZmFtaWx5OiAnRlNNZSc7XG4gIGZvbnQtc2l6ZTogMXJlbTtcbn1cblxuaDEsXG5oMixcbmgzLFxuaDQsXG5oNSB7XG4gIGZvbnQtZmFtaWx5OiAnRmVkcmFTZXJpZkEnO1xuICBsaW5lLWhlaWdodDogMS41ICFpbXBvcnRhbnQ7XG59XG5cbnN0cm9uZyB7XG4gIGZvbnQtd2VpZ2h0OiBib2xkO1xufVxuXG4vKiBNb2JpbGU6ICovXG5oMSxcbi5oMSB7XG4gIGZvbnQtc2l6ZTogMS41cmVtO1xuICBjb2xvcjogJGVyZ28tbWFpbjtcbn1cblxuaDEuaDEtLXNtYWxsIHtcbiAgZm9udC1zaXplOiAxLjM3NXJlbTtcbiAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogMTIwMHB4KSB7XG4gICAgZm9udC1zaXplOiAycmVtO1xuICB9XG59XG5cbmgyLFxuLmgyIHtcbiAgZm9udC1zaXplOiAxLjM3NXJlbTtcbiAgY29sb3I6ICRlcmdvLW1haW47XG4gIGZvbnQtd2VpZ2h0OiA1MDA7XG59XG5cbmgzLFxuLmgzIHtcbiAgZm9udC1zaXplOiAxLjEyNXJlbTtcbiAgbGluZS1oZWlnaHQ6IDEuNzVyZW07XG4gIGNvbG9yOiAkZXJnby1ibGFjaztcbiAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gIGZvbnQtZmFtaWx5OiAnRlNNZSc7XG59XG5cbmg0LFxuLmg0IHtcbiAgZm9udC1mYW1pbHk6ICdGU01lJztcbiAgZm9udC1zaXplOiAxcmVtO1xuICBmb250LXdlaWdodDogYm9sZDtcbiAgY29sb3I6ICRlcmdvLWJsYWNrO1xuICBtYXJnaW46IDA7XG59XG5cbmg1LFxuLmg1IHtcbiAgZm9udC1mYW1pbHk6ICdGU01lJztcbiAgZm9udC1zaXplOiAwLjg3NXJlbTtcbiAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gIGNvbG9yOiAkZXJnby1ibGFjaztcbiAgbGluZS1oZWlnaHQ6IDE0MCU7XG59XG5cbi5sZWFkIHtcbiAgZm9udC1zaXplOiAxLjEyNXJlbTtcbiAgZm9udC1mYW1pbHk6ICdGU01lJztcbiAgZm9udC13ZWlnaHQ6IDQwMDtcbiAgbGluZS1oZWlnaHQ6IDE0MCU7XG59XG5cbnAge1xuICBmb250LXNpemU6IDFyZW07XG4gIGZvbnQtZmFtaWx5OiAnRlNNZSc7XG4gIGZvbnQtd2VpZ2h0OiA0MDA7XG4gIGxpbmUtaGVpZ2h0OiAxNDAlO1xufVxuXG4uYzEge1xuICBmb250LXNpemU6IDFyZW07XG59XG4uYzIge1xuICBmb250LXNpemU6IDAuODc1cmVtO1xufVxuLmMzIHtcbiAgZm9udC1zaXplOiAwLjc1cmVtO1xufVxuXG5hLnRleHQtbGluayB7XG4gIGNvbG9yOiAkZXJnby1tYWluO1xuICBmb250LXdlaWdodDogYm9sZDtcbn1cblxuLyogTW9iaWxlOiBUYWJlbGV0ICovXG5AbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiA1NzZweCkge1xuICAubGVhZCB7XG4gICAgZm9udC1zaXplOiAxLjI1cmVtO1xuICB9XG59XG5cbi8qIFRhYmxldDogKi9cbkBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6IDc2OHB4KSB7XG4gIGgxLFxuICAuaDEge1xuICAgIGZvbnQtc2l6ZTogMS42MjVyZW07XG4gIH1cbiAgaDIsXG4gIC5oMiB7XG4gICAgZm9udC1zaXplOiAxLjVyZW07XG4gIH1cbiAgaDMsXG4gIC5oMyB7XG4gICAgZm9udC1zaXplOiAxLjI1cmVtO1xuICB9XG4gIGg0LFxuICAuaDQge1xuICAgIGZvbnQtc2l6ZTogMS4xMjVyZW07XG4gIH1cbiAgaDUsXG4gIC5oNSB7XG4gICAgZm9udC1zaXplOiAxcmVtO1xuICB9XG4gIHAge1xuICAgIGZvbnQtc2l6ZTogMS4xMjVyZW07XG4gIH1cbiAgLmMxIHtcbiAgICBmb250LXNpemU6IDEuMTI1cmVtO1xuICB9XG4gIC5jMiB7XG4gICAgZm9udC1zaXplOiAxcmVtO1xuICB9XG4gIC5jMyB7XG4gICAgZm9udC1zaXplOiAwLjc1cmVtO1xuICB9XG59XG5cbi8qIFRhYmxldCAvIERlc2t0b3A6ICovXG5AbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiA5OTJweCkge1xufVxuXG4vKiBEZXNrdG9wOiAqL1xuQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogMTIwMHB4KSB7XG4gIGgxLFxuICAuaDEge1xuICAgIGZvbnQtc2l6ZTogMnJlbTtcbiAgfVxuICBoMixcbiAgLmgyIHtcbiAgICBmb250LXNpemU6IDEuNzVyZW07XG4gIH1cbiAgaDMsXG4gIC5oMyB7XG4gICAgZm9udC1zaXplOiAxLjVyZW07XG4gIH1cbiAgaDQsXG4gIC5oNCB7XG4gICAgZm9udC1zaXplOiAxLjI1cmVtO1xuICB9XG4gIC5sZWFkIHtcbiAgICBmb250LXNpemU6IDEuNXJlbTtcbiAgfVxuICBwIHtcbiAgICBmb250LXNpemU6IDEuMjVyZW07XG4gIH1cbiAgLmMxIHtcbiAgICBmb250LXNpemU6IDEuMjVyZW07XG4gIH1cbiAgLmMyIHtcbiAgICBmb250LXNpemU6IDFyZW07XG4gIH1cbiAgLmMzIHtcbiAgICBmb250LXNpemU6IDAuNzVyZW07XG4gIH1cbn1cbiIsIi5zbGlkZS1vdXQtYmx1cnJlZC10b3Age1xuICAtd2Via2l0LWFuaW1hdGlvbjogc2xpZGUtb3V0LWJsdXJyZWQtdG9wIDAuNDVzIGN1YmljLWJlemllcigwLjc1NSwgMC4wNTAsIDAuODU1LCAwLjA2MCkgYm90aDtcbiAgYW5pbWF0aW9uOiBzbGlkZS1vdXQtYmx1cnJlZC10b3AgMC40NXMgY3ViaWMtYmV6aWVyKDAuNzU1LCAwLjA1MCwgMC44NTUsIDAuMDYwKSBib3RoO1xufVxuXG4uc2xpZGUtb3V0LWJsdXJyZWQtbGVmdCB7XG4gIC13ZWJraXQtYW5pbWF0aW9uOiBzbGlkZS1vdXQtYmx1cnJlZC1sZWZ0IDAuNDVzIGN1YmljLWJlemllcigwLjc1NSwgMC4wNTAsIDAuODU1LCAwLjA2MCkgYm90aDtcbiAgYW5pbWF0aW9uOiBzbGlkZS1vdXQtYmx1cnJlZC1sZWZ0IDAuNDVzIGN1YmljLWJlemllcigwLjc1NSwgMC4wNTAsIDAuODU1LCAwLjA2MCkgYm90aDtcbn1cblxuLnNsaWRlLW91dC1ibHVycmVkLXJpZ2h0IHtcbiAgLXdlYmtpdC1hbmltYXRpb246IHNsaWRlLW91dC1ibHVycmVkLXJpZ2h0IDAuNDVzIGN1YmljLWJlemllcigwLjc1NSwgMC4wNTAsIDAuODU1LCAwLjA2MCkgYm90aDtcbiAgYW5pbWF0aW9uOiBzbGlkZS1vdXQtYmx1cnJlZC1yaWdodCAwLjQ1cyBjdWJpYy1iZXppZXIoMC43NTUsIDAuMDUwLCAwLjg1NSwgMC4wNjApIGJvdGg7XG59XG5cbi5zbGlkZS1vdXQtYmx1cnJlZC1ib3R0b20ge1xuICAtd2Via2l0LWFuaW1hdGlvbjogc2xpZGUtb3V0LWJsdXJyZWQtYm90dG9tIDAuNDVzIGN1YmljLWJlemllcigwLjc1NSwgMC4wNTAsIDAuODU1LCAwLjA2MCkgYm90aDtcbiAgYW5pbWF0aW9uOiBzbGlkZS1vdXQtYmx1cnJlZC1ib3R0b20gMC40NXMgY3ViaWMtYmV6aWVyKDAuNzU1LCAwLjA1MCwgMC44NTUsIDAuMDYwKSBib3RoO1xufVxuXG4uc2xpZGUtaW4tYmx1cnJlZC10b3Age1xuICAtd2Via2l0LWFuaW1hdGlvbjogc2xpZGUtaW4tYmx1cnJlZC10b3AgMC42cyBjdWJpYy1iZXppZXIoMC4yMzAsIDEuMDAwLCAwLjMyMCwgMS4wMDApIGJvdGg7XG4gIGFuaW1hdGlvbjogc2xpZGUtaW4tYmx1cnJlZC10b3AgMC42cyBjdWJpYy1iZXppZXIoMC4yMzAsIDEuMDAwLCAwLjMyMCwgMS4wMDApIGJvdGg7XG59XG5cbi5zbGlkZS1pbi1ibHVycmVkLWxlZnQge1xuICAtd2Via2l0LWFuaW1hdGlvbjogc2xpZGUtaW4tYmx1cnJlZC1sZWZ0IDAuNnMgY3ViaWMtYmV6aWVyKDAuMjMwLCAxLjAwMCwgMC4zMjAsIDEuMDAwKSBib3RoO1xuICBhbmltYXRpb246IHNsaWRlLWluLWJsdXJyZWQtbGVmdCAwLjZzIGN1YmljLWJlemllcigwLjIzMCwgMS4wMDAsIDAuMzIwLCAxLjAwMCkgYm90aDtcbn1cblxuLnNsaWRlLWluLWJsdXJyZWQtcmlnaHQge1xuICAtd2Via2l0LWFuaW1hdGlvbjogc2xpZGUtaW4tYmx1cnJlZC1yaWdodCAwLjZzIGN1YmljLWJlemllcigwLjIzMCwgMS4wMDAsIDAuMzIwLCAxLjAwMCkgYm90aDtcbiAgYW5pbWF0aW9uOiBzbGlkZS1pbi1ibHVycmVkLXJpZ2h0IDAuNnMgY3ViaWMtYmV6aWVyKDAuMjMwLCAxLjAwMCwgMC4zMjAsIDEuMDAwKSBib3RoO1xufVxuXG4uc2xpZGUtaW4tYmx1cnJlZC1ib3R0b20ge1xuICAtd2Via2l0LWFuaW1hdGlvbjogc2xpZGUtaW4tYmx1cnJlZC1ib3R0b20gMC42cyBjdWJpYy1iZXppZXIoMC4yMzAsIDEuMDAwLCAwLjMyMCwgMS4wMDApIGJvdGg7XG4gIGFuaW1hdGlvbjogc2xpZGUtaW4tYmx1cnJlZC1ib3R0b20gMC42cyBjdWJpYy1iZXppZXIoMC4yMzAsIDEuMDAwLCAwLjMyMCwgMS4wMDApIGJvdGg7XG59XG5cblxuLyogLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLVxuICogR2VuZXJhdGVkIGJ5IEFuaW1pc3RhIG9uIDIwMjMtNC0xNSAxNjoyNToxNVxuICogTGljZW5zZWQgdW5kZXIgRnJlZUJTRCBMaWNlbnNlLlxuICogU2VlIGh0dHA6Ly9hbmltaXN0YS5uZXQvbGljZW5zZSBmb3IgbW9yZSBpbmZvLlxuICogdzogaHR0cDovL2FuaW1pc3RhLm5ldCwgdDogQGNzc2FuaW1pc3RhXG4gKiAtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tICovXG5cbi8qKlxuICogLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLVxuICogYW5pbWF0aW9uIHNsaWRlLWluLWJsdXJyZWQtYm90dG9tXG4gKiAtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tXG4gKi9cbkAtd2Via2l0LWtleWZyYW1lcyBzbGlkZS1pbi1ibHVycmVkLWJvdHRvbSB7XG4gIDAlIHtcbiAgICAtd2Via2l0LXRyYW5zZm9ybTogdHJhbnNsYXRlWSgxMDAwcHgpIHNjYWxlWSgyLjUpIHNjYWxlWCgwLjIpO1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgxMDAwcHgpIHNjYWxlWSgyLjUpIHNjYWxlWCgwLjIpO1xuICAgIC13ZWJraXQtdHJhbnNmb3JtLW9yaWdpbjogNTAlIDEwMCU7XG4gICAgdHJhbnNmb3JtLW9yaWdpbjogNTAlIDEwMCU7XG4gICAgLXdlYmtpdC1maWx0ZXI6IGJsdXIoNDBweCk7XG4gICAgZmlsdGVyOiBibHVyKDQwcHgpO1xuICAgIG9wYWNpdHk6IDA7XG4gIH1cbiAgMTAwJSB7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm06IHRyYW5zbGF0ZVkoMCkgc2NhbGVZKDEpIHNjYWxlWCgxKTtcbiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoMCkgc2NhbGVZKDEpIHNjYWxlWCgxKTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybS1vcmlnaW46IDUwJSA1MCU7XG4gICAgdHJhbnNmb3JtLW9yaWdpbjogNTAlIDUwJTtcbiAgICAtd2Via2l0LWZpbHRlcjogYmx1cigwKTtcbiAgICBmaWx0ZXI6IGJsdXIoMCk7XG4gICAgb3BhY2l0eTogMTtcbiAgfVxufVxuXG5Aa2V5ZnJhbWVzIHNsaWRlLWluLWJsdXJyZWQtYm90dG9tIHtcbiAgMCUge1xuICAgIC13ZWJraXQtdHJhbnNmb3JtOiB0cmFuc2xhdGVZKDEwMDBweCkgc2NhbGVZKDIuNSkgc2NhbGVYKDAuMik7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKDEwMDBweCkgc2NhbGVZKDIuNSkgc2NhbGVYKDAuMik7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm0tb3JpZ2luOiA1MCUgMTAwJTtcbiAgICB0cmFuc2Zvcm0tb3JpZ2luOiA1MCUgMTAwJTtcbiAgICAtd2Via2l0LWZpbHRlcjogYmx1cig0MHB4KTtcbiAgICBmaWx0ZXI6IGJsdXIoNDBweCk7XG4gICAgb3BhY2l0eTogMDtcbiAgfVxuICAxMDAlIHtcbiAgICAtd2Via2l0LXRyYW5zZm9ybTogdHJhbnNsYXRlWSgwKSBzY2FsZVkoMSkgc2NhbGVYKDEpO1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgwKSBzY2FsZVkoMSkgc2NhbGVYKDEpO1xuICAgIC13ZWJraXQtdHJhbnNmb3JtLW9yaWdpbjogNTAlIDUwJTtcbiAgICB0cmFuc2Zvcm0tb3JpZ2luOiA1MCUgNTAlO1xuICAgIC13ZWJraXQtZmlsdGVyOiBibHVyKDApO1xuICAgIGZpbHRlcjogYmx1cigwKTtcbiAgICBvcGFjaXR5OiAxO1xuICB9XG59XG5cblxuLyogLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLVxuICogR2VuZXJhdGVkIGJ5IEFuaW1pc3RhIG9uIDIwMjMtNC0xNSAxNjoyNDo1NFxuICogTGljZW5zZWQgdW5kZXIgRnJlZUJTRCBMaWNlbnNlLlxuICogU2VlIGh0dHA6Ly9hbmltaXN0YS5uZXQvbGljZW5zZSBmb3IgbW9yZSBpbmZvLlxuICogdzogaHR0cDovL2FuaW1pc3RhLm5ldCwgdDogQGNzc2FuaW1pc3RhXG4gKiAtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tICovXG5cbi8qKlxuICogLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLVxuICogYW5pbWF0aW9uIHNsaWRlLWluLWJsdXJyZWQtcmlnaHRcbiAqIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS1cbiAqL1xuQC13ZWJraXQta2V5ZnJhbWVzIHNsaWRlLWluLWJsdXJyZWQtcmlnaHQge1xuICAwJSB7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm06IHRyYW5zbGF0ZVgoMTAwMHB4KSBzY2FsZVgoMi41KSBzY2FsZVkoMC4yKTtcbiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoMTAwMHB4KSBzY2FsZVgoMi41KSBzY2FsZVkoMC4yKTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybS1vcmlnaW46IDAlIDUwJTtcbiAgICB0cmFuc2Zvcm0tb3JpZ2luOiAwJSA1MCU7XG4gICAgLXdlYmtpdC1maWx0ZXI6IGJsdXIoNDBweCk7XG4gICAgZmlsdGVyOiBibHVyKDQwcHgpO1xuICAgIG9wYWNpdHk6IDA7XG4gIH1cbiAgMTAwJSB7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm06IHRyYW5zbGF0ZVgoMCkgc2NhbGVZKDEpIHNjYWxlWCgxKTtcbiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoMCkgc2NhbGVZKDEpIHNjYWxlWCgxKTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybS1vcmlnaW46IDUwJSA1MCU7XG4gICAgdHJhbnNmb3JtLW9yaWdpbjogNTAlIDUwJTtcbiAgICAtd2Via2l0LWZpbHRlcjogYmx1cigwKTtcbiAgICBmaWx0ZXI6IGJsdXIoMCk7XG4gICAgb3BhY2l0eTogMTtcbiAgfVxufVxuXG5Aa2V5ZnJhbWVzIHNsaWRlLWluLWJsdXJyZWQtcmlnaHQge1xuICAwJSB7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm06IHRyYW5zbGF0ZVgoMTAwMHB4KSBzY2FsZVgoMi41KSBzY2FsZVkoMC4yKTtcbiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoMTAwMHB4KSBzY2FsZVgoMi41KSBzY2FsZVkoMC4yKTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybS1vcmlnaW46IDAlIDUwJTtcbiAgICB0cmFuc2Zvcm0tb3JpZ2luOiAwJSA1MCU7XG4gICAgLXdlYmtpdC1maWx0ZXI6IGJsdXIoNDBweCk7XG4gICAgZmlsdGVyOiBibHVyKDQwcHgpO1xuICAgIG9wYWNpdHk6IDA7XG4gIH1cbiAgMTAwJSB7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm06IHRyYW5zbGF0ZVgoMCkgc2NhbGVZKDEpIHNjYWxlWCgxKTtcbiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoMCkgc2NhbGVZKDEpIHNjYWxlWCgxKTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybS1vcmlnaW46IDUwJSA1MCU7XG4gICAgdHJhbnNmb3JtLW9yaWdpbjogNTAlIDUwJTtcbiAgICAtd2Via2l0LWZpbHRlcjogYmx1cigwKTtcbiAgICBmaWx0ZXI6IGJsdXIoMCk7XG4gICAgb3BhY2l0eTogMTtcbiAgfVxufVxuXG5cbi8qIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS1cbiAqIEdlbmVyYXRlZCBieSBBbmltaXN0YSBvbiAyMDIzLTQtMTUgMTY6MjQ6MzJcbiAqIExpY2Vuc2VkIHVuZGVyIEZyZWVCU0QgTGljZW5zZS5cbiAqIFNlZSBodHRwOi8vYW5pbWlzdGEubmV0L2xpY2Vuc2UgZm9yIG1vcmUgaW5mby5cbiAqIHc6IGh0dHA6Ly9hbmltaXN0YS5uZXQsIHQ6IEBjc3NhbmltaXN0YVxuICogLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLSAqL1xuXG4vKipcbiAqIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS1cbiAqIGFuaW1hdGlvbiBzbGlkZS1pbi1ibHVycmVkLWxlZnRcbiAqIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS1cbiAqL1xuQC13ZWJraXQta2V5ZnJhbWVzIHNsaWRlLWluLWJsdXJyZWQtbGVmdCB7XG4gIDAlIHtcbiAgICAtd2Via2l0LXRyYW5zZm9ybTogdHJhbnNsYXRlWCgtMTAwMHB4KSBzY2FsZVgoMi41KSBzY2FsZVkoMC4yKTtcbiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoLTEwMDBweCkgc2NhbGVYKDIuNSkgc2NhbGVZKDAuMik7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm0tb3JpZ2luOiAxMDAlIDUwJTtcbiAgICB0cmFuc2Zvcm0tb3JpZ2luOiAxMDAlIDUwJTtcbiAgICAtd2Via2l0LWZpbHRlcjogYmx1cig0MHB4KTtcbiAgICBmaWx0ZXI6IGJsdXIoNDBweCk7XG4gICAgb3BhY2l0eTogMDtcbiAgfVxuICAxMDAlIHtcbiAgICAtd2Via2l0LXRyYW5zZm9ybTogdHJhbnNsYXRlWCgwKSBzY2FsZVkoMSkgc2NhbGVYKDEpO1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWCgwKSBzY2FsZVkoMSkgc2NhbGVYKDEpO1xuICAgIC13ZWJraXQtdHJhbnNmb3JtLW9yaWdpbjogNTAlIDUwJTtcbiAgICB0cmFuc2Zvcm0tb3JpZ2luOiA1MCUgNTAlO1xuICAgIC13ZWJraXQtZmlsdGVyOiBibHVyKDApO1xuICAgIGZpbHRlcjogYmx1cigwKTtcbiAgICBvcGFjaXR5OiAxO1xuICB9XG59XG5cbkBrZXlmcmFtZXMgc2xpZGUtaW4tYmx1cnJlZC1sZWZ0IHtcbiAgMCUge1xuICAgIC13ZWJraXQtdHJhbnNmb3JtOiB0cmFuc2xhdGVYKC0xMDAwcHgpIHNjYWxlWCgyLjUpIHNjYWxlWSgwLjIpO1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWCgtMTAwMHB4KSBzY2FsZVgoMi41KSBzY2FsZVkoMC4yKTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybS1vcmlnaW46IDEwMCUgNTAlO1xuICAgIHRyYW5zZm9ybS1vcmlnaW46IDEwMCUgNTAlO1xuICAgIC13ZWJraXQtZmlsdGVyOiBibHVyKDQwcHgpO1xuICAgIGZpbHRlcjogYmx1cig0MHB4KTtcbiAgICBvcGFjaXR5OiAwO1xuICB9XG4gIDEwMCUge1xuICAgIC13ZWJraXQtdHJhbnNmb3JtOiB0cmFuc2xhdGVYKDApIHNjYWxlWSgxKSBzY2FsZVgoMSk7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKDApIHNjYWxlWSgxKSBzY2FsZVgoMSk7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm0tb3JpZ2luOiA1MCUgNTAlO1xuICAgIHRyYW5zZm9ybS1vcmlnaW46IDUwJSA1MCU7XG4gICAgLXdlYmtpdC1maWx0ZXI6IGJsdXIoMCk7XG4gICAgZmlsdGVyOiBibHVyKDApO1xuICAgIG9wYWNpdHk6IDE7XG4gIH1cbn1cblxuXG4vKiAtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tXG4gKiBHZW5lcmF0ZWQgYnkgQW5pbWlzdGEgb24gMjAyMy00LTE1IDE2OjI0OjE1XG4gKiBMaWNlbnNlZCB1bmRlciBGcmVlQlNEIExpY2Vuc2UuXG4gKiBTZWUgaHR0cDovL2FuaW1pc3RhLm5ldC9saWNlbnNlIGZvciBtb3JlIGluZm8uXG4gKiB3OiBodHRwOi8vYW5pbWlzdGEubmV0LCB0OiBAY3NzYW5pbWlzdGFcbiAqIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0gKi9cblxuLyoqXG4gKiAtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tXG4gKiBhbmltYXRpb24gc2xpZGUtaW4tYmx1cnJlZC10b3BcbiAqIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS1cbiAqL1xuQC13ZWJraXQta2V5ZnJhbWVzIHNsaWRlLWluLWJsdXJyZWQtdG9wIHtcbiAgMCUge1xuICAgIC13ZWJraXQtdHJhbnNmb3JtOiB0cmFuc2xhdGVZKC0xMDAwcHgpIHNjYWxlWSgyLjUpIHNjYWxlWCgwLjIpO1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgtMTAwMHB4KSBzY2FsZVkoMi41KSBzY2FsZVgoMC4yKTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybS1vcmlnaW46IDUwJSAwJTtcbiAgICB0cmFuc2Zvcm0tb3JpZ2luOiA1MCUgMCU7XG4gICAgLXdlYmtpdC1maWx0ZXI6IGJsdXIoNDBweCk7XG4gICAgZmlsdGVyOiBibHVyKDQwcHgpO1xuICAgIG9wYWNpdHk6IDA7XG4gIH1cbiAgMTAwJSB7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm06IHRyYW5zbGF0ZVkoMCkgc2NhbGVZKDEpIHNjYWxlWCgxKTtcbiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoMCkgc2NhbGVZKDEpIHNjYWxlWCgxKTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybS1vcmlnaW46IDUwJSA1MCU7XG4gICAgdHJhbnNmb3JtLW9yaWdpbjogNTAlIDUwJTtcbiAgICAtd2Via2l0LWZpbHRlcjogYmx1cigwKTtcbiAgICBmaWx0ZXI6IGJsdXIoMCk7XG4gICAgb3BhY2l0eTogMTtcbiAgfVxufVxuXG5Aa2V5ZnJhbWVzIHNsaWRlLWluLWJsdXJyZWQtdG9wIHtcbiAgMCUge1xuICAgIC13ZWJraXQtdHJhbnNmb3JtOiB0cmFuc2xhdGVZKC0xMDAwcHgpIHNjYWxlWSgyLjUpIHNjYWxlWCgwLjIpO1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgtMTAwMHB4KSBzY2FsZVkoMi41KSBzY2FsZVgoMC4yKTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybS1vcmlnaW46IDUwJSAwJTtcbiAgICB0cmFuc2Zvcm0tb3JpZ2luOiA1MCUgMCU7XG4gICAgLXdlYmtpdC1maWx0ZXI6IGJsdXIoNDBweCk7XG4gICAgZmlsdGVyOiBibHVyKDQwcHgpO1xuICAgIG9wYWNpdHk6IDA7XG4gIH1cbiAgMTAwJSB7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm06IHRyYW5zbGF0ZVkoMCkgc2NhbGVZKDEpIHNjYWxlWCgxKTtcbiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoMCkgc2NhbGVZKDEpIHNjYWxlWCgxKTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybS1vcmlnaW46IDUwJSA1MCU7XG4gICAgdHJhbnNmb3JtLW9yaWdpbjogNTAlIDUwJTtcbiAgICAtd2Via2l0LWZpbHRlcjogYmx1cigwKTtcbiAgICBmaWx0ZXI6IGJsdXIoMCk7XG4gICAgb3BhY2l0eTogMTtcbiAgfVxufVxuXG5cbi8qIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS1cbiAqIEdlbmVyYXRlZCBieSBBbmltaXN0YSBvbiAyMDIzLTQtMTUgMTY6MjM6NTNcbiAqIExpY2Vuc2VkIHVuZGVyIEZyZWVCU0QgTGljZW5zZS5cbiAqIFNlZSBodHRwOi8vYW5pbWlzdGEubmV0L2xpY2Vuc2UgZm9yIG1vcmUgaW5mby5cbiAqIHc6IGh0dHA6Ly9hbmltaXN0YS5uZXQsIHQ6IEBjc3NhbmltaXN0YVxuICogLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLSAqL1xuXG4vKipcbiAqIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS1cbiAqIGFuaW1hdGlvbiBzbGlkZS1vdXQtYmx1cnJlZC1ib3R0b21cbiAqIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS1cbiAqL1xuQC13ZWJraXQta2V5ZnJhbWVzIHNsaWRlLW91dC1ibHVycmVkLWJvdHRvbSB7XG4gIDAlIHtcbiAgICAtd2Via2l0LXRyYW5zZm9ybTogdHJhbnNsYXRlWSgwKSBzY2FsZVkoMSkgc2NhbGVYKDEpO1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgwKSBzY2FsZVkoMSkgc2NhbGVYKDEpO1xuICAgIC13ZWJraXQtdHJhbnNmb3JtLW9yaWdpbjogNTAlIDUwJTtcbiAgICB0cmFuc2Zvcm0tb3JpZ2luOiA1MCUgNTAlO1xuICAgIC13ZWJraXQtZmlsdGVyOiBibHVyKDApO1xuICAgIGZpbHRlcjogYmx1cigwKTtcbiAgICBvcGFjaXR5OiAxO1xuICB9XG4gIDEwMCUge1xuICAgIC13ZWJraXQtdHJhbnNmb3JtOiB0cmFuc2xhdGVZKDEwMDBweCkgc2NhbGVZKDIpIHNjYWxlWCgwLjIpO1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgxMDAwcHgpIHNjYWxlWSgyKSBzY2FsZVgoMC4yKTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybS1vcmlnaW46IDUwJSAxMDAlO1xuICAgIHRyYW5zZm9ybS1vcmlnaW46IDUwJSAxMDAlO1xuICAgIC13ZWJraXQtZmlsdGVyOiBibHVyKDQwcHgpO1xuICAgIGZpbHRlcjogYmx1cig0MHB4KTtcbiAgICBvcGFjaXR5OiAwO1xuICB9XG59XG5cbkBrZXlmcmFtZXMgc2xpZGUtb3V0LWJsdXJyZWQtYm90dG9tIHtcbiAgMCUge1xuICAgIC13ZWJraXQtdHJhbnNmb3JtOiB0cmFuc2xhdGVZKDApIHNjYWxlWSgxKSBzY2FsZVgoMSk7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKDApIHNjYWxlWSgxKSBzY2FsZVgoMSk7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm0tb3JpZ2luOiA1MCUgNTAlO1xuICAgIHRyYW5zZm9ybS1vcmlnaW46IDUwJSA1MCU7XG4gICAgLXdlYmtpdC1maWx0ZXI6IGJsdXIoMCk7XG4gICAgZmlsdGVyOiBibHVyKDApO1xuICAgIG9wYWNpdHk6IDE7XG4gIH1cbiAgMTAwJSB7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm06IHRyYW5zbGF0ZVkoMTAwMHB4KSBzY2FsZVkoMikgc2NhbGVYKDAuMik7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKDEwMDBweCkgc2NhbGVZKDIpIHNjYWxlWCgwLjIpO1xuICAgIC13ZWJraXQtdHJhbnNmb3JtLW9yaWdpbjogNTAlIDEwMCU7XG4gICAgdHJhbnNmb3JtLW9yaWdpbjogNTAlIDEwMCU7XG4gICAgLXdlYmtpdC1maWx0ZXI6IGJsdXIoNDBweCk7XG4gICAgZmlsdGVyOiBibHVyKDQwcHgpO1xuICAgIG9wYWNpdHk6IDA7XG4gIH1cbn1cblxuXG4vKiAtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tXG4gKiBHZW5lcmF0ZWQgYnkgQW5pbWlzdGEgb24gMjAyMy00LTE1IDE2OjIzOjM2XG4gKiBMaWNlbnNlZCB1bmRlciBGcmVlQlNEIExpY2Vuc2UuXG4gKiBTZWUgaHR0cDovL2FuaW1pc3RhLm5ldC9saWNlbnNlIGZvciBtb3JlIGluZm8uXG4gKiB3OiBodHRwOi8vYW5pbWlzdGEubmV0LCB0OiBAY3NzYW5pbWlzdGFcbiAqIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0gKi9cblxuLyoqXG4gKiAtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tXG4gKiBhbmltYXRpb24gc2xpZGUtb3V0LWJsdXJyZWQtcmlnaHRcbiAqIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS1cbiAqL1xuQC13ZWJraXQta2V5ZnJhbWVzIHNsaWRlLW91dC1ibHVycmVkLXJpZ2h0IHtcbiAgMCUge1xuICAgIC13ZWJraXQtdHJhbnNmb3JtOiB0cmFuc2xhdGVYKDApIHNjYWxlWSgxKSBzY2FsZVgoMSk7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKDApIHNjYWxlWSgxKSBzY2FsZVgoMSk7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm0tb3JpZ2luOiA1MCUgNTAlO1xuICAgIHRyYW5zZm9ybS1vcmlnaW46IDUwJSA1MCU7XG4gICAgLXdlYmtpdC1maWx0ZXI6IGJsdXIoMCk7XG4gICAgZmlsdGVyOiBibHVyKDApO1xuICAgIG9wYWNpdHk6IDE7XG4gIH1cbiAgMTAwJSB7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm06IHRyYW5zbGF0ZVgoMTAwMHB4KSBzY2FsZVgoMikgc2NhbGVZKDAuMik7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKDEwMDBweCkgc2NhbGVYKDIpIHNjYWxlWSgwLjIpO1xuICAgIC13ZWJraXQtdHJhbnNmb3JtLW9yaWdpbjogMCUgNTAlO1xuICAgIHRyYW5zZm9ybS1vcmlnaW46IDAlIDUwJTtcbiAgICAtd2Via2l0LWZpbHRlcjogYmx1cig0MHB4KTtcbiAgICBmaWx0ZXI6IGJsdXIoNDBweCk7XG4gICAgb3BhY2l0eTogMDtcbiAgfVxufVxuXG5Aa2V5ZnJhbWVzIHNsaWRlLW91dC1ibHVycmVkLXJpZ2h0IHtcbiAgMCUge1xuICAgIC13ZWJraXQtdHJhbnNmb3JtOiB0cmFuc2xhdGVYKDApIHNjYWxlWSgxKSBzY2FsZVgoMSk7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKDApIHNjYWxlWSgxKSBzY2FsZVgoMSk7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm0tb3JpZ2luOiA1MCUgNTAlO1xuICAgIHRyYW5zZm9ybS1vcmlnaW46IDUwJSA1MCU7XG4gICAgLXdlYmtpdC1maWx0ZXI6IGJsdXIoMCk7XG4gICAgZmlsdGVyOiBibHVyKDApO1xuICAgIG9wYWNpdHk6IDE7XG4gIH1cbiAgMTAwJSB7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm06IHRyYW5zbGF0ZVgoMTAwMHB4KSBzY2FsZVgoMikgc2NhbGVZKDAuMik7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKDEwMDBweCkgc2NhbGVYKDIpIHNjYWxlWSgwLjIpO1xuICAgIC13ZWJraXQtdHJhbnNmb3JtLW9yaWdpbjogMCUgNTAlO1xuICAgIHRyYW5zZm9ybS1vcmlnaW46IDAlIDUwJTtcbiAgICAtd2Via2l0LWZpbHRlcjogYmx1cig0MHB4KTtcbiAgICBmaWx0ZXI6IGJsdXIoNDBweCk7XG4gICAgb3BhY2l0eTogMDtcbiAgfVxufVxuXG5cbi8qIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS1cbiAqIEdlbmVyYXRlZCBieSBBbmltaXN0YSBvbiAyMDIzLTQtMTUgMTY6MjM6MTJcbiAqIExpY2Vuc2VkIHVuZGVyIEZyZWVCU0QgTGljZW5zZS5cbiAqIFNlZSBodHRwOi8vYW5pbWlzdGEubmV0L2xpY2Vuc2UgZm9yIG1vcmUgaW5mby5cbiAqIHc6IGh0dHA6Ly9hbmltaXN0YS5uZXQsIHQ6IEBjc3NhbmltaXN0YVxuICogLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLSAqL1xuXG4vKipcbiAqIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS1cbiAqIGFuaW1hdGlvbiBzbGlkZS1vdXQtYmx1cnJlZC1sZWZ0XG4gKiAtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tXG4gKi9cbkAtd2Via2l0LWtleWZyYW1lcyBzbGlkZS1vdXQtYmx1cnJlZC1sZWZ0IHtcbiAgMCUge1xuICAgIC13ZWJraXQtdHJhbnNmb3JtOiB0cmFuc2xhdGVYKDApIHNjYWxlWSgxKSBzY2FsZVgoMSk7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKDApIHNjYWxlWSgxKSBzY2FsZVgoMSk7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm0tb3JpZ2luOiA1MCUgNTAlO1xuICAgIHRyYW5zZm9ybS1vcmlnaW46IDUwJSA1MCU7XG4gICAgLXdlYmtpdC1maWx0ZXI6IGJsdXIoMCk7XG4gICAgZmlsdGVyOiBibHVyKDApO1xuICAgIG9wYWNpdHk6IDE7XG4gIH1cbiAgMTAwJSB7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm06IHRyYW5zbGF0ZVgoLTEwMDBweCkgc2NhbGVYKDIpIHNjYWxlWSgwLjIpO1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWCgtMTAwMHB4KSBzY2FsZVgoMikgc2NhbGVZKDAuMik7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm0tb3JpZ2luOiAxMDAlIDUwJTtcbiAgICB0cmFuc2Zvcm0tb3JpZ2luOiAxMDAlIDUwJTtcbiAgICAtd2Via2l0LWZpbHRlcjogYmx1cig0MHB4KTtcbiAgICBmaWx0ZXI6IGJsdXIoNDBweCk7XG4gICAgb3BhY2l0eTogMDtcbiAgfVxufVxuXG5Aa2V5ZnJhbWVzIHNsaWRlLW91dC1ibHVycmVkLWxlZnQge1xuICAwJSB7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm06IHRyYW5zbGF0ZVgoMCkgc2NhbGVZKDEpIHNjYWxlWCgxKTtcbiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoMCkgc2NhbGVZKDEpIHNjYWxlWCgxKTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybS1vcmlnaW46IDUwJSA1MCU7XG4gICAgdHJhbnNmb3JtLW9yaWdpbjogNTAlIDUwJTtcbiAgICAtd2Via2l0LWZpbHRlcjogYmx1cigwKTtcbiAgICBmaWx0ZXI6IGJsdXIoMCk7XG4gICAgb3BhY2l0eTogMTtcbiAgfVxuICAxMDAlIHtcbiAgICAtd2Via2l0LXRyYW5zZm9ybTogdHJhbnNsYXRlWCgtMTAwMHB4KSBzY2FsZVgoMikgc2NhbGVZKDAuMik7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKC0xMDAwcHgpIHNjYWxlWCgyKSBzY2FsZVkoMC4yKTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybS1vcmlnaW46IDEwMCUgNTAlO1xuICAgIHRyYW5zZm9ybS1vcmlnaW46IDEwMCUgNTAlO1xuICAgIC13ZWJraXQtZmlsdGVyOiBibHVyKDQwcHgpO1xuICAgIGZpbHRlcjogYmx1cig0MHB4KTtcbiAgICBvcGFjaXR5OiAwO1xuICB9XG59XG5cblxuLyogLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLVxuICogR2VuZXJhdGVkIGJ5IEFuaW1pc3RhIG9uIDIwMjMtNC0xNSAxNjoyMjo0OVxuICogTGljZW5zZWQgdW5kZXIgRnJlZUJTRCBMaWNlbnNlLlxuICogU2VlIGh0dHA6Ly9hbmltaXN0YS5uZXQvbGljZW5zZSBmb3IgbW9yZSBpbmZvLlxuICogdzogaHR0cDovL2FuaW1pc3RhLm5ldCwgdDogQGNzc2FuaW1pc3RhXG4gKiAtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tICovXG5cbi8qKlxuICogLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLVxuICogYW5pbWF0aW9uIHNsaWRlLW91dC1ibHVycmVkLXRvcFxuICogLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLVxuICovXG5ALXdlYmtpdC1rZXlmcmFtZXMgc2xpZGUtb3V0LWJsdXJyZWQtdG9wIHtcbiAgMCUge1xuICAgIC13ZWJraXQtdHJhbnNmb3JtOiB0cmFuc2xhdGVZKDApIHNjYWxlWSgxKSBzY2FsZVgoMSk7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKDApIHNjYWxlWSgxKSBzY2FsZVgoMSk7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm0tb3JpZ2luOiA1MCUgMCU7XG4gICAgdHJhbnNmb3JtLW9yaWdpbjogNTAlIDAlO1xuICAgIC13ZWJraXQtZmlsdGVyOiBibHVyKDApO1xuICAgIGZpbHRlcjogYmx1cigwKTtcbiAgICBvcGFjaXR5OiAxO1xuICB9XG4gIDEwMCUge1xuICAgIC13ZWJraXQtdHJhbnNmb3JtOiB0cmFuc2xhdGVZKC0xMDAwcHgpIHNjYWxlWSgyKSBzY2FsZVgoMC4yKTtcbiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoLTEwMDBweCkgc2NhbGVZKDIpIHNjYWxlWCgwLjIpO1xuICAgIC13ZWJraXQtdHJhbnNmb3JtLW9yaWdpbjogNTAlIDAlO1xuICAgIHRyYW5zZm9ybS1vcmlnaW46IDUwJSAwJTtcbiAgICAtd2Via2l0LWZpbHRlcjogYmx1cig0MHB4KTtcbiAgICBmaWx0ZXI6IGJsdXIoNDBweCk7XG4gICAgb3BhY2l0eTogMDtcbiAgfVxufVxuXG5Aa2V5ZnJhbWVzIHNsaWRlLW91dC1ibHVycmVkLXRvcCB7XG4gIDAlIHtcbiAgICAtd2Via2l0LXRyYW5zZm9ybTogdHJhbnNsYXRlWSgwKSBzY2FsZVkoMSkgc2NhbGVYKDEpO1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgwKSBzY2FsZVkoMSkgc2NhbGVYKDEpO1xuICAgIC13ZWJraXQtdHJhbnNmb3JtLW9yaWdpbjogNTAlIDAlO1xuICAgIHRyYW5zZm9ybS1vcmlnaW46IDUwJSAwJTtcbiAgICAtd2Via2l0LWZpbHRlcjogYmx1cigwKTtcbiAgICBmaWx0ZXI6IGJsdXIoMCk7XG4gICAgb3BhY2l0eTogMTtcbiAgfVxuICAxMDAlIHtcbiAgICAtd2Via2l0LXRyYW5zZm9ybTogdHJhbnNsYXRlWSgtMTAwMHB4KSBzY2FsZVkoMikgc2NhbGVYKDAuMik7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKC0xMDAwcHgpIHNjYWxlWSgyKSBzY2FsZVgoMC4yKTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybS1vcmlnaW46IDUwJSAwJTtcbiAgICB0cmFuc2Zvcm0tb3JpZ2luOiA1MCUgMCU7XG4gICAgLXdlYmtpdC1maWx0ZXI6IGJsdXIoNDBweCk7XG4gICAgZmlsdGVyOiBibHVyKDQwcHgpO1xuICAgIG9wYWNpdHk6IDA7XG4gIH1cbn1cblxuXG4vKiAtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tXG4gKiBHZW5lcmF0ZWQgYnkgQW5pbWlzdGEgb24gMjAyMy04LTEgMTY6NDQ6MjNcbiAqIExpY2Vuc2VkIHVuZGVyIEZyZWVCU0QgTGljZW5zZS5cbiAqIFNlZSBodHRwOi8vYW5pbWlzdGEubmV0L2xpY2Vuc2UgZm9yIG1vcmUgaW5mby5cbiAqIHc6IGh0dHA6Ly9hbmltaXN0YS5uZXQsIHQ6IEBjc3NhbmltaXN0YVxuICogLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLSAqL1xuXG4vKipcbiAqIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS1cbiAqIGFuaW1hdGlvbiBzbGlkZS1pbi1ib3R0b21cbiAqIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS1cbiAqL1xuQC13ZWJraXQta2V5ZnJhbWVzIHNsaWRlLWluLWJvdHRvbSB7XG4gIDAlIHtcbiAgICAtd2Via2l0LXRyYW5zZm9ybTogdHJhbnNsYXRlWSgxMDAwcHgpO1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgxMDAwcHgpO1xuICAgIG9wYWNpdHk6IDA7XG4gIH1cbiAgMTAwJSB7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm06IHRyYW5zbGF0ZVkoMCk7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKDApO1xuICAgIG9wYWNpdHk6IDE7XG4gIH1cbn1cblxuQGtleWZyYW1lcyBzbGlkZS1pbi1ib3R0b20ge1xuICAwJSB7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm06IHRyYW5zbGF0ZVkoMTAwMHB4KTtcbiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoMTAwMHB4KTtcbiAgICBvcGFjaXR5OiAwO1xuICB9XG4gIDEwMCUge1xuICAgIC13ZWJraXQtdHJhbnNmb3JtOiB0cmFuc2xhdGVZKDApO1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgwKTtcbiAgICBvcGFjaXR5OiAxO1xuICB9XG59XG5cbiIsIi5tYXJnaW4gXG4gIG1hcmdpbjogMjRweFxuXG4gIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZClcbiAgICBtYXJnaW46IDQycHhcblxuICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpXG4gICAgbWFyZ2luOiA4MHB4XG5cbiAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHhsKVxuICAgIG1hcmdpbjogMTAwcHhcblxuICAmLS1sclxuICAgIG1hcmdpbjogMCAyNHB4XG5cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpXG4gICAgICBtYXJnaW46IDAgNDJweFxuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKVxuICAgICAgbWFyZ2luOiAwIDgwcHhcblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICR4bClcbiAgICAgIG1hcmdpbjogMCAxMDBweFxuXG4gICYtLXRiXG4gICAgbWFyZ2luOiAyNHB4IDBcblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZClcbiAgICAgIG1hcmdpbjogMCA0MnB4XG5cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpXG4gICAgICBtYXJnaW46IDAgODBweFxuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHhsKVxuICAgICAgbWFyZ2luOiAwIDEwMHB4XG5cbiAgJi0tYm90dG9tXG4gICAgbWFyZ2luLWJvdHRvbTogMS4yNXJlbVxuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKVxuICAgICAgbWFyZ2luLWJvdHRvbTogNDJweFxuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKVxuICAgICAgbWFyZ2luLWJvdHRvbTogODBweFxuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHhsKVxuICAgICAgbWFyZ2luLWJvdHRvbTogMTAwcHhcblxuICAmLS10b3BcbiAgICBtYXJnaW4tdG9wOiAyNHB4XG5cbiIsIi8vIE1BSU4gQ09MT1JcbiRtYWluLWNvbG9yczpcbiAgJ2dyZWVuJyAkZXJnby1ncmVlbixcbiAgJ3llbGxvdycgJGVyZ28teWVsbG93LFxuICAnb3JhbmdlJyAkZXJnby1vcmFuZ2UsXG4gICdibHVlJyAkZXJnby1ibHVlLFxuICAndmlvbGV0JyAkZXJnby12aW9sZXQsXG4gICd3YXJtZ3JleScgJGVyZ28td2FybWdyZXksXG4gICd3aGl0ZScgI2ZmZjtcblxuQGVhY2ggJGNvbG9yLCAkdmFsdWUgaW4gJG1haW4tY29sb3JzIHtcbiAgLmJnLSN7JGNvbG9yfSB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHZhbHVlO1xuICB9XG59XG5cbi8vIExJR0hUXG4kbGlnaHQtY29sb3JzOlxuICAnZ3JlZW4nICRlcmdvLWdyZWVuLWxpZ2h0LFxuICAneWVsbG93JyAkZXJnby15ZWxsb3ctbGlnaHQsXG4gICdvcmFuZ2UnICRlcmdvLW9yYW5nZS1saWdodCxcbiAgJ2JsdWUnICRlcmdvLWJsdWUtbGlnaHQsXG4gICdncmV5JyAkZXJnby1ncmV5LWxpZ2h0LFxuICAndmlvbGV0JyAkZXJnby12aW9sZXQtbGlnaHQsXG4gICd3YXJtZ3JleScgJGVyZ28td2FybWdyZXktbGlnaHQsXG4gICdncmV5JyAkZXJnby1ncmV5LWxpZ2h0O1xuXG5AZWFjaCAkY29sb3IsICR2YWx1ZSBpbiAkbGlnaHQtY29sb3JzIHtcbiAgLmJnLSN7JGNvbG9yfS0tbGlnaHQge1xuICAgIGJhY2tncm91bmQtY29sb3I6ICR2YWx1ZTtcbiAgfVxufVxuXG4vLyBEQVJLXG4kZGFyazEtY29sb3JzOlxuICAnZ3JlZW4nICRlcmdvLWdyZWVuLWRhcmsxLFxuICAneWVsbG93JyAkZXJnby15ZWxsb3ctZGFyazEsXG4gICdvcmFuZ2UnICRlcmdvLW9yYW5nZS1kYXJrMSxcbiAgJ2JsdWUnICRlcmdvLWJsdWUtZGFyazEsXG4gICd2aW9sZXQnICRlcmdvLXZpb2xldC1kYXJrMTtcblxuQGVhY2ggJGNvbG9yLCAkdmFsdWUgaW4gJGRhcmsxLWNvbG9ycyB7XG4gIC5iZy0jeyRjb2xvcn0tLWRhcmsge1xuICAgIGJhY2tncm91bmQtY29sb3I6ICR2YWx1ZTtcbiAgfVxufVxuXG4kZGFyazItY29sb3JzOlxuICAnZ3JlZW4nICRlcmdvLWdyZWVuLWRhcmsyLFxuICAneWVsbG93JyAkZXJnby15ZWxsb3ctZGFyazIsXG4gICdvcmFuZ2UnICRlcmdvLW9yYW5nZS1kYXJrMixcbiAgJ2JsdWUnICRlcmdvLWJsdWUtZGFyazIsXG4gICd2aW9sZXQnICRlcmdvLXZpb2xldC1kYXJrMjtcblxuQGVhY2ggJGNvbG9yLCAkdmFsdWUgaW4gJGRhcmsyLWNvbG9ycyB7XG4gIC5iZy0jeyRjb2xvcn0tLWRhcmsyIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkdmFsdWU7XG4gIH1cbn1cblxuJGRhcmszLWNvbG9yczpcbiAgJ2dyZWVuJyAkZXJnby1ncmVlbi1kYXJrMyxcbiAgJ3llbGxvdycgJGVyZ28teWVsbG93LWRhcmszLFxuICAnb3JhbmdlJyAkZXJnby1vcmFuZ2UtZGFyazMsXG4gICdibHVlJyAkZXJnby1ibHVlLWRhcmszLFxuICAndmlvbGV0JyAkZXJnby12aW9sZXQtZGFyazM7XG5cbkBlYWNoICRjb2xvciwgJHZhbHVlIGluICRkYXJrMy1jb2xvcnMge1xuICAuYmctI3skY29sb3J9LS1kYXJrMyB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHZhbHVlO1xuICB9XG59XG5cbmEubGluayB7XG4gIGNvbG9yOiAjNmEwMDI5O1xuICBmb250LXdlaWdodDogNzAwO1xuICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG5cbiAgJjpob3ZlcixcbiAgJjpmb2N1cyB7XG4gICAgdGV4dC1kZWNvcmF0aW9uOiB1bmRlcmxpbmU7XG4gIH1cbn1cblxuXG4vLyAucGFkZGluZy13cmFwcGVyIHtcbi8vICAgbWFyZ2luOiAwIC0yNnB4O1xuLy8gICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbi8vICAgICBtYXJnaW46IGluaGVyaXQ7XG4vLyAgIH1cbi8vIH1cbi8vIC5wLXhzLWxyIHtcbi8vICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1heC13aWR0aDogJHNtKSB7XG4vLyAgICAgcGFkZGluZy1sZWZ0OiAxLjYyNXJlbTtcbi8vICAgICBwYWRkaW5nLXJpZ2h0OiAxLjYyNXJlbTtcbi8vICAgfVxuLy8gfVxuLy8gLnAteHMtYSB7XG4vLyAgIEBtZWRpYSBzY3JlZW4gYW5kIChtYXgtd2lkdGg6ICRzbSkge1xuLy8gICAgIHBhZGRpbmc6IDEuODc1cmVtIDEuNjI1cmVtO1xuLy8gICB9XG4vLyB9XG5cbi5oZWFkZXIge1xuICBoZWlnaHQ6IDQ1cHg7XG4gIGJhY2tncm91bmQtY29sb3I6ICRlcmdvLXdoaXRlO1xuICBib3gtc2hhZG93OiAwcHggNHB4IDE0cHggMHB4IHJnYmEoMCwgMCwgMCwgMC4xNSk7XG4gIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgIGhlaWdodDogODBweDtcbiAgfVxuXG4gIHN2ZyB7XG4gICAgaGVpZ2h0OiAxMDAlO1xuICAgIHdpZHRoOiBhdXRvO1xuICB9XG59XG5cbi8vIElOUFVUIEVNQUlMIENIRUNLQk9YIFNUWUxJTkdcbmlucHV0W3R5cGU9J2VtYWlsJ10sXG4uaW5wdXQtLWVtYWlsIHtcbiAgcGFkZGluZzogMXJlbSAwLjYyNXJlbTtcbiAgYm9yZGVyLXJhZGl1czogNXB4IDVweCAwIDA7XG4gIG1hcmdpbi1ib3R0b206IDEuNjI1cmVtO1xuICBib3JkZXI6IG5vbmU7XG4gIGJvcmRlci1ib3R0b206IDJweCBzb2xpZCBncmF5O1xufVxuXG5pbnB1dFt0eXBlPSdlbWFpbCddLmVycm9yLFxuLmlucHV0LS1lbWFpbC5lcnJvciB7XG4gIG1hcmdpbi1ib3R0b206IDA7XG59XG5cbmlucHV0W3R5cGU9J2VtYWlsJ10uZXJyb3IgKyAuZXJyb3IsXG4uaW5wdXQtLWVtYWlsLmVycm9yICsgLmVycm9yIHtcbiAgbWFyZ2luLWJvdHRvbTogMTNweDtcbn1cblxuLm5vdGljZSB7XG4gIG1hcmdpbi1ib3R0b206IDEuMjVyZW07XG59XG5cbi5ub3RpY2UtY29udGFpbmVyIHtcbiAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgbWF4LXdpZHRoOiA5MCU7XG4gIH1cbn1cblxuaW5wdXRbdHlwZT0nY2hlY2tib3gnXSB7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgb3BhY2l0eTogMDtcbiAgd2lkdGg6IDI0cHg7XG4gIGhlaWdodDogMjRweDtcbiAgY3Vyc29yOiBwb2ludGVyO1xufVxuXG4uY2hlY2tib3gtY29udGFpbmVyIHtcbiAgZGlzcGxheTogaW5saW5lLWZsZXg7XG4gIGFsaWduLWl0ZW1zOiBmbGV4LXN0YXJ0O1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIGN1cnNvcjogcG9pbnRlcjtcbiAgLXdlYmtpdC11c2VyLXNlbGVjdDogbm9uZTtcbiAgdXNlci1zZWxlY3Q6IG5vbmU7XG59XG5cbi5jaGVja21hcmsge1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIHdpZHRoOiAyNHB4O1xuICBoZWlnaHQ6IDI0cHg7XG4gIGJhY2tncm91bmQtY29sb3I6ICRlcmdvLXdoaXRlO1xuICBib3JkZXItcmFkaXVzOiA0cHg7XG4gIGJvcmRlcjogMXB4IHNvbGlkICRlcmdvLXdhcm1ncmV5LWRhcmszO1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbn1cblxuLmNoZWNrbWFyazphZnRlciB7XG4gIGNvbnRlbnQ6ICcnO1xuICB3aWR0aDogMTRweDtcbiAgaGVpZ2h0OiAxNHB4O1xuICBkaXNwbGF5OiBub25lO1xuICBiYWNrZ3JvdW5kOiBjZW50ZXIvY292ZXIgbm8tcmVwZWF0IHVybCgnLi4vLi4vc3Zncy9ibGFja19IYWVrY2hlbi5zdmcnKTtcbn1cblxuaW5wdXRbdHlwZT0nY2hlY2tib3gnXTpjaGVja2VkICsgLmNoZWNrbWFyazphZnRlciB7XG4gIGRpc3BsYXk6IGJsb2NrO1xufVxuXG5pbnB1dFt0eXBlPSdjaGVja2JveCddOmZvY3VzICsgLmNoZWNrbWFyayB7XG4gIG91dGxpbmU6IDJweCBzb2xpZCAjM2M3NGY4O1xuICBvdXRsaW5lLW9mZnNldDogMnB4O1xufVxuXG4udmlzaWJsZSB7XG4gIGRpc3BsYXk6IGJsb2NrO1xufVxuXG4uaGlkZGVuIHtcbiAgZGlzcGxheTogbm9uZTtcbn1cblxuLm1hZ2ljLXRleHQge1xuICBtYXJnaW4tYm90dG9tOiAxLjg3NXJlbTtcblxuICB1bCxcbiAgb2wge1xuICAgIGxpOm5vdCg6bGFzdC1jaGlsZCkge1xuICAgICAgcGFkZGluZy1ib3R0b206IDEwcHg7XG4gICAgfVxuICB9XG4gIGEge1xuICAgIGNvbG9yOiAkZXJnby1tYWluO1xuICAgIGZvbnQtd2VpZ2h0OiA3MDA7XG4gIH1cbn1cblxuLmZvbnQtcmVkIHtcbiAgY29sb3I6ICRlcmdvLW1haW47XG59XG4iLCIvKiFcbiAqIEJvb3RzdHJhcCBHcmlkIHY1LjIuMyAoaHR0cHM6Ly9nZXRib290c3RyYXAuY29tLylcbiAqIENvcHlyaWdodCAyMDExLTIwMjIgVGhlIEJvb3RzdHJhcCBBdXRob3JzXG4gKiBDb3B5cmlnaHQgMjAxMS0yMDIyIFR3aXR0ZXIsIEluYy5cbiAqIExpY2Vuc2VkIHVuZGVyIE1JVCAoaHR0cHM6Ly9naXRodWIuY29tL3R3YnMvYm9vdHN0cmFwL2Jsb2IvbWFpbi9MSUNFTlNFKVxuICovXG46cm9vdCB7XG4gIC0tYnMtYmx1ZTogIzBkNmVmZDtcbiAgLS1icy1pbmRpZ286ICM2NjEwZjI7XG4gIC0tYnMtcHVycGxlOiAjNmY0MmMxO1xuICAtLWJzLXBpbms6ICNkNjMzODQ7XG4gIC0tYnMtcmVkOiAjZGMzNTQ1O1xuICAtLWJzLW9yYW5nZTogI2ZkN2UxNDtcbiAgLS1icy15ZWxsb3c6ICNmZmMxMDc7XG4gIC0tYnMtZ3JlZW46ICMxOTg3NTQ7XG4gIC0tYnMtdGVhbDogIzIwYzk5NztcbiAgLS1icy1jeWFuOiAjMGRjYWYwO1xuICAtLWJzLWJsYWNrOiAjMDAwO1xuICAtLWJzLXdoaXRlOiAjZmZmO1xuICAtLWJzLWdyYXk6ICM2Yzc1N2Q7XG4gIC0tYnMtZ3JheS1kYXJrOiAjMzQzYTQwO1xuICAtLWJzLWdyYXktMTAwOiAjZjhmOWZhO1xuICAtLWJzLWdyYXktMjAwOiAjZTllY2VmO1xuICAtLWJzLWdyYXktMzAwOiAjZGVlMmU2O1xuICAtLWJzLWdyYXktNDAwOiAjY2VkNGRhO1xuICAtLWJzLWdyYXktNTAwOiAjYWRiNWJkO1xuICAtLWJzLWdyYXktNjAwOiAjNmM3NTdkO1xuICAtLWJzLWdyYXktNzAwOiAjNDk1MDU3O1xuICAtLWJzLWdyYXktODAwOiAjMzQzYTQwO1xuICAtLWJzLWdyYXktOTAwOiAjMjEyNTI5O1xuICAtLWJzLXByaW1hcnk6ICMwZDZlZmQ7XG4gIC0tYnMtc2Vjb25kYXJ5OiAjNmM3NTdkO1xuICAtLWJzLXN1Y2Nlc3M6ICMxOTg3NTQ7XG4gIC0tYnMtaW5mbzogIzBkY2FmMDtcbiAgLS1icy13YXJuaW5nOiAjZmZjMTA3O1xuICAtLWJzLWRhbmdlcjogI2RjMzU0NTtcbiAgLS1icy1saWdodDogI2Y4ZjlmYTtcbiAgLS1icy1kYXJrOiAjMjEyNTI5O1xuICAtLWJzLXByaW1hcnktcmdiOiAxMywgMTEwLCAyNTM7XG4gIC0tYnMtc2Vjb25kYXJ5LXJnYjogMTA4LCAxMTcsIDEyNTtcbiAgLS1icy1zdWNjZXNzLXJnYjogMjUsIDEzNSwgODQ7XG4gIC0tYnMtaW5mby1yZ2I6IDEzLCAyMDIsIDI0MDtcbiAgLS1icy13YXJuaW5nLXJnYjogMjU1LCAxOTMsIDc7XG4gIC0tYnMtZGFuZ2VyLXJnYjogMjIwLCA1MywgNjk7XG4gIC0tYnMtbGlnaHQtcmdiOiAyNDgsIDI0OSwgMjUwO1xuICAtLWJzLWRhcmstcmdiOiAzMywgMzcsIDQxO1xuICAtLWJzLXdoaXRlLXJnYjogMjU1LCAyNTUsIDI1NTtcbiAgLS1icy1ibGFjay1yZ2I6IDAsIDAsIDA7XG4gIC0tYnMtYm9keS1jb2xvci1yZ2I6IDMzLCAzNywgNDE7XG4gIC0tYnMtYm9keS1iZy1yZ2I6IDI1NSwgMjU1LCAyNTU7XG4gIC0tYnMtZm9udC1zYW5zLXNlcmlmOiBzeXN0ZW0tdWksIC1hcHBsZS1zeXN0ZW0sIFwiU2Vnb2UgVUlcIiwgUm9ib3RvLCBcIkhlbHZldGljYSBOZXVlXCIsIFwiTm90byBTYW5zXCIsIFwiTGliZXJhdGlvbiBTYW5zXCIsIEFyaWFsLCBzYW5zLXNlcmlmLCBcIkFwcGxlIENvbG9yIEVtb2ppXCIsIFwiU2Vnb2UgVUkgRW1vamlcIiwgXCJTZWdvZSBVSSBTeW1ib2xcIiwgXCJOb3RvIENvbG9yIEVtb2ppXCI7XG4gIC0tYnMtZm9udC1tb25vc3BhY2U6IFNGTW9uby1SZWd1bGFyLCBNZW5sbywgTW9uYWNvLCBDb25zb2xhcywgXCJMaWJlcmF0aW9uIE1vbm9cIiwgXCJDb3VyaWVyIE5ld1wiLCBtb25vc3BhY2U7XG4gIC0tYnMtZ3JhZGllbnQ6IGxpbmVhci1ncmFkaWVudCgxODBkZWcsIHJnYmEoMjU1LCAyNTUsIDI1NSwgMC4xNSksIHJnYmEoMjU1LCAyNTUsIDI1NSwgMCkpO1xuICAtLWJzLWJvZHktZm9udC1mYW1pbHk6IHZhcigtLWJzLWZvbnQtc2Fucy1zZXJpZik7XG4gIC0tYnMtYm9keS1mb250LXNpemU6IDFyZW07XG4gIC0tYnMtYm9keS1mb250LXdlaWdodDogNDAwO1xuICAtLWJzLWJvZHktbGluZS1oZWlnaHQ6IDEuNTtcbiAgLS1icy1ib2R5LWNvbG9yOiAjMjEyNTI5O1xuICAtLWJzLWJvZHktYmc6ICNmZmY7XG4gIC0tYnMtYm9yZGVyLXdpZHRoOiAxcHg7XG4gIC0tYnMtYm9yZGVyLXN0eWxlOiBzb2xpZDtcbiAgLS1icy1ib3JkZXItY29sb3I6ICNkZWUyZTY7XG4gIC0tYnMtYm9yZGVyLWNvbG9yLXRyYW5zbHVjZW50OiByZ2JhKDAsIDAsIDAsIDAuMTc1KTtcbiAgLS1icy1ib3JkZXItcmFkaXVzOiAwLjM3NXJlbTtcbiAgLS1icy1ib3JkZXItcmFkaXVzLXNtOiAwLjI1cmVtO1xuICAtLWJzLWJvcmRlci1yYWRpdXMtbGc6IDAuNXJlbTtcbiAgLS1icy1ib3JkZXItcmFkaXVzLXhsOiAxcmVtO1xuICAtLWJzLWJvcmRlci1yYWRpdXMtMnhsOiAycmVtO1xuICAtLWJzLWJvcmRlci1yYWRpdXMtcGlsbDogNTByZW07XG4gIC0tYnMtbGluay1jb2xvcjogIzBkNmVmZDtcbiAgLS1icy1saW5rLWhvdmVyLWNvbG9yOiAjMGE1OGNhO1xuICAtLWJzLWNvZGUtY29sb3I6ICNkNjMzODQ7XG4gIC0tYnMtaGlnaGxpZ2h0LWJnOiAjZmZmM2NkO1xufVxuXG4uY29udGFpbmVyLFxuLmNvbnRhaW5lci1mbHVpZCxcbi5jb250YWluZXIteHhsLFxuLmNvbnRhaW5lci14bCxcbi5jb250YWluZXItbGcsXG4uY29udGFpbmVyLW1kLFxuLmNvbnRhaW5lci1zbSB7XG4gIC0tYnMtZ3V0dGVyLXg6IDA7XG4gIC0tYnMtZ3V0dGVyLXk6IDA7XG4gIHdpZHRoOiAxMDAlO1xuICBwYWRkaW5nLXJpZ2h0OiBjYWxjKHZhcigtLWJzLWd1dHRlci14KSAqIDAuNSk7XG4gIHBhZGRpbmctbGVmdDogY2FsYyh2YXIoLS1icy1ndXR0ZXIteCkgKiAwLjUpO1xuICBtYXJnaW4tcmlnaHQ6IGF1dG87XG4gIG1hcmdpbi1sZWZ0OiBhdXRvO1xufVxuXG5cblxuQG1lZGlhIChtaW4td2lkdGg6IDU3NnB4KSB7XG4gIC5jb250YWluZXIge1xuICAgIHBhZGRpbmctcmlnaHQ6IGNhbGModmFyKC0tYnMtZ3V0dGVyLXgpICogMC41KTtcbiAgICBwYWRkaW5nLWxlZnQ6IGNhbGModmFyKC0tYnMtZ3V0dGVyLXgpICogMC41KTtcbiAgfVxuXG4gIC5jb250YWluZXItc20sIC5jb250YWluZXIge1xuICAgIG1heC13aWR0aDogNTUycHg7XG4gIH1cbn1cblxuQG1lZGlhIChtaW4td2lkdGg6IDc2OHB4KSB7XG4gIC5jb250YWluZXItbWQsIC5jb250YWluZXItc20sIC5jb250YWluZXIge1xuICAgIG1heC13aWR0aDogNjU2cHg7XG4gIH1cbn1cblxuQG1lZGlhIChtaW4td2lkdGg6IDk5MnB4KSB7XG4gIC5jb250YWluZXItbGcsIC5jb250YWluZXItbWQsIC5jb250YWluZXItc20sIC5jb250YWluZXIge1xuICAgIG1heC13aWR0aDogODQ3cHg7XG4gIH1cbn1cblxuQG1lZGlhIChtaW4td2lkdGg6IDEyMDBweCkge1xuICAuY29udGFpbmVyLXhsLCAuY29udGFpbmVyLWxnLCAuY29udGFpbmVyLW1kLCAuY29udGFpbmVyLXNtLCAuY29udGFpbmVyIHtcbiAgICBtYXgtd2lkdGg6IDEyNTJweDtcbiAgfVxufVxuXG5AbWVkaWEgKG1pbi13aWR0aDogMTQwMHB4KSB7XG4gIC5jb250YWluZXIteHhsLCAuY29udGFpbmVyLXhsLCAuY29udGFpbmVyLWxnLCAuY29udGFpbmVyLW1kLCAuY29udGFpbmVyLXNtLCAuY29udGFpbmVyIHtcbiAgICBtYXgtd2lkdGg6IDEzMDBweDtcbiAgfVxufVxuXG5AbWVkaWEgKG1pbi13aWR0aDogMTkyMHB4KSB7XG4gIC5jb250YWluZXIteHhsLCAuY29udGFpbmVyLXhsLCAuY29udGFpbmVyLWxnLCAuY29udGFpbmVyLW1kLCAuY29udGFpbmVyLXNtLCAuY29udGFpbmVyIHtcbiAgICBtYXgtd2lkdGg6IDE2NDBweDtcbiAgfVxufVxuXG4ucm93IHtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC13cmFwOiB3cmFwO1xuICAtLWJzLWd1dHRlci14OiAzMHB4O1xuICBtYXJnaW4tdG9wOiBjYWxjKC0xICogdmFyKC0tYnMtZ3V0dGVyLXkpKTtcbiAgbWFyZ2luLXJpZ2h0OiBjYWxjKC0wLjUgKiB2YXIoLS1icy1ndXR0ZXIteCkpO1xuICBtYXJnaW4tbGVmdDogY2FsYygtMC41ICogdmFyKC0tYnMtZ3V0dGVyLXgpKTtcbn1cblxuLnJvdyA+ICoge1xuICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICBmbGV4LXNocmluazogMDtcbiAgd2lkdGg6IDEwMCU7XG4gIG1heC13aWR0aDogMTAwJTtcbiAgcGFkZGluZy1yaWdodDogY2FsYyh2YXIoLS1icy1ndXR0ZXIteCkgKiAwLjUpO1xuICBwYWRkaW5nLWxlZnQ6IGNhbGModmFyKC0tYnMtZ3V0dGVyLXgpICogMC41KTtcbiAgbWFyZ2luLXRvcDogdmFyKC0tYnMtZ3V0dGVyLXkpO1xufVxuXG4uY29sIHtcbiAgZmxleDogMSAwIDAlO1xufVxuXG4ucm93LWNvbHMtYXV0byA+ICoge1xuICBmbGV4OiAwIDAgYXV0bztcbiAgd2lkdGg6IGF1dG87XG59XG5cbi5yb3ctY29scy0xID4gKiB7XG4gIGZsZXg6IDAgMCBhdXRvO1xuICB3aWR0aDogMTAwJTtcbn1cblxuLnJvdy1jb2xzLTIgPiAqIHtcbiAgZmxleDogMCAwIGF1dG87XG4gIHdpZHRoOiA1MCU7XG59XG5cbi5yb3ctY29scy0zID4gKiB7XG4gIGZsZXg6IDAgMCBhdXRvO1xuICB3aWR0aDogMzMuMzMzMzMzMzMzMyU7XG59XG5cbi5yb3ctY29scy00ID4gKiB7XG4gIGZsZXg6IDAgMCBhdXRvO1xuICB3aWR0aDogMjUlO1xufVxuXG4ucm93LWNvbHMtNSA+ICoge1xuICBmbGV4OiAwIDAgYXV0bztcbiAgd2lkdGg6IDIwJTtcbn1cblxuLnJvdy1jb2xzLTYgPiAqIHtcbiAgZmxleDogMCAwIGF1dG87XG4gIHdpZHRoOiAxNi42NjY2NjY2NjY3JTtcbn1cblxuLmNvbC1hdXRvIHtcbiAgZmxleDogMCAwIGF1dG87XG4gIHdpZHRoOiBhdXRvO1xufVxuXG4uY29sLTEge1xuICBmbGV4OiAwIDAgYXV0bztcbiAgd2lkdGg6IDguMzMzMzMzMzMlO1xufVxuXG4uY29sLTIge1xuICBmbGV4OiAwIDAgYXV0bztcbiAgd2lkdGg6IDE2LjY2NjY2NjY3JTtcbn1cblxuLmNvbC0zIHtcbiAgZmxleDogMCAwIGF1dG87XG4gIHdpZHRoOiAyNSU7XG59XG5cbi5jb2wtNCB7XG4gIGZsZXg6IDAgMCBhdXRvO1xuICB3aWR0aDogMzMuMzMzMzMzMzMlO1xufVxuXG4uY29sLTUge1xuICBmbGV4OiAwIDAgYXV0bztcbiAgd2lkdGg6IDQxLjY2NjY2NjY3JTtcbn1cblxuLmNvbC02IHtcbiAgZmxleDogMCAwIGF1dG87XG4gIHdpZHRoOiA1MCU7XG59XG5cbi5jb2wtNyB7XG4gIGZsZXg6IDAgMCBhdXRvO1xuICB3aWR0aDogNTguMzMzMzMzMzMlO1xufVxuXG4uY29sLTgge1xuICBmbGV4OiAwIDAgYXV0bztcbiAgd2lkdGg6IDY2LjY2NjY2NjY3JTtcbn1cblxuLmNvbC05IHtcbiAgZmxleDogMCAwIGF1dG87XG4gIHdpZHRoOiA3NSU7XG59XG5cbi5jb2wtMTAge1xuICBmbGV4OiAwIDAgYXV0bztcbiAgd2lkdGg6IDgzLjMzMzMzMzMzJTtcbn1cblxuLmNvbC0xMSB7XG4gIGZsZXg6IDAgMCBhdXRvO1xuICB3aWR0aDogOTEuNjY2NjY2NjclO1xufVxuXG4uY29sLTEyIHtcbiAgZmxleDogMCAwIGF1dG87XG4gIHdpZHRoOiAxMDAlO1xufVxuXG4ub2Zmc2V0LTEge1xuICBtYXJnaW4tbGVmdDogOC4zMzMzMzMzMyU7XG59XG5cbi5vZmZzZXQtMiB7XG4gIG1hcmdpbi1sZWZ0OiAxNi42NjY2NjY2NyU7XG59XG5cbi5vZmZzZXQtMyB7XG4gIG1hcmdpbi1sZWZ0OiAyNSU7XG59XG5cbi5vZmZzZXQtNCB7XG4gIG1hcmdpbi1sZWZ0OiAzMy4zMzMzMzMzMyU7XG59XG5cbi5vZmZzZXQtNSB7XG4gIG1hcmdpbi1sZWZ0OiA0MS42NjY2NjY2NyU7XG59XG5cbi5vZmZzZXQtNiB7XG4gIG1hcmdpbi1sZWZ0OiA1MCU7XG59XG5cbi5vZmZzZXQtNyB7XG4gIG1hcmdpbi1sZWZ0OiA1OC4zMzMzMzMzMyU7XG59XG5cbi5vZmZzZXQtOCB7XG4gIG1hcmdpbi1sZWZ0OiA2Ni42NjY2NjY2NyU7XG59XG5cbi5vZmZzZXQtOSB7XG4gIG1hcmdpbi1sZWZ0OiA3NSU7XG59XG5cbi5vZmZzZXQtMTAge1xuICBtYXJnaW4tbGVmdDogODMuMzMzMzMzMzMlO1xufVxuXG4ub2Zmc2V0LTExIHtcbiAgbWFyZ2luLWxlZnQ6IDkxLjY2NjY2NjY3JTtcbn1cblxuLmctMCxcbi5neC0wIHtcbiAgLS1icy1ndXR0ZXIteDogMDtcbn1cblxuLmctMCxcbi5neS0wIHtcbiAgLS1icy1ndXR0ZXIteTogMDtcbn1cblxuLmctMSxcbi5neC0xIHtcbiAgLS1icy1ndXR0ZXIteDogMC4yNXJlbTtcbn1cblxuLmctMSxcbi5neS0xIHtcbiAgLS1icy1ndXR0ZXIteTogMC4yNXJlbTtcbn1cblxuLmctMixcbi5neC0yIHtcbiAgLS1icy1ndXR0ZXIteDogMC41cmVtO1xufVxuXG4uZy0yLFxuLmd5LTIge1xuICAtLWJzLWd1dHRlci15OiAwLjVyZW07XG59XG5cbi5nLTMsXG4uZ3gtMyB7XG4gIC0tYnMtZ3V0dGVyLXg6IDFyZW07XG59XG5cbi5nLTMsXG4uZ3ktMyB7XG4gIC0tYnMtZ3V0dGVyLXk6IDFyZW07XG59XG5cbi5nLTQsXG4uZ3gtNCB7XG4gIC0tYnMtZ3V0dGVyLXg6IDEuNXJlbTtcbn1cblxuLmctNCxcbi5neS00IHtcbiAgLS1icy1ndXR0ZXIteTogMS41cmVtO1xufVxuXG4uZy01LFxuLmd4LTUge1xuICAtLWJzLWd1dHRlci14OiAzcmVtO1xufVxuXG4uZy01LFxuLmd5LTUge1xuICAtLWJzLWd1dHRlci15OiAzcmVtO1xufVxuXG5AbWVkaWEgKG1pbi13aWR0aDogNTc2cHgpIHtcbiAgLmNvbC1zbSB7XG4gICAgZmxleDogMSAwIDAlO1xuICB9XG4gIC5yb3ctY29scy1zbS1hdXRvID4gKiB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IGF1dG87XG4gIH1cbiAgLnJvdy1jb2xzLXNtLTEgPiAqIHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogMTAwJTtcbiAgfVxuICAucm93LWNvbHMtc20tMiA+ICoge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiA1MCU7XG4gIH1cbiAgLnJvdy1jb2xzLXNtLTMgPiAqIHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogMzMuMzMzMzMzMzMzMyU7XG4gIH1cbiAgLnJvdy1jb2xzLXNtLTQgPiAqIHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogMjUlO1xuICB9XG4gIC5yb3ctY29scy1zbS01ID4gKiB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDIwJTtcbiAgfVxuICAucm93LWNvbHMtc20tNiA+ICoge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiAxNi42NjY2NjY2NjY3JTtcbiAgfVxuICAuY29sLXNtLWF1dG8ge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiBhdXRvO1xuICB9XG4gIC5jb2wtc20tMSB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDguMzMzMzMzMzMlO1xuICB9XG4gIC5jb2wtc20tMiB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDE2LjY2NjY2NjY3JTtcbiAgfVxuICAuY29sLXNtLTMge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiAyNSU7XG4gIH1cbiAgLmNvbC1zbS00IHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogMzMuMzMzMzMzMzMlO1xuICB9XG4gIC5jb2wtc20tNSB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDQxLjY2NjY2NjY3JTtcbiAgfVxuICAuY29sLXNtLTYge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiA1MCU7XG4gIH1cbiAgLmNvbC1zbS03IHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogNTguMzMzMzMzMzMlO1xuICB9XG4gIC5jb2wtc20tOCB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDY2LjY2NjY2NjY3JTtcbiAgfVxuICAuY29sLXNtLTkge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiA3NSU7XG4gIH1cbiAgLmNvbC1zbS0xMCB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDgzLjMzMzMzMzMzJTtcbiAgfVxuICAuY29sLXNtLTExIHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogOTEuNjY2NjY2NjclO1xuICB9XG4gIC5jb2wtc20tMTIge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiAxMDAlO1xuICB9XG4gIC5vZmZzZXQtc20tMCB7XG4gICAgbWFyZ2luLWxlZnQ6IDA7XG4gIH1cbiAgLm9mZnNldC1zbS0xIHtcbiAgICBtYXJnaW4tbGVmdDogOC4zMzMzMzMzMyU7XG4gIH1cbiAgLm9mZnNldC1zbS0yIHtcbiAgICBtYXJnaW4tbGVmdDogMTYuNjY2NjY2NjclO1xuICB9XG4gIC5vZmZzZXQtc20tMyB7XG4gICAgbWFyZ2luLWxlZnQ6IDI1JTtcbiAgfVxuICAub2Zmc2V0LXNtLTQge1xuICAgIG1hcmdpbi1sZWZ0OiAzMy4zMzMzMzMzMyU7XG4gIH1cbiAgLm9mZnNldC1zbS01IHtcbiAgICBtYXJnaW4tbGVmdDogNDEuNjY2NjY2NjclO1xuICB9XG4gIC5vZmZzZXQtc20tNiB7XG4gICAgbWFyZ2luLWxlZnQ6IDUwJTtcbiAgfVxuICAub2Zmc2V0LXNtLTcge1xuICAgIG1hcmdpbi1sZWZ0OiA1OC4zMzMzMzMzMyU7XG4gIH1cbiAgLm9mZnNldC1zbS04IHtcbiAgICBtYXJnaW4tbGVmdDogNjYuNjY2NjY2NjclO1xuICB9XG4gIC5vZmZzZXQtc20tOSB7XG4gICAgbWFyZ2luLWxlZnQ6IDc1JTtcbiAgfVxuICAub2Zmc2V0LXNtLTEwIHtcbiAgICBtYXJnaW4tbGVmdDogODMuMzMzMzMzMzMlO1xuICB9XG4gIC5vZmZzZXQtc20tMTEge1xuICAgIG1hcmdpbi1sZWZ0OiA5MS42NjY2NjY2NyU7XG4gIH1cbiAgLmctc20tMCxcbiAgLmd4LXNtLTAge1xuICAgIC0tYnMtZ3V0dGVyLXg6IDA7XG4gIH1cbiAgLmctc20tMCxcbiAgLmd5LXNtLTAge1xuICAgIC0tYnMtZ3V0dGVyLXk6IDA7XG4gIH1cbiAgLmctc20tMSxcbiAgLmd4LXNtLTEge1xuICAgIC0tYnMtZ3V0dGVyLXg6IDAuMjVyZW07XG4gIH1cbiAgLmctc20tMSxcbiAgLmd5LXNtLTEge1xuICAgIC0tYnMtZ3V0dGVyLXk6IDAuMjVyZW07XG4gIH1cbiAgLmctc20tMixcbiAgLmd4LXNtLTIge1xuICAgIC0tYnMtZ3V0dGVyLXg6IDAuNXJlbTtcbiAgfVxuICAuZy1zbS0yLFxuICAuZ3ktc20tMiB7XG4gICAgLS1icy1ndXR0ZXIteTogMC41cmVtO1xuICB9XG4gIC5nLXNtLTMsXG4gIC5neC1zbS0zIHtcbiAgICAtLWJzLWd1dHRlci14OiAxcmVtO1xuICB9XG4gIC5nLXNtLTMsXG4gIC5neS1zbS0zIHtcbiAgICAtLWJzLWd1dHRlci15OiAxcmVtO1xuICB9XG4gIC5nLXNtLTQsXG4gIC5neC1zbS00IHtcbiAgICAtLWJzLWd1dHRlci14OiAxLjVyZW07XG4gIH1cbiAgLmctc20tNCxcbiAgLmd5LXNtLTQge1xuICAgIC0tYnMtZ3V0dGVyLXk6IDEuNXJlbTtcbiAgfVxuICAuZy1zbS01LFxuICAuZ3gtc20tNSB7XG4gICAgLS1icy1ndXR0ZXIteDogM3JlbTtcbiAgfVxuICAuZy1zbS01LFxuICAuZ3ktc20tNSB7XG4gICAgLS1icy1ndXR0ZXIteTogM3JlbTtcbiAgfVxufVxuXG5AbWVkaWEgKG1pbi13aWR0aDogNzY4cHgpIHtcbiAgLmNvbC1tZCB7XG4gICAgZmxleDogMSAwIDAlO1xuICB9XG4gIC5yb3ctY29scy1tZC1hdXRvID4gKiB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IGF1dG87XG4gIH1cbiAgLnJvdy1jb2xzLW1kLTEgPiAqIHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogMTAwJTtcbiAgfVxuICAucm93LWNvbHMtbWQtMiA+ICoge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiA1MCU7XG4gIH1cbiAgLnJvdy1jb2xzLW1kLTMgPiAqIHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogMzMuMzMzMzMzMzMzMyU7XG4gIH1cbiAgLnJvdy1jb2xzLW1kLTQgPiAqIHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogMjUlO1xuICB9XG4gIC5yb3ctY29scy1tZC01ID4gKiB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDIwJTtcbiAgfVxuICAucm93LWNvbHMtbWQtNiA+ICoge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiAxNi42NjY2NjY2NjY3JTtcbiAgfVxuICAuY29sLW1kLWF1dG8ge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiBhdXRvO1xuICB9XG4gIC5jb2wtbWQtMSB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDguMzMzMzMzMzMlO1xuICB9XG4gIC5jb2wtbWQtMiB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDE2LjY2NjY2NjY3JTtcbiAgfVxuICAuY29sLW1kLTMge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiAyNSU7XG4gIH1cbiAgLmNvbC1tZC00IHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogMzMuMzMzMzMzMzMlO1xuICB9XG4gIC5jb2wtbWQtNSB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDQxLjY2NjY2NjY3JTtcbiAgfVxuICAuY29sLW1kLTYge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiA1MCU7XG4gIH1cbiAgLmNvbC1tZC03IHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogNTguMzMzMzMzMzMlO1xuICB9XG4gIC5jb2wtbWQtOCB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDY2LjY2NjY2NjY3JTtcbiAgfVxuICAuY29sLW1kLTkge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiA3NSU7XG4gIH1cbiAgLmNvbC1tZC0xMCB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDgzLjMzMzMzMzMzJTtcbiAgfVxuICAuY29sLW1kLTExIHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogOTEuNjY2NjY2NjclO1xuICB9XG4gIC5jb2wtbWQtMTIge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiAxMDAlO1xuICB9XG4gIC5vZmZzZXQtbWQtMCB7XG4gICAgbWFyZ2luLWxlZnQ6IDA7XG4gIH1cbiAgLm9mZnNldC1tZC0xIHtcbiAgICBtYXJnaW4tbGVmdDogOC4zMzMzMzMzMyU7XG4gIH1cbiAgLm9mZnNldC1tZC0yIHtcbiAgICBtYXJnaW4tbGVmdDogMTYuNjY2NjY2NjclO1xuICB9XG4gIC5vZmZzZXQtbWQtMyB7XG4gICAgbWFyZ2luLWxlZnQ6IDI1JTtcbiAgfVxuICAub2Zmc2V0LW1kLTQge1xuICAgIG1hcmdpbi1sZWZ0OiAzMy4zMzMzMzMzMyU7XG4gIH1cbiAgLm9mZnNldC1tZC01IHtcbiAgICBtYXJnaW4tbGVmdDogNDEuNjY2NjY2NjclO1xuICB9XG4gIC5vZmZzZXQtbWQtNiB7XG4gICAgbWFyZ2luLWxlZnQ6IDUwJTtcbiAgfVxuICAub2Zmc2V0LW1kLTcge1xuICAgIG1hcmdpbi1sZWZ0OiA1OC4zMzMzMzMzMyU7XG4gIH1cbiAgLm9mZnNldC1tZC04IHtcbiAgICBtYXJnaW4tbGVmdDogNjYuNjY2NjY2NjclO1xuICB9XG4gIC5vZmZzZXQtbWQtOSB7XG4gICAgbWFyZ2luLWxlZnQ6IDc1JTtcbiAgfVxuICAub2Zmc2V0LW1kLTEwIHtcbiAgICBtYXJnaW4tbGVmdDogODMuMzMzMzMzMzMlO1xuICB9XG4gIC5vZmZzZXQtbWQtMTEge1xuICAgIG1hcmdpbi1sZWZ0OiA5MS42NjY2NjY2NyU7XG4gIH1cbiAgLmctbWQtMCxcbiAgLmd4LW1kLTAge1xuICAgIC0tYnMtZ3V0dGVyLXg6IDA7XG4gIH1cbiAgLmctbWQtMCxcbiAgLmd5LW1kLTAge1xuICAgIC0tYnMtZ3V0dGVyLXk6IDA7XG4gIH1cbiAgLmctbWQtMSxcbiAgLmd4LW1kLTEge1xuICAgIC0tYnMtZ3V0dGVyLXg6IDAuMjVyZW07XG4gIH1cbiAgLmctbWQtMSxcbiAgLmd5LW1kLTEge1xuICAgIC0tYnMtZ3V0dGVyLXk6IDAuMjVyZW07XG4gIH1cbiAgLmctbWQtMixcbiAgLmd4LW1kLTIge1xuICAgIC0tYnMtZ3V0dGVyLXg6IDAuNXJlbTtcbiAgfVxuICAuZy1tZC0yLFxuICAuZ3ktbWQtMiB7XG4gICAgLS1icy1ndXR0ZXIteTogMC41cmVtO1xuICB9XG4gIC5nLW1kLTMsXG4gIC5neC1tZC0zIHtcbiAgICAtLWJzLWd1dHRlci14OiAxcmVtO1xuICB9XG4gIC5nLW1kLTMsXG4gIC5neS1tZC0zIHtcbiAgICAtLWJzLWd1dHRlci15OiAxcmVtO1xuICB9XG4gIC5nLW1kLTQsXG4gIC5neC1tZC00IHtcbiAgICAtLWJzLWd1dHRlci14OiAxLjVyZW07XG4gIH1cbiAgLmctbWQtNCxcbiAgLmd5LW1kLTQge1xuICAgIC0tYnMtZ3V0dGVyLXk6IDEuNXJlbTtcbiAgfVxuICAuZy1tZC01LFxuICAuZ3gtbWQtNSB7XG4gICAgLS1icy1ndXR0ZXIteDogM3JlbTtcbiAgfVxuICAuZy1tZC01LFxuICAuZ3ktbWQtNSB7XG4gICAgLS1icy1ndXR0ZXIteTogM3JlbTtcbiAgfVxufVxuXG5AbWVkaWEgKG1pbi13aWR0aDogOTkycHgpIHtcbiAgLmNvbC1sZyB7XG4gICAgZmxleDogMSAwIDAlO1xuICB9XG4gIC5yb3ctY29scy1sZy1hdXRvID4gKiB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IGF1dG87XG4gIH1cbiAgLnJvdy1jb2xzLWxnLTEgPiAqIHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogMTAwJTtcbiAgfVxuICAucm93LWNvbHMtbGctMiA+ICoge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiA1MCU7XG4gIH1cbiAgLnJvdy1jb2xzLWxnLTMgPiAqIHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogMzMuMzMzMzMzMzMzMyU7XG4gIH1cbiAgLnJvdy1jb2xzLWxnLTQgPiAqIHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogMjUlO1xuICB9XG4gIC5yb3ctY29scy1sZy01ID4gKiB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDIwJTtcbiAgfVxuICAucm93LWNvbHMtbGctNiA+ICoge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiAxNi42NjY2NjY2NjY3JTtcbiAgfVxuICAuY29sLWxnLWF1dG8ge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiBhdXRvO1xuICB9XG4gIC5jb2wtbGctMSB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDguMzMzMzMzMzMlO1xuICB9XG4gIC5jb2wtbGctMiB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDE2LjY2NjY2NjY3JTtcbiAgfVxuICAuY29sLWxnLTMge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiAyNSU7XG4gIH1cbiAgLmNvbC1sZy00IHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogMzMuMzMzMzMzMzMlO1xuICB9XG4gIC5jb2wtbGctNSB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDQxLjY2NjY2NjY3JTtcbiAgfVxuICAuY29sLWxnLTYge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiA1MCU7XG4gIH1cbiAgLmNvbC1sZy03IHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogNTguMzMzMzMzMzMlO1xuICB9XG4gIC5jb2wtbGctOCB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDY2LjY2NjY2NjY3JTtcbiAgfVxuICAuY29sLWxnLTkge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiA3NSU7XG4gIH1cbiAgLmNvbC1sZy0xMCB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDgzLjMzMzMzMzMzJTtcbiAgfVxuICAuY29sLWxnLTExIHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogOTEuNjY2NjY2NjclO1xuICB9XG4gIC5jb2wtbGctMTIge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiAxMDAlO1xuICB9XG4gIC5vZmZzZXQtbGctMCB7XG4gICAgbWFyZ2luLWxlZnQ6IDA7XG4gIH1cbiAgLm9mZnNldC1sZy0xIHtcbiAgICBtYXJnaW4tbGVmdDogOC4zMzMzMzMzMyU7XG4gIH1cbiAgLm9mZnNldC1sZy0yIHtcbiAgICBtYXJnaW4tbGVmdDogMTYuNjY2NjY2NjclO1xuICB9XG4gIC5vZmZzZXQtbGctMyB7XG4gICAgbWFyZ2luLWxlZnQ6IDI1JTtcbiAgfVxuICAub2Zmc2V0LWxnLTQge1xuICAgIG1hcmdpbi1sZWZ0OiAzMy4zMzMzMzMzMyU7XG4gIH1cbiAgLm9mZnNldC1sZy01IHtcbiAgICBtYXJnaW4tbGVmdDogNDEuNjY2NjY2NjclO1xuICB9XG4gIC5vZmZzZXQtbGctNiB7XG4gICAgbWFyZ2luLWxlZnQ6IDUwJTtcbiAgfVxuICAub2Zmc2V0LWxnLTcge1xuICAgIG1hcmdpbi1sZWZ0OiA1OC4zMzMzMzMzMyU7XG4gIH1cbiAgLm9mZnNldC1sZy04IHtcbiAgICBtYXJnaW4tbGVmdDogNjYuNjY2NjY2NjclO1xuICB9XG4gIC5vZmZzZXQtbGctOSB7XG4gICAgbWFyZ2luLWxlZnQ6IDc1JTtcbiAgfVxuICAub2Zmc2V0LWxnLTEwIHtcbiAgICBtYXJnaW4tbGVmdDogODMuMzMzMzMzMzMlO1xuICB9XG4gIC5vZmZzZXQtbGctMTEge1xuICAgIG1hcmdpbi1sZWZ0OiA5MS42NjY2NjY2NyU7XG4gIH1cbiAgLmctbGctMCxcbiAgLmd4LWxnLTAge1xuICAgIC0tYnMtZ3V0dGVyLXg6IDA7XG4gIH1cbiAgLmctbGctMCxcbiAgLmd5LWxnLTAge1xuICAgIC0tYnMtZ3V0dGVyLXk6IDA7XG4gIH1cbiAgLmctbGctMSxcbiAgLmd4LWxnLTEge1xuICAgIC0tYnMtZ3V0dGVyLXg6IDAuMjVyZW07XG4gIH1cbiAgLmctbGctMSxcbiAgLmd5LWxnLTEge1xuICAgIC0tYnMtZ3V0dGVyLXk6IDAuMjVyZW07XG4gIH1cbiAgLmctbGctMixcbiAgLmd4LWxnLTIge1xuICAgIC0tYnMtZ3V0dGVyLXg6IDAuNXJlbTtcbiAgfVxuICAuZy1sZy0yLFxuICAuZ3ktbGctMiB7XG4gICAgLS1icy1ndXR0ZXIteTogMC41cmVtO1xuICB9XG4gIC5nLWxnLTMsXG4gIC5neC1sZy0zIHtcbiAgICAtLWJzLWd1dHRlci14OiAxcmVtO1xuICB9XG4gIC5nLWxnLTMsXG4gIC5neS1sZy0zIHtcbiAgICAtLWJzLWd1dHRlci15OiAxcmVtO1xuICB9XG4gIC5nLWxnLTQsXG4gIC5neC1sZy00IHtcbiAgICAtLWJzLWd1dHRlci14OiAxLjVyZW07XG4gIH1cbiAgLmctbGctNCxcbiAgLmd5LWxnLTQge1xuICAgIC0tYnMtZ3V0dGVyLXk6IDEuNXJlbTtcbiAgfVxuICAuZy1sZy01LFxuICAuZ3gtbGctNSB7XG4gICAgLS1icy1ndXR0ZXIteDogM3JlbTtcbiAgfVxuICAuZy1sZy01LFxuICAuZ3ktbGctNSB7XG4gICAgLS1icy1ndXR0ZXIteTogM3JlbTtcbiAgfVxufVxuXG5AbWVkaWEgKG1pbi13aWR0aDogMTIwMHB4KSB7XG4gIC5jb2wteGwge1xuICAgIGZsZXg6IDEgMCAwJTtcbiAgfVxuICAucm93LWNvbHMteGwtYXV0byA+ICoge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiBhdXRvO1xuICB9XG4gIC5yb3ctY29scy14bC0xID4gKiB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDEwMCU7XG4gIH1cbiAgLnJvdy1jb2xzLXhsLTIgPiAqIHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogNTAlO1xuICB9XG4gIC5yb3ctY29scy14bC0zID4gKiB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDMzLjMzMzMzMzMzMzMlO1xuICB9XG4gIC5yb3ctY29scy14bC00ID4gKiB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDI1JTtcbiAgfVxuICAucm93LWNvbHMteGwtNSA+ICoge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiAyMCU7XG4gIH1cbiAgLnJvdy1jb2xzLXhsLTYgPiAqIHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogMTYuNjY2NjY2NjY2NyU7XG4gIH1cbiAgLmNvbC14bC1hdXRvIHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogYXV0bztcbiAgfVxuICAuY29sLXhsLTEge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiA4LjMzMzMzMzMzJTtcbiAgfVxuICAuY29sLXhsLTIge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiAxNi42NjY2NjY2NyU7XG4gIH1cbiAgLmNvbC14bC0zIHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogMjUlO1xuICB9XG4gIC5jb2wteGwtNCB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDMzLjMzMzMzMzMzJTtcbiAgfVxuICAuY29sLXhsLTUge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiA0MS42NjY2NjY2NyU7XG4gIH1cbiAgLmNvbC14bC02IHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogNTAlO1xuICB9XG4gIC5jb2wteGwtNyB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDU4LjMzMzMzMzMzJTtcbiAgfVxuICAuY29sLXhsLTgge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiA2Ni42NjY2NjY2NyU7XG4gIH1cbiAgLmNvbC14bC05IHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogNzUlO1xuICB9XG4gIC5jb2wteGwtMTAge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiA4My4zMzMzMzMzMyU7XG4gIH1cbiAgLmNvbC14bC0xMSB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDkxLjY2NjY2NjY3JTtcbiAgfVxuICAuY29sLXhsLTEyIHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogMTAwJTtcbiAgfVxuICAub2Zmc2V0LXhsLTAge1xuICAgIG1hcmdpbi1sZWZ0OiAwO1xuICB9XG4gIC5vZmZzZXQteGwtMSB7XG4gICAgbWFyZ2luLWxlZnQ6IDguMzMzMzMzMzMlO1xuICB9XG4gIC5vZmZzZXQteGwtMiB7XG4gICAgbWFyZ2luLWxlZnQ6IDE2LjY2NjY2NjY3JTtcbiAgfVxuICAub2Zmc2V0LXhsLTMge1xuICAgIG1hcmdpbi1sZWZ0OiAyNSU7XG4gIH1cbiAgLm9mZnNldC14bC00IHtcbiAgICBtYXJnaW4tbGVmdDogMzMuMzMzMzMzMzMlO1xuICB9XG4gIC5vZmZzZXQteGwtNSB7XG4gICAgbWFyZ2luLWxlZnQ6IDQxLjY2NjY2NjY3JTtcbiAgfVxuICAub2Zmc2V0LXhsLTYge1xuICAgIG1hcmdpbi1sZWZ0OiA1MCU7XG4gIH1cbiAgLm9mZnNldC14bC03IHtcbiAgICBtYXJnaW4tbGVmdDogNTguMzMzMzMzMzMlO1xuICB9XG4gIC5vZmZzZXQteGwtOCB7XG4gICAgbWFyZ2luLWxlZnQ6IDY2LjY2NjY2NjY3JTtcbiAgfVxuICAub2Zmc2V0LXhsLTkge1xuICAgIG1hcmdpbi1sZWZ0OiA3NSU7XG4gIH1cbiAgLm9mZnNldC14bC0xMCB7XG4gICAgbWFyZ2luLWxlZnQ6IDgzLjMzMzMzMzMzJTtcbiAgfVxuICAub2Zmc2V0LXhsLTExIHtcbiAgICBtYXJnaW4tbGVmdDogOTEuNjY2NjY2NjclO1xuICB9XG4gIC5nLXhsLTAsXG4gIC5neC14bC0wIHtcbiAgICAtLWJzLWd1dHRlci14OiAwO1xuICB9XG4gIC5nLXhsLTAsXG4gIC5neS14bC0wIHtcbiAgICAtLWJzLWd1dHRlci15OiAwO1xuICB9XG4gIC5nLXhsLTEsXG4gIC5neC14bC0xIHtcbiAgICAtLWJzLWd1dHRlci14OiAwLjI1cmVtO1xuICB9XG4gIC5nLXhsLTEsXG4gIC5neS14bC0xIHtcbiAgICAtLWJzLWd1dHRlci15OiAwLjI1cmVtO1xuICB9XG4gIC5nLXhsLTIsXG4gIC5neC14bC0yIHtcbiAgICAtLWJzLWd1dHRlci14OiAwLjVyZW07XG4gIH1cbiAgLmcteGwtMixcbiAgLmd5LXhsLTIge1xuICAgIC0tYnMtZ3V0dGVyLXk6IDAuNXJlbTtcbiAgfVxuICAuZy14bC0zLFxuICAuZ3gteGwtMyB7XG4gICAgLS1icy1ndXR0ZXIteDogMXJlbTtcbiAgfVxuICAuZy14bC0zLFxuICAuZ3kteGwtMyB7XG4gICAgLS1icy1ndXR0ZXIteTogMXJlbTtcbiAgfVxuICAuZy14bC00LFxuICAuZ3gteGwtNCB7XG4gICAgLS1icy1ndXR0ZXIteDogMS41cmVtO1xuICB9XG4gIC5nLXhsLTQsXG4gIC5neS14bC00IHtcbiAgICAtLWJzLWd1dHRlci15OiAxLjVyZW07XG4gIH1cbiAgLmcteGwtNSxcbiAgLmd4LXhsLTUge1xuICAgIC0tYnMtZ3V0dGVyLXg6IDNyZW07XG4gIH1cbiAgLmcteGwtNSxcbiAgLmd5LXhsLTUge1xuICAgIC0tYnMtZ3V0dGVyLXk6IDNyZW07XG4gIH1cbn1cblxuQG1lZGlhIChtaW4td2lkdGg6IDE0MDBweCkge1xuICAuY29sLXh4bCB7XG4gICAgZmxleDogMSAwIDAlO1xuICB9XG4gIC5yb3ctY29scy14eGwtYXV0byA+ICoge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiBhdXRvO1xuICB9XG4gIC5yb3ctY29scy14eGwtMSA+ICoge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiAxMDAlO1xuICB9XG4gIC5yb3ctY29scy14eGwtMiA+ICoge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiA1MCU7XG4gIH1cbiAgLnJvdy1jb2xzLXh4bC0zID4gKiB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDMzLjMzMzMzMzMzMzMlO1xuICB9XG4gIC5yb3ctY29scy14eGwtNCA+ICoge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiAyNSU7XG4gIH1cbiAgLnJvdy1jb2xzLXh4bC01ID4gKiB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDIwJTtcbiAgfVxuICAucm93LWNvbHMteHhsLTYgPiAqIHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogMTYuNjY2NjY2NjY2NyU7XG4gIH1cbiAgLmNvbC14eGwtYXV0byB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IGF1dG87XG4gIH1cbiAgLmNvbC14eGwtMSB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDguMzMzMzMzMzMlO1xuICB9XG4gIC5jb2wteHhsLTIge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiAxNi42NjY2NjY2NyU7XG4gIH1cbiAgLmNvbC14eGwtMyB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDI1JTtcbiAgfVxuICAuY29sLXh4bC00IHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogMzMuMzMzMzMzMzMlO1xuICB9XG4gIC5jb2wteHhsLTUge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiA0MS42NjY2NjY2NyU7XG4gIH1cbiAgLmNvbC14eGwtNiB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDUwJTtcbiAgfVxuICAuY29sLXh4bC03IHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB3aWR0aDogNTguMzMzMzMzMzMlO1xuICB9XG4gIC5jb2wteHhsLTgge1xuICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgIHdpZHRoOiA2Ni42NjY2NjY2NyU7XG4gIH1cbiAgLmNvbC14eGwtOSB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDc1JTtcbiAgfVxuICAuY29sLXh4bC0xMCB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDgzLjMzMzMzMzMzJTtcbiAgfVxuICAuY29sLXh4bC0xMSB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDkxLjY2NjY2NjY3JTtcbiAgfVxuICAuY29sLXh4bC0xMiB7XG4gICAgZmxleDogMCAwIGF1dG87XG4gICAgd2lkdGg6IDEwMCU7XG4gIH1cbiAgLm9mZnNldC14eGwtMCB7XG4gICAgbWFyZ2luLWxlZnQ6IDA7XG4gIH1cbiAgLm9mZnNldC14eGwtMSB7XG4gICAgbWFyZ2luLWxlZnQ6IDguMzMzMzMzMzMlO1xuICB9XG4gIC5vZmZzZXQteHhsLTIge1xuICAgIG1hcmdpbi1sZWZ0OiAxNi42NjY2NjY2NyU7XG4gIH1cbiAgLm9mZnNldC14eGwtMyB7XG4gICAgbWFyZ2luLWxlZnQ6IDI1JTtcbiAgfVxuICAub2Zmc2V0LXh4bC00IHtcbiAgICBtYXJnaW4tbGVmdDogMzMuMzMzMzMzMzMlO1xuICB9XG4gIC5vZmZzZXQteHhsLTUge1xuICAgIG1hcmdpbi1sZWZ0OiA0MS42NjY2NjY2NyU7XG4gIH1cbiAgLm9mZnNldC14eGwtNiB7XG4gICAgbWFyZ2luLWxlZnQ6IDUwJTtcbiAgfVxuICAub2Zmc2V0LXh4bC03IHtcbiAgICBtYXJnaW4tbGVmdDogNTguMzMzMzMzMzMlO1xuICB9XG4gIC5vZmZzZXQteHhsLTgge1xuICAgIG1hcmdpbi1sZWZ0OiA2Ni42NjY2NjY2NyU7XG4gIH1cbiAgLm9mZnNldC14eGwtOSB7XG4gICAgbWFyZ2luLWxlZnQ6IDc1JTtcbiAgfVxuICAub2Zmc2V0LXh4bC0xMCB7XG4gICAgbWFyZ2luLWxlZnQ6IDgzLjMzMzMzMzMzJTtcbiAgfVxuICAub2Zmc2V0LXh4bC0xMSB7XG4gICAgbWFyZ2luLWxlZnQ6IDkxLjY2NjY2NjY3JTtcbiAgfVxuICAuZy14eGwtMCxcbiAgLmd4LXh4bC0wIHtcbiAgICAtLWJzLWd1dHRlci14OiAwO1xuICB9XG4gIC5nLXh4bC0wLFxuICAuZ3kteHhsLTAge1xuICAgIC0tYnMtZ3V0dGVyLXk6IDA7XG4gIH1cbiAgLmcteHhsLTEsXG4gIC5neC14eGwtMSB7XG4gICAgLS1icy1ndXR0ZXIteDogMC4yNXJlbTtcbiAgfVxuICAuZy14eGwtMSxcbiAgLmd5LXh4bC0xIHtcbiAgICAtLWJzLWd1dHRlci15OiAwLjI1cmVtO1xuICB9XG4gIC5nLXh4bC0yLFxuICAuZ3gteHhsLTIge1xuICAgIC0tYnMtZ3V0dGVyLXg6IDAuNXJlbTtcbiAgfVxuICAuZy14eGwtMixcbiAgLmd5LXh4bC0yIHtcbiAgICAtLWJzLWd1dHRlci15OiAwLjVyZW07XG4gIH1cbiAgLmcteHhsLTMsXG4gIC5neC14eGwtMyB7XG4gICAgLS1icy1ndXR0ZXIteDogMXJlbTtcbiAgfVxuICAuZy14eGwtMyxcbiAgLmd5LXh4bC0zIHtcbiAgICAtLWJzLWd1dHRlci15OiAxcmVtO1xuICB9XG4gIC5nLXh4bC00LFxuICAuZ3gteHhsLTQge1xuICAgIC0tYnMtZ3V0dGVyLXg6IDEuNXJlbTtcbiAgfVxuICAuZy14eGwtNCxcbiAgLmd5LXh4bC00IHtcbiAgICAtLWJzLWd1dHRlci15OiAxLjVyZW07XG4gIH1cbiAgLmcteHhsLTUsXG4gIC5neC14eGwtNSB7XG4gICAgLS1icy1ndXR0ZXIteDogM3JlbTtcbiAgfVxuICAuZy14eGwtNSxcbiAgLmd5LXh4bC01IHtcbiAgICAtLWJzLWd1dHRlci15OiAzcmVtO1xuICB9XG59XG5cbi5kLWlubGluZSB7XG4gIGRpc3BsYXk6IGlubGluZSAhaW1wb3J0YW50O1xufVxuXG4uZC1pbmxpbmUtYmxvY2sge1xuICBkaXNwbGF5OiBpbmxpbmUtYmxvY2sgIWltcG9ydGFudDtcbn1cblxuLmQtYmxvY2sge1xuICBkaXNwbGF5OiBibG9jayAhaW1wb3J0YW50O1xufVxuXG4uZC1ncmlkIHtcbiAgZGlzcGxheTogZ3JpZCAhaW1wb3J0YW50O1xufVxuXG4uZC10YWJsZSB7XG4gIGRpc3BsYXk6IHRhYmxlICFpbXBvcnRhbnQ7XG59XG5cbi5kLXRhYmxlLXJvdyB7XG4gIGRpc3BsYXk6IHRhYmxlLXJvdyAhaW1wb3J0YW50O1xufVxuXG4uZC10YWJsZS1jZWxsIHtcbiAgZGlzcGxheTogdGFibGUtY2VsbCAhaW1wb3J0YW50O1xufVxuXG4uZC1mbGV4IHtcbiAgZGlzcGxheTogZmxleCAhaW1wb3J0YW50O1xufVxuXG4uZC1pbmxpbmUtZmxleCB7XG4gIGRpc3BsYXk6IGlubGluZS1mbGV4ICFpbXBvcnRhbnQ7XG59XG5cbi5kLW5vbmUge1xuICBkaXNwbGF5OiBub25lICFpbXBvcnRhbnQ7XG59XG5cbi5mbGV4LWZpbGwge1xuICBmbGV4OiAxIDEgYXV0byAhaW1wb3J0YW50O1xufVxuXG4uZmxleC1yb3cge1xuICBmbGV4LWRpcmVjdGlvbjogcm93ICFpbXBvcnRhbnQ7XG59XG5cbi5mbGV4LWNvbHVtbiB7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW4gIWltcG9ydGFudDtcbn1cblxuLmZsZXgtcm93LXJldmVyc2Uge1xuICBmbGV4LWRpcmVjdGlvbjogcm93LXJldmVyc2UgIWltcG9ydGFudDtcbn1cblxuLmZsZXgtY29sdW1uLXJldmVyc2Uge1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uLXJldmVyc2UgIWltcG9ydGFudDtcbn1cblxuLmZsZXgtZ3Jvdy0wIHtcbiAgZmxleC1ncm93OiAwICFpbXBvcnRhbnQ7XG59XG5cbi5mbGV4LWdyb3ctMSB7XG4gIGZsZXgtZ3JvdzogMSAhaW1wb3J0YW50O1xufVxuXG4uZmxleC1zaHJpbmstMCB7XG4gIGZsZXgtc2hyaW5rOiAwICFpbXBvcnRhbnQ7XG59XG5cbi5mbGV4LXNocmluay0xIHtcbiAgZmxleC1zaHJpbms6IDEgIWltcG9ydGFudDtcbn1cblxuLmZsZXgtd3JhcCB7XG4gIGZsZXgtd3JhcDogd3JhcCAhaW1wb3J0YW50O1xufVxuXG4uZmxleC1ub3dyYXAge1xuICBmbGV4LXdyYXA6IG5vd3JhcCAhaW1wb3J0YW50O1xufVxuXG4uZmxleC13cmFwLXJldmVyc2Uge1xuICBmbGV4LXdyYXA6IHdyYXAtcmV2ZXJzZSAhaW1wb3J0YW50O1xufVxuXG4uanVzdGlmeS1jb250ZW50LXN0YXJ0IHtcbiAganVzdGlmeS1jb250ZW50OiBmbGV4LXN0YXJ0ICFpbXBvcnRhbnQ7XG59XG5cbi5qdXN0aWZ5LWNvbnRlbnQtZW5kIHtcbiAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZCAhaW1wb3J0YW50O1xufVxuXG4uanVzdGlmeS1jb250ZW50LWNlbnRlciB7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyICFpbXBvcnRhbnQ7XG59XG5cbi5qdXN0aWZ5LWNvbnRlbnQtYmV0d2VlbiB7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbiAhaW1wb3J0YW50O1xufVxuXG4uanVzdGlmeS1jb250ZW50LWFyb3VuZCB7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYXJvdW5kICFpbXBvcnRhbnQ7XG59XG5cbi5qdXN0aWZ5LWNvbnRlbnQtZXZlbmx5IHtcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1ldmVubHkgIWltcG9ydGFudDtcbn1cblxuLmFsaWduLWl0ZW1zLXN0YXJ0IHtcbiAgYWxpZ24taXRlbXM6IGZsZXgtc3RhcnQgIWltcG9ydGFudDtcbn1cblxuLmFsaWduLWl0ZW1zLWVuZCB7XG4gIGFsaWduLWl0ZW1zOiBmbGV4LWVuZCAhaW1wb3J0YW50O1xufVxuXG4uYWxpZ24taXRlbXMtY2VudGVyIHtcbiAgYWxpZ24taXRlbXM6IGNlbnRlciAhaW1wb3J0YW50O1xufVxuXG4uYWxpZ24taXRlbXMtYmFzZWxpbmUge1xuICBhbGlnbi1pdGVtczogYmFzZWxpbmUgIWltcG9ydGFudDtcbn1cblxuLmFsaWduLWl0ZW1zLXN0cmV0Y2gge1xuICBhbGlnbi1pdGVtczogc3RyZXRjaCAhaW1wb3J0YW50O1xufVxuXG4uYWxpZ24tY29udGVudC1zdGFydCB7XG4gIGFsaWduLWNvbnRlbnQ6IGZsZXgtc3RhcnQgIWltcG9ydGFudDtcbn1cblxuLmFsaWduLWNvbnRlbnQtZW5kIHtcbiAgYWxpZ24tY29udGVudDogZmxleC1lbmQgIWltcG9ydGFudDtcbn1cblxuLmFsaWduLWNvbnRlbnQtY2VudGVyIHtcbiAgYWxpZ24tY29udGVudDogY2VudGVyICFpbXBvcnRhbnQ7XG59XG5cbi5hbGlnbi1jb250ZW50LWJldHdlZW4ge1xuICBhbGlnbi1jb250ZW50OiBzcGFjZS1iZXR3ZWVuICFpbXBvcnRhbnQ7XG59XG5cbi5hbGlnbi1jb250ZW50LWFyb3VuZCB7XG4gIGFsaWduLWNvbnRlbnQ6IHNwYWNlLWFyb3VuZCAhaW1wb3J0YW50O1xufVxuXG4uYWxpZ24tY29udGVudC1zdHJldGNoIHtcbiAgYWxpZ24tY29udGVudDogc3RyZXRjaCAhaW1wb3J0YW50O1xufVxuXG4uYWxpZ24tc2VsZi1hdXRvIHtcbiAgYWxpZ24tc2VsZjogYXV0byAhaW1wb3J0YW50O1xufVxuXG4uYWxpZ24tc2VsZi1zdGFydCB7XG4gIGFsaWduLXNlbGY6IGZsZXgtc3RhcnQgIWltcG9ydGFudDtcbn1cblxuLmFsaWduLXNlbGYtZW5kIHtcbiAgYWxpZ24tc2VsZjogZmxleC1lbmQgIWltcG9ydGFudDtcbn1cblxuLmFsaWduLXNlbGYtY2VudGVyIHtcbiAgYWxpZ24tc2VsZjogY2VudGVyICFpbXBvcnRhbnQ7XG59XG5cbi5hbGlnbi1zZWxmLWJhc2VsaW5lIHtcbiAgYWxpZ24tc2VsZjogYmFzZWxpbmUgIWltcG9ydGFudDtcbn1cblxuLmFsaWduLXNlbGYtc3RyZXRjaCB7XG4gIGFsaWduLXNlbGY6IHN0cmV0Y2ggIWltcG9ydGFudDtcbn1cblxuLm9yZGVyLWZpcnN0IHtcbiAgb3JkZXI6IC0xICFpbXBvcnRhbnQ7XG59XG5cbi5vcmRlci0wIHtcbiAgb3JkZXI6IDAgIWltcG9ydGFudDtcbn1cblxuLm9yZGVyLTEge1xuICBvcmRlcjogMSAhaW1wb3J0YW50O1xufVxuXG4ub3JkZXItMiB7XG4gIG9yZGVyOiAyICFpbXBvcnRhbnQ7XG59XG5cbi5vcmRlci0zIHtcbiAgb3JkZXI6IDMgIWltcG9ydGFudDtcbn1cblxuLm9yZGVyLTQge1xuICBvcmRlcjogNCAhaW1wb3J0YW50O1xufVxuXG4ub3JkZXItNSB7XG4gIG9yZGVyOiA1ICFpbXBvcnRhbnQ7XG59XG5cbi5vcmRlci1sYXN0IHtcbiAgb3JkZXI6IDYgIWltcG9ydGFudDtcbn1cblxuLm0tMCB7XG4gIG1hcmdpbjogMCAhaW1wb3J0YW50O1xufVxuXG4ubS0xIHtcbiAgbWFyZ2luOiAwLjI1cmVtICFpbXBvcnRhbnQ7XG59XG5cbi5tLTIge1xuICBtYXJnaW46IDAuNXJlbSAhaW1wb3J0YW50O1xufVxuXG4ubS0zIHtcbiAgbWFyZ2luOiAxcmVtICFpbXBvcnRhbnQ7XG59XG5cbi5tLTQge1xuICBtYXJnaW46IDEuNXJlbSAhaW1wb3J0YW50O1xufVxuXG4ubS01IHtcbiAgbWFyZ2luOiAzcmVtICFpbXBvcnRhbnQ7XG59XG5cbi5tLWF1dG8ge1xuICBtYXJnaW46IGF1dG8gIWltcG9ydGFudDtcbn1cblxuLm14LTAge1xuICBtYXJnaW4tcmlnaHQ6IDAgIWltcG9ydGFudDtcbiAgbWFyZ2luLWxlZnQ6IDAgIWltcG9ydGFudDtcbn1cblxuLm14LTEge1xuICBtYXJnaW4tcmlnaHQ6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgbWFyZ2luLWxlZnQ6IDAuMjVyZW0gIWltcG9ydGFudDtcbn1cblxuLm14LTIge1xuICBtYXJnaW4tcmlnaHQ6IDAuNXJlbSAhaW1wb3J0YW50O1xuICBtYXJnaW4tbGVmdDogMC41cmVtICFpbXBvcnRhbnQ7XG59XG5cbi5teC0zIHtcbiAgbWFyZ2luLXJpZ2h0OiAxcmVtICFpbXBvcnRhbnQ7XG4gIG1hcmdpbi1sZWZ0OiAxcmVtICFpbXBvcnRhbnQ7XG59XG5cbi5teC00IHtcbiAgbWFyZ2luLXJpZ2h0OiAxLjVyZW0gIWltcG9ydGFudDtcbiAgbWFyZ2luLWxlZnQ6IDEuNXJlbSAhaW1wb3J0YW50O1xufVxuXG4ubXgtNSB7XG4gIG1hcmdpbi1yaWdodDogM3JlbSAhaW1wb3J0YW50O1xuICBtYXJnaW4tbGVmdDogM3JlbSAhaW1wb3J0YW50O1xufVxuXG4ubXgtYXV0byB7XG4gIG1hcmdpbi1yaWdodDogYXV0byAhaW1wb3J0YW50O1xuICBtYXJnaW4tbGVmdDogYXV0byAhaW1wb3J0YW50O1xufVxuXG4ubXktMCB7XG4gIG1hcmdpbi10b3A6IDAgIWltcG9ydGFudDtcbiAgbWFyZ2luLWJvdHRvbTogMCAhaW1wb3J0YW50O1xufVxuXG4ubXktMSB7XG4gIG1hcmdpbi10b3A6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgbWFyZ2luLWJvdHRvbTogMC4yNXJlbSAhaW1wb3J0YW50O1xufVxuXG4ubXktMiB7XG4gIG1hcmdpbi10b3A6IDAuNXJlbSAhaW1wb3J0YW50O1xuICBtYXJnaW4tYm90dG9tOiAwLjVyZW0gIWltcG9ydGFudDtcbn1cblxuLm15LTMge1xuICBtYXJnaW4tdG9wOiAxcmVtICFpbXBvcnRhbnQ7XG4gIG1hcmdpbi1ib3R0b206IDFyZW0gIWltcG9ydGFudDtcbn1cblxuLm15LTQge1xuICBtYXJnaW4tdG9wOiAxLjVyZW0gIWltcG9ydGFudDtcbiAgbWFyZ2luLWJvdHRvbTogMS41cmVtICFpbXBvcnRhbnQ7XG59XG5cbi5teS01IHtcbiAgbWFyZ2luLXRvcDogM3JlbSAhaW1wb3J0YW50O1xuICBtYXJnaW4tYm90dG9tOiAzcmVtICFpbXBvcnRhbnQ7XG59XG5cbi5teS1hdXRvIHtcbiAgbWFyZ2luLXRvcDogYXV0byAhaW1wb3J0YW50O1xuICBtYXJnaW4tYm90dG9tOiBhdXRvICFpbXBvcnRhbnQ7XG59XG5cbi5tdC0wIHtcbiAgbWFyZ2luLXRvcDogMCAhaW1wb3J0YW50O1xufVxuXG4ubXQtMSB7XG4gIG1hcmdpbi10b3A6IDAuMjVyZW0gIWltcG9ydGFudDtcbn1cblxuLm10LTIge1xuICBtYXJnaW4tdG9wOiAwLjVyZW0gIWltcG9ydGFudDtcbn1cblxuLm10LTMge1xuICBtYXJnaW4tdG9wOiAxcmVtICFpbXBvcnRhbnQ7XG59XG5cbi5tdC00IHtcbiAgbWFyZ2luLXRvcDogMS41cmVtICFpbXBvcnRhbnQ7XG59XG5cbi5tdC01IHtcbiAgbWFyZ2luLXRvcDogM3JlbSAhaW1wb3J0YW50O1xufVxuXG4ubXQtYXV0byB7XG4gIG1hcmdpbi10b3A6IGF1dG8gIWltcG9ydGFudDtcbn1cblxuLm1lLTAge1xuICBtYXJnaW4tcmlnaHQ6IDAgIWltcG9ydGFudDtcbn1cblxuLm1lLTEge1xuICBtYXJnaW4tcmlnaHQ6IDAuMjVyZW0gIWltcG9ydGFudDtcbn1cblxuLm1lLTIge1xuICBtYXJnaW4tcmlnaHQ6IDAuNXJlbSAhaW1wb3J0YW50O1xufVxuXG4ubWUtMyB7XG4gIG1hcmdpbi1yaWdodDogMXJlbSAhaW1wb3J0YW50O1xufVxuXG4ubWUtNCB7XG4gIG1hcmdpbi1yaWdodDogMS41cmVtICFpbXBvcnRhbnQ7XG59XG5cbi5tZS01IHtcbiAgbWFyZ2luLXJpZ2h0OiAzcmVtICFpbXBvcnRhbnQ7XG59XG5cbi5tZS1hdXRvIHtcbiAgbWFyZ2luLXJpZ2h0OiBhdXRvICFpbXBvcnRhbnQ7XG59XG5cbi5tYi0wIHtcbiAgbWFyZ2luLWJvdHRvbTogMCAhaW1wb3J0YW50O1xufVxuXG4ubWItMSB7XG4gIG1hcmdpbi1ib3R0b206IDAuMjVyZW0gIWltcG9ydGFudDtcbn1cblxuLm1iLTIge1xuICBtYXJnaW4tYm90dG9tOiAwLjVyZW0gIWltcG9ydGFudDtcbn1cblxuLm1iLTMge1xuICBtYXJnaW4tYm90dG9tOiAxcmVtICFpbXBvcnRhbnQ7XG59XG5cbi5tYi00IHtcbiAgbWFyZ2luLWJvdHRvbTogMS41cmVtICFpbXBvcnRhbnQ7XG59XG5cbi5tYi01IHtcbiAgbWFyZ2luLWJvdHRvbTogM3JlbSAhaW1wb3J0YW50O1xufVxuXG4ubWItYXV0byB7XG4gIG1hcmdpbi1ib3R0b206IGF1dG8gIWltcG9ydGFudDtcbn1cblxuLm1zLTAge1xuICBtYXJnaW4tbGVmdDogMCAhaW1wb3J0YW50O1xufVxuXG4ubXMtMSB7XG4gIG1hcmdpbi1sZWZ0OiAwLjI1cmVtICFpbXBvcnRhbnQ7XG59XG5cbi5tcy0yIHtcbiAgbWFyZ2luLWxlZnQ6IDAuNXJlbSAhaW1wb3J0YW50O1xufVxuXG4ubXMtMyB7XG4gIG1hcmdpbi1sZWZ0OiAxcmVtICFpbXBvcnRhbnQ7XG59XG5cbi5tcy00IHtcbiAgbWFyZ2luLWxlZnQ6IDEuNXJlbSAhaW1wb3J0YW50O1xufVxuXG4ubXMtNSB7XG4gIG1hcmdpbi1sZWZ0OiAzcmVtICFpbXBvcnRhbnQ7XG59XG5cbi5tcy1hdXRvIHtcbiAgbWFyZ2luLWxlZnQ6IGF1dG8gIWltcG9ydGFudDtcbn1cblxuLnAtMCB7XG4gIHBhZGRpbmc6IDAgIWltcG9ydGFudDtcbn1cblxuLnAtMSB7XG4gIHBhZGRpbmc6IDAuMjVyZW0gIWltcG9ydGFudDtcbn1cblxuLnAtMiB7XG4gIHBhZGRpbmc6IDAuNXJlbSAhaW1wb3J0YW50O1xufVxuXG4ucC0zIHtcbiAgcGFkZGluZzogMXJlbSAhaW1wb3J0YW50O1xufVxuXG4ucC00IHtcbiAgcGFkZGluZzogMS41cmVtICFpbXBvcnRhbnQ7XG59XG5cbi5wLTUge1xuICBwYWRkaW5nOiAzcmVtICFpbXBvcnRhbnQ7XG59XG5cbi5weC0wIHtcbiAgcGFkZGluZy1yaWdodDogMCAhaW1wb3J0YW50O1xuICBwYWRkaW5nLWxlZnQ6IDAgIWltcG9ydGFudDtcbn1cblxuLnB4LTEge1xuICBwYWRkaW5nLXJpZ2h0OiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIHBhZGRpbmctbGVmdDogMC4yNXJlbSAhaW1wb3J0YW50O1xufVxuXG4ucHgtMiB7XG4gIHBhZGRpbmctcmlnaHQ6IDAuNXJlbSAhaW1wb3J0YW50O1xuICBwYWRkaW5nLWxlZnQ6IDAuNXJlbSAhaW1wb3J0YW50O1xufVxuXG4ucHgtMyB7XG4gIHBhZGRpbmctcmlnaHQ6IDFyZW0gIWltcG9ydGFudDtcbiAgcGFkZGluZy1sZWZ0OiAxcmVtICFpbXBvcnRhbnQ7XG59XG5cbi5weC00IHtcbiAgcGFkZGluZy1yaWdodDogMS41cmVtICFpbXBvcnRhbnQ7XG4gIHBhZGRpbmctbGVmdDogMS41cmVtICFpbXBvcnRhbnQ7XG59XG5cbi5weC01IHtcbiAgcGFkZGluZy1yaWdodDogM3JlbSAhaW1wb3J0YW50O1xuICBwYWRkaW5nLWxlZnQ6IDNyZW0gIWltcG9ydGFudDtcbn1cblxuLnB5LTAge1xuICBwYWRkaW5nLXRvcDogMCAhaW1wb3J0YW50O1xuICBwYWRkaW5nLWJvdHRvbTogMCAhaW1wb3J0YW50O1xufVxuXG4ucHktMSB7XG4gIHBhZGRpbmctdG9wOiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIHBhZGRpbmctYm90dG9tOiAwLjI1cmVtICFpbXBvcnRhbnQ7XG59XG5cbi5weS0yIHtcbiAgcGFkZGluZy10b3A6IDAuNXJlbSAhaW1wb3J0YW50O1xuICBwYWRkaW5nLWJvdHRvbTogMC41cmVtICFpbXBvcnRhbnQ7XG59XG5cbi5weS0zIHtcbiAgcGFkZGluZy10b3A6IDFyZW0gIWltcG9ydGFudDtcbiAgcGFkZGluZy1ib3R0b206IDFyZW0gIWltcG9ydGFudDtcbn1cblxuLnB5LTQge1xuICBwYWRkaW5nLXRvcDogMS41cmVtICFpbXBvcnRhbnQ7XG4gIHBhZGRpbmctYm90dG9tOiAxLjVyZW0gIWltcG9ydGFudDtcbn1cblxuLnB5LTUge1xuICBwYWRkaW5nLXRvcDogM3JlbSAhaW1wb3J0YW50O1xuICBwYWRkaW5nLWJvdHRvbTogM3JlbSAhaW1wb3J0YW50O1xufVxuXG4ucHQtMCB7XG4gIHBhZGRpbmctdG9wOiAwICFpbXBvcnRhbnQ7XG59XG5cbi5wdC0xIHtcbiAgcGFkZGluZy10b3A6IDAuMjVyZW0gIWltcG9ydGFudDtcbn1cblxuLnB0LTIge1xuICBwYWRkaW5nLXRvcDogMC41cmVtICFpbXBvcnRhbnQ7XG59XG5cbi5wdC0zIHtcbiAgcGFkZGluZy10b3A6IDFyZW0gIWltcG9ydGFudDtcbn1cblxuLnB0LTQge1xuICBwYWRkaW5nLXRvcDogMS41cmVtICFpbXBvcnRhbnQ7XG59XG5cbi5wdC01IHtcbiAgcGFkZGluZy10b3A6IDNyZW0gIWltcG9ydGFudDtcbn1cblxuLnBlLTAge1xuICBwYWRkaW5nLXJpZ2h0OiAwICFpbXBvcnRhbnQ7XG59XG5cbi5wZS0xIHtcbiAgcGFkZGluZy1yaWdodDogMC4yNXJlbSAhaW1wb3J0YW50O1xufVxuXG4ucGUtMiB7XG4gIHBhZGRpbmctcmlnaHQ6IDAuNXJlbSAhaW1wb3J0YW50O1xufVxuXG4ucGUtMyB7XG4gIHBhZGRpbmctcmlnaHQ6IDFyZW0gIWltcG9ydGFudDtcbn1cblxuLnBlLTQge1xuICBwYWRkaW5nLXJpZ2h0OiAxLjVyZW0gIWltcG9ydGFudDtcbn1cblxuLnBlLTUge1xuICBwYWRkaW5nLXJpZ2h0OiAzcmVtICFpbXBvcnRhbnQ7XG59XG5cbi5wYi0wIHtcbiAgcGFkZGluZy1ib3R0b206IDAgIWltcG9ydGFudDtcbn1cblxuLnBiLTEge1xuICBwYWRkaW5nLWJvdHRvbTogMC4yNXJlbSAhaW1wb3J0YW50O1xufVxuXG4ucGItMiB7XG4gIHBhZGRpbmctYm90dG9tOiAwLjVyZW0gIWltcG9ydGFudDtcbn1cblxuLnBiLTMge1xuICBwYWRkaW5nLWJvdHRvbTogMXJlbSAhaW1wb3J0YW50O1xufVxuXG4ucGItNCB7XG4gIHBhZGRpbmctYm90dG9tOiAxLjVyZW0gIWltcG9ydGFudDtcbn1cblxuLnBiLTUge1xuICBwYWRkaW5nLWJvdHRvbTogM3JlbSAhaW1wb3J0YW50O1xufVxuXG4ucHMtMCB7XG4gIHBhZGRpbmctbGVmdDogMCAhaW1wb3J0YW50O1xufVxuXG4ucHMtMSB7XG4gIHBhZGRpbmctbGVmdDogMC4yNXJlbSAhaW1wb3J0YW50O1xufVxuXG4ucHMtMiB7XG4gIHBhZGRpbmctbGVmdDogMC41cmVtICFpbXBvcnRhbnQ7XG59XG5cbi5wcy0zIHtcbiAgcGFkZGluZy1sZWZ0OiAxcmVtICFpbXBvcnRhbnQ7XG59XG5cbi5wcy00IHtcbiAgcGFkZGluZy1sZWZ0OiAxLjVyZW0gIWltcG9ydGFudDtcbn1cblxuLnBzLTUge1xuICBwYWRkaW5nLWxlZnQ6IDNyZW0gIWltcG9ydGFudDtcbn1cblxuQG1lZGlhIChtaW4td2lkdGg6IDU3NnB4KSB7XG4gIC5kLXNtLWlubGluZSB7XG4gICAgZGlzcGxheTogaW5saW5lICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmQtc20taW5saW5lLWJsb2NrIHtcbiAgICBkaXNwbGF5OiBpbmxpbmUtYmxvY2sgIWltcG9ydGFudDtcbiAgfVxuICAuZC1zbS1ibG9jayB7XG4gICAgZGlzcGxheTogYmxvY2sgIWltcG9ydGFudDtcbiAgfVxuICAuZC1zbS1ncmlkIHtcbiAgICBkaXNwbGF5OiBncmlkICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmQtc20tdGFibGUge1xuICAgIGRpc3BsYXk6IHRhYmxlICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmQtc20tdGFibGUtcm93IHtcbiAgICBkaXNwbGF5OiB0YWJsZS1yb3cgIWltcG9ydGFudDtcbiAgfVxuICAuZC1zbS10YWJsZS1jZWxsIHtcbiAgICBkaXNwbGF5OiB0YWJsZS1jZWxsICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmQtc20tZmxleCB7XG4gICAgZGlzcGxheTogZmxleCAhaW1wb3J0YW50O1xuICB9XG4gIC5kLXNtLWlubGluZS1mbGV4IHtcbiAgICBkaXNwbGF5OiBpbmxpbmUtZmxleCAhaW1wb3J0YW50O1xuICB9XG4gIC5kLXNtLW5vbmUge1xuICAgIGRpc3BsYXk6IG5vbmUgIWltcG9ydGFudDtcbiAgfVxuICAuZmxleC1zbS1maWxsIHtcbiAgICBmbGV4OiAxIDEgYXV0byAhaW1wb3J0YW50O1xuICB9XG4gIC5mbGV4LXNtLXJvdyB7XG4gICAgZmxleC1kaXJlY3Rpb246IHJvdyAhaW1wb3J0YW50O1xuICB9XG4gIC5mbGV4LXNtLWNvbHVtbiB7XG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbiAhaW1wb3J0YW50O1xuICB9XG4gIC5mbGV4LXNtLXJvdy1yZXZlcnNlIHtcbiAgICBmbGV4LWRpcmVjdGlvbjogcm93LXJldmVyc2UgIWltcG9ydGFudDtcbiAgfVxuICAuZmxleC1zbS1jb2x1bW4tcmV2ZXJzZSB7XG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbi1yZXZlcnNlICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmZsZXgtc20tZ3Jvdy0wIHtcbiAgICBmbGV4LWdyb3c6IDAgIWltcG9ydGFudDtcbiAgfVxuICAuZmxleC1zbS1ncm93LTEge1xuICAgIGZsZXgtZ3JvdzogMSAhaW1wb3J0YW50O1xuICB9XG4gIC5mbGV4LXNtLXNocmluay0wIHtcbiAgICBmbGV4LXNocmluazogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5mbGV4LXNtLXNocmluay0xIHtcbiAgICBmbGV4LXNocmluazogMSAhaW1wb3J0YW50O1xuICB9XG4gIC5mbGV4LXNtLXdyYXAge1xuICAgIGZsZXgtd3JhcDogd3JhcCAhaW1wb3J0YW50O1xuICB9XG4gIC5mbGV4LXNtLW5vd3JhcCB7XG4gICAgZmxleC13cmFwOiBub3dyYXAgIWltcG9ydGFudDtcbiAgfVxuICAuZmxleC1zbS13cmFwLXJldmVyc2Uge1xuICAgIGZsZXgtd3JhcDogd3JhcC1yZXZlcnNlICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmp1c3RpZnktY29udGVudC1zbS1zdGFydCB7XG4gICAganVzdGlmeS1jb250ZW50OiBmbGV4LXN0YXJ0ICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmp1c3RpZnktY29udGVudC1zbS1lbmQge1xuICAgIGp1c3RpZnktY29udGVudDogZmxleC1lbmQgIWltcG9ydGFudDtcbiAgfVxuICAuanVzdGlmeS1jb250ZW50LXNtLWNlbnRlciB7XG4gICAganVzdGlmeS1jb250ZW50OiBjZW50ZXIgIWltcG9ydGFudDtcbiAgfVxuICAuanVzdGlmeS1jb250ZW50LXNtLWJldHdlZW4ge1xuICAgIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbiAhaW1wb3J0YW50O1xuICB9XG4gIC5qdXN0aWZ5LWNvbnRlbnQtc20tYXJvdW5kIHtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWFyb3VuZCAhaW1wb3J0YW50O1xuICB9XG4gIC5qdXN0aWZ5LWNvbnRlbnQtc20tZXZlbmx5IHtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWV2ZW5seSAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1pdGVtcy1zbS1zdGFydCB7XG4gICAgYWxpZ24taXRlbXM6IGZsZXgtc3RhcnQgIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24taXRlbXMtc20tZW5kIHtcbiAgICBhbGlnbi1pdGVtczogZmxleC1lbmQgIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24taXRlbXMtc20tY2VudGVyIHtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLWl0ZW1zLXNtLWJhc2VsaW5lIHtcbiAgICBhbGlnbi1pdGVtczogYmFzZWxpbmUgIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24taXRlbXMtc20tc3RyZXRjaCB7XG4gICAgYWxpZ24taXRlbXM6IHN0cmV0Y2ggIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24tY29udGVudC1zbS1zdGFydCB7XG4gICAgYWxpZ24tY29udGVudDogZmxleC1zdGFydCAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1jb250ZW50LXNtLWVuZCB7XG4gICAgYWxpZ24tY29udGVudDogZmxleC1lbmQgIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24tY29udGVudC1zbS1jZW50ZXIge1xuICAgIGFsaWduLWNvbnRlbnQ6IGNlbnRlciAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1jb250ZW50LXNtLWJldHdlZW4ge1xuICAgIGFsaWduLWNvbnRlbnQ6IHNwYWNlLWJldHdlZW4gIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24tY29udGVudC1zbS1hcm91bmQge1xuICAgIGFsaWduLWNvbnRlbnQ6IHNwYWNlLWFyb3VuZCAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1jb250ZW50LXNtLXN0cmV0Y2gge1xuICAgIGFsaWduLWNvbnRlbnQ6IHN0cmV0Y2ggIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24tc2VsZi1zbS1hdXRvIHtcbiAgICBhbGlnbi1zZWxmOiBhdXRvICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLXNlbGYtc20tc3RhcnQge1xuICAgIGFsaWduLXNlbGY6IGZsZXgtc3RhcnQgIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24tc2VsZi1zbS1lbmQge1xuICAgIGFsaWduLXNlbGY6IGZsZXgtZW5kICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLXNlbGYtc20tY2VudGVyIHtcbiAgICBhbGlnbi1zZWxmOiBjZW50ZXIgIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24tc2VsZi1zbS1iYXNlbGluZSB7XG4gICAgYWxpZ24tc2VsZjogYmFzZWxpbmUgIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24tc2VsZi1zbS1zdHJldGNoIHtcbiAgICBhbGlnbi1zZWxmOiBzdHJldGNoICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm9yZGVyLXNtLWZpcnN0IHtcbiAgICBvcmRlcjogLTEgIWltcG9ydGFudDtcbiAgfVxuICAub3JkZXItc20tMCB7XG4gICAgb3JkZXI6IDAgIWltcG9ydGFudDtcbiAgfVxuICAub3JkZXItc20tMSB7XG4gICAgb3JkZXI6IDEgIWltcG9ydGFudDtcbiAgfVxuICAub3JkZXItc20tMiB7XG4gICAgb3JkZXI6IDIgIWltcG9ydGFudDtcbiAgfVxuICAub3JkZXItc20tMyB7XG4gICAgb3JkZXI6IDMgIWltcG9ydGFudDtcbiAgfVxuICAub3JkZXItc20tNCB7XG4gICAgb3JkZXI6IDQgIWltcG9ydGFudDtcbiAgfVxuICAub3JkZXItc20tNSB7XG4gICAgb3JkZXI6IDUgIWltcG9ydGFudDtcbiAgfVxuICAub3JkZXItc20tbGFzdCB7XG4gICAgb3JkZXI6IDYgIWltcG9ydGFudDtcbiAgfVxuICAubS1zbS0wIHtcbiAgICBtYXJnaW46IDAgIWltcG9ydGFudDtcbiAgfVxuICAubS1zbS0xIHtcbiAgICBtYXJnaW46IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubS1zbS0yIHtcbiAgICBtYXJnaW46IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tLXNtLTMge1xuICAgIG1hcmdpbjogMXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tLXNtLTQge1xuICAgIG1hcmdpbjogMS41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm0tc20tNSB7XG4gICAgbWFyZ2luOiAzcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm0tc20tYXV0byB7XG4gICAgbWFyZ2luOiBhdXRvICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm14LXNtLTAge1xuICAgIG1hcmdpbi1yaWdodDogMCAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1sZWZ0OiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm14LXNtLTEge1xuICAgIG1hcmdpbi1yaWdodDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1sZWZ0OiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm14LXNtLTIge1xuICAgIG1hcmdpbi1yaWdodDogMC41cmVtICFpbXBvcnRhbnQ7XG4gICAgbWFyZ2luLWxlZnQ6IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5teC1zbS0zIHtcbiAgICBtYXJnaW4tcmlnaHQ6IDFyZW0gIWltcG9ydGFudDtcbiAgICBtYXJnaW4tbGVmdDogMXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5teC1zbS00IHtcbiAgICBtYXJnaW4tcmlnaHQ6IDEuNXJlbSAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1sZWZ0OiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXgtc20tNSB7XG4gICAgbWFyZ2luLXJpZ2h0OiAzcmVtICFpbXBvcnRhbnQ7XG4gICAgbWFyZ2luLWxlZnQ6IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXgtc20tYXV0byB7XG4gICAgbWFyZ2luLXJpZ2h0OiBhdXRvICFpbXBvcnRhbnQ7XG4gICAgbWFyZ2luLWxlZnQ6IGF1dG8gIWltcG9ydGFudDtcbiAgfVxuICAubXktc20tMCB7XG4gICAgbWFyZ2luLXRvcDogMCAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1ib3R0b206IDAgIWltcG9ydGFudDtcbiAgfVxuICAubXktc20tMSB7XG4gICAgbWFyZ2luLXRvcDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1ib3R0b206IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXktc20tMiB7XG4gICAgbWFyZ2luLXRvcDogMC41cmVtICFpbXBvcnRhbnQ7XG4gICAgbWFyZ2luLWJvdHRvbTogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm15LXNtLTMge1xuICAgIG1hcmdpbi10b3A6IDFyZW0gIWltcG9ydGFudDtcbiAgICBtYXJnaW4tYm90dG9tOiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm15LXNtLTQge1xuICAgIG1hcmdpbi10b3A6IDEuNXJlbSAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1ib3R0b206IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5teS1zbS01IHtcbiAgICBtYXJnaW4tdG9wOiAzcmVtICFpbXBvcnRhbnQ7XG4gICAgbWFyZ2luLWJvdHRvbTogM3JlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5teS1zbS1hdXRvIHtcbiAgICBtYXJnaW4tdG9wOiBhdXRvICFpbXBvcnRhbnQ7XG4gICAgbWFyZ2luLWJvdHRvbTogYXV0byAhaW1wb3J0YW50O1xuICB9XG4gIC5tdC1zbS0wIHtcbiAgICBtYXJnaW4tdG9wOiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm10LXNtLTEge1xuICAgIG1hcmdpbi10b3A6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXQtc20tMiB7XG4gICAgbWFyZ2luLXRvcDogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm10LXNtLTMge1xuICAgIG1hcmdpbi10b3A6IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXQtc20tNCB7XG4gICAgbWFyZ2luLXRvcDogMS41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm10LXNtLTUge1xuICAgIG1hcmdpbi10b3A6IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXQtc20tYXV0byB7XG4gICAgbWFyZ2luLXRvcDogYXV0byAhaW1wb3J0YW50O1xuICB9XG4gIC5tZS1zbS0wIHtcbiAgICBtYXJnaW4tcmlnaHQ6IDAgIWltcG9ydGFudDtcbiAgfVxuICAubWUtc20tMSB7XG4gICAgbWFyZ2luLXJpZ2h0OiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1lLXNtLTIge1xuICAgIG1hcmdpbi1yaWdodDogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1lLXNtLTMge1xuICAgIG1hcmdpbi1yaWdodDogMXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tZS1zbS00IHtcbiAgICBtYXJnaW4tcmlnaHQ6IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tZS1zbS01IHtcbiAgICBtYXJnaW4tcmlnaHQ6IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubWUtc20tYXV0byB7XG4gICAgbWFyZ2luLXJpZ2h0OiBhdXRvICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1iLXNtLTAge1xuICAgIG1hcmdpbi1ib3R0b206IDAgIWltcG9ydGFudDtcbiAgfVxuICAubWItc20tMSB7XG4gICAgbWFyZ2luLWJvdHRvbTogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tYi1zbS0yIHtcbiAgICBtYXJnaW4tYm90dG9tOiAwLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubWItc20tMyB7XG4gICAgbWFyZ2luLWJvdHRvbTogMXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tYi1zbS00IHtcbiAgICBtYXJnaW4tYm90dG9tOiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubWItc20tNSB7XG4gICAgbWFyZ2luLWJvdHRvbTogM3JlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tYi1zbS1hdXRvIHtcbiAgICBtYXJnaW4tYm90dG9tOiBhdXRvICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1zLXNtLTAge1xuICAgIG1hcmdpbi1sZWZ0OiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1zLXNtLTEge1xuICAgIG1hcmdpbi1sZWZ0OiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1zLXNtLTIge1xuICAgIG1hcmdpbi1sZWZ0OiAwLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXMtc20tMyB7XG4gICAgbWFyZ2luLWxlZnQ6IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXMtc20tNCB7XG4gICAgbWFyZ2luLWxlZnQ6IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tcy1zbS01IHtcbiAgICBtYXJnaW4tbGVmdDogM3JlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tcy1zbS1hdXRvIHtcbiAgICBtYXJnaW4tbGVmdDogYXV0byAhaW1wb3J0YW50O1xuICB9XG4gIC5wLXNtLTAge1xuICAgIHBhZGRpbmc6IDAgIWltcG9ydGFudDtcbiAgfVxuICAucC1zbS0xIHtcbiAgICBwYWRkaW5nOiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnAtc20tMiB7XG4gICAgcGFkZGluZzogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnAtc20tMyB7XG4gICAgcGFkZGluZzogMXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wLXNtLTQge1xuICAgIHBhZGRpbmc6IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wLXNtLTUge1xuICAgIHBhZGRpbmc6IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHgtc20tMCB7XG4gICAgcGFkZGluZy1yaWdodDogMCAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctbGVmdDogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5weC1zbS0xIHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gICAgcGFkZGluZy1sZWZ0OiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB4LXNtLTIge1xuICAgIHBhZGRpbmctcmlnaHQ6IDAuNXJlbSAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctbGVmdDogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB4LXNtLTMge1xuICAgIHBhZGRpbmctcmlnaHQ6IDFyZW0gIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWxlZnQ6IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHgtc20tNCB7XG4gICAgcGFkZGluZy1yaWdodDogMS41cmVtICFpbXBvcnRhbnQ7XG4gICAgcGFkZGluZy1sZWZ0OiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHgtc20tNSB7XG4gICAgcGFkZGluZy1yaWdodDogM3JlbSAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctbGVmdDogM3JlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5weS1zbS0wIHtcbiAgICBwYWRkaW5nLXRvcDogMCAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctYm90dG9tOiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB5LXNtLTEge1xuICAgIHBhZGRpbmctdG9wOiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gICAgcGFkZGluZy1ib3R0b206IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHktc20tMiB7XG4gICAgcGFkZGluZy10b3A6IDAuNXJlbSAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctYm90dG9tOiAwLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHktc20tMyB7XG4gICAgcGFkZGluZy10b3A6IDFyZW0gIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWJvdHRvbTogMXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5weS1zbS00IHtcbiAgICBwYWRkaW5nLXRvcDogMS41cmVtICFpbXBvcnRhbnQ7XG4gICAgcGFkZGluZy1ib3R0b206IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5weS1zbS01IHtcbiAgICBwYWRkaW5nLXRvcDogM3JlbSAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctYm90dG9tOiAzcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB0LXNtLTAge1xuICAgIHBhZGRpbmctdG9wOiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB0LXNtLTEge1xuICAgIHBhZGRpbmctdG9wOiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB0LXNtLTIge1xuICAgIHBhZGRpbmctdG9wOiAwLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHQtc20tMyB7XG4gICAgcGFkZGluZy10b3A6IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHQtc20tNCB7XG4gICAgcGFkZGluZy10b3A6IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wdC1zbS01IHtcbiAgICBwYWRkaW5nLXRvcDogM3JlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wZS1zbS0wIHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBlLXNtLTEge1xuICAgIHBhZGRpbmctcmlnaHQ6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucGUtc20tMiB7XG4gICAgcGFkZGluZy1yaWdodDogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBlLXNtLTMge1xuICAgIHBhZGRpbmctcmlnaHQ6IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucGUtc20tNCB7XG4gICAgcGFkZGluZy1yaWdodDogMS41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBlLXNtLTUge1xuICAgIHBhZGRpbmctcmlnaHQ6IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucGItc20tMCB7XG4gICAgcGFkZGluZy1ib3R0b206IDAgIWltcG9ydGFudDtcbiAgfVxuICAucGItc20tMSB7XG4gICAgcGFkZGluZy1ib3R0b206IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucGItc20tMiB7XG4gICAgcGFkZGluZy1ib3R0b206IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wYi1zbS0zIHtcbiAgICBwYWRkaW5nLWJvdHRvbTogMXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wYi1zbS00IHtcbiAgICBwYWRkaW5nLWJvdHRvbTogMS41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBiLXNtLTUge1xuICAgIHBhZGRpbmctYm90dG9tOiAzcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBzLXNtLTAge1xuICAgIHBhZGRpbmctbGVmdDogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5wcy1zbS0xIHtcbiAgICBwYWRkaW5nLWxlZnQ6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHMtc20tMiB7XG4gICAgcGFkZGluZy1sZWZ0OiAwLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHMtc20tMyB7XG4gICAgcGFkZGluZy1sZWZ0OiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBzLXNtLTQge1xuICAgIHBhZGRpbmctbGVmdDogMS41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBzLXNtLTUge1xuICAgIHBhZGRpbmctbGVmdDogM3JlbSAhaW1wb3J0YW50O1xuICB9XG59XG5cbkBtZWRpYSAobWluLXdpZHRoOiA3NjhweCkge1xuICAuZC1tZC1pbmxpbmUge1xuICAgIGRpc3BsYXk6IGlubGluZSAhaW1wb3J0YW50O1xuICB9XG4gIC5kLW1kLWlubGluZS1ibG9jayB7XG4gICAgZGlzcGxheTogaW5saW5lLWJsb2NrICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmQtbWQtYmxvY2sge1xuICAgIGRpc3BsYXk6IGJsb2NrICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmQtbWQtZ3JpZCB7XG4gICAgZGlzcGxheTogZ3JpZCAhaW1wb3J0YW50O1xuICB9XG4gIC5kLW1kLXRhYmxlIHtcbiAgICBkaXNwbGF5OiB0YWJsZSAhaW1wb3J0YW50O1xuICB9XG4gIC5kLW1kLXRhYmxlLXJvdyB7XG4gICAgZGlzcGxheTogdGFibGUtcm93ICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmQtbWQtdGFibGUtY2VsbCB7XG4gICAgZGlzcGxheTogdGFibGUtY2VsbCAhaW1wb3J0YW50O1xuICB9XG4gIC5kLW1kLWZsZXgge1xuICAgIGRpc3BsYXk6IGZsZXggIWltcG9ydGFudDtcbiAgfVxuICAuZC1tZC1pbmxpbmUtZmxleCB7XG4gICAgZGlzcGxheTogaW5saW5lLWZsZXggIWltcG9ydGFudDtcbiAgfVxuICAuZC1tZC1ub25lIHtcbiAgICBkaXNwbGF5OiBub25lICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmZsZXgtbWQtZmlsbCB7XG4gICAgZmxleDogMSAxIGF1dG8gIWltcG9ydGFudDtcbiAgfVxuICAuZmxleC1tZC1yb3cge1xuICAgIGZsZXgtZGlyZWN0aW9uOiByb3cgIWltcG9ydGFudDtcbiAgfVxuICAuZmxleC1tZC1jb2x1bW4ge1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW4gIWltcG9ydGFudDtcbiAgfVxuICAuZmxleC1tZC1yb3ctcmV2ZXJzZSB7XG4gICAgZmxleC1kaXJlY3Rpb246IHJvdy1yZXZlcnNlICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmZsZXgtbWQtY29sdW1uLXJldmVyc2Uge1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW4tcmV2ZXJzZSAhaW1wb3J0YW50O1xuICB9XG4gIC5mbGV4LW1kLWdyb3ctMCB7XG4gICAgZmxleC1ncm93OiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmZsZXgtbWQtZ3Jvdy0xIHtcbiAgICBmbGV4LWdyb3c6IDEgIWltcG9ydGFudDtcbiAgfVxuICAuZmxleC1tZC1zaHJpbmstMCB7XG4gICAgZmxleC1zaHJpbms6IDAgIWltcG9ydGFudDtcbiAgfVxuICAuZmxleC1tZC1zaHJpbmstMSB7XG4gICAgZmxleC1zaHJpbms6IDEgIWltcG9ydGFudDtcbiAgfVxuICAuZmxleC1tZC13cmFwIHtcbiAgICBmbGV4LXdyYXA6IHdyYXAgIWltcG9ydGFudDtcbiAgfVxuICAuZmxleC1tZC1ub3dyYXAge1xuICAgIGZsZXgtd3JhcDogbm93cmFwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmZsZXgtbWQtd3JhcC1yZXZlcnNlIHtcbiAgICBmbGV4LXdyYXA6IHdyYXAtcmV2ZXJzZSAhaW1wb3J0YW50O1xuICB9XG4gIC5qdXN0aWZ5LWNvbnRlbnQtbWQtc3RhcnQge1xuICAgIGp1c3RpZnktY29udGVudDogZmxleC1zdGFydCAhaW1wb3J0YW50O1xuICB9XG4gIC5qdXN0aWZ5LWNvbnRlbnQtbWQtZW5kIHtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmp1c3RpZnktY29udGVudC1tZC1jZW50ZXIge1xuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmp1c3RpZnktY29udGVudC1tZC1iZXR3ZWVuIHtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW4gIWltcG9ydGFudDtcbiAgfVxuICAuanVzdGlmeS1jb250ZW50LW1kLWFyb3VuZCB7XG4gICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1hcm91bmQgIWltcG9ydGFudDtcbiAgfVxuICAuanVzdGlmeS1jb250ZW50LW1kLWV2ZW5seSB7XG4gICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1ldmVubHkgIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24taXRlbXMtbWQtc3RhcnQge1xuICAgIGFsaWduLWl0ZW1zOiBmbGV4LXN0YXJ0ICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLWl0ZW1zLW1kLWVuZCB7XG4gICAgYWxpZ24taXRlbXM6IGZsZXgtZW5kICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLWl0ZW1zLW1kLWNlbnRlciB7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlciAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1pdGVtcy1tZC1iYXNlbGluZSB7XG4gICAgYWxpZ24taXRlbXM6IGJhc2VsaW5lICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLWl0ZW1zLW1kLXN0cmV0Y2gge1xuICAgIGFsaWduLWl0ZW1zOiBzdHJldGNoICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLWNvbnRlbnQtbWQtc3RhcnQge1xuICAgIGFsaWduLWNvbnRlbnQ6IGZsZXgtc3RhcnQgIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24tY29udGVudC1tZC1lbmQge1xuICAgIGFsaWduLWNvbnRlbnQ6IGZsZXgtZW5kICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLWNvbnRlbnQtbWQtY2VudGVyIHtcbiAgICBhbGlnbi1jb250ZW50OiBjZW50ZXIgIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24tY29udGVudC1tZC1iZXR3ZWVuIHtcbiAgICBhbGlnbi1jb250ZW50OiBzcGFjZS1iZXR3ZWVuICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLWNvbnRlbnQtbWQtYXJvdW5kIHtcbiAgICBhbGlnbi1jb250ZW50OiBzcGFjZS1hcm91bmQgIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24tY29udGVudC1tZC1zdHJldGNoIHtcbiAgICBhbGlnbi1jb250ZW50OiBzdHJldGNoICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLXNlbGYtbWQtYXV0byB7XG4gICAgYWxpZ24tc2VsZjogYXV0byAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1zZWxmLW1kLXN0YXJ0IHtcbiAgICBhbGlnbi1zZWxmOiBmbGV4LXN0YXJ0ICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLXNlbGYtbWQtZW5kIHtcbiAgICBhbGlnbi1zZWxmOiBmbGV4LWVuZCAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1zZWxmLW1kLWNlbnRlciB7XG4gICAgYWxpZ24tc2VsZjogY2VudGVyICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLXNlbGYtbWQtYmFzZWxpbmUge1xuICAgIGFsaWduLXNlbGY6IGJhc2VsaW5lICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLXNlbGYtbWQtc3RyZXRjaCB7XG4gICAgYWxpZ24tc2VsZjogc3RyZXRjaCAhaW1wb3J0YW50O1xuICB9XG4gIC5vcmRlci1tZC1maXJzdCB7XG4gICAgb3JkZXI6IC0xICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm9yZGVyLW1kLTAge1xuICAgIG9yZGVyOiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm9yZGVyLW1kLTEge1xuICAgIG9yZGVyOiAxICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm9yZGVyLW1kLTIge1xuICAgIG9yZGVyOiAyICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm9yZGVyLW1kLTMge1xuICAgIG9yZGVyOiAzICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm9yZGVyLW1kLTQge1xuICAgIG9yZGVyOiA0ICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm9yZGVyLW1kLTUge1xuICAgIG9yZGVyOiA1ICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm9yZGVyLW1kLWxhc3Qge1xuICAgIG9yZGVyOiA2ICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm0tbWQtMCB7XG4gICAgbWFyZ2luOiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm0tbWQtMSB7XG4gICAgbWFyZ2luOiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm0tbWQtMiB7XG4gICAgbWFyZ2luOiAwLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubS1tZC0zIHtcbiAgICBtYXJnaW46IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubS1tZC00IHtcbiAgICBtYXJnaW46IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tLW1kLTUge1xuICAgIG1hcmdpbjogM3JlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tLW1kLWF1dG8ge1xuICAgIG1hcmdpbjogYXV0byAhaW1wb3J0YW50O1xuICB9XG4gIC5teC1tZC0wIHtcbiAgICBtYXJnaW4tcmlnaHQ6IDAgIWltcG9ydGFudDtcbiAgICBtYXJnaW4tbGVmdDogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5teC1tZC0xIHtcbiAgICBtYXJnaW4tcmlnaHQ6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgICBtYXJnaW4tbGVmdDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5teC1tZC0yIHtcbiAgICBtYXJnaW4tcmlnaHQ6IDAuNXJlbSAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1sZWZ0OiAwLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXgtbWQtMyB7XG4gICAgbWFyZ2luLXJpZ2h0OiAxcmVtICFpbXBvcnRhbnQ7XG4gICAgbWFyZ2luLWxlZnQ6IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXgtbWQtNCB7XG4gICAgbWFyZ2luLXJpZ2h0OiAxLjVyZW0gIWltcG9ydGFudDtcbiAgICBtYXJnaW4tbGVmdDogMS41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm14LW1kLTUge1xuICAgIG1hcmdpbi1yaWdodDogM3JlbSAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1sZWZ0OiAzcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm14LW1kLWF1dG8ge1xuICAgIG1hcmdpbi1yaWdodDogYXV0byAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1sZWZ0OiBhdXRvICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm15LW1kLTAge1xuICAgIG1hcmdpbi10b3A6IDAgIWltcG9ydGFudDtcbiAgICBtYXJnaW4tYm90dG9tOiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm15LW1kLTEge1xuICAgIG1hcmdpbi10b3A6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgICBtYXJnaW4tYm90dG9tOiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm15LW1kLTIge1xuICAgIG1hcmdpbi10b3A6IDAuNXJlbSAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1ib3R0b206IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5teS1tZC0zIHtcbiAgICBtYXJnaW4tdG9wOiAxcmVtICFpbXBvcnRhbnQ7XG4gICAgbWFyZ2luLWJvdHRvbTogMXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5teS1tZC00IHtcbiAgICBtYXJnaW4tdG9wOiAxLjVyZW0gIWltcG9ydGFudDtcbiAgICBtYXJnaW4tYm90dG9tOiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXktbWQtNSB7XG4gICAgbWFyZ2luLXRvcDogM3JlbSAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1ib3R0b206IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXktbWQtYXV0byB7XG4gICAgbWFyZ2luLXRvcDogYXV0byAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1ib3R0b206IGF1dG8gIWltcG9ydGFudDtcbiAgfVxuICAubXQtbWQtMCB7XG4gICAgbWFyZ2luLXRvcDogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5tdC1tZC0xIHtcbiAgICBtYXJnaW4tdG9wOiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm10LW1kLTIge1xuICAgIG1hcmdpbi10b3A6IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tdC1tZC0zIHtcbiAgICBtYXJnaW4tdG9wOiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm10LW1kLTQge1xuICAgIG1hcmdpbi10b3A6IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tdC1tZC01IHtcbiAgICBtYXJnaW4tdG9wOiAzcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm10LW1kLWF1dG8ge1xuICAgIG1hcmdpbi10b3A6IGF1dG8gIWltcG9ydGFudDtcbiAgfVxuICAubWUtbWQtMCB7XG4gICAgbWFyZ2luLXJpZ2h0OiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1lLW1kLTEge1xuICAgIG1hcmdpbi1yaWdodDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tZS1tZC0yIHtcbiAgICBtYXJnaW4tcmlnaHQ6IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tZS1tZC0zIHtcbiAgICBtYXJnaW4tcmlnaHQ6IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubWUtbWQtNCB7XG4gICAgbWFyZ2luLXJpZ2h0OiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubWUtbWQtNSB7XG4gICAgbWFyZ2luLXJpZ2h0OiAzcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1lLW1kLWF1dG8ge1xuICAgIG1hcmdpbi1yaWdodDogYXV0byAhaW1wb3J0YW50O1xuICB9XG4gIC5tYi1tZC0wIHtcbiAgICBtYXJnaW4tYm90dG9tOiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1iLW1kLTEge1xuICAgIG1hcmdpbi1ib3R0b206IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubWItbWQtMiB7XG4gICAgbWFyZ2luLWJvdHRvbTogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1iLW1kLTMge1xuICAgIG1hcmdpbi1ib3R0b206IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubWItbWQtNCB7XG4gICAgbWFyZ2luLWJvdHRvbTogMS41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1iLW1kLTUge1xuICAgIG1hcmdpbi1ib3R0b206IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubWItbWQtYXV0byB7XG4gICAgbWFyZ2luLWJvdHRvbTogYXV0byAhaW1wb3J0YW50O1xuICB9XG4gIC5tcy1tZC0wIHtcbiAgICBtYXJnaW4tbGVmdDogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5tcy1tZC0xIHtcbiAgICBtYXJnaW4tbGVmdDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tcy1tZC0yIHtcbiAgICBtYXJnaW4tbGVmdDogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1zLW1kLTMge1xuICAgIG1hcmdpbi1sZWZ0OiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1zLW1kLTQge1xuICAgIG1hcmdpbi1sZWZ0OiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXMtbWQtNSB7XG4gICAgbWFyZ2luLWxlZnQ6IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXMtbWQtYXV0byB7XG4gICAgbWFyZ2luLWxlZnQ6IGF1dG8gIWltcG9ydGFudDtcbiAgfVxuICAucC1tZC0wIHtcbiAgICBwYWRkaW5nOiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnAtbWQtMSB7XG4gICAgcGFkZGluZzogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wLW1kLTIge1xuICAgIHBhZGRpbmc6IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wLW1kLTMge1xuICAgIHBhZGRpbmc6IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucC1tZC00IHtcbiAgICBwYWRkaW5nOiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucC1tZC01IHtcbiAgICBwYWRkaW5nOiAzcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB4LW1kLTAge1xuICAgIHBhZGRpbmctcmlnaHQ6IDAgIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWxlZnQ6IDAgIWltcG9ydGFudDtcbiAgfVxuICAucHgtbWQtMSB7XG4gICAgcGFkZGluZy1yaWdodDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctbGVmdDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5weC1tZC0yIHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAwLjVyZW0gIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWxlZnQ6IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5weC1tZC0zIHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAxcmVtICFpbXBvcnRhbnQ7XG4gICAgcGFkZGluZy1sZWZ0OiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB4LW1kLTQge1xuICAgIHBhZGRpbmctcmlnaHQ6IDEuNXJlbSAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctbGVmdDogMS41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB4LW1kLTUge1xuICAgIHBhZGRpbmctcmlnaHQ6IDNyZW0gIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWxlZnQ6IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHktbWQtMCB7XG4gICAgcGFkZGluZy10b3A6IDAgIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWJvdHRvbTogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5weS1tZC0xIHtcbiAgICBwYWRkaW5nLXRvcDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctYm90dG9tOiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB5LW1kLTIge1xuICAgIHBhZGRpbmctdG9wOiAwLjVyZW0gIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWJvdHRvbTogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB5LW1kLTMge1xuICAgIHBhZGRpbmctdG9wOiAxcmVtICFpbXBvcnRhbnQ7XG4gICAgcGFkZGluZy1ib3R0b206IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHktbWQtNCB7XG4gICAgcGFkZGluZy10b3A6IDEuNXJlbSAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctYm90dG9tOiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHktbWQtNSB7XG4gICAgcGFkZGluZy10b3A6IDNyZW0gIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWJvdHRvbTogM3JlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wdC1tZC0wIHtcbiAgICBwYWRkaW5nLXRvcDogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5wdC1tZC0xIHtcbiAgICBwYWRkaW5nLXRvcDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wdC1tZC0yIHtcbiAgICBwYWRkaW5nLXRvcDogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB0LW1kLTMge1xuICAgIHBhZGRpbmctdG9wOiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB0LW1kLTQge1xuICAgIHBhZGRpbmctdG9wOiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHQtbWQtNSB7XG4gICAgcGFkZGluZy10b3A6IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucGUtbWQtMCB7XG4gICAgcGFkZGluZy1yaWdodDogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5wZS1tZC0xIHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBlLW1kLTIge1xuICAgIHBhZGRpbmctcmlnaHQ6IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wZS1tZC0zIHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBlLW1kLTQge1xuICAgIHBhZGRpbmctcmlnaHQ6IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wZS1tZC01IHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAzcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBiLW1kLTAge1xuICAgIHBhZGRpbmctYm90dG9tOiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBiLW1kLTEge1xuICAgIHBhZGRpbmctYm90dG9tOiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBiLW1kLTIge1xuICAgIHBhZGRpbmctYm90dG9tOiAwLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucGItbWQtMyB7XG4gICAgcGFkZGluZy1ib3R0b206IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucGItbWQtNCB7XG4gICAgcGFkZGluZy1ib3R0b206IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wYi1tZC01IHtcbiAgICBwYWRkaW5nLWJvdHRvbTogM3JlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wcy1tZC0wIHtcbiAgICBwYWRkaW5nLWxlZnQ6IDAgIWltcG9ydGFudDtcbiAgfVxuICAucHMtbWQtMSB7XG4gICAgcGFkZGluZy1sZWZ0OiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBzLW1kLTIge1xuICAgIHBhZGRpbmctbGVmdDogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBzLW1kLTMge1xuICAgIHBhZGRpbmctbGVmdDogMXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wcy1tZC00IHtcbiAgICBwYWRkaW5nLWxlZnQ6IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wcy1tZC01IHtcbiAgICBwYWRkaW5nLWxlZnQ6IDNyZW0gIWltcG9ydGFudDtcbiAgfVxufVxuXG5AbWVkaWEgKG1pbi13aWR0aDogOTkycHgpIHtcbiAgLmQtbGctaW5saW5lIHtcbiAgICBkaXNwbGF5OiBpbmxpbmUgIWltcG9ydGFudDtcbiAgfVxuICAuZC1sZy1pbmxpbmUtYmxvY2sge1xuICAgIGRpc3BsYXk6IGlubGluZS1ibG9jayAhaW1wb3J0YW50O1xuICB9XG4gIC5kLWxnLWJsb2NrIHtcbiAgICBkaXNwbGF5OiBibG9jayAhaW1wb3J0YW50O1xuICB9XG4gIC5kLWxnLWdyaWQge1xuICAgIGRpc3BsYXk6IGdyaWQgIWltcG9ydGFudDtcbiAgfVxuICAuZC1sZy10YWJsZSB7XG4gICAgZGlzcGxheTogdGFibGUgIWltcG9ydGFudDtcbiAgfVxuICAuZC1sZy10YWJsZS1yb3cge1xuICAgIGRpc3BsYXk6IHRhYmxlLXJvdyAhaW1wb3J0YW50O1xuICB9XG4gIC5kLWxnLXRhYmxlLWNlbGwge1xuICAgIGRpc3BsYXk6IHRhYmxlLWNlbGwgIWltcG9ydGFudDtcbiAgfVxuICAuZC1sZy1mbGV4IHtcbiAgICBkaXNwbGF5OiBmbGV4ICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmQtbGctaW5saW5lLWZsZXgge1xuICAgIGRpc3BsYXk6IGlubGluZS1mbGV4ICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmQtbGctbm9uZSB7XG4gICAgZGlzcGxheTogbm9uZSAhaW1wb3J0YW50O1xuICB9XG4gIC5mbGV4LWxnLWZpbGwge1xuICAgIGZsZXg6IDEgMSBhdXRvICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmZsZXgtbGctcm93IHtcbiAgICBmbGV4LWRpcmVjdGlvbjogcm93ICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmZsZXgtbGctY29sdW1uIHtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmZsZXgtbGctcm93LXJldmVyc2Uge1xuICAgIGZsZXgtZGlyZWN0aW9uOiByb3ctcmV2ZXJzZSAhaW1wb3J0YW50O1xuICB9XG4gIC5mbGV4LWxnLWNvbHVtbi1yZXZlcnNlIHtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uLXJldmVyc2UgIWltcG9ydGFudDtcbiAgfVxuICAuZmxleC1sZy1ncm93LTAge1xuICAgIGZsZXgtZ3JvdzogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5mbGV4LWxnLWdyb3ctMSB7XG4gICAgZmxleC1ncm93OiAxICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmZsZXgtbGctc2hyaW5rLTAge1xuICAgIGZsZXgtc2hyaW5rOiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmZsZXgtbGctc2hyaW5rLTEge1xuICAgIGZsZXgtc2hyaW5rOiAxICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmZsZXgtbGctd3JhcCB7XG4gICAgZmxleC13cmFwOiB3cmFwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmZsZXgtbGctbm93cmFwIHtcbiAgICBmbGV4LXdyYXA6IG5vd3JhcCAhaW1wb3J0YW50O1xuICB9XG4gIC5mbGV4LWxnLXdyYXAtcmV2ZXJzZSB7XG4gICAgZmxleC13cmFwOiB3cmFwLXJldmVyc2UgIWltcG9ydGFudDtcbiAgfVxuICAuanVzdGlmeS1jb250ZW50LWxnLXN0YXJ0IHtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtc3RhcnQgIWltcG9ydGFudDtcbiAgfVxuICAuanVzdGlmeS1jb250ZW50LWxnLWVuZCB7XG4gICAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZCAhaW1wb3J0YW50O1xuICB9XG4gIC5qdXN0aWZ5LWNvbnRlbnQtbGctY2VudGVyIHtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlciAhaW1wb3J0YW50O1xuICB9XG4gIC5qdXN0aWZ5LWNvbnRlbnQtbGctYmV0d2VlbiB7XG4gICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmp1c3RpZnktY29udGVudC1sZy1hcm91bmQge1xuICAgIGp1c3RpZnktY29udGVudDogc3BhY2UtYXJvdW5kICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmp1c3RpZnktY29udGVudC1sZy1ldmVubHkge1xuICAgIGp1c3RpZnktY29udGVudDogc3BhY2UtZXZlbmx5ICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLWl0ZW1zLWxnLXN0YXJ0IHtcbiAgICBhbGlnbi1pdGVtczogZmxleC1zdGFydCAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1pdGVtcy1sZy1lbmQge1xuICAgIGFsaWduLWl0ZW1zOiBmbGV4LWVuZCAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1pdGVtcy1sZy1jZW50ZXIge1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXIgIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24taXRlbXMtbGctYmFzZWxpbmUge1xuICAgIGFsaWduLWl0ZW1zOiBiYXNlbGluZSAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1pdGVtcy1sZy1zdHJldGNoIHtcbiAgICBhbGlnbi1pdGVtczogc3RyZXRjaCAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1jb250ZW50LWxnLXN0YXJ0IHtcbiAgICBhbGlnbi1jb250ZW50OiBmbGV4LXN0YXJ0ICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLWNvbnRlbnQtbGctZW5kIHtcbiAgICBhbGlnbi1jb250ZW50OiBmbGV4LWVuZCAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1jb250ZW50LWxnLWNlbnRlciB7XG4gICAgYWxpZ24tY29udGVudDogY2VudGVyICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLWNvbnRlbnQtbGctYmV0d2VlbiB7XG4gICAgYWxpZ24tY29udGVudDogc3BhY2UtYmV0d2VlbiAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1jb250ZW50LWxnLWFyb3VuZCB7XG4gICAgYWxpZ24tY29udGVudDogc3BhY2UtYXJvdW5kICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLWNvbnRlbnQtbGctc3RyZXRjaCB7XG4gICAgYWxpZ24tY29udGVudDogc3RyZXRjaCAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1zZWxmLWxnLWF1dG8ge1xuICAgIGFsaWduLXNlbGY6IGF1dG8gIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24tc2VsZi1sZy1zdGFydCB7XG4gICAgYWxpZ24tc2VsZjogZmxleC1zdGFydCAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1zZWxmLWxnLWVuZCB7XG4gICAgYWxpZ24tc2VsZjogZmxleC1lbmQgIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24tc2VsZi1sZy1jZW50ZXIge1xuICAgIGFsaWduLXNlbGY6IGNlbnRlciAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1zZWxmLWxnLWJhc2VsaW5lIHtcbiAgICBhbGlnbi1zZWxmOiBiYXNlbGluZSAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1zZWxmLWxnLXN0cmV0Y2gge1xuICAgIGFsaWduLXNlbGY6IHN0cmV0Y2ggIWltcG9ydGFudDtcbiAgfVxuICAub3JkZXItbGctZmlyc3Qge1xuICAgIG9yZGVyOiAtMSAhaW1wb3J0YW50O1xuICB9XG4gIC5vcmRlci1sZy0wIHtcbiAgICBvcmRlcjogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5vcmRlci1sZy0xIHtcbiAgICBvcmRlcjogMSAhaW1wb3J0YW50O1xuICB9XG4gIC5vcmRlci1sZy0yIHtcbiAgICBvcmRlcjogMiAhaW1wb3J0YW50O1xuICB9XG4gIC5vcmRlci1sZy0zIHtcbiAgICBvcmRlcjogMyAhaW1wb3J0YW50O1xuICB9XG4gIC5vcmRlci1sZy00IHtcbiAgICBvcmRlcjogNCAhaW1wb3J0YW50O1xuICB9XG4gIC5vcmRlci1sZy01IHtcbiAgICBvcmRlcjogNSAhaW1wb3J0YW50O1xuICB9XG4gIC5vcmRlci1sZy1sYXN0IHtcbiAgICBvcmRlcjogNiAhaW1wb3J0YW50O1xuICB9XG4gIC5tLWxnLTAge1xuICAgIG1hcmdpbjogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5tLWxnLTEge1xuICAgIG1hcmdpbjogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tLWxnLTIge1xuICAgIG1hcmdpbjogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm0tbGctMyB7XG4gICAgbWFyZ2luOiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm0tbGctNCB7XG4gICAgbWFyZ2luOiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubS1sZy01IHtcbiAgICBtYXJnaW46IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubS1sZy1hdXRvIHtcbiAgICBtYXJnaW46IGF1dG8gIWltcG9ydGFudDtcbiAgfVxuICAubXgtbGctMCB7XG4gICAgbWFyZ2luLXJpZ2h0OiAwICFpbXBvcnRhbnQ7XG4gICAgbWFyZ2luLWxlZnQ6IDAgIWltcG9ydGFudDtcbiAgfVxuICAubXgtbGctMSB7XG4gICAgbWFyZ2luLXJpZ2h0OiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gICAgbWFyZ2luLWxlZnQ6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXgtbGctMiB7XG4gICAgbWFyZ2luLXJpZ2h0OiAwLjVyZW0gIWltcG9ydGFudDtcbiAgICBtYXJnaW4tbGVmdDogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm14LWxnLTMge1xuICAgIG1hcmdpbi1yaWdodDogMXJlbSAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1sZWZ0OiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm14LWxnLTQge1xuICAgIG1hcmdpbi1yaWdodDogMS41cmVtICFpbXBvcnRhbnQ7XG4gICAgbWFyZ2luLWxlZnQ6IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5teC1sZy01IHtcbiAgICBtYXJnaW4tcmlnaHQ6IDNyZW0gIWltcG9ydGFudDtcbiAgICBtYXJnaW4tbGVmdDogM3JlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5teC1sZy1hdXRvIHtcbiAgICBtYXJnaW4tcmlnaHQ6IGF1dG8gIWltcG9ydGFudDtcbiAgICBtYXJnaW4tbGVmdDogYXV0byAhaW1wb3J0YW50O1xuICB9XG4gIC5teS1sZy0wIHtcbiAgICBtYXJnaW4tdG9wOiAwICFpbXBvcnRhbnQ7XG4gICAgbWFyZ2luLWJvdHRvbTogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5teS1sZy0xIHtcbiAgICBtYXJnaW4tdG9wOiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gICAgbWFyZ2luLWJvdHRvbTogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5teS1sZy0yIHtcbiAgICBtYXJnaW4tdG9wOiAwLjVyZW0gIWltcG9ydGFudDtcbiAgICBtYXJnaW4tYm90dG9tOiAwLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXktbGctMyB7XG4gICAgbWFyZ2luLXRvcDogMXJlbSAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1ib3R0b206IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXktbGctNCB7XG4gICAgbWFyZ2luLXRvcDogMS41cmVtICFpbXBvcnRhbnQ7XG4gICAgbWFyZ2luLWJvdHRvbTogMS41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm15LWxnLTUge1xuICAgIG1hcmdpbi10b3A6IDNyZW0gIWltcG9ydGFudDtcbiAgICBtYXJnaW4tYm90dG9tOiAzcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm15LWxnLWF1dG8ge1xuICAgIG1hcmdpbi10b3A6IGF1dG8gIWltcG9ydGFudDtcbiAgICBtYXJnaW4tYm90dG9tOiBhdXRvICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm10LWxnLTAge1xuICAgIG1hcmdpbi10b3A6IDAgIWltcG9ydGFudDtcbiAgfVxuICAubXQtbGctMSB7XG4gICAgbWFyZ2luLXRvcDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tdC1sZy0yIHtcbiAgICBtYXJnaW4tdG9wOiAwLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXQtbGctMyB7XG4gICAgbWFyZ2luLXRvcDogMXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tdC1sZy00IHtcbiAgICBtYXJnaW4tdG9wOiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXQtbGctNSB7XG4gICAgbWFyZ2luLXRvcDogM3JlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tdC1sZy1hdXRvIHtcbiAgICBtYXJnaW4tdG9wOiBhdXRvICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1lLWxnLTAge1xuICAgIG1hcmdpbi1yaWdodDogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5tZS1sZy0xIHtcbiAgICBtYXJnaW4tcmlnaHQ6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubWUtbGctMiB7XG4gICAgbWFyZ2luLXJpZ2h0OiAwLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubWUtbGctMyB7XG4gICAgbWFyZ2luLXJpZ2h0OiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1lLWxnLTQge1xuICAgIG1hcmdpbi1yaWdodDogMS41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1lLWxnLTUge1xuICAgIG1hcmdpbi1yaWdodDogM3JlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tZS1sZy1hdXRvIHtcbiAgICBtYXJnaW4tcmlnaHQ6IGF1dG8gIWltcG9ydGFudDtcbiAgfVxuICAubWItbGctMCB7XG4gICAgbWFyZ2luLWJvdHRvbTogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5tYi1sZy0xIHtcbiAgICBtYXJnaW4tYm90dG9tOiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1iLWxnLTIge1xuICAgIG1hcmdpbi1ib3R0b206IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tYi1sZy0zIHtcbiAgICBtYXJnaW4tYm90dG9tOiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1iLWxnLTQge1xuICAgIG1hcmdpbi1ib3R0b206IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tYi1sZy01IHtcbiAgICBtYXJnaW4tYm90dG9tOiAzcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1iLWxnLWF1dG8ge1xuICAgIG1hcmdpbi1ib3R0b206IGF1dG8gIWltcG9ydGFudDtcbiAgfVxuICAubXMtbGctMCB7XG4gICAgbWFyZ2luLWxlZnQ6IDAgIWltcG9ydGFudDtcbiAgfVxuICAubXMtbGctMSB7XG4gICAgbWFyZ2luLWxlZnQ6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXMtbGctMiB7XG4gICAgbWFyZ2luLWxlZnQ6IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tcy1sZy0zIHtcbiAgICBtYXJnaW4tbGVmdDogMXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tcy1sZy00IHtcbiAgICBtYXJnaW4tbGVmdDogMS41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1zLWxnLTUge1xuICAgIG1hcmdpbi1sZWZ0OiAzcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1zLWxnLWF1dG8ge1xuICAgIG1hcmdpbi1sZWZ0OiBhdXRvICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnAtbGctMCB7XG4gICAgcGFkZGluZzogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5wLWxnLTEge1xuICAgIHBhZGRpbmc6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucC1sZy0yIHtcbiAgICBwYWRkaW5nOiAwLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucC1sZy0zIHtcbiAgICBwYWRkaW5nOiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnAtbGctNCB7XG4gICAgcGFkZGluZzogMS41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnAtbGctNSB7XG4gICAgcGFkZGluZzogM3JlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5weC1sZy0wIHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAwICFpbXBvcnRhbnQ7XG4gICAgcGFkZGluZy1sZWZ0OiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB4LWxnLTEge1xuICAgIHBhZGRpbmctcmlnaHQ6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWxlZnQ6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHgtbGctMiB7XG4gICAgcGFkZGluZy1yaWdodDogMC41cmVtICFpbXBvcnRhbnQ7XG4gICAgcGFkZGluZy1sZWZ0OiAwLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHgtbGctMyB7XG4gICAgcGFkZGluZy1yaWdodDogMXJlbSAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctbGVmdDogMXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5weC1sZy00IHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAxLjVyZW0gIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWxlZnQ6IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5weC1sZy01IHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAzcmVtICFpbXBvcnRhbnQ7XG4gICAgcGFkZGluZy1sZWZ0OiAzcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB5LWxnLTAge1xuICAgIHBhZGRpbmctdG9wOiAwICFpbXBvcnRhbnQ7XG4gICAgcGFkZGluZy1ib3R0b206IDAgIWltcG9ydGFudDtcbiAgfVxuICAucHktbGctMSB7XG4gICAgcGFkZGluZy10b3A6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWJvdHRvbTogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5weS1sZy0yIHtcbiAgICBwYWRkaW5nLXRvcDogMC41cmVtICFpbXBvcnRhbnQ7XG4gICAgcGFkZGluZy1ib3R0b206IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5weS1sZy0zIHtcbiAgICBwYWRkaW5nLXRvcDogMXJlbSAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctYm90dG9tOiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB5LWxnLTQge1xuICAgIHBhZGRpbmctdG9wOiAxLjVyZW0gIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWJvdHRvbTogMS41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB5LWxnLTUge1xuICAgIHBhZGRpbmctdG9wOiAzcmVtICFpbXBvcnRhbnQ7XG4gICAgcGFkZGluZy1ib3R0b206IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHQtbGctMCB7XG4gICAgcGFkZGluZy10b3A6IDAgIWltcG9ydGFudDtcbiAgfVxuICAucHQtbGctMSB7XG4gICAgcGFkZGluZy10b3A6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHQtbGctMiB7XG4gICAgcGFkZGluZy10b3A6IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wdC1sZy0zIHtcbiAgICBwYWRkaW5nLXRvcDogMXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wdC1sZy00IHtcbiAgICBwYWRkaW5nLXRvcDogMS41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB0LWxnLTUge1xuICAgIHBhZGRpbmctdG9wOiAzcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBlLWxnLTAge1xuICAgIHBhZGRpbmctcmlnaHQ6IDAgIWltcG9ydGFudDtcbiAgfVxuICAucGUtbGctMSB7XG4gICAgcGFkZGluZy1yaWdodDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wZS1sZy0yIHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAwLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucGUtbGctMyB7XG4gICAgcGFkZGluZy1yaWdodDogMXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wZS1sZy00IHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucGUtbGctNSB7XG4gICAgcGFkZGluZy1yaWdodDogM3JlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wYi1sZy0wIHtcbiAgICBwYWRkaW5nLWJvdHRvbTogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5wYi1sZy0xIHtcbiAgICBwYWRkaW5nLWJvdHRvbTogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wYi1sZy0yIHtcbiAgICBwYWRkaW5nLWJvdHRvbTogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBiLWxnLTMge1xuICAgIHBhZGRpbmctYm90dG9tOiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBiLWxnLTQge1xuICAgIHBhZGRpbmctYm90dG9tOiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucGItbGctNSB7XG4gICAgcGFkZGluZy1ib3R0b206IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHMtbGctMCB7XG4gICAgcGFkZGluZy1sZWZ0OiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBzLWxnLTEge1xuICAgIHBhZGRpbmctbGVmdDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wcy1sZy0yIHtcbiAgICBwYWRkaW5nLWxlZnQ6IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wcy1sZy0zIHtcbiAgICBwYWRkaW5nLWxlZnQ6IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHMtbGctNCB7XG4gICAgcGFkZGluZy1sZWZ0OiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHMtbGctNSB7XG4gICAgcGFkZGluZy1sZWZ0OiAzcmVtICFpbXBvcnRhbnQ7XG4gIH1cbn1cblxuQG1lZGlhIChtaW4td2lkdGg6IDEyMDBweCkge1xuICAuZC14bC1pbmxpbmUge1xuICAgIGRpc3BsYXk6IGlubGluZSAhaW1wb3J0YW50O1xuICB9XG4gIC5kLXhsLWlubGluZS1ibG9jayB7XG4gICAgZGlzcGxheTogaW5saW5lLWJsb2NrICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmQteGwtYmxvY2sge1xuICAgIGRpc3BsYXk6IGJsb2NrICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmQteGwtZ3JpZCB7XG4gICAgZGlzcGxheTogZ3JpZCAhaW1wb3J0YW50O1xuICB9XG4gIC5kLXhsLXRhYmxlIHtcbiAgICBkaXNwbGF5OiB0YWJsZSAhaW1wb3J0YW50O1xuICB9XG4gIC5kLXhsLXRhYmxlLXJvdyB7XG4gICAgZGlzcGxheTogdGFibGUtcm93ICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmQteGwtdGFibGUtY2VsbCB7XG4gICAgZGlzcGxheTogdGFibGUtY2VsbCAhaW1wb3J0YW50O1xuICB9XG4gIC5kLXhsLWZsZXgge1xuICAgIGRpc3BsYXk6IGZsZXggIWltcG9ydGFudDtcbiAgfVxuICAuZC14bC1pbmxpbmUtZmxleCB7XG4gICAgZGlzcGxheTogaW5saW5lLWZsZXggIWltcG9ydGFudDtcbiAgfVxuICAuZC14bC1ub25lIHtcbiAgICBkaXNwbGF5OiBub25lICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmZsZXgteGwtZmlsbCB7XG4gICAgZmxleDogMSAxIGF1dG8gIWltcG9ydGFudDtcbiAgfVxuICAuZmxleC14bC1yb3cge1xuICAgIGZsZXgtZGlyZWN0aW9uOiByb3cgIWltcG9ydGFudDtcbiAgfVxuICAuZmxleC14bC1jb2x1bW4ge1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW4gIWltcG9ydGFudDtcbiAgfVxuICAuZmxleC14bC1yb3ctcmV2ZXJzZSB7XG4gICAgZmxleC1kaXJlY3Rpb246IHJvdy1yZXZlcnNlICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmZsZXgteGwtY29sdW1uLXJldmVyc2Uge1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW4tcmV2ZXJzZSAhaW1wb3J0YW50O1xuICB9XG4gIC5mbGV4LXhsLWdyb3ctMCB7XG4gICAgZmxleC1ncm93OiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmZsZXgteGwtZ3Jvdy0xIHtcbiAgICBmbGV4LWdyb3c6IDEgIWltcG9ydGFudDtcbiAgfVxuICAuZmxleC14bC1zaHJpbmstMCB7XG4gICAgZmxleC1zaHJpbms6IDAgIWltcG9ydGFudDtcbiAgfVxuICAuZmxleC14bC1zaHJpbmstMSB7XG4gICAgZmxleC1zaHJpbms6IDEgIWltcG9ydGFudDtcbiAgfVxuICAuZmxleC14bC13cmFwIHtcbiAgICBmbGV4LXdyYXA6IHdyYXAgIWltcG9ydGFudDtcbiAgfVxuICAuZmxleC14bC1ub3dyYXAge1xuICAgIGZsZXgtd3JhcDogbm93cmFwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmZsZXgteGwtd3JhcC1yZXZlcnNlIHtcbiAgICBmbGV4LXdyYXA6IHdyYXAtcmV2ZXJzZSAhaW1wb3J0YW50O1xuICB9XG4gIC5qdXN0aWZ5LWNvbnRlbnQteGwtc3RhcnQge1xuICAgIGp1c3RpZnktY29udGVudDogZmxleC1zdGFydCAhaW1wb3J0YW50O1xuICB9XG4gIC5qdXN0aWZ5LWNvbnRlbnQteGwtZW5kIHtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmp1c3RpZnktY29udGVudC14bC1jZW50ZXIge1xuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmp1c3RpZnktY29udGVudC14bC1iZXR3ZWVuIHtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW4gIWltcG9ydGFudDtcbiAgfVxuICAuanVzdGlmeS1jb250ZW50LXhsLWFyb3VuZCB7XG4gICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1hcm91bmQgIWltcG9ydGFudDtcbiAgfVxuICAuanVzdGlmeS1jb250ZW50LXhsLWV2ZW5seSB7XG4gICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1ldmVubHkgIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24taXRlbXMteGwtc3RhcnQge1xuICAgIGFsaWduLWl0ZW1zOiBmbGV4LXN0YXJ0ICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLWl0ZW1zLXhsLWVuZCB7XG4gICAgYWxpZ24taXRlbXM6IGZsZXgtZW5kICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLWl0ZW1zLXhsLWNlbnRlciB7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlciAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1pdGVtcy14bC1iYXNlbGluZSB7XG4gICAgYWxpZ24taXRlbXM6IGJhc2VsaW5lICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLWl0ZW1zLXhsLXN0cmV0Y2gge1xuICAgIGFsaWduLWl0ZW1zOiBzdHJldGNoICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLWNvbnRlbnQteGwtc3RhcnQge1xuICAgIGFsaWduLWNvbnRlbnQ6IGZsZXgtc3RhcnQgIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24tY29udGVudC14bC1lbmQge1xuICAgIGFsaWduLWNvbnRlbnQ6IGZsZXgtZW5kICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLWNvbnRlbnQteGwtY2VudGVyIHtcbiAgICBhbGlnbi1jb250ZW50OiBjZW50ZXIgIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24tY29udGVudC14bC1iZXR3ZWVuIHtcbiAgICBhbGlnbi1jb250ZW50OiBzcGFjZS1iZXR3ZWVuICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLWNvbnRlbnQteGwtYXJvdW5kIHtcbiAgICBhbGlnbi1jb250ZW50OiBzcGFjZS1hcm91bmQgIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24tY29udGVudC14bC1zdHJldGNoIHtcbiAgICBhbGlnbi1jb250ZW50OiBzdHJldGNoICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLXNlbGYteGwtYXV0byB7XG4gICAgYWxpZ24tc2VsZjogYXV0byAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1zZWxmLXhsLXN0YXJ0IHtcbiAgICBhbGlnbi1zZWxmOiBmbGV4LXN0YXJ0ICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLXNlbGYteGwtZW5kIHtcbiAgICBhbGlnbi1zZWxmOiBmbGV4LWVuZCAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1zZWxmLXhsLWNlbnRlciB7XG4gICAgYWxpZ24tc2VsZjogY2VudGVyICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLXNlbGYteGwtYmFzZWxpbmUge1xuICAgIGFsaWduLXNlbGY6IGJhc2VsaW5lICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLXNlbGYteGwtc3RyZXRjaCB7XG4gICAgYWxpZ24tc2VsZjogc3RyZXRjaCAhaW1wb3J0YW50O1xuICB9XG4gIC5vcmRlci14bC1maXJzdCB7XG4gICAgb3JkZXI6IC0xICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm9yZGVyLXhsLTAge1xuICAgIG9yZGVyOiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm9yZGVyLXhsLTEge1xuICAgIG9yZGVyOiAxICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm9yZGVyLXhsLTIge1xuICAgIG9yZGVyOiAyICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm9yZGVyLXhsLTMge1xuICAgIG9yZGVyOiAzICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm9yZGVyLXhsLTQge1xuICAgIG9yZGVyOiA0ICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm9yZGVyLXhsLTUge1xuICAgIG9yZGVyOiA1ICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm9yZGVyLXhsLWxhc3Qge1xuICAgIG9yZGVyOiA2ICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm0teGwtMCB7XG4gICAgbWFyZ2luOiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm0teGwtMSB7XG4gICAgbWFyZ2luOiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm0teGwtMiB7XG4gICAgbWFyZ2luOiAwLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubS14bC0zIHtcbiAgICBtYXJnaW46IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubS14bC00IHtcbiAgICBtYXJnaW46IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tLXhsLTUge1xuICAgIG1hcmdpbjogM3JlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tLXhsLWF1dG8ge1xuICAgIG1hcmdpbjogYXV0byAhaW1wb3J0YW50O1xuICB9XG4gIC5teC14bC0wIHtcbiAgICBtYXJnaW4tcmlnaHQ6IDAgIWltcG9ydGFudDtcbiAgICBtYXJnaW4tbGVmdDogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5teC14bC0xIHtcbiAgICBtYXJnaW4tcmlnaHQ6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgICBtYXJnaW4tbGVmdDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5teC14bC0yIHtcbiAgICBtYXJnaW4tcmlnaHQ6IDAuNXJlbSAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1sZWZ0OiAwLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXgteGwtMyB7XG4gICAgbWFyZ2luLXJpZ2h0OiAxcmVtICFpbXBvcnRhbnQ7XG4gICAgbWFyZ2luLWxlZnQ6IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXgteGwtNCB7XG4gICAgbWFyZ2luLXJpZ2h0OiAxLjVyZW0gIWltcG9ydGFudDtcbiAgICBtYXJnaW4tbGVmdDogMS41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm14LXhsLTUge1xuICAgIG1hcmdpbi1yaWdodDogM3JlbSAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1sZWZ0OiAzcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm14LXhsLWF1dG8ge1xuICAgIG1hcmdpbi1yaWdodDogYXV0byAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1sZWZ0OiBhdXRvICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm15LXhsLTAge1xuICAgIG1hcmdpbi10b3A6IDAgIWltcG9ydGFudDtcbiAgICBtYXJnaW4tYm90dG9tOiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm15LXhsLTEge1xuICAgIG1hcmdpbi10b3A6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgICBtYXJnaW4tYm90dG9tOiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm15LXhsLTIge1xuICAgIG1hcmdpbi10b3A6IDAuNXJlbSAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1ib3R0b206IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5teS14bC0zIHtcbiAgICBtYXJnaW4tdG9wOiAxcmVtICFpbXBvcnRhbnQ7XG4gICAgbWFyZ2luLWJvdHRvbTogMXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5teS14bC00IHtcbiAgICBtYXJnaW4tdG9wOiAxLjVyZW0gIWltcG9ydGFudDtcbiAgICBtYXJnaW4tYm90dG9tOiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXkteGwtNSB7XG4gICAgbWFyZ2luLXRvcDogM3JlbSAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1ib3R0b206IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXkteGwtYXV0byB7XG4gICAgbWFyZ2luLXRvcDogYXV0byAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1ib3R0b206IGF1dG8gIWltcG9ydGFudDtcbiAgfVxuICAubXQteGwtMCB7XG4gICAgbWFyZ2luLXRvcDogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5tdC14bC0xIHtcbiAgICBtYXJnaW4tdG9wOiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm10LXhsLTIge1xuICAgIG1hcmdpbi10b3A6IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tdC14bC0zIHtcbiAgICBtYXJnaW4tdG9wOiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm10LXhsLTQge1xuICAgIG1hcmdpbi10b3A6IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tdC14bC01IHtcbiAgICBtYXJnaW4tdG9wOiAzcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm10LXhsLWF1dG8ge1xuICAgIG1hcmdpbi10b3A6IGF1dG8gIWltcG9ydGFudDtcbiAgfVxuICAubWUteGwtMCB7XG4gICAgbWFyZ2luLXJpZ2h0OiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1lLXhsLTEge1xuICAgIG1hcmdpbi1yaWdodDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tZS14bC0yIHtcbiAgICBtYXJnaW4tcmlnaHQ6IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tZS14bC0zIHtcbiAgICBtYXJnaW4tcmlnaHQ6IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubWUteGwtNCB7XG4gICAgbWFyZ2luLXJpZ2h0OiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubWUteGwtNSB7XG4gICAgbWFyZ2luLXJpZ2h0OiAzcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1lLXhsLWF1dG8ge1xuICAgIG1hcmdpbi1yaWdodDogYXV0byAhaW1wb3J0YW50O1xuICB9XG4gIC5tYi14bC0wIHtcbiAgICBtYXJnaW4tYm90dG9tOiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1iLXhsLTEge1xuICAgIG1hcmdpbi1ib3R0b206IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubWIteGwtMiB7XG4gICAgbWFyZ2luLWJvdHRvbTogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1iLXhsLTMge1xuICAgIG1hcmdpbi1ib3R0b206IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubWIteGwtNCB7XG4gICAgbWFyZ2luLWJvdHRvbTogMS41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1iLXhsLTUge1xuICAgIG1hcmdpbi1ib3R0b206IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubWIteGwtYXV0byB7XG4gICAgbWFyZ2luLWJvdHRvbTogYXV0byAhaW1wb3J0YW50O1xuICB9XG4gIC5tcy14bC0wIHtcbiAgICBtYXJnaW4tbGVmdDogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5tcy14bC0xIHtcbiAgICBtYXJnaW4tbGVmdDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tcy14bC0yIHtcbiAgICBtYXJnaW4tbGVmdDogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1zLXhsLTMge1xuICAgIG1hcmdpbi1sZWZ0OiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1zLXhsLTQge1xuICAgIG1hcmdpbi1sZWZ0OiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXMteGwtNSB7XG4gICAgbWFyZ2luLWxlZnQ6IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXMteGwtYXV0byB7XG4gICAgbWFyZ2luLWxlZnQ6IGF1dG8gIWltcG9ydGFudDtcbiAgfVxuICAucC14bC0wIHtcbiAgICBwYWRkaW5nOiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnAteGwtMSB7XG4gICAgcGFkZGluZzogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wLXhsLTIge1xuICAgIHBhZGRpbmc6IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wLXhsLTMge1xuICAgIHBhZGRpbmc6IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucC14bC00IHtcbiAgICBwYWRkaW5nOiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucC14bC01IHtcbiAgICBwYWRkaW5nOiAzcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB4LXhsLTAge1xuICAgIHBhZGRpbmctcmlnaHQ6IDAgIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWxlZnQ6IDAgIWltcG9ydGFudDtcbiAgfVxuICAucHgteGwtMSB7XG4gICAgcGFkZGluZy1yaWdodDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctbGVmdDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5weC14bC0yIHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAwLjVyZW0gIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWxlZnQ6IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5weC14bC0zIHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAxcmVtICFpbXBvcnRhbnQ7XG4gICAgcGFkZGluZy1sZWZ0OiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB4LXhsLTQge1xuICAgIHBhZGRpbmctcmlnaHQ6IDEuNXJlbSAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctbGVmdDogMS41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB4LXhsLTUge1xuICAgIHBhZGRpbmctcmlnaHQ6IDNyZW0gIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWxlZnQ6IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHkteGwtMCB7XG4gICAgcGFkZGluZy10b3A6IDAgIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWJvdHRvbTogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5weS14bC0xIHtcbiAgICBwYWRkaW5nLXRvcDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctYm90dG9tOiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB5LXhsLTIge1xuICAgIHBhZGRpbmctdG9wOiAwLjVyZW0gIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWJvdHRvbTogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB5LXhsLTMge1xuICAgIHBhZGRpbmctdG9wOiAxcmVtICFpbXBvcnRhbnQ7XG4gICAgcGFkZGluZy1ib3R0b206IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHkteGwtNCB7XG4gICAgcGFkZGluZy10b3A6IDEuNXJlbSAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctYm90dG9tOiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHkteGwtNSB7XG4gICAgcGFkZGluZy10b3A6IDNyZW0gIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWJvdHRvbTogM3JlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wdC14bC0wIHtcbiAgICBwYWRkaW5nLXRvcDogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5wdC14bC0xIHtcbiAgICBwYWRkaW5nLXRvcDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wdC14bC0yIHtcbiAgICBwYWRkaW5nLXRvcDogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB0LXhsLTMge1xuICAgIHBhZGRpbmctdG9wOiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB0LXhsLTQge1xuICAgIHBhZGRpbmctdG9wOiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHQteGwtNSB7XG4gICAgcGFkZGluZy10b3A6IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucGUteGwtMCB7XG4gICAgcGFkZGluZy1yaWdodDogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5wZS14bC0xIHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBlLXhsLTIge1xuICAgIHBhZGRpbmctcmlnaHQ6IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wZS14bC0zIHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBlLXhsLTQge1xuICAgIHBhZGRpbmctcmlnaHQ6IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wZS14bC01IHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAzcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBiLXhsLTAge1xuICAgIHBhZGRpbmctYm90dG9tOiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBiLXhsLTEge1xuICAgIHBhZGRpbmctYm90dG9tOiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBiLXhsLTIge1xuICAgIHBhZGRpbmctYm90dG9tOiAwLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucGIteGwtMyB7XG4gICAgcGFkZGluZy1ib3R0b206IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucGIteGwtNCB7XG4gICAgcGFkZGluZy1ib3R0b206IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wYi14bC01IHtcbiAgICBwYWRkaW5nLWJvdHRvbTogM3JlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wcy14bC0wIHtcbiAgICBwYWRkaW5nLWxlZnQ6IDAgIWltcG9ydGFudDtcbiAgfVxuICAucHMteGwtMSB7XG4gICAgcGFkZGluZy1sZWZ0OiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBzLXhsLTIge1xuICAgIHBhZGRpbmctbGVmdDogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBzLXhsLTMge1xuICAgIHBhZGRpbmctbGVmdDogMXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wcy14bC00IHtcbiAgICBwYWRkaW5nLWxlZnQ6IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wcy14bC01IHtcbiAgICBwYWRkaW5nLWxlZnQ6IDNyZW0gIWltcG9ydGFudDtcbiAgfVxufVxuXG5AbWVkaWEgKG1pbi13aWR0aDogMTQwMHB4KSB7XG4gIC5kLXh4bC1pbmxpbmUge1xuICAgIGRpc3BsYXk6IGlubGluZSAhaW1wb3J0YW50O1xuICB9XG4gIC5kLXh4bC1pbmxpbmUtYmxvY2sge1xuICAgIGRpc3BsYXk6IGlubGluZS1ibG9jayAhaW1wb3J0YW50O1xuICB9XG4gIC5kLXh4bC1ibG9jayB7XG4gICAgZGlzcGxheTogYmxvY2sgIWltcG9ydGFudDtcbiAgfVxuICAuZC14eGwtZ3JpZCB7XG4gICAgZGlzcGxheTogZ3JpZCAhaW1wb3J0YW50O1xuICB9XG4gIC5kLXh4bC10YWJsZSB7XG4gICAgZGlzcGxheTogdGFibGUgIWltcG9ydGFudDtcbiAgfVxuICAuZC14eGwtdGFibGUtcm93IHtcbiAgICBkaXNwbGF5OiB0YWJsZS1yb3cgIWltcG9ydGFudDtcbiAgfVxuICAuZC14eGwtdGFibGUtY2VsbCB7XG4gICAgZGlzcGxheTogdGFibGUtY2VsbCAhaW1wb3J0YW50O1xuICB9XG4gIC5kLXh4bC1mbGV4IHtcbiAgICBkaXNwbGF5OiBmbGV4ICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmQteHhsLWlubGluZS1mbGV4IHtcbiAgICBkaXNwbGF5OiBpbmxpbmUtZmxleCAhaW1wb3J0YW50O1xuICB9XG4gIC5kLXh4bC1ub25lIHtcbiAgICBkaXNwbGF5OiBub25lICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmZsZXgteHhsLWZpbGwge1xuICAgIGZsZXg6IDEgMSBhdXRvICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmZsZXgteHhsLXJvdyB7XG4gICAgZmxleC1kaXJlY3Rpb246IHJvdyAhaW1wb3J0YW50O1xuICB9XG4gIC5mbGV4LXh4bC1jb2x1bW4ge1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW4gIWltcG9ydGFudDtcbiAgfVxuICAuZmxleC14eGwtcm93LXJldmVyc2Uge1xuICAgIGZsZXgtZGlyZWN0aW9uOiByb3ctcmV2ZXJzZSAhaW1wb3J0YW50O1xuICB9XG4gIC5mbGV4LXh4bC1jb2x1bW4tcmV2ZXJzZSB7XG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbi1yZXZlcnNlICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmZsZXgteHhsLWdyb3ctMCB7XG4gICAgZmxleC1ncm93OiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmZsZXgteHhsLWdyb3ctMSB7XG4gICAgZmxleC1ncm93OiAxICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmZsZXgteHhsLXNocmluay0wIHtcbiAgICBmbGV4LXNocmluazogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5mbGV4LXh4bC1zaHJpbmstMSB7XG4gICAgZmxleC1zaHJpbms6IDEgIWltcG9ydGFudDtcbiAgfVxuICAuZmxleC14eGwtd3JhcCB7XG4gICAgZmxleC13cmFwOiB3cmFwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmZsZXgteHhsLW5vd3JhcCB7XG4gICAgZmxleC13cmFwOiBub3dyYXAgIWltcG9ydGFudDtcbiAgfVxuICAuZmxleC14eGwtd3JhcC1yZXZlcnNlIHtcbiAgICBmbGV4LXdyYXA6IHdyYXAtcmV2ZXJzZSAhaW1wb3J0YW50O1xuICB9XG4gIC5qdXN0aWZ5LWNvbnRlbnQteHhsLXN0YXJ0IHtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtc3RhcnQgIWltcG9ydGFudDtcbiAgfVxuICAuanVzdGlmeS1jb250ZW50LXh4bC1lbmQge1xuICAgIGp1c3RpZnktY29udGVudDogZmxleC1lbmQgIWltcG9ydGFudDtcbiAgfVxuICAuanVzdGlmeS1jb250ZW50LXh4bC1jZW50ZXIge1xuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmp1c3RpZnktY29udGVudC14eGwtYmV0d2VlbiB7XG4gICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmp1c3RpZnktY29udGVudC14eGwtYXJvdW5kIHtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWFyb3VuZCAhaW1wb3J0YW50O1xuICB9XG4gIC5qdXN0aWZ5LWNvbnRlbnQteHhsLWV2ZW5seSB7XG4gICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1ldmVubHkgIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24taXRlbXMteHhsLXN0YXJ0IHtcbiAgICBhbGlnbi1pdGVtczogZmxleC1zdGFydCAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1pdGVtcy14eGwtZW5kIHtcbiAgICBhbGlnbi1pdGVtczogZmxleC1lbmQgIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24taXRlbXMteHhsLWNlbnRlciB7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlciAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1pdGVtcy14eGwtYmFzZWxpbmUge1xuICAgIGFsaWduLWl0ZW1zOiBiYXNlbGluZSAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1pdGVtcy14eGwtc3RyZXRjaCB7XG4gICAgYWxpZ24taXRlbXM6IHN0cmV0Y2ggIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24tY29udGVudC14eGwtc3RhcnQge1xuICAgIGFsaWduLWNvbnRlbnQ6IGZsZXgtc3RhcnQgIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24tY29udGVudC14eGwtZW5kIHtcbiAgICBhbGlnbi1jb250ZW50OiBmbGV4LWVuZCAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1jb250ZW50LXh4bC1jZW50ZXIge1xuICAgIGFsaWduLWNvbnRlbnQ6IGNlbnRlciAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1jb250ZW50LXh4bC1iZXR3ZWVuIHtcbiAgICBhbGlnbi1jb250ZW50OiBzcGFjZS1iZXR3ZWVuICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLWNvbnRlbnQteHhsLWFyb3VuZCB7XG4gICAgYWxpZ24tY29udGVudDogc3BhY2UtYXJvdW5kICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLWNvbnRlbnQteHhsLXN0cmV0Y2gge1xuICAgIGFsaWduLWNvbnRlbnQ6IHN0cmV0Y2ggIWltcG9ydGFudDtcbiAgfVxuICAuYWxpZ24tc2VsZi14eGwtYXV0byB7XG4gICAgYWxpZ24tc2VsZjogYXV0byAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1zZWxmLXh4bC1zdGFydCB7XG4gICAgYWxpZ24tc2VsZjogZmxleC1zdGFydCAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1zZWxmLXh4bC1lbmQge1xuICAgIGFsaWduLXNlbGY6IGZsZXgtZW5kICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLXNlbGYteHhsLWNlbnRlciB7XG4gICAgYWxpZ24tc2VsZjogY2VudGVyICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFsaWduLXNlbGYteHhsLWJhc2VsaW5lIHtcbiAgICBhbGlnbi1zZWxmOiBiYXNlbGluZSAhaW1wb3J0YW50O1xuICB9XG4gIC5hbGlnbi1zZWxmLXh4bC1zdHJldGNoIHtcbiAgICBhbGlnbi1zZWxmOiBzdHJldGNoICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm9yZGVyLXh4bC1maXJzdCB7XG4gICAgb3JkZXI6IC0xICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm9yZGVyLXh4bC0wIHtcbiAgICBvcmRlcjogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5vcmRlci14eGwtMSB7XG4gICAgb3JkZXI6IDEgIWltcG9ydGFudDtcbiAgfVxuICAub3JkZXIteHhsLTIge1xuICAgIG9yZGVyOiAyICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm9yZGVyLXh4bC0zIHtcbiAgICBvcmRlcjogMyAhaW1wb3J0YW50O1xuICB9XG4gIC5vcmRlci14eGwtNCB7XG4gICAgb3JkZXI6IDQgIWltcG9ydGFudDtcbiAgfVxuICAub3JkZXIteHhsLTUge1xuICAgIG9yZGVyOiA1ICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm9yZGVyLXh4bC1sYXN0IHtcbiAgICBvcmRlcjogNiAhaW1wb3J0YW50O1xuICB9XG4gIC5tLXh4bC0wIHtcbiAgICBtYXJnaW46IDAgIWltcG9ydGFudDtcbiAgfVxuICAubS14eGwtMSB7XG4gICAgbWFyZ2luOiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm0teHhsLTIge1xuICAgIG1hcmdpbjogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm0teHhsLTMge1xuICAgIG1hcmdpbjogMXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tLXh4bC00IHtcbiAgICBtYXJnaW46IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tLXh4bC01IHtcbiAgICBtYXJnaW46IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubS14eGwtYXV0byB7XG4gICAgbWFyZ2luOiBhdXRvICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm14LXh4bC0wIHtcbiAgICBtYXJnaW4tcmlnaHQ6IDAgIWltcG9ydGFudDtcbiAgICBtYXJnaW4tbGVmdDogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5teC14eGwtMSB7XG4gICAgbWFyZ2luLXJpZ2h0OiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gICAgbWFyZ2luLWxlZnQ6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXgteHhsLTIge1xuICAgIG1hcmdpbi1yaWdodDogMC41cmVtICFpbXBvcnRhbnQ7XG4gICAgbWFyZ2luLWxlZnQ6IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5teC14eGwtMyB7XG4gICAgbWFyZ2luLXJpZ2h0OiAxcmVtICFpbXBvcnRhbnQ7XG4gICAgbWFyZ2luLWxlZnQ6IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXgteHhsLTQge1xuICAgIG1hcmdpbi1yaWdodDogMS41cmVtICFpbXBvcnRhbnQ7XG4gICAgbWFyZ2luLWxlZnQ6IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5teC14eGwtNSB7XG4gICAgbWFyZ2luLXJpZ2h0OiAzcmVtICFpbXBvcnRhbnQ7XG4gICAgbWFyZ2luLWxlZnQ6IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXgteHhsLWF1dG8ge1xuICAgIG1hcmdpbi1yaWdodDogYXV0byAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1sZWZ0OiBhdXRvICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm15LXh4bC0wIHtcbiAgICBtYXJnaW4tdG9wOiAwICFpbXBvcnRhbnQ7XG4gICAgbWFyZ2luLWJvdHRvbTogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5teS14eGwtMSB7XG4gICAgbWFyZ2luLXRvcDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1ib3R0b206IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXkteHhsLTIge1xuICAgIG1hcmdpbi10b3A6IDAuNXJlbSAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1ib3R0b206IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5teS14eGwtMyB7XG4gICAgbWFyZ2luLXRvcDogMXJlbSAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1ib3R0b206IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXkteHhsLTQge1xuICAgIG1hcmdpbi10b3A6IDEuNXJlbSAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1ib3R0b206IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5teS14eGwtNSB7XG4gICAgbWFyZ2luLXRvcDogM3JlbSAhaW1wb3J0YW50O1xuICAgIG1hcmdpbi1ib3R0b206IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXkteHhsLWF1dG8ge1xuICAgIG1hcmdpbi10b3A6IGF1dG8gIWltcG9ydGFudDtcbiAgICBtYXJnaW4tYm90dG9tOiBhdXRvICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm10LXh4bC0wIHtcbiAgICBtYXJnaW4tdG9wOiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm10LXh4bC0xIHtcbiAgICBtYXJnaW4tdG9wOiAwLjI1cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm10LXh4bC0yIHtcbiAgICBtYXJnaW4tdG9wOiAwLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXQteHhsLTMge1xuICAgIG1hcmdpbi10b3A6IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXQteHhsLTQge1xuICAgIG1hcmdpbi10b3A6IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tdC14eGwtNSB7XG4gICAgbWFyZ2luLXRvcDogM3JlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tdC14eGwtYXV0byB7XG4gICAgbWFyZ2luLXRvcDogYXV0byAhaW1wb3J0YW50O1xuICB9XG4gIC5tZS14eGwtMCB7XG4gICAgbWFyZ2luLXJpZ2h0OiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1lLXh4bC0xIHtcbiAgICBtYXJnaW4tcmlnaHQ6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubWUteHhsLTIge1xuICAgIG1hcmdpbi1yaWdodDogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1lLXh4bC0zIHtcbiAgICBtYXJnaW4tcmlnaHQ6IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubWUteHhsLTQge1xuICAgIG1hcmdpbi1yaWdodDogMS41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1lLXh4bC01IHtcbiAgICBtYXJnaW4tcmlnaHQ6IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubWUteHhsLWF1dG8ge1xuICAgIG1hcmdpbi1yaWdodDogYXV0byAhaW1wb3J0YW50O1xuICB9XG4gIC5tYi14eGwtMCB7XG4gICAgbWFyZ2luLWJvdHRvbTogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5tYi14eGwtMSB7XG4gICAgbWFyZ2luLWJvdHRvbTogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tYi14eGwtMiB7XG4gICAgbWFyZ2luLWJvdHRvbTogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1iLXh4bC0zIHtcbiAgICBtYXJnaW4tYm90dG9tOiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1iLXh4bC00IHtcbiAgICBtYXJnaW4tYm90dG9tOiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubWIteHhsLTUge1xuICAgIG1hcmdpbi1ib3R0b206IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubWIteHhsLWF1dG8ge1xuICAgIG1hcmdpbi1ib3R0b206IGF1dG8gIWltcG9ydGFudDtcbiAgfVxuICAubXMteHhsLTAge1xuICAgIG1hcmdpbi1sZWZ0OiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1zLXh4bC0xIHtcbiAgICBtYXJnaW4tbGVmdDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tcy14eGwtMiB7XG4gICAgbWFyZ2luLWxlZnQ6IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5tcy14eGwtMyB7XG4gICAgbWFyZ2luLWxlZnQ6IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXMteHhsLTQge1xuICAgIG1hcmdpbi1sZWZ0OiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAubXMteHhsLTUge1xuICAgIG1hcmdpbi1sZWZ0OiAzcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLm1zLXh4bC1hdXRvIHtcbiAgICBtYXJnaW4tbGVmdDogYXV0byAhaW1wb3J0YW50O1xuICB9XG4gIC5wLXh4bC0wIHtcbiAgICBwYWRkaW5nOiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnAteHhsLTEge1xuICAgIHBhZGRpbmc6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucC14eGwtMiB7XG4gICAgcGFkZGluZzogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnAteHhsLTMge1xuICAgIHBhZGRpbmc6IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucC14eGwtNCB7XG4gICAgcGFkZGluZzogMS41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnAteHhsLTUge1xuICAgIHBhZGRpbmc6IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHgteHhsLTAge1xuICAgIHBhZGRpbmctcmlnaHQ6IDAgIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWxlZnQ6IDAgIWltcG9ydGFudDtcbiAgfVxuICAucHgteHhsLTEge1xuICAgIHBhZGRpbmctcmlnaHQ6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWxlZnQ6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHgteHhsLTIge1xuICAgIHBhZGRpbmctcmlnaHQ6IDAuNXJlbSAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctbGVmdDogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB4LXh4bC0zIHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAxcmVtICFpbXBvcnRhbnQ7XG4gICAgcGFkZGluZy1sZWZ0OiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB4LXh4bC00IHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAxLjVyZW0gIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWxlZnQ6IDEuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5weC14eGwtNSB7XG4gICAgcGFkZGluZy1yaWdodDogM3JlbSAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctbGVmdDogM3JlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5weS14eGwtMCB7XG4gICAgcGFkZGluZy10b3A6IDAgIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWJvdHRvbTogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5weS14eGwtMSB7XG4gICAgcGFkZGluZy10b3A6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWJvdHRvbTogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5weS14eGwtMiB7XG4gICAgcGFkZGluZy10b3A6IDAuNXJlbSAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctYm90dG9tOiAwLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHkteHhsLTMge1xuICAgIHBhZGRpbmctdG9wOiAxcmVtICFpbXBvcnRhbnQ7XG4gICAgcGFkZGluZy1ib3R0b206IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHkteHhsLTQge1xuICAgIHBhZGRpbmctdG9wOiAxLjVyZW0gIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWJvdHRvbTogMS41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB5LXh4bC01IHtcbiAgICBwYWRkaW5nLXRvcDogM3JlbSAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctYm90dG9tOiAzcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB0LXh4bC0wIHtcbiAgICBwYWRkaW5nLXRvcDogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5wdC14eGwtMSB7XG4gICAgcGFkZGluZy10b3A6IDAuMjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHQteHhsLTIge1xuICAgIHBhZGRpbmctdG9wOiAwLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHQteHhsLTMge1xuICAgIHBhZGRpbmctdG9wOiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB0LXh4bC00IHtcbiAgICBwYWRkaW5nLXRvcDogMS41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnB0LXh4bC01IHtcbiAgICBwYWRkaW5nLXRvcDogM3JlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wZS14eGwtMCB7XG4gICAgcGFkZGluZy1yaWdodDogMCAhaW1wb3J0YW50O1xuICB9XG4gIC5wZS14eGwtMSB7XG4gICAgcGFkZGluZy1yaWdodDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wZS14eGwtMiB7XG4gICAgcGFkZGluZy1yaWdodDogMC41cmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBlLXh4bC0zIHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAxcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBlLXh4bC00IHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucGUteHhsLTUge1xuICAgIHBhZGRpbmctcmlnaHQ6IDNyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucGIteHhsLTAge1xuICAgIHBhZGRpbmctYm90dG9tOiAwICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBiLXh4bC0xIHtcbiAgICBwYWRkaW5nLWJvdHRvbTogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wYi14eGwtMiB7XG4gICAgcGFkZGluZy1ib3R0b206IDAuNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wYi14eGwtMyB7XG4gICAgcGFkZGluZy1ib3R0b206IDFyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucGIteHhsLTQge1xuICAgIHBhZGRpbmctYm90dG9tOiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucGIteHhsLTUge1xuICAgIHBhZGRpbmctYm90dG9tOiAzcmVtICFpbXBvcnRhbnQ7XG4gIH1cbiAgLnBzLXh4bC0wIHtcbiAgICBwYWRkaW5nLWxlZnQ6IDAgIWltcG9ydGFudDtcbiAgfVxuICAucHMteHhsLTEge1xuICAgIHBhZGRpbmctbGVmdDogMC4yNXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wcy14eGwtMiB7XG4gICAgcGFkZGluZy1sZWZ0OiAwLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHMteHhsLTMge1xuICAgIHBhZGRpbmctbGVmdDogMXJlbSAhaW1wb3J0YW50O1xuICB9XG4gIC5wcy14eGwtNCB7XG4gICAgcGFkZGluZy1sZWZ0OiAxLjVyZW0gIWltcG9ydGFudDtcbiAgfVxuICAucHMteHhsLTUge1xuICAgIHBhZGRpbmctbGVmdDogM3JlbSAhaW1wb3J0YW50O1xuICB9XG59XG5cbkBtZWRpYSBwcmludCB7XG4gIC5kLXByaW50LWlubGluZSB7XG4gICAgZGlzcGxheTogaW5saW5lICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmQtcHJpbnQtaW5saW5lLWJsb2NrIHtcbiAgICBkaXNwbGF5OiBpbmxpbmUtYmxvY2sgIWltcG9ydGFudDtcbiAgfVxuICAuZC1wcmludC1ibG9jayB7XG4gICAgZGlzcGxheTogYmxvY2sgIWltcG9ydGFudDtcbiAgfVxuICAuZC1wcmludC1ncmlkIHtcbiAgICBkaXNwbGF5OiBncmlkICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmQtcHJpbnQtdGFibGUge1xuICAgIGRpc3BsYXk6IHRhYmxlICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmQtcHJpbnQtdGFibGUtcm93IHtcbiAgICBkaXNwbGF5OiB0YWJsZS1yb3cgIWltcG9ydGFudDtcbiAgfVxuICAuZC1wcmludC10YWJsZS1jZWxsIHtcbiAgICBkaXNwbGF5OiB0YWJsZS1jZWxsICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmQtcHJpbnQtZmxleCB7XG4gICAgZGlzcGxheTogZmxleCAhaW1wb3J0YW50O1xuICB9XG4gIC5kLXByaW50LWlubGluZS1mbGV4IHtcbiAgICBkaXNwbGF5OiBpbmxpbmUtZmxleCAhaW1wb3J0YW50O1xuICB9XG4gIC5kLXByaW50LW5vbmUge1xuICAgIGRpc3BsYXk6IG5vbmUgIWltcG9ydGFudDtcbiAgfVxufVxuXG4vKiMgc291cmNlTWFwcGluZ1VSTD1ib290c3RyYXAtZ3JpZC5jc3MubWFwICovXG4iLCIuYnRuIHtcbiAgJHNlbGY6ICY7XG4gIHdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IDIuNzVyZW07XG4gIHBhZGRpbmc6IDAuNjI1cmVtIDFyZW07XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGJvcmRlcjogMnB4IHNvbGlkICRlcmdvLW1haW47XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBib3JkZXItcmFkaXVzOiAzMHB4O1xuICBtYXJnaW46IDAgYXV0bztcbiAgZm9udC1zaXplOiAxcmVtO1xuICBsaW5lLWhlaWdodDogMS4ycmVtO1xuICB3b3JkLWJyZWFrOiBrZWVwLWFsbDtcbiAgZm9udC13ZWlnaHQ6IDcwMDtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG4gIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgIGZvbnQtc2l6ZTogMS4yNXJlbTtcbiAgICBsaW5lLWhlaWdodDogMS41cmVtO1xuICAgIHBhZGRpbmc6IDAuNjI1cmVtIDIuNXJlbTtcbiAgfVxuXG4gICYtLWRvd25sb2FkIHtcbiAgICBzdmcge1xuICAgICAgd2lkdGg6IDM2cHg7XG4gICAgICBtYXJnaW4tcmlnaHQ6IDVweDtcbiAgICAgIGhlaWdodDogMzZweDtcbiAgICAgIHBhdGgge1xuICAgICAgICBmaWxsOiAkZXJnby1tYWluO1xuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gICYtLWRvd25sb2FkLmJ0bi0tcHJpbWFyeSB7XG4gICAgc3ZnIHtcbiAgICAgIHBhdGgge1xuICAgICAgICBmaWxsOiAkZXJnby13aGl0ZTtcbiAgICAgIH1cbiAgICB9XG4gIH1cbiAgJi0tZG93bmxvYWQuYnRuLS1zZWNvbmRhcnkge1xuICAgIHN2ZyB7XG4gICAgICBwYXRoIHtcbiAgICAgICAgZmlsbDogJGVyZ28tbWFpbjtcbiAgICAgIH1cbiAgICB9XG4gICAgJjpob3ZlcixcbiAgICAmOmZvY3VzIHtcbiAgICAgIHBhdGgge1xuICAgICAgICBmaWxsOiAkZXJnby13aGl0ZTtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAuYnRuLWxvZ28ge1xuICAgIHdpZHRoOiAxLjg3NXJlbTtcbiAgICBoZWlnaHQ6IDEuODc1cmVtO1xuICAgIG1hcmdpbi1yaWdodDogMC42MjVyZW07XG4gICAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICB9XG5cbiAgJi0tcHJpbWFyeSB7XG4gICAgY29sb3I6ICRlcmdvLXdoaXRlO1xuICAgIGJhY2tncm91bmQ6ICRlcmdvLW1haW47XG5cbiAgICAuYnRuLWxvZ28ge1xuICAgICAgZmlsdGVyOiBjb250cmFzdCgwKSBicmlnaHRuZXNzKDQpO1xuICAgIH1cblxuICAgICYtb24tZGVza3RvcCB7XG4gICAgICBiYWNrZ3JvdW5kOiAkZXJnby13aGl0ZTtcbiAgICAgIGJvcmRlcjogMC4xMjVyZW0gc29saWQgJGVyZ28tbWFpbjtcbiAgICAgIGNvbG9yOiAkZXJnby1tYWluO1xuXG4gICAgICAuYnRuLWxvZ28ge1xuICAgICAgICBmaWx0ZXI6IGludmVydCg2JSkgc2VwaWEoOTglKSBzYXR1cmF0ZSg2NjAzJSkgaHVlLXJvdGF0ZSgzMzBkZWcpXG4gICAgICAgICAgYnJpZ2h0bmVzcyg4NSUpIGNvbnRyYXN0KDEwMyUpO1xuICAgICAgfVxuXG4gICAgICAmOmRpc2FibGVkIHtcbiAgICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1heC13aWR0aDogJGxnKSB7XG4gICAgICAgICAgY29sb3I6ICNkNGEyYjYgIWltcG9ydGFudDtcbiAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmZmICFpbXBvcnRhbnQ7XG4gICAgICAgIH1cbiAgICAgIH1cblxuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICAgIGNvbG9yOiAkZXJnby13aGl0ZTtcbiAgICAgICAgYmFja2dyb3VuZDogJGVyZ28tbWFpbjtcblxuICAgICAgICAuYnRuLWxvZ28ge1xuICAgICAgICAgIGZpbHRlcjogY29udHJhc3QoMCkgYnJpZ2h0bmVzcyg0KTtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gICYtLXNlY29uZGFyeSB7XG4gICAgYmFja2dyb3VuZDogJGVyZ28td2hpdGU7XG4gICAgYm9yZGVyOiAwLjEyNXJlbSBzb2xpZCAkZXJnby1tYWluO1xuICAgIGNvbG9yOiAkZXJnby1tYWluO1xuXG4gICAgLmJ0bi1sb2dvIHtcbiAgICAgIGZpbHRlcjogaW52ZXJ0KDYlKSBzZXBpYSg5OCUpIHNhdHVyYXRlKDY2MDMlKSBodWUtcm90YXRlKDMzMGRlZylcbiAgICAgICAgYnJpZ2h0bmVzcyg4NSUpIGNvbnRyYXN0KDEwMyUpO1xuICAgIH1cbiAgfVxuXG4gICY6aG92ZXIsXG4gICY6Zm9jdXMge1xuICAgIGJhY2tncm91bmQ6ICRlcmdvLWFjY2VudDI7XG4gICAgYm9yZGVyOiAwLjEyNXJlbSBzb2xpZCAkZXJnby1hY2NlbnQyO1xuICAgIGNvbG9yOiAkZXJnby13aGl0ZTtcbiAgICBib3gtc2hhZG93OiBub25lO1xuICAgIHRleHQtZGVjb3JhdGlvbjogbm9uZTtcbiAgfVxuXG4gIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgIG1heC13aWR0aDogZml0LWNvbnRlbnQ7XG4gICAgaGVpZ2h0OiAzcmVtO1xuICB9XG5cbiAgJltkaXNhYmxlZF0ge1xuICAgIGNvbG9yOiAkZXJnby13aGl0ZTtcbiAgICBiYWNrZ3JvdW5kOiAkZXJnby1hY2NlbnQ7XG4gICAgYm9yZGVyLWNvbG9yOiAkZXJnby1hY2NlbnQ7XG4gIH1cbn1cblxuLmJ0bi5zdGlja3kge1xuICBwb3NpdGlvbjogZml4ZWQ7XG4gIHdpZHRoOiA5MHZ3O1xuICBib3R0b206IDAuNXJlbTtcbiAgZGlzcGxheTogYmxvY2s7XG4gIHotaW5kZXg6IDI7XG4gIGxlZnQ6IDUwJTtcbiAgdHJhbnNmb3JtOiB0cmFuc2xhdGUoLTUwJSwgLTUwJSk7XG5cbiAgJi0taGlkZGVuIHtcbiAgICBvcGFjaXR5OiAwO1xuICAgIHBvaW50ZXItZXZlbnRzOiBub25lO1xuICAgIHRyYW5zaXRpb246IG9wYWNpdHkgMC4zcyBlYXNlO1xuICB9XG5cbiAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgaGVpZ2h0OiAzcmVtO1xuICAgIG1heC13aWR0aDogZml0LWNvbnRlbnQ7XG4gIH1cblxuICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgd2lkdGg6IGluaGVyaXQ7XG4gICAgYm90dG9tOiBpbmhlcml0O1xuICAgIGxlZnQ6IDA7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGUoMCk7XG5cbiAgICAmLS1oaWRkZW4ge1xuICAgICAgZGlzcGxheTogYmxvY2s7XG4gICAgfVxuICB9XG59XG5cbkBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAucmVhZC1tb3JlLWxpbmsgKyAuYnRuLnN0aWNreSB7XG4gICAgbWFyZ2luLXRvcDogMXJlbTtcbiAgfVxuXG4gIC5wb3B1cCB7XG4gICAgLmJ0bi0tcHJpbWFyeS1vbi1kZXNrdG9wIHtcbiAgICAgIGNvbG9yOiAkZXJnby13aGl0ZTtcbiAgICAgIGJhY2tncm91bmQ6ICRlcmdvLW1haW47XG4gICAgfVxuICB9XG59XG4vLyBwcm9wcy5jc3NTdGlja3kgPT09IHRydWVcbi5zdGlja3ktYnV0dG9uLXdyYXBwZXIge1xuICB0cmFuc2l0aW9uOiBhbGwgMC4zcyBlYXNlO1xuICBoZWlnaHQ6IDQ1cHg7XG59XG5cbi5jc3Mtc3RpY2t5IHtcbiAgQG1lZGlhIHNjcmVlbiBhbmQgKG1heC13aWR0aDogJG1kKSB7XG4gICAgcG9zaXRpb246IGZpeGVkO1xuICAgIGJvdHRvbTogMjBweDtcbiAgICBsZWZ0OiBhdXRvO1xuICAgIHJpZ2h0OiBhdXRvO1xuICAgIHotaW5kZXg6IDEwMDA7XG4gIH1cbn1cbiIsIi5yZWFkLW1vcmUtbGluayB7XG4gIGNvbG9yOiAkZXJnby1tYWluO1xuICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG4gIGZvbnQtd2VpZ2h0OiBib2xkO1xuICBib3JkZXI6IG5vbmU7XG4gIGJhY2tncm91bmQ6IG5vbmU7XG4gIG1hcmdpbjogMCBhdXRvO1xuICBncmlkLWNvbHVtbjogMSAvIC0xO1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBnYXA6IDAuMjVyZW07XG5cbiAgJjpob3ZlciwgJjpmb2N1cyB7XG4gICAgY29sb3I6ICRlcmdvLW1haW47XG4gICAgdGV4dC1kZWNvcmF0aW9uOiB1bmRlcmxpbmU7XG4gICAgdGV4dC11bmRlcmxpbmUtb2Zmc2V0OiAwLjI1cmVtO1xuICB9XG5cbiAgJl9fbG9nbyB7XG4gICAgd2lkdGg6IDEuNXJlbTtcbiAgICBoZWlnaHQ6IDEuNXJlbTtcbiAgICBtaW4td2lkdGg6IDEuNXJlbTtcbiAgICBtaW4taGVpZ2h0OiAxLjVyZW07XG5cbiAgICAucm90YXRlZCB7XG4gICAgICB0cmFuc2Zvcm06IHJvdGF0ZSgxODBkZWcpO1xuICAgIH1cbiAgfVxuXG59XG4iLCIuc2VhbC1wbGFjZWhvbGRlciB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogc3RhcnQ7XG4gIGZsZXgtd3JhcDogd3JhcDtcbiAgbWFyZ2luLWJvdHRvbTogMS44NzVyZW07XG4gIGdhcDogMXJlbTtcblxuICBAbWVkaWEgc2NyZWVuIGFuZCAobWF4LXdpZHRoOiAkbWQpIHtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgfVxuXG4gIGltZyB7XG4gICAgbWF4LXdpZHRoOiAzMzVweDtcbiAgICBwYWRkaW5nOiAwO1xuICB9XG59XG4iLCIuY2FyZCB7XG4gIHBhZGRpbmc6IDEuNXJlbTtcbiAgZmxleC1ncm93OiAxO1xuXG4gICZfX2hlYWRsaW5lIHtcbiAgICBtYXJnaW4tYm90dG9tOiAxLjVyZW07XG4gIH1cblxuICAmX19wcmljZSB7XG4gICAgY29sb3I6ICRlcmdvLW1haW47XG4gIH1cblxuICAmLmNvbC1tZC02IHtcbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgIG1hcmdpbi1yaWdodDogMSU7XG4gICAgICB3aWR0aDogNDklO1xuICAgIH1cbiAgfVxuXG4gICYuY29sLXhsLTMge1xuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICR4bCkge1xuICAgICAgbWFyZ2luLXJpZ2h0OiAxJTtcbiAgICAgIHdpZHRoOiAyNCU7XG4gICAgfVxuICB9XG59XG4iLCIuZGlzdHVyYmVyIHtcbiAgd2lkdGg6IDYuMjVyZW07XG4gIGhlaWdodDogNi4yNXJlbTtcbiAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgd2lkdGg6IDcuNXJlbTtcbiAgICBoZWlnaHQ6IDcuNXJlbTtcbiAgfVxufVxuLmRpc3R1cmJlci5kaXN0dXJiZXItLWR5bmFtaWMge1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgcGFkZGluZzogMCAxMHB4O1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gIGJhY2tncm91bmQtY29sb3I6ICRlcmdvLW1haW47XG4gIGNvbG9yOiAkZXJnby13aGl0ZTtcbiAgcm90YXRlOiAtMTVkZWc7XG4gIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgLmRpc3R1cmJlci10ZXh0IHAge1xuICAgIG1hcmdpbi1ib3R0b206IDA7XG4gICAgbGluZS1oZWlnaHQ6IDEwMCU7XG4gIH1cbn1cblxuLmRpc3R1cmJlci10ZXh0IHtcbiAgLmQxIHtcbiAgICBmb250LXNpemU6IDEuNXJlbTtcbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgIGZvbnQtc2l6ZTogMS42MjVyZW07XG4gICAgfVxuICB9XG4gIC5kMiB7XG4gICAgZm9udC1zaXplOiAxLjM3NXJlbTtcbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgIGZvbnQtc2l6ZTogMS41cmVtO1xuICAgIH1cbiAgfVxuICAuZDMge1xuICAgIGZvbnQtc2l6ZTogMS4yNXJlbTtcbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgIGZvbnQtc2l6ZTogMS4zNzVyZW07XG4gICAgfVxuICB9XG4gIC5kNCB7XG4gICAgZm9udC1zaXplOiAxLjEyNXJlbTtcbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgIGZvbnQtc2l6ZTogMS4yNXJlbTtcbiAgICB9XG4gIH1cbiAgLmQ1IHtcbiAgICBmb250LXNpemU6IDAuODc1cmVtO1xuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgZm9udC1zaXplOiAxcmVtO1xuICAgIH1cbiAgfVxuICAuZDYge1xuICAgIGZvbnQtc2l6ZTogMC43NXJlbTtcbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgIGZvbnQtc2l6ZTogMC44NzVyZW07XG4gICAgfVxuICB9XG59XG4iLCIuY29udGVudC1saXN0IHtcbiAgbWFyZ2luLWJvdHRvbTogMi41cmVtO1xuXG4gICZfX3RpdGxlIHtcbiAgICBtYXJnaW4tYm90dG9tOiAxLjI1cmVtO1xuICB9XG5cbiAgb2wsXG4gIHVsIHtcbiAgICBsaXN0LXN0eWxlOiBub25lO1xuICAgIHBhZGRpbmc6IDA7XG4gICAgZGlzcGxheTogZ3JpZDtcbiAgICBnYXA6IDAuNjI1cmVtO1xuXG4gICAgbGkge1xuICAgICAgQGV4dGVuZCAuYzE7XG4gICAgICBjb3VudGVyLWluY3JlbWVudDogbXktYXdlc29tZS1jb3VudGVyO1xuICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICBnYXA6IDAuNzVyZW07XG4gICAgfVxuICB9XG5cbiAgb2wge1xuICAgIGNvdW50ZXItcmVzZXQ6IG15LWF3ZXNvbWUtY291bnRlcjtcbiAgICBtYXJnaW4tYm90dG9tOiAwO1xuXG4gICAgbGk6YmVmb3JlIHtcbiAgICAgIGNvbnRlbnQ6IGNvdW50ZXIobXktYXdlc29tZS1jb3VudGVyKSAnLic7XG4gICAgICBjb2xvcjogJGVyZ28tbWFpbjtcbiAgICAgIG1pbi13aWR0aDogMS44NzVyZW07XG4gICAgICB3aWR0aDogMS44NzVyZW07XG4gICAgICBtYXgtaGVpZ2h0OiAxLjg3NXJlbTtcbiAgICAgIGhlaWdodDogMS44NzVyZW07XG4gICAgICBsaW5lLWhlaWdodDogMS44NzVyZW07XG4gICAgICBib3JkZXItcmFkaXVzOiA1MCU7XG4gICAgICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gICAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gICAgICBtYXJnaW4tcmlnaHQ6IDAuNjI1cmVtO1xuICAgICAgZm9udC13ZWlnaHQ6IDgwMDtcbiAgICAgIHBhZGRpbmctbGVmdDogMC4ycmVtO1xuICAgICAgYm94LXNoYWRvdzogMHB4IDJweCA4cHggcmdiYSgwLCAwLCAwLCAwLjE1KTtcblxuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgICAgIG1pbi13aWR0aDogMi41cmVtO1xuICAgICAgICB3aWR0aDogMi41cmVtO1xuICAgICAgICBtYXgtaGVpZ2h0OiAyLjVyZW07XG4gICAgICAgIGhlaWdodDogMi41cmVtO1xuICAgICAgICBsaW5lLWhlaWdodDogMi41cmVtO1xuICAgICAgICBwYWRkaW5nLWxlZnQ6IDAuMjVyZW07XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgLy8gQlVMTEVUIExJU1RcbiAgdWwge1xuICAgIG1hcmdpbi1ib3R0b206IDA7XG4gICAgbGkge1xuICAgICAgJjpiZWZvcmUge1xuICAgICAgICBjb250ZW50OiB1cmwoLi4vLi4vc3Zncy9ibGFja19IYWVrY2hlbi5zdmcpO1xuICAgICAgICB3aWR0aDogMi41cmVtO1xuICAgICAgICBoZWlnaHQ6IDIuNXJlbTtcbiAgICAgICAgYXNwZWN0LXJhdGlvOiAxO1xuICAgICAgICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gICAgICAgIGxpbmUtaGVpZ2h0OiAzcmVtO1xuICAgICAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gICAgICAgIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgICAgIH1cblxuICAgICAgJjpsYXN0LWNoaWxkIHtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogMDtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAuYmx1ZS1saWdodCB7XG4gICAgb2wgbGk6YmVmb3JlLFxuICAgIHVsIGxpOmJlZm9yZSB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkZXJnby1ibHVlLWxpZ2h0O1xuICAgIH1cbiAgfVxuXG4gIC5ncmVlbi1saWdodCB7XG4gICAgb2wgbGk6YmVmb3JlLFxuICAgIHVsIGxpOmJlZm9yZSB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkZXJnby1ncmVlbi1saWdodDtcbiAgICB9XG4gIH1cblxuICAueWVsbG93LWxpZ2h0IHtcbiAgICBvbCBsaTpiZWZvcmUsXG4gICAgdWwgbGk6YmVmb3JlIHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICRlcmdvLXllbGxvdy1saWdodDtcbiAgICB9XG4gIH1cblxuICAudmlvbGV0LWxpZ2h0IHtcbiAgICBvbCBsaTpiZWZvcmUsXG4gICAgdWwgbGk6YmVmb3JlIHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICRlcmdvLXZpb2xldC1saWdodDtcbiAgICB9XG4gIH1cblxuICAub3JhbmdlLWxpZ2h0IHtcbiAgICBvbCBsaTpiZWZvcmUsXG4gICAgdWwgbGk6YmVmb3JlIHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICRlcmdvLW9yYW5nZS1saWdodDtcbiAgICB9XG4gIH1cblxuICAud2hpdGUge1xuICAgIG9sIGxpOmJlZm9yZSxcbiAgICB1bCBsaTpiZWZvcmUge1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogJGVyZ28td2hpdGU7XG4gICAgfVxuICB9XG4gIC50cmFuc3BhcmVudCB7XG4gICAgb2wgbGk6YmVmb3JlLFxuICAgIHVsIGxpOmJlZm9yZSB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiB0cmFuc3BhcmVudDtcbiAgICB9XG4gIH1cbn1cblxuLmNvbnRlbnQtbGlzdC1pY29uIHtcbiAgJHNlbGY6ICY7XG4gIG1hcmdpbi1ib3R0b206IDEuODc1cmVtO1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogZmxleC1zdGFydDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcblxuICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICBmbGV4LWRpcmVjdGlvbjogcm93O1xuICAgIGdhcDogMS44NzVyZW07XG4gICAgbWFyZ2luLWJvdHRvbTogMi41cmVtO1xuICB9XG5cbiAgJl9fdGV4dCB7XG4gICAgYWxpZ24tc2VsZjogY2VudGVyO1xuXG4gICAgLy8gJl9faGVhZGxpbmUge1xuICAgIC8vICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHhsKSB7XG4gICAgLy8gICAgIGhlaWdodDogNHJlbTtcbiAgICAvLyAgIH1cbiAgICAvLyB9XG4gIH1cblxuICAmX19pY29uIHtcbiAgICB3aWR0aDogNjRweDtcbiAgICBoZWlnaHQ6IDY0cHg7XG4gICAgbWluLXdpZHRoOiA2NHB4O1xuICAgIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgICBwYWRkaW5nOiA4cHg7XG4gICAgbWFyZ2luOiAwIGF1dG8gMS44NzVyZW0gYXV0bztcblxuICAgIGltZyB7XG4gICAgICBtYXJnaW46IDAgYXV0bztcbiAgICB9XG5cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgIHdpZHRoOiA4MHB4O1xuICAgICAgaGVpZ2h0OiA4MHB4O1xuICAgICAgbWluLXdpZHRoOiA4MHB4O1xuICAgIH1cbiAgfVxuXG4gIGg0IHtcbiAgICBtYXJnaW4tYm90dG9tOiAxLjI1cmVtO1xuICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgfVxuXG4gICZfX2ltZyB7XG4gICAgaGVpZ2h0OiAyMjBweDtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBtYXJnaW4tYm90dG9tOiAxLjg3NXJlbTtcblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRzbSkge1xuICAgICAgaGVpZ2h0OiAzMDBweDtcbiAgICB9XG5cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgIGhlaWdodDogMzUwcHg7XG4gICAgfVxuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICBoZWlnaHQ6IDIyMHB4O1xuICAgIH1cblxuICAgIGltZyB7XG4gICAgICBvYmplY3QtZml0OiBjb3ZlcjtcbiAgICB9XG4gIH1cblxuICAmLS1hbGlnbmVkLWxlZnQge1xuICAgIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gICAgZ2FwOiAxMHB4O1xuXG4gICAgI3skc2VsZn1fX2ljb24ge1xuICAgICAgbWFyZ2luOiAwO1xuICAgIH1cbiAgfVxufVxuIiwiLnNlY3Rpb24ge1xuICBtYXJnaW4tYm90dG9tOiAwLjkzNzVyZW07XG4gIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgIG1hcmdpbi1ib3R0b206IDMuMTI1cmVtO1xuICB9XG4gICYtbWFyZ2luLS1iaWcge1xuICAgIG1hcmdpbi1ib3R0b206IDEuODc1cmVtO1xuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgbWFyZ2luLWJvdHRvbTogNi4yNXJlbTtcbiAgICB9XG4gIH1cbn1cbiIsIi5hY2NvcmRpb24ge1xuICBtYXJnaW4tYm90dG9tOiAwLjVyZW07XG5cbiAgLmljb24ge1xuICAgIHdpZHRoOiAxLjVyZW07XG4gICAgaGVpZ2h0OiAxLjVyZW07XG4gICAgbWluLXdpZHRoOiAxLjVyZW07XG4gICAgbWluLWhlaWdodDogMS41cmVtO1xuICB9XG5cbiAgLmljb24tLXNtYWxsIHtcbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgIHdpZHRoOiAycmVtO1xuICAgICAgaGVpZ2h0OiAycmVtO1xuICAgICAgbWluLXdpZHRoOiAycmVtO1xuICAgICAgbWluLWhlaWdodDogMnJlbTtcbiAgICB9XG4gIH1cblxuICAuaWNvbi0tYmlnIHtcbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgIHdpZHRoOiAyLjg3NXJlbTtcbiAgICAgIGhlaWdodDogMi44NzVyZW07XG4gICAgICBtaW4td2lkdGg6IDIuODc1cmVtO1xuICAgICAgbWluLWhlaWdodDogMi44NzVyZW07XG4gICAgfVxuICB9XG5cbiAgJl9faXRlbSB7XG4gICAgcGFkZGluZzogMXJlbSAxLjYyNXJlbTtcbiAgICBib3JkZXItYm90dG9tOiAxcHggc29saWQgcmdiYSgkZXJnby1ibGFjaywgMC4xKTtcbiAgfVxuXG4gICYuYmctd2hpdGUgJl9faXRlbSB7XG4gICAgYm9yZGVyLWJvdHRvbTogMXB4IHNvbGlkICMwMDAwMDAxYTtcbiAgfVxuXG4gICZfX2hlYWRlciB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgICBnYXA6IDAuNXJlbTtcblxuICAgICYtdGl0bGUge1xuICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICBnYXA6IDAuNXJlbTtcblxuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICAgIGdhcDogMXJlbTtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAmOmhvdmVyLFxuICAgICZfX2l0ZW06Zm9jdXMge1xuICAgICAgY3Vyc29yOiBwb2ludGVyO1xuICAgIH1cbiAgfVxuXG4gICZfX3RpdGxlIHtcbiAgICBtYXJnaW46IDAuMjVyZW0gMDtcbiAgfVxuXG4gICZfX2NvbnRlbnQge1xuICAgIG1hcmdpbi10b3A6IDFyZW07XG4gICAgZGlzcGxheTogZ3JpZDtcbiAgICBncmlkLXRlbXBsYXRlLXJvd3M6IDFmcjtcbiAgICB0cmFuc2l0aW9uOiBncmlkLXRlbXBsYXRlLXJvd3MgMzAwbXMgZWFzZS1pbi1vdXQ7XG4gIH1cblxuICAmX19jb250ZW50LS1oaWRkZW4ge1xuICAgIGdyaWQtdGVtcGxhdGUtcm93czogMGZyO1xuICB9XG5cbiAgJl9fY29udGVudENvbnRhaW5lciB7XG4gICAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgfVxuXG4gICZfX2NvbnRlbnQtLW9mZnNldCB7XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgICBtYXJnaW4tbGVmdDogMi42MjVyZW07XG4gICAgfVxuICB9XG5cbiAgJl9fY29udGVudC0tb2Zmc2V0LWxhcmdlIHtcbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgIG1hcmdpbi1sZWZ0OiAzLjM3NXJlbTtcbiAgICB9XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICBtYXJnaW4tbGVmdDogMy43NXJlbTtcbiAgICB9XG4gIH1cblxuICAmX190ZXh0IHtcbiAgICBtYXJnaW4tYm90dG9tOiAxLjI1cmVtO1xuICB9XG5cbiAgLmFycm93IHtcbiAgICB3aWR0aDogMS4yNXJlbTtcbiAgICBoZWlnaHQ6IDEuMjVyZW07XG4gICAgbWluLXdpZHRoOiAxLjI1cmVtO1xuICAgIG1pbi1oZWlnaHQ6IDEuMjVyZW07XG4gIH1cblxuICAmX19mbGV4LWNvbnRhaW5lciB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LXdyYXA6IHdyYXA7XG4gICAgYWxpZ24taXRlbXM6IHN0cmV0Y2g7XG4gIH1cblxuICAmX19jYXRlZ29yeSB7XG4gICAgYm9yZGVyLWJvdHRvbTogMnB4IHNvbGlkICNiYmI5YWQ7XG5cbiAgICAudGFiIHtcbiAgICAgIGgzIHtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogMDtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAmX193cmFwcGVyIHtcbiAgICAubWFnaWMtdGV4dCB7XG4gICAgICBwYWRkaW5nOiAxcmVtIDEuNjI1cmVtO1xuICAgIH1cbiAgfVxuXG4gIC5zZWN0aW9uOmhhcyguYWNjb3JkaW9uKSB7XG4gICAgcGFkZGluZzogMDtcbiAgfVxufVxuXG4ucXVpel9yZXN1bHRzIHtcbiAgLmFjY29yZGlvbiAuYWNjb3JkaW9uLXdyYXBwZXItY29udGVudF9fdGl0bGUge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gICAgcCB7XG4gICAgICBmb250LXdlaWdodDogaW5oZXJpdDtcbiAgICB9XG4gIH1cbiAgLmFjY29yZGlvbl9fbm8taGVhZGVyIHtcbiAgICAuYWNjb3JkaW9uX19jb250ZW50IHtcbiAgICAgIG1hcmdpbi10b3A6IDA7XG4gICAgfVxuICAgIC5hY2NvcmRpb24td3JhcHBlci1jb250ZW50IHtcbiAgICAgIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCByZ2JhKCRlcmdvLWJsYWNrLCAwLjEpO1xuICAgICAgbWFyZ2luLXRvcDogMS4yNXJlbTtcbiAgICB9XG4gICAgLmFjY29yZGlvbi13cmFwcGVyLWNvbnRlbnQ6bGFzdC1jaGlsZCB7XG4gICAgICBib3JkZXItYm90dG9tOiAwO1xuICAgIH1cbiAgICAuYWNjb3JkaW9uLXdyYXBwZXItY29udGVudDpmaXJzdC1jaGlsZCB7XG4gICAgICBtYXJnaW4tdG9wOiB2YXIoLS1icy1ndXR0ZXIteSk7XG4gICAgfVxuICB9XG59XG4iLCIudmlkZW8tbW9kYWwge1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgcG9zaXRpb246IGZpeGVkO1xuICB0b3A6IDA7XG4gIGxlZnQ6IDA7XG4gIHdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IDEwMCU7XG4gIGJhY2tncm91bmQtY29sb3I6IHJnYmEoMCwgMCwgMCwgMC44KTtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgei1pbmRleDogOTk5OTtcbiAgJl9fY29udGVudCB7XG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICBtYXgtd2lkdGg6IDgwJTtcbiAgICB2aWRlbyB7XG4gICAgICB3aWR0aDogMTAwJTtcbiAgICB9XG4gIH1cbiAgJl9fY2xvc2Uge1xuICAgIGNvbG9yOiAjZmZmO1xuICAgIGZvbnQtc2l6ZTogMjRweDtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgdG9wOiAtNDBweDtcbiAgICByaWdodDogMTBweDtcbiAgICBjdXJzb3I6IHBvaW50ZXI7XG4gIH1cbiAgLmJ0biB7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIHJpZ2h0OiAwO1xuXG4gIH1cblxufVxuXG4uZGV0YWlsLW1vZGFsIHtcbiAgQGV4dGVuZCAudmlkZW8tbW9kYWw7XG4gICZfX2NvbnRlbnQge1xuICAgIEBleHRlbmQgLnZpZGVvLW1vZGFsX19jb250ZW50O1xuICAgIGJhY2tncm91bmQtY29sb3I6ICNmZmY7XG4gICAgY29sb3I6ICRlcmdvLWJsYWNrO1xuICAgICYtaWNvbiB7XG4gICAgICB3aWR0aDogNjBweDtcbiAgICAgIGhlaWdodDogNjBweDtcbiAgICAgIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgICB9XG4gICAgJi13cmFwcGVyIHtcbiAgICAgIG1hcmdpbjogMzBweCAxNXB4O1xuICAgICAgZ2FwOiAyMHB4O1xuICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgICB0ZXh0LWFsaWduOmxlZnQ7XG4gICAgICBtYXgtaGVpZ2h0OiBjYWxjKDEwMHZoIC0gMTAwcHgpO1xuICAgICAgb3ZlcmZsb3cteTogYXV0bztcbiAgICAgID4qIHtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogMDtcbiAgICAgIH1cbiAgICAgIHRhYmxlIHtcbiAgICAgICAgdGQge1xuICAgICAgICAgIHRleHQtYWxpZ246IHJpZ2h0O1xuICAgICAgICAgIHdpZHRoOiA1MCU7XG4gICAgICAgICAgcGFkZGluZy1yaWdodDogLjM3NXJlbTtcbiAgICAgICAgICBmb250LXNpemU6IDEuMTI1cmVtO1xuICAgICAgICAgIGZvbnQtd2VpZ2h0OiA3MDA7XG4gICAgICAgIH1cbiAgICAgICAgdGgge1xuICAgICAgICAgIHRleHQtYWxpZ246IGxlZnQ7XG4gICAgICAgICAgd2lkdGg6IDUwJTtcbiAgICAgICAgICBmb250LXNpemU6IC42MjVyZW07XG4gICAgICAgIH1cblxuICAgICAgfVxuICAgIH1cbiAgICAmLWJ1bGIge1xuICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICYtdGV4dCB7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICBwYWRkaW5nLWxlZnQ6IDEwcHg7XG4gICAgICAgIGxpbmUtaGVpZ2h0OiAyLjI1cmVtO1xuICAgICAgICBmb250LXdlaWdodDogNzAwO1xuICAgICAgfVxuICAgICAgJi1pY29uIHtcbiAgICAgICAgcGFkZGluZzogNXB4O1xuICAgICAgfVxuICAgIH1cbiAgICAmLWluZm8ge1xuICAgICAgZm9udC1zaXplOiAxMHB4O1xuICAgICAgZm9udC13ZWlnaHQ6IDQwMDtcbiAgICAgIGxpbmUtaGVpZ2h0OiAxcmVtO1xuICAgICAgc3BhbiB7XG4gICAgICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgICAgICAmOmZpcnN0LWNoaWxkIHtcbiAgICAgICAgICBtYXJnaW4tYm90dG9tOiAxMHB4O1xuICAgICAgICB9XG4gICAgICAgICY6bGFzdC1jaGlsZCB7XG4gICAgICAgICAgbWFyZ2luLWJvdHRvbTogMDtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cbiAgfVxuICAmX190YWJsZSB7XG4gICAgJi0tdW5mYWxsIHtcbiAgICAgIGNvbG9yOiAkZXJnby1tYWluO1xuICAgICAgJi1zbWFsbCB7XG4gICAgICBmb250LXNpemU6IDEwcHg7XG4gICAgICBmb250LXdlaWdodDogNDAwO1xuICAgICAgdGV4dC1hbGlnbjogY2VudGVyICFpbXBvcnRhbnQ7XG4gICAgICB9XG4gICAgICB0ci5hbmQgdGgge1xuICAgICAgICBmb250LXNpemU6IDEycHg7XG4gICAgICAgIGZvbnQtd2VpZ2h0OiA0MDA7XG4gICAgICAgIGNvbG9yOiAkZXJnby1ibGFjaztcbiAgICAgICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgICAgfVxuICAgIH1cbiAgICAmLWxpbmUge1xuICAgICAgdGQge1xuICAgICAgICBzdmd7XG4gICAgICAgICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKDEwMHB4KTtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gICZfX2Nsb3NlIHtcbiAgICBjdXJzb3I6IHBvaW50ZXI7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIGJvcmRlcjogMXB4IHNvbGlkIGJsYWNrO1xuICAgIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgICBwYWRkaW5nOiAxcHggNnB4IDAgNnB4O1xuICAgIG1hcmdpbjogMCBhdXRvO1xuICAgIGZvbnQtc2l6ZTogMTZweDtcbiAgICByaWdodDogMTBweDtcbiAgICB0b3A6IDEwcHg7XG4gICAgbGluZS1oZWlnaHQ6IDIwcHg7XG4gIH1cbiAgLmJ0biB7XG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICB9XG5cbn1cblxuLyogQWRkaXRpb25hbCBzdHlsZXMgZm9yIHRoZSBwbGF5L3BhdXNlIGJ1dHRvbiAqL1xuLy8gLnZpZGVvLWNvbnRyb2xzIHtcbi8vICAgcG9zaXRpb246IGFic29sdXRlO1xuLy8gICBib3R0b206IDEwcHg7XG4vLyAgIGxlZnQ6IDUwJTtcbi8vICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKC01MCUpO1xuLy8gICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDAsIDAsIDAsIDAuNSk7XG4vLyAgIGJvcmRlcjogbm9uZTtcbi8vICAgcGFkZGluZzogMTBweDtcbi8vICAgY29sb3I6ICNmZmY7XG4vLyAgIGN1cnNvcjogcG9pbnRlcjtcbi8vICAgZm9udC1zaXplOiAxOHB4O1xuLy8gICBib3JkZXItcmFkaXVzOiA1cHg7XG4vLyB9XG5cbi8vIC52aWRlby1jb250cm9sczpob3ZlciB7XG4vLyAgIGJhY2tncm91bmQtY29sb3I6IHJnYmEoMCwgMCwgMCwgMC44KTtcbi8vIH1cblxuLy8gLnBsYXktaWNvbjpiZWZvcmUge1xuLy8gICBjb250ZW50OiAn4pa2Jztcbi8vIH1cblxuLy8gLnBhdXNlLWljb246YmVmb3JlIHtcbi8vICAgY29udGVudDogJ+KdmuKdmic7XG4vLyB9XG4iLCIuY2Fyb3VzZWwtaXRlbSB7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgd2lkdGg6IDEwMCU7XG4gIG1heC13aWR0aDogMTAwc3Z3O1xuICB0cmFuc2l0aW9uOiBhbGwgMC4zcyBsaW5lYXI7XG4gIGZpbHRlcjogYmx1cigxcHgpO1xuICBib3JkZXItcmFkaXVzOiA4cHg7XG4gIG9wYWNpdHk6IDAuMjtcblxuICAmOmhvdmVyLFxuICAmOmZvY3VzIHtcbiAgICBjdXJzb3I6IGdyYWJiaW5nO1xuICB9XG5cbiAgJi5hY3RpdmUge1xuICAgIGZpbHRlcjogbm9uZTtcbiAgICBvcGFjaXR5OiAxO1xuICB9XG5cbiAgJi5hY3RpdmU6aG92ZXIsXG4gICYuYWN0aXZlOmZvY3VzIHtcbiAgICBjdXJzb3I6IGluaXRpYWw7XG4gIH1cbiAgJl9faW1hZ2Utd3JhcHBlciB7XG4gICAgaGVpZ2h0OiAxODBweDtcbiAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgcGFkZGluZzogMDtcblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRzbSkge1xuICAgICAgaGVpZ2h0OiAzMDBweDtcbiAgICB9XG5cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgIGhlaWdodDogNTgwcHg7XG4gICAgfVxuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICBoZWlnaHQ6IDQwMHB4O1xuICAgIH1cbiAgfVxuXG4gICZfX2ltYWdlIHtcbiAgICBvYmplY3QtZml0OiBjb3ZlcjtcbiAgICBib3JkZXItcmFkaXVzOiA4cHggOHB4IDAgMDtcblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgYm9yZGVyLXJhZGl1czogOHB4IDAgMCA4cHg7XG4gICAgfVxuICB9XG5cbiAgLmRpc3R1cmJlciB7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIHRvcDogNjglO1xuICAgIHJpZ2h0OiA1JTtcblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6IDU3NnB4KSBhbmQgKG1heC13aWR0aDogNzY3cHgpIHtcbiAgICAgIHRvcDogNzIlO1xuICAgIH1cblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgcmlnaHQ6IC03JTtcbiAgICAgIHRvcDogMiU7XG4gICAgfVxuICB9XG5cbiAgJl9fdGV4dC1jb250ZW50IHtcbiAgICBwYWRkaW5nOiAxLjg3NXJlbSAxLjI1cmVtO1xuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgcGFkZGluZzogMy43NXJlbSAyLjVyZW07XG4gICAgfVxuICB9XG5cbiAgLnRleHQtYXJlYSB7XG4gICAgLy8gdHJhbnNmb3JtOiB0cmFuc2xhdGVZKC0xMDUlKTtcbiAgICB0cmFuc2xhdGU6IDAgLTEwNSU7XG4gICAgd2lkdGg6IDgwMCU7XG4gICAgbWFyZ2luOiBhdXRvO1xuICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICBwYWRkaW5nOiAxLjI1cmVtO1xuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgICBwYWRkaW5nOiAxLjg3NXJlbTtcbiAgICB9XG5cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgIHdpZHRoOiA5NSU7XG4gICAgfVxuICB9XG5cbiAgJl9fdGV4dC1jb250ZW50LS12aXN1YWwge1xuICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICBwYWRkaW5nOiAzLjAzMTI1cmVtIDEuMjVyZW07XG4gICAgYm9yZGVyLXJhZGl1czogMCA4cHg7XG4gIH1cblxuICAmX19pbWFnZS13cmFwcGVyLS12aXN1YWwge1xuICAgIGhlaWdodDogMzAwcHg7XG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICBoZWlnaHQ6IDUwMHB4O1xuICAgIH1cblxuICAgIC50ZXh0LWFyZWEge1xuICAgICAgdG9wOiAxMDAlO1xuICAgICAgaGVpZ2h0OiA1MDBweDtcbiAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgcGFkZGluZzogMzBweCAyMHB4O1xuICAgICAgYm9yZGVyLXJhZGl1czogMCAwIDhweCA4cHg7XG4gICAgICBtYXJnaW46IDA7XG5cbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRzbSkge1xuICAgICAgICBwYWRkaW5nOiAzMHB4IDYwcHg7XG4gICAgICAgIHRyYW5zbGF0ZTogMCBjYWxjKC0xMDAlICsgMXB4KTtcbiAgICAgICAgaGVpZ2h0OiBhdXRvO1xuICAgICAgfVxuXG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgICAgcGFkZGluZzogMzBweCA2MHB4O1xuICAgICAgfVxuXG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICAgICAgaDIge1xuICAgICAgICAgIGZvbnQtc2l6ZTogMS41cmVtO1xuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgJl9faW1hZ2UtLXZpc3VhbCB7XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICBib3JkZXItcmFkaXVzOiA4cHg7XG4gICAgfVxuICB9XG59XG4iLCIucG9wdXAge1xuICBwb3NpdGlvbjogZml4ZWQ7XG4gIHotaW5kZXg6IDk5OTk7XG4gIHRvcDogMDtcbiAgYm90dG9tOiAwO1xuICBsZWZ0OiAwO1xuICByaWdodDogMDtcbiAgYmFja2dyb3VuZDogcmdiYSgkZXJnby1ibGFjay1yZ2IsIDAuNyk7XG5cbiAgJl9fY29udGVudCB7XG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgIHdpZHRoOiA4NSU7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgIGJhY2tncm91bmQ6IHdoaXRlO1xuICAgIHBhZGRpbmc6IDMuNTYyNXJlbSAwLjgxMjVyZW0gMS44NzVyZW0gMC45Mzc1cmVtO1xuICAgIGJvcmRlci1yYWRpdXM6IDRweDtcblxuICAgICYtLWNvbmZpcm0ge1xuICAgICAgLnBvcHVwX19pY29uLXdyYXBwZXIge1xuICAgICAgICB3aWR0aDogMTYwcHg7XG4gICAgICAgIGhlaWdodDogMTMwcHg7XG4gICAgICAgIG1hcmdpbi1ib3R0b206IDEuODc1cmVtO1xuXG4gICAgICAgIGltZyB7XG4gICAgICAgICAgd2lkdGg6IGluaGVyaXQ7XG4gICAgICAgICAgbWFyZ2luOiAwO1xuICAgICAgICB9XG4gICAgICB9XG5cbiAgICAgIC5wb3B1cF9fY29udGVudC1ub3RpY2Uge1xuICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICBmbGV4LWRpcmVjdGlvbjogcm93O1xuICAgICAgICBmbGV4LXdyYXA6IG5vd3JhcDtcbiAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgICAganVzdGlmeS1jb250ZW50OiBzdGFydDtcbiAgICAgICAgZ2FwOiAwLjVyZW07XG4gICAgICAgIG1hcmdpbi1ib3R0b206IDEuMjVyZW07XG4gICAgICAgIHdpZHRoOiA3MCU7XG5cbiAgICAgICAgJjpsYXN0LWNoaWxkIHtcbiAgICAgICAgICBwIHtcbiAgICAgICAgICAgIGZvbnQtd2VpZ2h0OiA3MDA7XG4gICAgICAgICAgfVxuICAgICAgICB9XG5cbiAgICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgICAgICAgbWFyZ2luLWxlZnQ6IGF1dG87XG4gICAgICAgICAgbWFyZ2luLXJpZ2h0OiBhdXRvO1xuICAgICAgICAgIHdpZHRoOiBhdXRvO1xuICAgICAgICB9XG5cbiAgICAgICAgLmMyIHtcbiAgICAgICAgICBtYXJnaW4tYm90dG9tOiAwO1xuICAgICAgICAgIHRleHQtYWxpZ246IGxlZnQ7XG4gICAgICAgIH1cblxuICAgICAgICAmLWljb24ge1xuICAgICAgICAgIHdpZHRoOiAyN3B4O1xuICAgICAgICAgIGhlaWdodDogMjdweDtcbiAgICAgICAgICBtaW4td2lkdGg6IDI3cHg7XG4gICAgICAgICAgbWluLWhlaWdodDogMjdweDtcbiAgICAgICAgICBtYXgtd2lkdGg6IDI3cHg7XG4gICAgICAgICAgbWF4LWhlaWdodDogMjdweDtcbiAgICAgICAgICBtYXJnaW4tcmlnaHQ6IDJweDtcblxuICAgICAgICAgIHN2ZyB7XG4gICAgICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgICAgIGhlaWdodDogMTAwJTtcbiAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAmX19jbG9zZS1pY29uIHtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgcmlnaHQ6IDAuOTM3NXJlbTtcbiAgICB0b3A6IDAuOTM3NXJlbTtcbiAgfVxuXG4gICZfX2Nsb3NlLWljb246aG92ZXIsXG4gICZfX2Nsb3NlLWljb246Zm9jdXMge1xuICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgfVxuXG4gICZfX2NvbnRlbnQtYm94IHtcbiAgICBwYWRkaW5nLXRvcDogMC42MjVyZW07XG4gIH1cblxuICAmX19pY29uIHtcbiAgICB3aWR0aDogNXJlbTtcbiAgICBtYXJnaW46IDAgYXV0byAxLjg3NXJlbSBhdXRvO1xuICB9XG5cbiAgJl9faWNvbi0tc21hbGwge1xuICAgIHdpZHRoOiAyNHB4O1xuICAgIG1hcmdpbi1ib3R0b206IDA7XG4gIH1cblxuICBoMyB7XG4gICAgbWFyZ2luLWJvdHRvbTogMS4yNXJlbTtcbiAgfVxuXG4gIHAge1xuICAgIG1hcmdpbi1ib3R0b206IDEuMjVyZW07XG4gIH1cblxuICAmX19ncmFwaGljLXdyYXBwZXIge1xuICAgIHdpZHRoOiAyNTBweDtcbiAgICBoZWlnaHQ6IDE1MHB4O1xuICAgIG1hcmdpbi1ib3R0b206IDIwcHg7XG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICB9XG5cbiAgLmRpc3R1cmJlciB7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIHdpZHRoOiAxMDBweDtcbiAgICB0b3A6IC0xMCU7XG4gICAgbGVmdDogLTEwJTtcbiAgfVxuXG4gICZfX2VtYWlsIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gICAgYWxpZ24taXRlbXM6IGZsZXgtc3RhcnQ7XG4gICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG5cbiAgICBwIHtcbiAgICAgIGZvbnQtc2l6ZTogMjBweDtcbiAgICAgIGZvbnQtd2VpZ2h0OiA3MDA7XG4gICAgICBsaW5lLWhlaWdodDogMjhweDtcbiAgICB9XG5cbiAgICAucG9wdXBfX2ljb24tLXNtYWxsIHtcbiAgICAgIHdpZHRoOiAyOHB4O1xuICAgICAgbWFyZ2luLWJvdHRvbTogMDtcbiAgICB9XG4gIH1cbn1cbiIsIi5zdWNjZXNzX19iYW5uZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGJhY2tncm91bmQtY29sb3I6ICRlcmdvLWdyZWVuLWRhcmszO1xuICB3aWR0aDogMTAwJTtcbiAgY29sb3I6ICRlcmdvLXdoaXRlO1xuICBwYWRkaW5nOiAuNjI1cmVtO1xuICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICBwYWRkaW5nOiAxLjI1cmVtO1xuICB9XG4gICYtd3JhcHBlciB7XG4gICAgZGlzcGxheTogaW5saW5lLWZsZXg7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgfVxuICAmLWljb24ge1xuICAgIHdpZHRoOiA0OHB4O1xuICAgIGhlaWdodDogNDhweDtcbiAgICBtaW4td2lkdGg6IDQ4cHg7XG4gICAgbWluLWhlaWdodDogNDhweDtcbiAgICAtd2Via2l0LWZpbHRlcjogaW52ZXJ0KDEwMCUpO1xuICAgIGZpbHRlcjogaW52ZXJ0KDEwMCUpO1xuICB9XG4gICYtY2xvc2Uge1xuICAgIGJhY2tncm91bmQtY29sb3I6dHJhbnNwYXJlbnQ7XG4gIH1cbiAgcCB7XG4gICAgbWFyZ2luOiAwO1xuICB9XG59IiwiLmNvbnRlbnQtb2ZmZXIge1xuICB3aWR0aDogMTAwJTtcbiAgbWFyZ2luOiAwIGF1dG87XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcblxuICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICBtaW4taGVpZ2h0OiAzNTBweDtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgfVxuXG4gICZfX2ltYWdlIHtcbiAgICBwYWRkaW5nOiAwO1xuICAgICYtZGVza3RvcCB7XG4gICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICB3aWR0aDogMTAwJTtcbiAgICAgIGhlaWdodDogMTAwJTtcbiAgICAgIHJpZ2h0OiAwO1xuICAgICAgbGVmdDogMDtcbiAgICAgIHRvcDogMDtcbiAgICAgIGJvdHRvbTogMDtcbiAgICAgIHBhZGRpbmc6IDA7XG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgICAgJjo6YWZ0ZXIge1xuICAgICAgICAgIGNvbnRlbnQ6ICcnO1xuICAgICAgICAgIGJhY2tncm91bmQ6IGxpbmVhci1ncmFkaWVudChcbiAgICAgICAgICAgIHRvIHJpZ2h0LFxuICAgICAgICAgICAgcmdiYSgyNTUsIDI1NSwgMjU1LCAwKSAwJSxcbiAgICAgICAgICAgIHJnYmEoMjU1LCAyNTUsIDI1NSwgMCkgNDAlLFxuICAgICAgICAgICAgcmdiYSgyNTUsIDI1NSwgMjU1LCAxKSA4MCVcbiAgICAgICAgICApO1xuICAgICAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgICAgICB0b3A6IDA7XG4gICAgICAgICAgbGVmdDogMDtcbiAgICAgICAgICByaWdodDogMDtcbiAgICAgICAgICBib3R0b206IDA7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICAgIGltZyB7XG4gICAgICAgIG9iamVjdC1maXQ6IGNvdmVyO1xuICAgICAgICBvYmplY3QtcG9zaXRpb246IGxlZnQgY2VudGVyO1xuICAgICAgfVxuICAgIH1cbiAgICAmLW1vYmlsZSB7XG4gICAgICBwYWRkaW5nOiAwO1xuICAgICAgaGVpZ2h0OiAyMDBweDtcbiAgICAgIG92ZXJmbG93OiBoaWRkZW47XG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkc20pIHtcbiAgICAgICAgaGVpZ2h0OiAzMDBweDtcbiAgICAgIH1cbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgICBkaXNwbGF5OiBub25lO1xuICAgICAgfVxuXG4gICAgICBpbWcge1xuICAgICAgICBoZWlnaHQ6IGF1dG87XG4gICAgICB9XG4gICAgfVxuICB9XG4gICZfX3RleHQge1xuICAgIHotaW5kZXg6IDE7XG4gICAgcGFkZGluZzogMCAyNnB4O1xuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICBwYWRkaW5nOiAwIDMwcHg7XG4gICAgfVxuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgICBwYWRkaW5nOiAwIDQwcHggMCAwO1xuICAgIH1cblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgcGFkZGluZzogMCAzMHB4IDAgMDtcbiAgICB9XG5cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICAgIHBhZGRpbmc6IDAgNjBweCAwIDA7XG4gICAgfVxuXG4gICAgLmNvbnRlbnQtdGV4dF9fd3JhcHBlciB7XG4gICAgICAuc2VhbC1wbGFjZWhvbGRlciB7XG4gICAgICAgIGltZyB7XG4gICAgICAgICAgbWF4LXdpZHRoOiAyNzVweDtcbiAgICAgICAgICBtYXgtaGVpZ2h0OiAxNzBweDtcbiAgICAgICAgICB3aWR0aDogYXV0bztcbiAgICAgICAgICBoZWlnaHQ6IGF1dG87XG5cbiAgICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgICAgICAgIG1heC1oZWlnaHQ6IDIwMHB4O1xuICAgICAgICAgIH1cblxuICAgICAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICR4bCkge1xuICAgICAgICAgICAgbWF4LXdpZHRoOiAyNTFweDtcbiAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgIH1cblxuICAgICAgLmNvbnRlbnQtbGlzdC1pY29uIHtcbiAgICAgICAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgICAgICAgZ2FwOiA4cHg7XG4gICAgICAgIG1hcmdpbi1ib3R0b206IDAuNjI1cmVtO1xuXG4gICAgICAgICY6bGFzdC1vZi10eXBlIHtcbiAgICAgICAgICBtYXJnaW4tYm90dG9tOiAyLjVyZW07XG4gICAgICAgIH1cblxuICAgICAgICAmX19pY29uIHtcbiAgICAgICAgICBtYXJnaW46IDA7XG4gICAgICAgICAgcGFkZGluZzogMC4yNXJlbTtcbiAgICAgICAgICBtYXgtd2lkdGg6IDMycHg7XG4gICAgICAgICAgbWF4LWhlaWdodDogMzJweDtcbiAgICAgICAgICB3aWR0aDogMzJweDtcbiAgICAgICAgICBoZWlnaHQ6IDMycHg7XG4gICAgICAgICAgbWluLXdpZHRoOiAzMnB4O1xuICAgICAgICAgIG1pbi1oZWlnaHQ6IDMycHg7XG4gICAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgICAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAuYnRuIHtcbiAgICBtYXJnaW46IDA7XG5cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgIG1heC13aWR0aDogdW5zZXQ7XG4gICAgfVxuXG4gICAgJjpub3QoOmxhc3QtY2hpbGQpIHtcbiAgICAgIG1hcmdpbi1ib3R0b206IDIwcHg7XG4gICAgfVxuICB9XG59XG4iLCIuY29udGVudC10ZXh0IHtcbiAgaDIsXG4gIGgzIHtcbiAgICBjb2xvcjogJGVyZ28tbWFpbjtcbiAgICBtYXJnaW4tYm90dG9tOiAxLjI1cmVtO1xuICB9XG4gICZfX3dyYXBwZXIge1xuICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICBwYWRkaW5nOiAxLjg3NXJlbSAwO1xuXG4gICAgcCB7XG4gICAgICBtYXJnaW4tYm90dG9tOiAyLjVyZW07XG4gICAgfVxuXG4gICAgLm1hZ2ljLXRleHQge1xuICAgICAgQGV4dGVuZCAuYzI7XG4gICAgfVxuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgICBwYWRkaW5nOiAzLjEyNXJlbSAwO1xuICAgIH1cblxuICAgIC5kaXN0dXJiZXIge1xuICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgdG9wOiAtODBweDtcbiAgICAgIHJpZ2h0OiAwO1xuXG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgICAgdG9wOiAtODBweDtcbiAgICAgIH1cblxuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICAgIHRvcDogLTgwcHg7XG4gICAgICB9XG5cbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICR4bCkge1xuICAgICAgICB0b3A6IC04MHB4O1xuICAgICAgfVxuICAgIH1cbiAgfVxufVxuIiwiLmNvbnRlbnQtZG93bmxvYWQge1xuICAmX19jb250ZW50IHtcbiAgICBwYWRkaW5nOiAxLjI1cmVtIDEuNjI1cmVtO1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICBnYXA6IDEuMjVyZW07XG4gICAgYSB7XG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgICAgbWFyZ2luOiAwO1xuICAgICAgfVxuICAgIH1cbiAgICAuYnRuIHtcbiAgICAgIHN2ZyB7XG4gICAgICAgIHdpZHRoOiAzNnB4O1xuICAgICAgICBtYXJnaW4tcmlnaHQ6IDVweDtcbiAgICAgICAgaGVpZ2h0OiAzNnB4O1xuICAgICAgfVxuXG4gICAgICAmLS1zZWNvbmRhcnkge1xuICAgICAgICBwYXRoIHtcbiAgICAgICAgICBmaWxsOiAkZXJnby1tYWluO1xuICAgICAgICB9XG4gICAgICAgICY6aG92ZXIsXG4gICAgICAgICY6Zm9jdXMge1xuICAgICAgICAgIHBhdGgge1xuICAgICAgICAgICAgZmlsbDogJGVyZ28td2hpdGU7XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICB9XG5cbiAgICAgICYtLXByaW1hcnkge1xuICAgICAgICBwYXRoIHtcbiAgICAgICAgICBmaWxsOiAkZXJnby13aGl0ZTtcbiAgICAgICAgfVxuICAgICAgfVxuXG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgICAgbWF4LXdpZHRoOiB1bnNldDtcbiAgICAgIH1cbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgICBtYXgtd2lkdGg6IGZpdC1jb250ZW50O1xuICAgICAgfVxuICAgIH1cbiAgfVxuICAmX19pbWFnZSB7XG4gICAgd2lkdGg6IDEyNXB4O1xuICAgIGhlaWdodDogMTI1cHg7XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICB3aWR0aDogMTc1cHg7XG4gICAgICBoZWlnaHQ6IDE3NXB4O1xuICAgIH1cbiAgICAmLWNvbnRhaW5lciB7XG4gICAgICBwYWRkaW5nOiAzLjEyNXJlbSAwO1xuICAgIH1cbiAgfVxufVxuIiwiLmNvbnRlbnQtaGVhZGxpbmUtYmxvY2sge1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIHRleHQtYWxpZ246IGxlZnQ7XG4gIHBhZGRpbmc6IDMwcHggMjZweDtcblxuICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICBwYWRkaW5nOiA1MHB4IDQwcHg7XG4gIH1cblxuICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICBwYWRkaW5nOiA1MHB4IDk1cHg7XG4gIH1cblxuICAmLS1kaXN0dXJiZXIge1xuICAgIG1hcmdpbi10b3A6IDgwcHg7XG4gIH1cblxuICBoMSB7XG4gICAgbWFyZ2luLWJvdHRvbTogMC42MjVyZW07XG4gIH1cblxuICBoMyB7XG4gICAgbWFyZ2luLWJvdHRvbTogMS4yNXJlbTtcbiAgfVxuXG4gIHAge1xuICAgIG1hcmdpbi1ib3R0b206IDEuODc1cmVtO1xuICB9XG5cbiAgYSB7XG4gICAgY29sb3I6ICRlcmdvLW1haW47XG4gICAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gIH1cblxuICAuYnRuLXdyYXBwZXIge1xuICAgIGdhcDogMC42MjVyZW07XG4gICAgd2lkdGg6IDEwMCU7XG4gICAgbWluLXdpZHRoOiAzNTBweDtcbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkc20pIHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBmbGV4LWRpcmVjdGlvbjogcm93O1xuICAgICAgZmxleC13cmFwOiB3cmFwO1xuICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgbWFyZ2luOiBhdXRvO1xuICAgIH1cbiAgICA6bGFzdC1jaGlsZCB7XG4gICAgICBtYXJnaW4tYm90dG9tOiAwO1xuICAgIH1cblxuICAgIC5jb250ZW50LXRleHRfX3dyYXBwZXIge1xuICAgICAgcGFkZGluZzogMDtcblxuICAgICAgLmRpc3R1cmJlciB7XG4gICAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgICAgdG9wOiAtMTAwcHg7XG4gICAgICAgIHJpZ2h0OiA1JTtcblxuICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgICAgICB0b3A6IC0xMzBweDtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cblxuICAgIC5zZWFsLXBsYWNlaG9sZGVyIHtcbiAgICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgIGZsZXgtYmFzaXM6IDEwMCU7XG4gICAgfVxuXG4gICAgLm1hZ2ljLXRleHQge1xuICAgICAgbWFyZ2luOiAwO1xuXG4gICAgICBwIHtcbiAgICAgICAgbWFyZ2luOiAwO1xuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICBwIHtcbiAgICAgIG1hcmdpbi1ib3R0b206IDIuNXJlbTtcbiAgICB9XG4gIH1cbiAgLmJ0bi13cmFwcGVyID4gZGl2ID4gYnV0dG9uIHtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBtaW4td2lkdGg6IDM1MHB4O1xuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgbWluLXdpZHRoOiBhdXRvO1xuICAgIH1cbiAgfVxuICAuZGlzdHVyYmVyIHtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgdG9wOiAtODVweDtcbiAgICByaWdodDogNSU7XG5cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgIHRvcDogLTkwcHg7XG4gICAgfVxuICB9XG59XG4iLCIuY29udGFjdC1hcHBvaW50bWVudCB7XG4gIC0taWNvbi13aWR0aDogNjRweDtcblxuICBtYXJnaW4tYm90dG9tOiAzLjg3NXJlbTtcblxuICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkc20pIHtcbiAgICBtYXJnaW4taW5saW5lOiAzM3B4O1xuICB9XG5cbiAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgLS1pY29uLXdpZHRoOiA4MHB4O1xuXG4gICAgbWFyZ2luLWlubGluZTogMCAzOXB4O1xuICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgfVxuXG4gIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgIC0taWNvbi13aWR0aDogOTZweDtcbiAgICBtYXJnaW4tdG9wOiAxMDBweDtcbiAgICBtYXJnaW4taW5saW5lOiAwIDMycHg7XG4gIH1cblxuICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICBtYXJnaW4taW5saW5lOiAwIDQ1cHg7XG4gIH1cblxuICAuaWNvbiB7XG4gICAgd2lkdGg6IHZhcigtLWljb24td2lkdGgpO1xuICAgIGhlaWdodDogdmFyKC0taWNvbi13aWR0aCk7XG4gIH1cblxuICAub2Zmc2V0LWJ5LWljb24ge1xuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgbWFyZ2luLWxlZnQ6IHZhcigtLWljb24td2lkdGgpO1xuICAgIH1cbiAgfVxuXG4gIC5mb3JtIHtcbiAgICB0ZXh0LWFsaWduOiBsZWZ0O1xuICB9XG5cbiAgJl9fZm9ybS1jb250YWluZXIge1xuICAgIHBhZGRpbmc6IDMwcHggMjZweCA1MHB4O1xuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICBwYWRkaW5nOiAzMHB4IDMwcHggNTBweDtcbiAgICB9XG5cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgIGJvcmRlci1yYWRpdXM6IDAgOHB4IDhweCAwO1xuICAgICAgcGFkZGluZzogMzBweCAzMHB4IDUwcHggNDBweDtcbiAgICB9XG5cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgIHBhZGRpbmc6IDUwcHggMzBweCAzMHB4O1xuICAgIH1cblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICR4bCkge1xuICAgICAgcGFkZGluZzogMS44NzVyZW0gMS44NzVyZW0gMy4xMjVyZW07XG4gICAgfVxuICB9XG5cbiAgJi0tZXhwYW5kZWQgJl9fZm9ybS1jb250YWluZXIge1xuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgcGFkZGluZzogMS44NzVyZW0gMS42MjVyZW0gNi4yNXJlbTtcbiAgICB9XG5cbiAgICAuZGF0YS1wcm90ZWN0aW9uLWNvbnRhaW5lciB7XG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgICAgbWF4LXdpZHRoOiA2NiU7XG4gICAgICB9XG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICAgICAgbWF4LXdpZHRoOiB1bnNldDtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAmX19pY29uLXdyYXBwZXIge1xuICAgIG1hcmdpbi1ib3R0b206IDEuMjVyZW07XG5cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgIG1hcmdpbi1ib3R0b206IDAuNjI1cmVtO1xuICAgIH1cbiAgfVxuXG4gICZfX2NvbnRlbnQtd3JhcHBlciB7XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgICBtYXgtd2lkdGg6IDUyJTtcbiAgICB9XG4gIH1cblxuICBoMiB7XG4gICAgbWFyZ2luLWJvdHRvbTogMS4yNXJlbTtcbiAgfVxuXG4gIC5sZWFkIHtcbiAgICBtYXJnaW4tYm90dG9tOiAxLjI1cmVtO1xuICB9XG5cbiAgJl9fdGVsZXBob25lLWNvbnRhaW5lciB7XG4gICAgbWFyZ2luOiBhdXRvO1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgtMTUlKTtcbiAgICBtYXJnaW4tYm90dG9tOiAtMTUlO1xuICAgIHdpZHRoOiBjYWxjKDEwMCUgLSA1MnB4KTtcbiAgICBib3JkZXItcmFkaXVzOiAxMHB4O1xuICAgIHBhZGRpbmc6IDEuODc1cmVtIDEuMjVyZW07XG5cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkc20pIHtcbiAgICAgIHdpZHRoOiBjYWxjKDEwMCUgLSA2MHB4KTtcbiAgICAgIHBhZGRpbmc6IDEuODc1cmVtO1xuICAgIH1cbiAgfVxuXG4gICZfX3RlbGVwaG9uZS1jb250YWluZXIuYmctZ3JlZW4tLWxpZ2h0IHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkZXJnby1ncmVlbi1saWdodDtcbiAgfVxuXG4gIGg0IHtcbiAgICBtYXJnaW4tYm90dG9tOiAxMHB4O1xuICB9XG5cbiAgaDQ6bGFzdC1vZi10eXBlIHtcbiAgICBtYXJnaW4tYm90dG9tOiAxLjg3NXJlbTtcbiAgfVxuXG4gIC5lcnJvciB7XG4gICAgY29sb3I6ICRlcmdvLXJlZDtcbiAgfVxuXG4gIC5lcnJvcjpsYXN0LW9mLXR5cGUge1xuICAgIG1hcmdpbi1ib3R0b206IDEuODc1cmVtO1xuICB9XG5cbiAgaW5wdXRbdHlwZT0nZW1haWwnXSB7XG4gICAgcGFkZGluZzogMXJlbSAwLjYyNXJlbTtcbiAgICBib3JkZXItcmFkaXVzOiA1cHggNXB4IDAgMDtcbiAgICBtYXJnaW4tYm90dG9tOiAxLjYyNXJlbTtcbiAgICBib3JkZXI6IG5vbmU7XG4gICAgYm9yZGVyLWJvdHRvbTogMnB4IHNvbGlkIGdyYXk7XG4gIH1cblxuICBpbnB1dFt0eXBlPSdlbWFpbCddLmVycm9yIHtcbiAgICBtYXJnaW4tYm90dG9tOiAwO1xuICB9XG5cbiAgaW5wdXRbdHlwZT0nZW1haWwnXS5lcnJvciArIC5lcnJvciB7XG4gICAgbWFyZ2luLWJvdHRvbTogMTNweDtcbiAgfVxuXG4gIC5ub3RpY2Uge1xuICAgIG1hcmdpbi1ib3R0b206IDEuMjVyZW07XG4gICAgcCB7XG4gICAgICBAZXh0ZW5kIC5jMjtcbiAgICB9XG4gICAgYSB7XG4gICAgICBjb2xvcjogJGVyZ28tbWFpbjtcbiAgICAgIGZvbnQtd2VpZ2h0OiBib2xkO1xuICAgIH1cbiAgfVxuXG4gIC5ub3RpY2UtY29udGFpbmVyIHtcbiAgICBtYXJnaW4tbGVmdDogMTBweDtcbiAgICB6LWluZGV4OiAxO1xuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgbWF4LXdpZHRoOiA5MCU7XG4gICAgfVxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICR4bCkge1xuICAgICAgbWF4LXdpZHRoOiA2NSU7XG4gICAgfVxuICB9XG5cbiAgJl9fYXBwb2ludG1lbnQtY3RhIHtcbiAgICBtYXJnaW4tdG9wOiAxLjg3NXJlbTtcbiAgICBtYXJnaW4tYm90dG9tOiAzLjEyNXJlbTtcbiAgICBtYXJnaW4tbGVmdDogMDtcblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgbWFyZ2luLXRvcDogMi41cmVtO1xuICAgIH1cbiAgfVxuXG4gICZfX2FwcG9pbnRtZW50LWN0YVt0eXBlPSdzdWJtaXQnXSB7XG4gICAgbWFyZ2luLWJvdHRvbTogMS44NzVyZW07XG4gIH1cblxuICBoNC5ub3RpY2UtLWVtYWlsLXNlbmQge1xuICAgIG1hcmdpbi1ib3R0b206IDEuODc1cmVtO1xuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgbWF4LXdpZHRoOiA5MCU7XG4gICAgfVxuICB9XG5cbiAgLy8gLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLWlQaG9uZSBzdHlsaW5nXG5cbiAgLm1vYmlsZS1waG9uZSB7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIGRpc3BsYXk6IG5vbmU7XG4gICAgLy8gdG9wOiAtMTUlO1xuICAgIHRvcDogLTg1cHg7XG4gICAgLy8gdHJhbnNsYXRlOiAwIC01MCU7XG4gICAgcmlnaHQ6IC0zMHB4O1xuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgIH1cblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgcmlnaHQ6IC01MHB4O1xuICAgIH1cblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICR4bCkge1xuICAgICAgcmlnaHQ6IC05MHB4O1xuICAgIH1cblxuICAgICZfX2ltYWdlIHtcbiAgICAgIGhlaWdodDogNjM2cHg7XG4gICAgICBtaW4td2lkdGg6IDQ0NXB4O1xuICAgICAgbWF4LXdpZHRoOiA0NDVweDtcbiAgICB9XG5cbiAgICAmX19jb250ZW50IHtcbiAgICAgIHdpZHRoOiAyMjBweDtcbiAgICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgIHRvcDogMjAlO1xuICAgICAgcGFkZGluZzogMCAxMHB4O1xuXG4gICAgICA+IGg0IHtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogMDtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAmX19hdmF0YXIge1xuICAgICAgbWFyZ2luLWJvdHRvbTogMS44NzVyZW07XG4gICAgfVxuICB9XG5cbiAgLy8gJi0tZXhwYW5kZWQgLm1vYmlsZS1waG9uZSB7XG4gIC8vICAgdG9wOiAtMTAlO1xuICAvLyAgIHRyYW5zbGF0ZTogbm9uZTtcbiAgLy8gfVxuXG4gIC5tb2JpbGUtcGhvbmUge1xuICAgIG92ZXJmbG93OiBoaWRkZW47XG4gIH1cblxuICAubW9iaWxlLXBob25lX19jb250ZW50IHtcbiAgICB3aWR0aDogMjIwcHg7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICB0b3A6IDIwJTtcbiAgfVxuXG4gIC5tb2JpbGUtcGhvbmVfX3RleHQge1xuICAgIGZvbnQtc2l6ZTogMTRweDtcbiAgfVxuXG4gIC5tb2JpbGUtcGhvbmVfX2F2YXRhciB7XG4gICAgbWFyZ2luLWJvdHRvbTogMS44NzVyZW07XG4gIH1cblxuICAubW9iaWxlLXBob25lX19pbWFnZSB7XG4gICAgaGVpZ2h0OiA2MzZweDtcbiAgICB3aWR0aDogNDQ1cHg7XG4gICAgLy8gICBoZWlnaHQ6IDU4NXB4O1xuICAgIC8vICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHhsKSB7XG4gICAgLy8gICAgIGhlaWdodDogYXV0bztcbiAgICAvLyAgIH1cbiAgfVxuXG4gIC8vIGlQaG9uZSBiZy1jb2xvciBydWxlc1xuICAkaXBob25lLWJnLWNvbG9yLXBhbGV0dGU6XG4gICAgJ2JnLW9yYW5nZS0tbGlnaHQnICRlcmdvLW9yYW5nZS1saWdodCxcbiAgICAnYmctYmx1ZS0tbGlnaHQnICRlcmdvLWJsdWUtbGlnaHQsXG4gICAgJ2JnLWdyZWVuLS1saWdodCcgJGVyZ28tZ3JlZW4tbGlnaHQsXG4gICAgJ2JnLXZpb2xldC0tbGlnaHQnICRlcmdvLXZpb2xldC1saWdodCxcbiAgICAnYmcteWVsbG93LS1saWdodCcgJGVyZ28teWVsbG93LWxpZ2h0LFxuICAgICdiZy13YXJtZ3JleScgJGVyZ28td2FybWdyZXksXG4gICAgJ2JnLXdhcm1ncmV5LS1saWdodCcgJGVyZ28td2FybWdyZXktbGlnaHQ7XG4gIC8vIGJsb2NrLWNsciA9IHByb3BzLnRlbGVwaG9uZUNvbnRhaW5lckJhY2tncm91bmRDb2xvclxuICBAZWFjaCAkYmxvY2stY2xyLCAkY2hpbGQtY2xyIGluICRpcGhvbmUtYmctY29sb3ItcGFsZXR0ZSB7XG4gICAgLm1vYmlsZS1waG9uZV9faW1hZ2VbZGF0YS1iZy1jb2xvcj0nI3skYmxvY2stY2xyfSddIGcgcGF0aCB7XG4gICAgICBmaWxsOiAkY2hpbGQtY2xyO1xuICAgIH1cbiAgfVxuXG4gIC8vbGlnaHQgYmctY29sb3JzID4+PiBkYXJrIGNhbGwtYnV0dG9uXG4gICRjYWxsLWJ1dHRvbi1jb2xvci1wYWxldHRlOlxuICAgICdiZy1vcmFuZ2UtLWxpZ2h0JyAkZXJnby1vcmFuZ2UtZGFyazEsXG4gICAgJ2JnLWJsdWUtLWxpZ2h0JyAkZXJnby1ibHVlLWRhcmsxLFxuICAgICdiZy1ncmVlbi0tbGlnaHQnICRlcmdvLWdyZWVuLWRhcmsxLFxuICAgICdiZy12aW9sZXQtLWxpZ2h0JyAkZXJnby12aW9sZXQtZGFyazEsXG4gICAgJ2JnLXllbGxvdy0tbGlnaHQnICRlcmdvLXllbGxvdy1kYXJrMSxcbiAgICAnYmctd2FybWdyZXknICRlcmdvLXdoaXRlLFxuICAgICdiZy13YXJtZ3JleS0tbGlnaHQnICRlcmdvLXdoaXRlO1xuICAvLyBibG9jay1jbHIgPSBwcm9wcy50ZWxlcGhvbmVDb250YWluZXJCYWNrZ3JvdW5kQ29sb3JcbiAgQGVhY2ggJGJsb2NrLWNsciwgJGNoaWxkLWNsciBpbiAkY2FsbC1idXR0b24tY29sb3ItcGFsZXR0ZSB7XG4gICAgLm1vYmlsZS1waG9uZV9faW1hZ2VbZGF0YS1iZy1jb2xvcj0nI3skYmxvY2stY2xyfSddIGcgcmVjdFtyeD0nMjguOCddIHtcbiAgICAgIGZpbGw6ICRjaGlsZC1jbHI7XG4gICAgfVxuICB9XG5cbiAgLm1vYmlsZS1waG9uZV9faW1hZ2UgZyBwYXRoOmxhc3Qtb2YtdHlwZSB7XG4gICAgZmlsbDogYmxhY2s7XG4gIH1cblxuICAuZGF0YS1wcm90ZWN0aW9uLWNvbnRhaW5lciB7XG4gICAgbWFyZ2luLXRvcDogMzBweDtcblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgbWFyZ2luLXRvcDogNDBweDtcbiAgICB9XG5cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICAgIG1hcmdpbi10b3A6IDMwcHg7XG4gICAgfVxuICB9XG5cbiAgJi0tc3VjY2Vzczpub3QoJi0tZXhwYW5kZWQpLFxuICAmLS1hcHBvaW50ZWQge1xuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgLS1pY29uLXdpZHRoOiA5NnB4O1xuICAgIH1cblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgLS1pY29uLXdpZHRoOiAxMzVweDtcbiAgICAgIGJvcmRlci1yYWRpdXM6IDAgOHB4IDhweCAwO1xuICAgICAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgICB9XG5cbiAgICAubW9iaWxlLXBob25lLFxuICAgIC5jb250YWN0LWFwcG9pbnRtZW50X190ZWxlcGhvbmUtY29udGFpbmVyIHtcbiAgICAgIGRpc3BsYXk6IG5vbmU7XG4gICAgfVxuXG4gICAgLm9mZnNldC1ieS1pY29uIHtcbiAgICAgIG1hcmdpbi1sZWZ0OiAwO1xuXG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICAgICAgbWFyZ2luLWxlZnQ6IHZhcigtLWljb24td2lkdGgpO1xuICAgICAgfVxuICAgIH1cblxuICAgIC5jb250YWN0LWFwcG9pbnRtZW50X19jb250ZW50LXdyYXBwZXIge1xuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgICAgIG1heC13aWR0aDogNjYlO1xuICAgICAgfVxuXG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICAgICAgbWF4LXdpZHRoOiBjYWxjKDY2JSAtIHZhcigtLWljb24td2lkdGgsIDBweCkpO1xuICAgICAgfVxuICAgIH1cblxuICAgIC5jb250YWN0LWFwcG9pbnRtZW50X19pY29uLXdyYXBwZXIge1xuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgICAgbGVmdDogY2FsYyg2NiUgKyAzMyUgLyAyKTtcbiAgICAgICAgdG9wOiA1MCU7XG4gICAgICAgIHRyYW5zbGF0ZTogLTUwJSAtNTAlO1xuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gICYtLWFwcG9pbnRlZCB7XG4gICAgLmNvbnRhY3QtYXBwb2ludG1lbnRfX2NvbnRlbnQtd3JhcHBlciB7XG4gICAgICBtYXgtd2lkdGg6IHVuc2V0O1xuXG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgICAgbWF4LXdpZHRoOiA2NiU7XG4gICAgICB9XG4gICAgfVxuXG4gICAgLmNvbnRhY3QtYXBwb2ludG1lbnRfX2Zvcm0tY29udGFpbmVyIHtcbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgICBib3JkZXItcmFkaXVzOiAwIDhweCA4cHggMDtcbiAgICAgICAgcGFkZGluZzogMzBweCAzMHB4IDEwcHggNDBweDtcbiAgICAgIH1cblxuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICAgIHBhZGRpbmc6IDUwcHggMzBweCAzMHB4O1xuICAgICAgfVxuICAgIH1cbiAgfVxufVxuIiwiLmNvbnRlbnQtY29sb3JwbGFuZSB7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgJl9faW1hZ2Uge1xuICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICBoZWlnaHQ6IDIyMHB4O1xuICAgIHBhZGRpbmc6IDAgMi42MjVyZW07XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICBoZWlnaHQ6IDMwMHB4O1xuICAgICAgcGFkZGluZzogMCAxNnB4O1xuICAgIH1cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgIGhlaWdodDogMzUwcHg7XG4gICAgfVxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgd2lkdGg6IDUwJTtcbiAgICB9XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHhsKSB7XG4gICAgICBtaW4taGVpZ2h0OiA0MDBweDtcbiAgICB9XG5cbiAgICBpbWcge1xuICAgICAgb2JqZWN0LWZpdDogY292ZXI7XG4gICAgICBib3JkZXItcmFkaXVzOiAwLjVyZW07XG4gICAgfVxuICAgIC5kaXN0dXJiZXIge1xuICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgcmlnaHQ6IDMwcHg7XG4gICAgICBib3R0b206IC0yMHB4O1xuICAgICAgei1pbmRleDogMTtcbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgICByaWdodDogMzBweDtcbiAgICAgICAgdG9wOiAtMzBweDtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAmLWNvbG9yLWJveCB7XG4gICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICB0b3A6IDEwMHB4O1xuICAgICAgYm90dG9tOiAwO1xuICAgICAgbGVmdDogLTIwMHB4O1xuICAgICAgcmlnaHQ6IC0yMDBweDtcbiAgICAgIHdpZHRoOiBhdXRvO1xuICAgICAgei1pbmRleDogLTE7XG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgICAgdG9wOiAxMjBweDtcbiAgICAgIH1cbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgICBoZWlnaHQ6IDU1MHB4O1xuICAgICAgICB0b3A6IC0xMDBweDtcbiAgICAgICAgcmlnaHQ6IDEyMHB4O1xuICAgICAgICBsZWZ0OiAtMTAwJTtcbiAgICAgIH1cbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICR4bCkge1xuICAgICAgICBoZWlnaHQ6IDUwMHB4O1xuICAgICAgICB0b3A6IC01MHB4O1xuICAgICAgICByaWdodDogMTIwcHg7XG4gICAgICB9XG4gICAgfVxuICAgIC5iZy1mdWxsIHtcbiAgICAgIHRvcDogMDtcbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgICB0b3A6IC0xMDBweDtcbiAgICAgIH1cbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICR4bCkge1xuICAgICAgICB0b3A6IC01MHB4O1xuICAgICAgfVxuICAgICAgKyBpbWcge1xuICAgICAgICBvYmplY3QtZml0OiBjb250YWluO1xuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gICZfX3RleHQge1xuICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICB6LWluZGV4OiAwO1xuXG4gICAgJi13cmFwcGVyIHtcbiAgICAgIHBhZGRpbmc6IDAgMS42MjVyZW07XG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkc20pIHtcbiAgICAgICAgcGFkZGluZzogMDtcbiAgICAgIH1cblxuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICAgIC5jb250ZW50LWxpc3RfX3dyYXBwZXIge1xuICAgICAgICAgIC5jb250ZW50LWxpc3Qge1xuICAgICAgICAgICAgdWwsXG4gICAgICAgICAgICBvbCB7XG4gICAgICAgICAgICAgIGdyaWQtdGVtcGxhdGUtY29sdW1uczogcmVwZWF0KDEsIDFmcik7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICB9XG5cbiAgICAgIC5tYWdpYy10ZXh0IHtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogMDtcblxuICAgICAgICBzcGFuIHtcbiAgICAgICAgICBsaW5lLWhlaWdodDogMS40ZW07XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG5cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgIHBhZGRpbmc6IDA7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgICAgbWluLWhlaWdodDogNTUwcHg7XG4gICAgfVxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICR4bCkge1xuICAgICAgbWluLWhlaWdodDogNTAwcHg7XG4gICAgICBwYWRkaW5nLXJpZ2h0OiA0MHB4O1xuICAgIH1cblxuICAgICYtY29sb3ItYm94IHtcbiAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgIHRvcDogMDtcbiAgICAgIGJvdHRvbTogMDtcbiAgICAgIHJpZ2h0OiAtMjAwcHg7XG4gICAgICBsZWZ0OiAtMjAwcHg7XG4gICAgICB3aWR0aDogYXV0bztcbiAgICAgIHotaW5kZXg6IC0xO1xuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICAgIGRpc3BsYXk6IG5vbmU7XG4gICAgICB9XG4gICAgfVxuXG4gICAgLmNvbnRlbnQtdGV4dF9fd3JhcHBlciB7XG4gICAgICBwYWRkaW5nOiAxLjg3NXJlbSAwO1xuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgICAgIHBhZGRpbmc6IDMuMTI1cmVtIDA7XG4gICAgICB9XG5cbiAgICAgIC5jb250ZW50LXRleHRfX3JlZC1zdGlja2VyIHtcbiAgICAgICAgcmlnaHQ6IDEuNXJlbTtcbiAgICAgICAgdG9wOiAtNXJlbTtcblxuICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgICAgICByaWdodDogMHJlbTtcbiAgICAgICAgICB0b3A6IC0yLjI1cmVtO1xuICAgICAgICB9XG4gICAgICB9XG4gICAgICAuY29udGVudC1saXN0Omxhc3QtY2hpbGQge1xuICAgICAgICBtYXJnaW4tYm90dG9tOiAwO1xuICAgICAgfVxuICAgIH1cbiAgfVxuICAuY29udGVudC1saXN0X193cmFwcGVyIHtcbiAgICAuY29udGVudC1saXN0X19oZWFkbGluZSB7XG4gICAgICBoMiB7XG4gICAgICAgIHRleHQtYWxpZ246IGxlZnQ7XG4gICAgICAgIGZvbnQtc2l6ZTogMS4xMjVyZW07XG4gICAgICAgIGxpbmUtaGVpZ2h0OiAxLjc1cmVtO1xuICAgICAgICBmb250LXdlaWdodDogYm9sZDtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogMXJlbTtcblxuICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiA3NjhweCkge1xuICAgICAgICAgIGZvbnQtc2l6ZTogMS4yNXJlbTtcbiAgICAgICAgfVxuXG4gICAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6IDEyMDBweCkge1xuICAgICAgICAgIGZvbnQtc2l6ZTogMS41cmVtO1xuICAgICAgICB9XG4gICAgICB9XG5cbiAgICAgIC5jb250ZW50LWxpc3RfX3RleHQge1xuICAgICAgICB0ZXh0LWFsaWduOiBsZWZ0O1xuICAgICAgfVxuICAgIH1cbiAgICAuY29udGVudC1saXN0X19pdGVtcyB7XG4gICAgICAubWFnaWMtdGV4dCB7XG4gICAgICAgIGdyaWQtY29sdW1uOiAxIC8gLTE7XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgLmJ0biB7XG4gICAgbWFyZ2luOiAwO1xuICB9XG5cbiAgLy8gSUYgSU1BR0UgTEVGVCBTSURFXG4gIC5mbGV3LXJvdyB7XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICAuY29udGVudC10ZXh0X193cmFwcGVyIC5kaXN0dXJiZXIge1xuICAgICAgICB0b3A6IDUwcHg7XG4gICAgICAgIGxlZnQ6IC0zMCU7XG4gICAgICB9XG4gICAgfVxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICR4bCkge1xuICAgICAgLmNvbnRlbnQtdGV4dF9fd3JhcHBlciAuZGlzdHVyYmVyIHtcbiAgICAgICAgdG9wOiA1JTtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAvLyBJRiBJTUFHRSBSSUdIVCBTSURFXG4gIC5mbGV4LXJvdy1yZXZlcnNlIHtcbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgIC5jb250ZW50LWNvbG9ycGxhbmVfX2ltYWdlIHtcbiAgICAgICAgcGFkZGluZy1yaWdodDogMzBweDtcbiAgICAgICAgcGFkZGluZy1sZWZ0OiAzMHB4O1xuXG4gICAgICAgICYtY29sb3ItYm94IHtcbiAgICAgICAgICByaWdodDogLTIwMCU7XG4gICAgICAgICAgbGVmdDogMTIwcHg7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICAgIC5jb250ZW50LWNvbG9ycGxhbmVfX3RleHQge1xuICAgICAgICBwYWRkaW5nLWxlZnQ6IDQwcHg7XG4gICAgICB9XG4gICAgfVxuICB9XG59XG4iLCIubWFpbi1jb250YWluZXItLWhhc1N0aWNreSB7XG4gIC5mb290ZXJfX2JhciB7XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1heC13aWR0aDogJGxnKSB7XG4gICAgICBwYWRkaW5nLXRvcDogMjRweDtcbiAgICAgIHBhZGRpbmctYm90dG9tOiAxMTJweDtcbiAgICB9XG4gIH1cbn1cblxuLmZvb3RlciB7XG4gICZfX2Rpc2NsYWltZXIge1xuICAgIG1hcmdpbi1ib3R0b206IDEuODc1cmVtO1xuICAgIC8vIGJhY2tncm91bmQtY29sb3I6ICRlcmdvLXdhcm1ncmV5LWxpZ2h0O1xuICAgIHBhZGRpbmc6IDEuODc1cmVtIDEuNjI1cmVtO1xuICAgIHNwYW4ge1xuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICAgIHBhZGRpbmc6IDA7XG4gICAgICB9XG4gICAgfVxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgbWFyZ2luLWJvdHRvbTogMy4xMjVyZW07XG4gICAgfVxuICAgIC5jMyB7XG4gICAgICBwIHtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogMDtcbiAgICAgICAgZm9udC1zaXplOiBpbmhlcml0O1xuICAgICAgICBhIHtcbiAgICAgICAgICBjb2xvcjogJGVyZ28tbWFpbjtcbiAgICAgICAgICBmb250LXdlaWdodDogNzAwO1xuICAgICAgICAgIFxuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICB9XG4gICZfX2NvbnRhY3Qge1xuICAgIG1hcmdpbi1ib3R0b206IDEuODc1cmVtO1xuICAgICYtd3JhcHBlciB7XG4gICAgICBwYWRkaW5nOiAxLjg3NXJlbSAxLjYyNXJlbTtcbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRzbSkge1xuICAgICAgICBwYWRkaW5nOiBpbml0aWFsO1xuICAgICAgfVxuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICAgIHBhZGRpbmctbGVmdDogMTZweDtcbiAgICAgIH1cbiAgICB9XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICBwYWRkaW5nOiAwIDQ1cHg7XG4gICAgfVxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgbWFyZ2luLWJvdHRvbTogMy4xMjVyZW07XG4gICAgfVxuICAgICYtaGVhZGxpbmUge1xuICAgICAgY29sb3I6ICRlcmdvLW1haW47XG4gICAgICBtYXJnaW4tYm90dG9tOiAxLjg3NXJlbTtcbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgICBtYXJnaW4tYm90dG9tOiAxLjI1cmVtO1xuICAgICAgfVxuICAgICAgcCB7XG4gICAgICAgIGZvbnQtd2VpZ2h0OiA3MDA7XG4gICAgICB9XG4gICAgfVxuICAgIHAge1xuICAgICAgbWFyZ2luLWJvdHRvbTogMDtcbiAgICB9XG4gICAgLnJvdyB7XG4gICAgICBnYXA6IDEuODc1cmVtO1xuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgICAgIGdhcDogMDtcbiAgICAgIH1cbiAgICB9XG4gIH1cbiAgJl9fYmFyIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgZmxleC13cmFwOiB3cmFwO1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIG1pbi1oZWlnaHQ6IDU4cHg7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgIGJhY2tncm91bmQtY29sb3I6IHJnYmEoMjE3LCAyMTMsIDE5OSwgMC4zKTtcbiAgICBjb2xvcjogJGVyZ28tYmxhY2s7XG4gICAgcGFkZGluZzogNnB4IDA7XG5cbiAgICAmLS13aGVuLXN0aWNreS1jdGEtaXMtdGhlcmUge1xuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1heC13aWR0aDogJGxnKSB7XG4gICAgICAgIHBhZGRpbmctdG9wOiAyNHB4O1xuICAgICAgICBwYWRkaW5nLWJvdHRvbTogMTEycHg7XG4gICAgICB9XG4gICAgfVxuICAgIGEge1xuICAgICAgY29sb3I6ICRlcmdvLWJsYWNrO1xuICAgIH1cbiAgICAqOm5vdCg6bGFzdC1jaGlsZCk6YWZ0ZXIge1xuICAgICAgY29udGVudDogJ3wnO1xuICAgICAgbWFyZ2luOiAwIDAuMzEyNXJlbTtcbiAgICB9XG4gIH1cbn1cbiIsIi5zdGFnZSB7XG4gICZfX2NvbnRlbnQge1xuICAgICYtdmlkZW8ge1xuICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgYm90dG9tOiAyMHB4O1xuICAgICAgbGVmdDogMjBweDtcbiAgICAgIHdpZHRoOiAxMDBweDtcbiAgICAgIGhlaWdodDogMTAwcHg7XG4gICAgICBjdXJzb3I6IHBvaW50ZXI7XG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkc20pIHtcbiAgICAgICAgd2lkdGg6IDE1MHB4O1xuICAgICAgICBoZWlnaHQ6IDE1MHB4O1xuICAgICAgICBib3R0b206IDMwcHg7XG4gICAgICAgIGxlZnQ6IDMwcHg7XG4gICAgICB9XG4gICAgICBzdmcge1xuICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgaGVpZ2h0OiAxMDAlO1xuICAgICAgfVxuICAgICAgc3ZnIHBhdGgge1xuICAgICAgICB0cmFuc2l0aW9uOiBmaWxsIDAuNXMgZWFzZTtcbiAgICAgIH1cbiAgICAgICY6Zm9jdXMsXG4gICAgICAmOmhvdmVyIHtcbiAgICAgICAgc3ZnID4gcGF0aDpudGgtb2YtdHlwZSgxKSB7XG4gICAgICAgICAgZmlsbDogJGVyZ28td2hpdGU7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG4gICAgJi1ibG9ja3Mge1xuICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgICBnYXA6IDIwcHg7XG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICAgICAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgICAgIH1cbiAgICB9XG4gICAgJi10ZXh0LXdyYXBwZXIge1xuICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICAgIGJhY2tncm91bmQtc2l6ZTogY292ZXI7XG4gICAgICBwYWRkaW5nOiAxLjg3NXJlbSAxLjYyNXJlbTtcblxuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICAgIHBhZGRpbmc6IDEuODc1cmVtO1xuICAgICAgfVxuXG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgICAgcGFkZGluZzogMy43NXJlbTtcbiAgICAgIH1cblxuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICAgIGhlaWdodDogMTAwJTtcbiAgICAgICAgbWluLWhlaWdodDogNTAwcHg7XG4gICAgICAgIHBhZGRpbmc6IDMuNzVyZW0gMi41cmVtO1xuICAgICAgfVxuXG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICAgICAgcGFkZGluZzogNXJlbSAzLjc1cmVtO1xuICAgICAgICBtYXgtd2lkdGg6IDk5MHB4O1xuICAgICAgfVxuXG4gICAgICAuaDEge1xuICAgICAgICBmb250LXdlaWdodDogNTAwO1xuICAgICAgICBtYXJnaW4tYm90dG9tOiAwLjYyNXJlbTtcbiAgICAgIH1cblxuICAgICAgLmxlYWQge1xuICAgICAgICBtYXJnaW4tYm90dG9tOiAxLjI1cmVtO1xuICAgICAgfVxuXG4gICAgICAuaDQge1xuICAgICAgICBtYXJnaW4tYm90dG9tOiAxLjI1cmVtO1xuICAgICAgfVxuXG4gICAgICAuYzEge1xuICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgICAgICBtYXJnaW4tYm90dG9tOiAyLjVyZW07XG4gICAgICAgIH1cbiAgICAgIH1cblxuICAgICAgLmJ0biB7XG4gICAgICAgIG1hcmdpbjogMDtcblxuICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgICAgICBtYXgtd2lkdGg6IHVuc2V0O1xuICAgICAgICB9XG4gICAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgICAgIG1heC13aWR0aDogZml0LWNvbnRlbnQ7XG4gICAgICAgIH1cbiAgICAgIH1cblxuICAgICAgLmJ0bi5zdGlja3kge1xuICAgICAgICB3aWR0aDogOTB2dztcbiAgICAgICAgbWF4LXdpZHRoOiAxMDAlO1xuICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgICBtaW4td2lkdGg6IDI1MHB4O1xuICAgICAgICB9XG4gICAgICB9XG5cbiAgICAgIC5yZWFkLW1vcmUtbGluayB7XG4gICAgICAgIG1hcmdpbjogMCBhdXRvO1xuXG4gICAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgICAgIG1hcmdpbi10b3A6IDIwcHg7XG4gICAgICAgIH1cbiAgICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHhsKSB7XG4gICAgICAgICAgbWFyZ2luOiBhdXRvO1xuICAgICAgICAgIG1hcmdpbi10b3A6IDMwcHg7XG4gICAgICAgIH1cbiAgICAgIH1cblxuICAgICAgLmNvbnRlbnQtbGlzdC1pY29uIHtcbiAgICAgICAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgICAgICAgZ2FwOiA4cHg7XG5cbiAgICAgICAgJl9faWNvbiB7XG4gICAgICAgICAgbWFyZ2luOiAwO1xuICAgICAgICAgIHBhZGRpbmc6IDAuMjVyZW07XG4gICAgICAgICAgbWF4LXdpZHRoOiAzMnB4O1xuICAgICAgICAgIG1heC1oZWlnaHQ6IDMycHg7XG4gICAgICAgICAgd2lkdGg6IDMycHg7XG4gICAgICAgICAgaGVpZ2h0OiAzMnB4O1xuICAgICAgICAgIG1pbi13aWR0aDogMzJweDtcbiAgICAgICAgICBtaW4taGVpZ2h0OiAzMnB4O1xuICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICAgICYtaW1hZ2Utd3JhcHBlciB7XG4gICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICBwYWRkaW5nOiAwO1xuICAgICAgaGVpZ2h0OiAyMjBweDtcblxuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICAgIGhlaWdodDogMzAwcHg7XG4gICAgICB9XG5cbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgICBoZWlnaHQ6IDM1MHB4O1xuICAgICAgfVxuXG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgICAgbWF4LWhlaWdodDogaW5oZXJpdDtcbiAgICAgICAgaGVpZ2h0OiBhdXRvO1xuICAgICAgICBtaW4taGVpZ2h0OiA1MDBweDtcbiAgICAgIH1cblxuICAgICAgaW1nIHtcbiAgICAgICAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgICAgICAgLW8tb2JqZWN0LWZpdDogY292ZXI7XG4gICAgICAgIG9iamVjdC1maXQ6IGNvdmVyO1xuICAgICAgICBoZWlnaHQ6IDEwMCU7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgfVxuICAgICAgLmRpc3R1cmJlciB7XG4gICAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgICAgcmlnaHQ6IDMwcHg7XG4gICAgICAgIGJvdHRvbTogLTIwcHg7XG4gICAgICAgIHotaW5kZXg6IDE7XG4gICAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgICAgIHJpZ2h0OiAtMjBweDtcbiAgICAgICAgICB0b3A6IDIwcHg7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG4gIH1cbn1cbiIsIi5jb250ZW50LWNvbXBvc2l0aW9uIHtcbiAgJHNlbGY6ICY7XG4gIGRpc3BsYXk6IGdyaWQ7XG4gIC0tZ3V0dGVyLXdpZHRoOiAyNnB4O1xuICAtLW92ZXJsYXA6IDE4MHB4O1xuICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IHZhcigtLWd1dHRlci13aWR0aCkgMWZyIHZhcigtLWd1dHRlci13aWR0aCk7XG4gIGdyaWQtdGVtcGxhdGUtcm93czogYXV0byB2YXIoLS1vdmVybGFwKSBhdXRvO1xuXG4gICZfX2hlYWRpbmcge1xuICAgIG1hcmdpbi1ib3R0b206IDEuMjVyZW07XG5cbiAgICAubGVhZCB7XG4gICAgICBwYWRkaW5nLXRvcDogMC42MjVyZW07XG4gICAgfVxuICB9XG5cbiAgLmMyID4gcCB7XG4gICAgZm9udC1zaXplOiBpbmhlcml0OyAvLyB1c2UgLmMyIHN0eWxlc1xuXG4gICAgJjpsYXN0LWNoaWxkIHtcbiAgICAgIG1hcmdpbi1ib3R0b206IDA7XG4gICAgfVxuICB9XG5cbiAgJi1pY29uIHtcbiAgICB3aWR0aDogNjRweDtcbiAgICBoZWlnaHQ6IDY0cHg7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogJGVyZ28td2hpdGU7XG4gICAgcGFkZGluZzogMC41cmVtO1xuICAgIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgICBtYXJnaW46IDAgYXV0byAxLjg3NXJlbSBhdXRvO1xuICB9XG5cbiAgJl9fYmlnIHtcbiAgICBncmlkLWNvbHVtbjogMSAvIC0xO1xuICAgIGdyaWQtcm93OiAxIC8gMztcbiAgICBwYWRkaW5nLWlubGluZTogdmFyKC0tZ3V0dGVyLXdpZHRoKTtcbiAgICBwYWRkaW5nLWJsb2NrOiAzMHB4IDE4MHB4O1xuXG4gICAgJi1saXN0IHtcbiAgICAgIHBhZGRpbmctdG9wOiAxLjg3NXJlbTtcbiAgICB9XG5cbiAgICAmLW91dHJvVGV4dCB7XG4gICAgICBwYWRkaW5nLWJsb2NrOiA0MHB4IDMwcHg7XG4gICAgfVxuICB9XG5cbiAgJl9faGlnaGxpZ2h0IHtcbiAgICBncmlkLWNvbHVtbjogMjtcbiAgICBncmlkLXJvdzogMiAvIDQ7XG5cbiAgICBkaXNwbGF5OiBncmlkO1xuICAgIGdyaWQtdGVtcGxhdGUtcm93czogYXV0byAyMHB4IGF1dG87XG5cbiAgICAmLWltZyB7XG4gICAgICB3aWR0aDogZml0LWNvbnRlbnQ7XG4gICAgICBtYXJnaW46IDE1cHggYXV0bztcbiAgICB9XG5cbiAgICAmLWNvbnRlbnQge1xuICAgICAgYm9yZGVyLXJhZGl1czogOHB4O1xuICAgICAgcGFkZGluZzogMzBweDtcbiAgICAgIGdyaWQtY29sdW1uOiAxO1xuICAgICAgZ3JpZC1yb3c6IDIgLyA0O1xuICAgIH1cblxuICAgICYtZGlzdHVyYmVyIHtcbiAgICAgIGdyaWQtcm93OiAxIC8gMztcbiAgICAgIGdyaWQtY29sdW1uOiAxO1xuICAgICAganVzdGlmeS1zZWxmOiBmbGV4LWVuZDtcbiAgICAgIHotaW5kZXg6IDE7XG4gICAgICBtYXJnaW4taW5saW5lLWVuZDogMjBweDtcblxuICAgICAgaW1nIHtcbiAgICAgICAgb2JqZWN0LWZpdDogY292ZXI7XG4gICAgICB9XG4gICAgfVxuXG4gICAgaDUsXG4gICAgaDIsXG4gICAgaDMge1xuICAgICAgbWFyZ2luLWJvdHRvbTogMS4yNXJlbTtcbiAgICB9XG5cbiAgICAuY29udGVudC1saXN0IHtcbiAgICAgIHBhZGRpbmctdG9wOiAxLjg3NXJlbTtcbiAgICB9XG5cbiAgICAvLyBIQUNLIGVudHdlZGVyIGRhcyBTaWVnZWwgd2lyZCBmZXN0ZXIgVGVpbCBkaWVzZXMgTW9kdWxzIG9kZXIgd2lyIHNvbGx0ZW4gZWluaGVpdGxpY2hlIFN0eWxlcyBmw7xyIGRpZSBFaW5iZXR0dW5nIHZvbiBTaWVnZWxuIGRlZmluaWVyZW5cbiAgICAuc2VhbC1wbGFjZWhvbGRlciB7XG4gICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICAgIG1hcmdpbi10b3A6IDEuMjVyZW07XG4gICAgICBtYXJnaW4tYm90dG9tOiAwO1xuICAgIH1cbiAgICBcbiAgICAuYnRuIHtcbiAgICAgIG1hcmdpbi10b3A6IDEuODc1cmVtO1xuICAgIH1cbiAgfVxuXG4gIC5jb250ZW50LWxpc3QtaWNvbl9fdGV4dF9faGVhZGxpbmUge1xuICAgIHRleHQtYWxpZ246IGxlZnQ7XG4gIH1cblxuICAuY29udGVudC1saXN0LWljb24tLWFsaWduZWQtbGVmdCB7XG4gICAgbWFyZ2luLWJvdHRvbTogMS4yNXJlbTtcbiAgICBnYXA6IDFyZW07XG4gICAgLmNvbnRlbnQtbGlzdC1pY29uX19pY29uIHtcbiAgICAgIGFsaWduLXNlbGY6IGNlbnRlcjtcbiAgICAgIHBhZGRpbmc6IDAuMjVyZW07XG4gICAgICBtYXJnaW46IDA7XG4gICAgICB3aWR0aDogMzJweDtcbiAgICAgIGhlaWdodDogMzJweDtcbiAgICAgIG1pbi13aWR0aDogMzJweDtcbiAgICAgIG1pbi1oZWlnaHQ6IDMycHg7XG4gICAgICBtYXgtd2lkdGg6IDMycHg7XG4gICAgICBtYXgtaGVpZ2h0OiAzMnB4O1xuICAgICAgPiBpbWcge1xuICAgICAgICB2ZXJ0aWNhbC1hbGlnbjogYmFzZWxpbmU7XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgLS1vdmVybGFwOiA1MHB4O1xuICAgIC0taGlnaGxpZ2h0LXdpZHRoOiAzNzBweDtcblxuICAgIGdyaWQtdGVtcGxhdGUtY29sdW1uczpcbiAgICAgIGF1dG9cbiAgICAgIHZhcigtLW92ZXJsYXApXG4gICAgICBjYWxjKHZhcigtLWhpZ2hsaWdodC13aWR0aCkgLSB2YXIoLS1vdmVybGFwKSk7XG4gICAgZ3JpZC10ZW1wbGF0ZS1yb3dzOiBhdXRvO1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG5cbiAgICAmX19iaWcge1xuICAgICAgZ3JpZC1yb3c6IDE7XG4gICAgICBncmlkLWNvbHVtbjogMSAvIDM7XG4gICAgICBwYWRkaW5nLWJsb2NrOiA1MHB4O1xuICAgICAgcGFkZGluZy1pbmxpbmU6IDUwcHggY2FsYyg1MHB4ICsgdmFyKC0tb3ZlcmxhcCkpO1xuICAgICAgYm9yZGVyLXJhZGl1czogOHB4O1xuICAgIH1cblxuICAgICZfX2hpZ2hsaWdodCB7XG4gICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICBncmlkLXJvdzogMTtcbiAgICAgIGdyaWQtY29sdW1uOiAyIC8gNDtcblxuICAgICAgJi1jb250ZW50IHtcbiAgICAgICAgcGFkZGluZzogNTBweCAzMHB4O1xuICAgICAgfVxuXG4gICAgICAmLWRpc3R1cmJlciB7XG4gICAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgICAgdG9wOiAyMHB4O1xuICAgICAgICB0cmFuc2xhdGU6IDAgLTEwMCU7XG4gICAgICB9XG5cbiAgICAgIC5zZWFsLXBsYWNlaG9sZGVyIHtcbiAgICAgICAgbWFyZ2luLXRvcDogMi41cmVtO1xuICAgICAgfVxuICAgICAgYS5idG4ge1xuICAgICAgICBtYXJnaW4tdG9wOiAyLjVyZW07XG4gICAgICB9XG4gICAgfVxuXG4gICAgJi0tYmlnUmlnaHQge1xuICAgICAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOlxuICAgICAgICBjYWxjKHZhcigtLWhpZ2hsaWdodC13aWR0aCkgLSB2YXIoLS1vdmVybGFwKSlcbiAgICAgICAgdmFyKC0tb3ZlcmxhcClcbiAgICAgICAgYXV0bztcblxuICAgICAgI3skc2VsZn1fX2JpZyB7XG4gICAgICAgIGdyaWQtY29sdW1uOiAyIC8gNDtcbiAgICAgICAgcGFkZGluZy1pbmxpbmU6IGNhbGMoNTBweCArIHZhcigtLW92ZXJsYXApKSA1MHB4O1xuICAgICAgfVxuICAgICAgI3skc2VsZn1fX2hpZ2hsaWdodCB7XG4gICAgICAgIGdyaWQtY29sdW1uOiAxIC8gMztcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICAtLWhpZ2hsaWdodC13aWR0aDogNDQ1cHg7XG4gICAgLS1vdmVybGFwOiA2NXB4O1xuXG4gICAgJl9faGlnaGxpZ2h0IHtcbiAgICAgICYtY29udGVudCB7XG4gICAgICAgIHBhZGRpbmc6IDUwcHg7XG4gICAgICB9XG4gICAgfVxuICB9XG59XG4iLCIuY29udGVudC1jYXJkIHtcbiAgJl9faWNvbiB7XG4gICAgaGVpZ2h0OiAxMjZweDtcbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgIGhlaWdodDogMTc2cHg7XG4gICAgfVxuICB9XG5cbiAgJl9fY29udGVudCB7XG4gICAgcGFkZGluZzogMS44NzVyZW0gMS42MjVyZW07XG5cbiAgICAmLWNvbnRhaW5lciB7XG4gICAgICBib3JkZXItcmFkaXVzOiAwIDAgOHB4IDhweDtcblxuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgICAgICBAaW5jbHVkZSBib3JkZXItbGctcmFkaXVzO1xuICAgICAgfVxuICAgIH1cblxuICAgIC5idG4ge1xuICAgICAgbWFyZ2luOiAwO1xuICAgIH1cbiAgfVxuXG4gICZfX2hlYWRsaW5lIHtcbiAgICBtYXJnaW4tYm90dG9tOiAwLjYyNXJlbTtcbiAgfVxuXG4gICZfX3N1Yi1oZWFkbGluZSB7XG4gICAgbWFyZ2luLWJvdHRvbTogMS4yNXJlbTtcbiAgICBmb250LXdlaWdodDogbm9ybWFsO1xuICB9XG5cbiAgJl9fdGV4dCB7XG4gICAgbWFyZ2luLWJvdHRvbTogMDtcblxuICAgIH4gLmJ0biB7XG4gICAgICBtYXJnaW4tdG9wOiAxLjg3NXJlbTtcblxuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICAgIG1hcmdpbi10b3A6IDIuNXJlbTtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAuZGlzdHVyYmVyIHtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgdG9wOiBjYWxjKDEwMCUgKyAxMHB4KTtcbiAgICB0cmFuc2xhdGU6IDAgLTEwMCU7XG5cbiAgICAmLS1pbWFnZS1yaWdodCxcbiAgICAmLS1pbWFnZS1sZWZ0IHtcbiAgICAgIHJpZ2h0OiA1JTtcbiAgICB9XG5cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgIHRvcDogY2FsYygxMDAlICsgMjBweCk7XG4gICAgfVxuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICAmLS1pbWFnZS1yaWdodCB7XG4gICAgICAgIHJpZ2h0OiA3Mi41JTtcbiAgICAgIH1cblxuICAgICAgJi0taW1hZ2UtbGVmdCB7XG4gICAgICAgIGxlZnQ6IDcyLjUlO1xuICAgICAgfVxuICAgICAgdHJhbnNsYXRlOiAwIDA7XG4gICAgICB0b3A6IDIwcHg7XG4gICAgfVxuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHhsKSB7XG4gICAgICAmLS1pbWFnZS1yaWdodCB7XG4gICAgICAgIHJpZ2h0OiA4MCU7XG4gICAgICB9XG5cbiAgICAgICYtLWltYWdlLWxlZnQge1xuICAgICAgICBsZWZ0OiA4MCU7XG4gICAgICB9XG4gICAgfVxuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHh4bCkge1xuICAgICAgJi0taW1hZ2UtcmlnaHQge1xuICAgICAgICByaWdodDogODUlO1xuICAgICAgfVxuXG4gICAgICAmLS1pbWFnZS1sZWZ0IHtcbiAgICAgICAgbGVmdDogODUlO1xuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gIGJ1dHRvbiB7XG4gICAgbWFyZ2luLWxlZnQ6IDA7XG4gIH1cblxuICAmX19pbWFnZS1jb250YWluZXIge1xuICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICBoZWlnaHQ6IDIyMHB4O1xuICAgIHBhZGRpbmctbGVmdDogMDtcbiAgICBwYWRkaW5nLXJpZ2h0OiAwO1xuICAgIGJvcmRlci1yYWRpdXM6IDhweCA4cHggMCAwO1xuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICBoZWlnaHQ6IDMwMHB4O1xuICAgIH1cblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgaGVpZ2h0OiAzNTBweDtcbiAgICB9XG5cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgIGhlaWdodDogYXV0bztcbiAgICAgIEBpbmNsdWRlIGJvcmRlci1sZy1yYWRpdXM7XG4gICAgfVxuICB9XG5cbiAgJl9faW1hZ2Uge1xuICAgIG9iamVjdC1maXQ6IGNvdmVyO1xuICAgIGJvcmRlci1yYWRpdXM6IDhweCA4cHggMCAwO1xuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICBAaW5jbHVkZSBib3JkZXItbGctcmFkaXVzO1xuICAgIH1cbiAgICAmLS1iaWcge1xuICAgICAgaGVpZ2h0OiAzMjBweDtcblxuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICAgIGhlaWdodDogMzAwcHg7XG4gICAgICB9XG5cbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgICBoZWlnaHQ6IDM1MHB4O1xuICAgICAgfVxuICAgIH1cblxuICAgICYtLWxldHRlcmJveGVkIHtcbiAgICAgIG9iamVjdC1maXQ6IGNvbnRhaW47XG5cbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICR4bCkge1xuICAgICAgICBwYWRkaW5nOiAxcmVtO1xuICAgICAgfVxuXG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICAgICAgcGFkZGluZzogMS41cmVtO1xuICAgICAgfVxuXG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICAgICAgcGFkZGluZzogMnJlbTtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAmX19ncmFwaGljIHtcbiAgICB3aWR0aDogNzAlO1xuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgd2lkdGg6IDEwMCU7XG4gICAgfVxuICB9XG59XG5cbi8vIEludmVyc2UgY29sb3JzIG9mIHRleHQgYW5kIGJ1dHRvbnMgaWYgYmctY29sb3IgaXMgXCJkYXJrM1wiXG4kZGFyazMtcGFsZXR0ZTpcbiAgJ29yYW5nZScgJGVyZ28tb3JhbmdlLWRhcmszLFxuICAnYmx1ZScgJGVyZ28tYmx1ZS1kYXJrMyxcbiAgJ2dyZWVuJyAkZXJnby1ncmVlbi1kYXJrMyxcbiAgJ3Zpb2xldCcgJGVyZ28tdmlvbGV0LWRhcmszLFxuICAneWVsbG93JyAkZXJnby15ZWxsb3ctZGFyazM7XG5cbkBlYWNoICRiZy1jbHIsICRjaGlsZC1jbHIgaW4gJGRhcmszLXBhbGV0dGUge1xuICAuYmctI3skYmctY2xyfS0tZGFyazMge1xuICAgIGNvbG9yOiB3aGl0ZTtcblxuICAgIC5idG4uYnRuLS1wcmltYXJ5IHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICRjaGlsZC1jbHI7XG4gICAgICBib3JkZXI6IDJweCBzb2xpZCB3aGl0ZTtcbiAgICB9XG5cbiAgICAuYnRuLmJ0bi0tc2Vjb25kYXJ5IHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6IHdoaXRlO1xuICAgICAgYm9yZGVyOiAycHggc29saWQgJGNoaWxkLWNscjtcbiAgICAgIGNvbG9yOiAkY2hpbGQtY2xyO1xuICAgIH1cblxuICAgIC5idG46aG92ZXIsXG4gICAgLmJ0bjpmb2N1cyB7XG4gICAgICBjb2xvcjogJGVyZ28td2hpdGU7XG4gICAgICBiYWNrZ3JvdW5kOiAkZXJnby1tYWluO1xuICAgICAgYm9yZGVyOiAycHggc29saWQgJGVyZ28tbWFpbjtcbiAgICB9XG5cbiAgICBoMSxcbiAgICAuaDEsXG4gICAgaDIsXG4gICAgLmgyLFxuICAgIGgzLFxuICAgIC5oMyxcbiAgICBoNCxcbiAgICAuaDQge1xuICAgICAgY29sb3I6IHdoaXRlO1xuICAgIH1cbiAgfVxufVxuIiwiQG1peGluIGJvcmRlci1yYWRpdXMge1xuICBib3JkZXItcmFkaXVzOiA2cHg7XG59XG5cbkBtaXhpbiBkcm9wLXNoYWRvdyB7XG4gIGJveC1zaGFkb3c6IDAgMTZweCAzN3B4IDFweCByZ2JhKDAsIDAsIDAsIDAuNCk7XG59XG5cbkBtaXhpbiBib3JkZXItbGctcmFkaXVzIHtcbiAgJi5ib3JkZXItcmFkaXVzLWxlZnQge1xuICAgIGJvcmRlci1yYWRpdXM6IDhweCAwIDAgOHB4O1xuICB9XG5cbiAgJi5ib3JkZXItcmFkaXVzLXJpZ2h0IHtcbiAgICBib3JkZXItcmFkaXVzOiAwIDhweCA4cHggMDtcbiAgfVxufVxuXG5cbiIsIi5jdXRvdXR2aXN1YWwge1xuICAmX190ZXh0IHtcbiAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG5cbiAgICAmLXdyYXBwZXIge1xuICAgICAgcGFkZGluZzogMS44NzVyZW0gMS42MjVyZW07XG5cbiAgICAgIGgzLCBwLCB1bCwgb2wge1xuICAgICAgICBtYXJnaW4tYm90dG9tOiAycmVtO1xuICAgICAgfVxuXG4gICAgICAuZGlzdHVyYmVyIHtcbiAgICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgICB0b3A6IC0zNXB4O1xuICAgICAgICByaWdodDogMjBweDtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAmX19pbWcge1xuICAgICYtbW9iaWxlIHtcbiAgICAgIHdpZHRoOiAyMDBweDtcbiAgICAgIG1hcmdpbjogMCBhdXRvIDEuODc1cmVtIGF1dG87XG4gICAgfVxuICB9XG59XG5cbkBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICR4bCkge1xuICAuY3V0b3V0dmlzdWFsIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtd3JhcDogbm93cmFwO1xuXG4gICAgJl9fdGV4dCB7XG4gICAgICBwYWRkaW5nOiAwO1xuICAgICAgaGVpZ2h0OiAxMDAlO1xuXG4gICAgICAmLXdyYXBwZXIge1xuICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICAgICAgbWluLWhlaWdodDogNDUwcHg7XG4gICAgICAgIHBhZGRpbmc6IDMuMTI1cmVtIDMuMTI1cmVtIDMuMTI1cmVtIDUuOTM3NXJlbTtcblxuICAgICAgICAuYnRuIHtcbiAgICAgICAgICBtYXJnaW46IDA7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG5cbiAgICAmX19pbWctZGVza3RvcCB7XG4gICAgICB6LWluZGV4OiAxO1xuXG4gICAgICBpbWcge1xuICAgICAgICBtYXgtaGVpZ2h0OiA1MDBweDtcbiAgICAgICAgd2lkdGg6IGF1dG87XG4gICAgICAgIG1hcmdpbjogMCBhdXRvO1xuICAgICAgfVxuICAgIH1cbiAgfVxuICAuY3V0b3V0dmlzdWFsLmZsZXgtcm93LXJldmVyc2Uge1xuICAgIC5jdXRvdXR2aXN1YWxfX2ltZy1kZXNrdG9wIHtcbiAgICAgIHotaW5kZXg6IDE7XG4gICAgfVxuXG4gICAgLmN1dG91dHZpc3VhbF9fdGV4dCB7XG4gICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoMTIuNSUpO1xuICAgIH1cblxuICB9XG59XG4iLCIuaW50ZXJhY3Rpb24ge1xuICAkc2VsZjogJjtcblxuICAmX193cmFwcGVyIHtcbiAgICBwYWRkaW5nOiAyMHB4O1xuICAgIG1hcmdpbjogMS4yNXJlbSAwO1xuICAgIGJhY2tncm91bmQ6IHJnYmEoMjU1LCAyNTUsIDI1NSwgMC40NSk7XG4gICAgYm9yZGVyLXJhZGl1czogOHB4O1xuICAgICY6aGFzKGZvcm1bZGF0YS10eXBlPSd0eG5kZXItY2FyZCddKSB7XG4gICAgICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudDsgLy8gZmlyZWZveCBub3Qgc3VwcG9ydGVkXG4gICAgfVxuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICBwYWRkaW5nOiAyMHB4IDMwcHg7XG4gICAgfVxuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgICBwYWRkaW5nOiAzMHB4IDYwcHg7XG4gICAgfVxuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHhsKSB7XG4gICAgICBwYWRkaW5nOiAzMHB4IDk1cHg7XG4gICAgfVxuXG4gICAgI3skc2VsZn1fX2ltZyB7XG4gICAgICBtYXgtd2lkdGg6IDQwMHB4O1xuICAgICAgcGFkZGluZy1ib3R0b206IDEuMjVyZW07XG4gICAgfVxuXG4gICAgLmZvcm0ge1xuICAgICAgJl9faGVhZGxpbmUge1xuICAgICAgICBjb2xvcjogJGVyZ28tbWFpbjtcbiAgICAgIH1cbiAgICB9XG5cbiAgICBmb3JtW2RhdGEtdHlwZT0nZHJvcGRvd24nXSB7XG4gICAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG5cbiAgICAgIC5zZWxlY3RXcmFwcGVyIHtcbiAgICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgICAgfVxuXG4gICAgICBzZWxlY3QsXG4gICAgICAuc2VsZWN0IHtcbiAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICAgIG1hcmdpbjogMTBweCAwO1xuICAgICAgICBib3JkZXI6IDA7XG4gICAgICAgIGJvcmRlci1ib3R0b206IDJweCBzb2xpZDtcbiAgICAgICAgYm9yZGVyLXJhZGl1czogMDtcbiAgICAgICAgZm9udC1zaXplOiAxcmVtO1xuICAgICAgICBmb250LXdlaWdodDogYm9sZDtcbiAgICAgICAgaGVpZ2h0OiA1MHB4O1xuICAgICAgICBwYWRkaW5nOiAxMnB4IDEwcHggMDtcbiAgICAgICAgYm9yZGVyLWNvbG9yOiBibGFjayAhaW1wb3J0YW50O1xuICAgICAgICAtbW96LWFwcGVhcmFuY2U6IG5vbmU7XG4gICAgICAgIC13ZWJraXQtYXBwZWFyYW5jZTogbm9uZTtcbiAgICAgICAgYXBwZWFyYW5jZTogbm9uZTtcbiAgICAgICAgYmFja2dyb3VuZC1pbWFnZTogdXJsKC4vLi4vLi4vc3Zncy9hcnJvdy1jbG9zZWQuc3ZnKTtcbiAgICAgICAgYmFja2dyb3VuZC1yZXBlYXQ6IG5vLXJlcGVhdDtcbiAgICAgICAgYmFja2dyb3VuZC1wb3NpdGlvbjogcmlnaHQgMXJlbSBjZW50ZXI7XG4gICAgICAgIGJhY2tncm91bmQtc2l6ZTogMWVtO1xuICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkZXJnby13aGl0ZTtcblxuICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkc20pIHtcbiAgICAgICAgICBmb250LXNpemU6IDEuMjVyZW07XG4gICAgICAgIH1cblxuICAgICAgICAmOmZvY3VzLFxuICAgICAgICAmOnZhbGlkLFxuICAgICAgICAmOmhvdmVyIHtcbiAgICAgICAgICBib3gtc2hhZG93OiBub25lO1xuICAgICAgICAgIG91dGxpbmU6IG5vbmU7XG4gICAgICAgIH1cblxuICAgICAgICBvcHRpb24ge1xuICAgICAgICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgICAgICAgIG1pbi1oZWlnaHQ6IDEuMmVtO1xuICAgICAgICAgIHBhZGRpbmc6IDBweCAycHggMXB4O1xuICAgICAgICAgIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gICAgICAgIH1cbiAgICAgIH1cblxuICAgICAgLnNlbGVjdFdyYXBwZXItLWZhbmN5IHtcbiAgICAgICAgLnNlbGVjdCB7XG4gICAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgICAgIGhlaWdodDogYXV0bztcbiAgICAgICAgICB0ZXh0LWFsaWduOiBzdGFydDtcbiAgICAgICAgICBnYXA6IDJweDtcbiAgICAgICAgICBwYWRkaW5nOiA4cHggMTBweDtcblxuICAgICAgICAgICZMYWJlbCB7XG4gICAgICAgICAgICAmX190b3Age1xuICAgICAgICAgICAgICBmb250LXNpemU6IDAuNzVyZW07XG4gICAgICAgICAgICAgIGxpbmUtaGVpZ2h0OiAxcmVtO1xuICAgICAgICAgICAgICBmb250LXdlaWdodDogNDAwO1xuICAgICAgICAgICAgICBjb2xvcjogJGVyZ28taW5wdXQzO1xuICAgICAgICAgICAgICB6LWluZGV4OiAyO1xuICAgICAgICAgICAgfVxuICAgICAgICAgICAgJl9fdmFsdWUge1xuICAgICAgICAgICAgICBmb250LXNpemU6IDFyZW07XG4gICAgICAgICAgICAgIGxpbmUtaGVpZ2h0OiAxLjE7XG4gICAgICAgICAgICAgIGZvbnQtd2VpZ2h0OiA0MDA7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICAmX192YWx1ZUhpbnQge1xuICAgICAgICAgICAgICBmb250LXNpemU6IDAuNzVyZW07XG4gICAgICAgICAgICB9XG4gICAgICAgICAgfVxuICAgICAgICB9XG5cbiAgICAgICAgc2VsZWN0IHtcbiAgICAgICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICAgICAgaW5zZXQ6IDA7XG4gICAgICAgICAgei1pbmRleDogMTtcbiAgICAgICAgfVxuICAgICAgfVxuXG4gICAgICAubW9yZS10ZXh0IHtcbiAgICAgICAgdGV4dC1hbGlnbjogc3RhcnQ7XG4gICAgICAgIGNvbG9yOiAkZXJnby1pbnB1dDM7XG4gICAgICAgIGZvbnQtc2l6ZTogMC42MjVyZW07XG5cbiAgICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogMTIwMHB4KSB7XG4gICAgICAgIH1cbiAgICAgIH1cblxuICAgICAgLm9wdGlvbi0tZXh0ZW5kZWQge1xuICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgfVxuICAgIH1cblxuICAgIGZvcm1bZGF0YS10eXBlPSd0eG5kZXItY2FyZCddIHtcbiAgICAgIG1pbi1oZWlnaHQ6IDEwMHN2aDtcbiAgICAgIC50eG5kZXItaGVhZGxpbmUge1xuICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICAgICAgICB3aWR0aDogNzAlO1xuICAgICAgICAgIG1hcmdpbjogMCBhdXRvO1xuICAgICAgICB9XG4gICAgICB9XG4gICAgICAudHhuZGVyLWltYWdlIHtcbiAgICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgICAgICBtYXgtaGVpZ2h0OiA0ODBweDtcblxuICAgICAgICAmX19jb250YWluZXIge1xuICAgICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICAgIGhlaWdodDogMTAwJTtcbiAgICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgICAgICAgIG1heC13aWR0aDogNDIwcHg7XG4gICAgICAgICAgICBtYXJnaW46IDAgYXV0bztcbiAgICAgICAgICB9XG4gICAgICAgIH1cblxuICAgICAgICAmX193cmFwcGVyIHtcbiAgICAgICAgICBib3gtc2hhZG93OiAwIDEwcHggMjBweCAwIHJnYmEoMCwgMCwgMCwgMC4yNSk7XG4gICAgICAgICAgYm9yZGVyLXJhZGl1czogOHB4O1xuICAgICAgICAgIG92ZXJmbG93OiBoaWRkZW47XG4gICAgICAgICAgdG91Y2gtYWN0aW9uOiBub25lO1xuXG4gICAgICAgICAgJiA+ICoge1xuICAgICAgICAgICAgcG9pbnRlci1ldmVudHM6IG5vbmU7XG4gICAgICAgICAgfVxuICAgICAgICB9XG5cbiAgICAgICAgJjpiZWZvcmUge1xuICAgICAgICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgICAgICAgIGNvbnRlbnQ6ICcnO1xuICAgICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICAgIHBhZGRpbmctdG9wOiBjYWxjKCg3NiAvIDY1KSAqIDEwMCUpO1xuICAgICAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgICAgICAgcGFkZGluZy10b3A6IGNhbGMoKDggLyA3KSAqIDEwMCUpO1xuICAgICAgICAgIH1cbiAgICAgICAgfVxuXG4gICAgICAgICYgPiAudHhuZGVyLWltZyB7XG4gICAgICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICAgIGhlaWdodDogMTAwJTtcbiAgICAgICAgICBvYmplY3QtZml0OiBjb3ZlcjtcbiAgICAgICAgICB0b3A6IDA7XG4gICAgICAgICAgcmlnaHQ6IDA7XG4gICAgICAgICAgYm90dG9tOiAwO1xuICAgICAgICAgIGxlZnQ6IDA7XG4gICAgICAgIH1cblxuICAgICAgICAmX19pbmZvIHtcbiAgICAgICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICAgICAgYm90dG9tOiAwO1xuICAgICAgICAgIHotaW5kZXg6IDI7XG4gICAgICAgICAgbWFyZ2luOiAwIGF1dG87XG4gICAgICAgICAgbGVmdDogMDtcbiAgICAgICAgICByaWdodDogMDtcbiAgICAgICAgICBwYWRkaW5nOiAxcmVtO1xuICAgICAgICAgIHdpZHRoOiBjYWxjKDEwMCUgLSA0cmVtKTtcbiAgICAgICAgICBiYWNrZ3JvdW5kOiAjZmZmO1xuICAgICAgICAgIGJvcmRlci1yYWRpdXM6IDAuMjVyZW0gMC4yNXJlbSAwIDA7XG4gICAgICAgICAgLmMxIHtcbiAgICAgICAgICAgIG1hcmdpbi1ib3R0b206IDAuNXJlbTtcbiAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG5cbiAgICBmb3JtW2RhdGEtdHlwZT0nbXVsdGlwbGUtY2hvaWNlLWljb25zJ10ge1xuICAgICAgLmludGVyYWN0aW9uX19pY29ucy1pbWcge1xuICAgICAgICB3aWR0aDogMTI1cHg7XG4gICAgICAgIGhlaWdodDogMTI1cHg7XG4gICAgICAgIG1hcmdpbi1ib3R0b206IDJyZW07XG4gICAgICB9XG5cbiAgICAgIC5pbWctY2hlY2tib3hlcyB7XG4gICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gICAgICAgIGp1c3RpZnktY29udGVudDogc3BhY2UtZXZlbmx5O1xuICAgICAgICBhbGlnbi1pdGVtczogZmxleC1zdGFydDtcblxuICAgICAgICAuY29sIHtcbiAgICAgICAgICBwYWRkaW5nOiAwO1xuXG4gICAgICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICAgICAgICBwYWRkaW5nOiBpbmhlcml0O1xuICAgICAgICAgIH1cbiAgICAgICAgfVxuICAgICAgfVxuXG4gICAgICAuaW1nLWNoZWNrYm94IHtcbiAgICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuXG4gICAgICAgIGlucHV0IHtcbiAgICAgICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICAgICAgb3BhY2l0eTogMDtcbiAgICAgICAgICB6LWluZGV4OiAtMTtcbiAgICAgICAgfVxuXG4gICAgICAgIGlucHV0ICsgbGFiZWwge1xuICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgICAgICBib3JkZXItcmFkaXVzOiA2cHg7XG4gICAgICAgICAgY3Vyc29yOiBwb2ludGVyO1xuICAgICAgICAgIGZvbnQtd2VpZ2h0OiBib2xkO1xuICAgICAgICAgIG1hcmdpbjogMDtcbiAgICAgICAgICBvdmVyZmxvdzogaGlkZGVuO1xuICAgICAgICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgfVxuXG4gICAgICAgIGlucHV0LmFsdGVybmF0ZSArIGxhYmVsIHtcbiAgICAgICAgICBpbWcge1xuICAgICAgICAgICAgbWFyZ2luOiBhdXRvO1xuICAgICAgICAgICAgbWF4LXdpZHRoOiAxMjBweDtcbiAgICAgICAgICAgIGJhY2tncm91bmQ6ICNlYmU2ZDg7XG4gICAgICAgICAgICBib3JkZXItcmFkaXVzOiA1MCU7XG4gICAgICAgICAgICBhc3BlY3QtcmF0aW86IDE7XG4gICAgICAgICAgICB3aWR0aDogOTAlO1xuICAgICAgICAgICAgbWluLXdpZHRoOiAxcHg7XG5cbiAgICAgICAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRzbSkge1xuICAgICAgICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgICAgICAgbWluLXdpZHRoOiAxMDBweDtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICB9XG5cbiAgICAgICAgICBzcGFuIHtcbiAgICAgICAgICAgIGZvbnQtc2l6ZTogMXJlbTtcbiAgICAgICAgICAgIG1hcmdpbi10b3A6IDFyZW07XG4gICAgICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgICAgICAgbGluZS1oZWlnaHQ6IDEuMztcbiAgICAgICAgICAgIHBhZGRpbmc6IDAuNXJlbTtcbiAgICAgICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICAgICAgY29sb3I6ICMwMDA7XG5cbiAgICAgICAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRzbSkge1xuICAgICAgICAgICAgICBmb250LXNpemU6IDEuMXJlbTtcbiAgICAgICAgICAgIH1cblxuICAgICAgICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgICAgICAgICAgIGZvbnQtc2l6ZTogMS4ycmVtO1xuICAgICAgICAgICAgfVxuXG4gICAgICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgICAgICAgICAgZm9udC1zaXplOiAxLjNyZW07XG4gICAgICAgICAgICB9XG5cbiAgICAgICAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICR4bCkge1xuICAgICAgICAgICAgICBmb250LXNpemU6IDEuNXJlbTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICB9XG4gICAgICAgIH1cblxuICAgICAgICBpbnB1dFt0eXBlPSdyYWRpbyddOmNoZWNrZWQgKyBsYWJlbCBpbWcge1xuICAgICAgICAgIGJhY2tncm91bmQ6ICNmN2RiNmY7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG5cbiAgICBmb3JtW2RhdGEtdHlwZT0nbXVsdGlwbGUtY2hvaWNlLXNsaWRlciddIHtcbiAgICAgIC5pbnRlcmFjdGlvbl9fc2xpZGVyLWltYWdlIHtcbiAgICAgICAgd2lkdGg6IDE5MHB4O1xuICAgICAgICBib3JkZXItcmFkaXVzOiA1MCU7XG4gICAgICAgIGhlaWdodDogMTkwcHg7XG4gICAgICAgIG1hcmdpbjogYXV0bztcblxuICAgICAgICBpbWcge1xuICAgICAgICAgIGJvcmRlci1yYWRpdXM6IDUwJSAhaW1wb3J0YW50O1xuICAgICAgICAgIGJhY2tncm91bmQ6ICNmNWYyZWI7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG5cbiAgICAuaW50ZXJhY3Rpb25fX3NsaWRlci1pbWFnZS52aXNpYmxlIHtcbiAgICAgIGFuaW1hdGlvbjogcG9wIDAuM3M7XG4gICAgICBvcGFjaXR5OiAxO1xuICAgICAgei1pbmRleDogMjtcbiAgICB9XG5cbiAgICAuaW50ZXJhY3Rpb25fX3NsaWRlci13cmFwcGVyIHtcbiAgICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICAgIGhlaWdodDogNjBweDtcbiAgICAgIG1hcmdpbi10b3A6IDIwcHg7XG5cbiAgICAgIGlucHV0W3R5cGU9J3JhbmdlJ10ge1xuICAgICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICAgIG1hcmdpbjogMCBhdXRvO1xuICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgbGVmdDogMDtcbiAgICAgICAgYXBwZWFyYW5jZTogbm9uZTtcbiAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogI2QyY2VjYztcbiAgICAgICAgYm9yZGVyLXJhZGl1czogNnB4O1xuICAgICAgICBoZWlnaHQ6IDExcHg7XG4gICAgICAgIGJhY2tncm91bmQtaW1hZ2U6IGxpbmVhci1ncmFkaWVudCh0byByaWdodCwgIzQ3YmNjYSA0NSUsICNkMmNlY2MgNDUlKTtcblxuICAgICAgICAmOjotd2Via2l0LXNsaWRlci1ydW5uYWJsZS10cmFjayB7XG4gICAgICAgICAgaGVpZ2h0OiAxMXB4O1xuICAgICAgICAgIGNvbG9yOiAjNDdiY2NhO1xuICAgICAgICAgIHotaW5kZXg6IDA7XG4gICAgICAgIH1cblxuICAgICAgICAmOjotd2Via2l0LXNsaWRlci10aHVtYiB7XG4gICAgICAgICAgZGlzcGxheTogYmxvY2s7XG4gICAgICAgICAgei1pbmRleDogMjtcbiAgICAgICAgICB3aWR0aDogNDBweDtcbiAgICAgICAgICBoZWlnaHQ6IDQwcHg7XG4gICAgICAgICAgY3Vyc29yOiBwb2ludGVyO1xuICAgICAgICAgIGJhY2tncm91bmQ6ICRlcmdvLW1haW47XG4gICAgICAgICAgY29sb3I6IHRyYW5zcGFyZW50O1xuICAgICAgICAgIGJvcmRlcjogMTBweCAkZXJnby1tYWluO1xuICAgICAgICAgIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgICAgICAgICBtYXJnaW4tdG9wOiAtMjBweDtcbiAgICAgICAgfVxuXG4gICAgICAgICY6Oi1tb3otcmFuZ2UtcHJvZ3Jlc3Mge1xuICAgICAgICAgIGJhY2tncm91bmQtY29sb3I6ICM0N2JjY2E7XG4gICAgICAgIH1cblxuICAgICAgICAmOjotbW96LXJhbmdlLXRyYWNrIHtcbiAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZDJjZWNjO1xuICAgICAgICB9XG5cbiAgICAgICAgJjo6LW1zLWZpbGwtbG93ZXIge1xuICAgICAgICAgIGJhY2tncm91bmQtY29sb3I6ICM0N2JjY2E7XG4gICAgICAgIH1cblxuICAgICAgICAmOjotbXMtZmlsbC11cHBlciB7XG4gICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogI2QyY2VjYztcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cblxuICAgIGZvcm1bZGF0YS10eXBlPSdtdWx0aXBsZS1jaG9pY2UtcGljdHVyZXMnXSB7XG4gICAgICAudGV4dF9faGVhZGxpbmUge1xuICAgICAgICBmb250LWZhbWlseTogJ0ZTTWUnO1xuICAgICAgICBjb2xvcjogJGVyZ28tYmxhY2s7XG4gICAgICAgIGxpbmUtaGVpZ2h0OiAxLjQ7XG4gICAgICAgIGZvbnQtd2VpZ2h0OiBib2xkO1xuICAgICAgfVxuXG4gICAgICAucm93IHtcbiAgICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICAgICAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgICAgICAgfVxuICAgICAgfVxuXG4gICAgICAuaW1nLXBpY3R1cmUge1xuICAgICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG5cbiAgICAgICAgaW5wdXRbdHlwZT0ncmFkaW8nXSArIGxhYmVsIHtcbiAgICAgICAgICBjdXJzb3I6IHBvaW50ZXI7XG4gICAgICAgICAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gICAgICAgICAgbWFyZ2luOiAwO1xuICAgICAgICAgIG92ZXJmbG93OiBoaWRkZW47XG4gICAgICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICAgIGhlaWdodDogMTAwJTtcbiAgICAgICAgICBtYXgtaGVpZ2h0OiAxNjBweDtcblxuICAgICAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRzbSkge1xuICAgICAgICAgICAgbWF4LWhlaWdodDogMjAwcHg7XG4gICAgICAgICAgfVxuXG4gICAgICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICAgICAgICBtYXgtaGVpZ2h0OiAxMDAlO1xuICAgICAgICAgIH1cblxuICAgICAgICAgIEBpbmNsdWRlIGJvcmRlci1yYWRpdXM7XG4gICAgICAgICAgY29sb3I6ICRlcmdvLW1haW47XG5cbiAgICAgICAgICBpbWcge1xuICAgICAgICAgICAgYXNwZWN0LXJhdGlvOiAxO1xuICAgICAgICAgICAgZGlzcGxheTogYmxvY2s7XG4gICAgICAgICAgICBvYmplY3QtZml0OiBjb3ZlcjtcbiAgICAgICAgICAgIHBvaW50ZXItZXZlbnRzOiBub25lO1xuICAgICAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICAgICAgICBiYWNrZ3JvdW5kOiAjZWJlNmQ4O1xuICAgICAgICAgICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKC0yMCUpO1xuXG4gICAgICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgICAgICAgICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKDApO1xuICAgICAgICAgICAgfVxuICAgICAgICAgIH1cblxuICAgICAgICAgICY6aG92ZXIsXG4gICAgICAgICAgJjpmb2N1cyB7XG4gICAgICAgICAgICBzcGFuIHtcbiAgICAgICAgICAgICAgYmFja2dyb3VuZDogcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjg1KTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICB9XG5cbiAgICAgICAgICBzcGFuIHtcbiAgICAgICAgICAgIHBhZGRpbmc6IDAuNXJlbSAyLjVyZW07XG4gICAgICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgICAgICAgYmFja2dyb3VuZDogcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjc1KTtcbiAgICAgICAgICAgIGJvdHRvbTogMDtcbiAgICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgICBoZWlnaHQ6IDMuNXJlbTtcbiAgICAgICAgICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgICAgICAgICAgbGVmdDogMDtcbiAgICAgICAgICAgIGxpbmUtaGVpZ2h0OiAxLjM7XG4gICAgICAgICAgICBwYWRkaW5nOiAwLjVyZW07XG4gICAgICAgICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICAgICAgICB0cmFuc2l0aW9uOiAwLjE1cyBiYWNrZ3JvdW5kO1xuICAgICAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICAgICAgfVxuICAgICAgICB9XG5cbiAgICAgICAgaW5wdXRbdHlwZT0ncmFkaW8nXS5hbHRlcm5hdGUge1xuICAgICAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgICAgICBvcGFjaXR5OiAwO1xuICAgICAgICAgIHotaW5kZXg6IC0xO1xuICAgICAgICB9XG5cbiAgICAgICAgaW5wdXQuYWx0ZXJuYXRlOmNoZWNrZWQgKyBsYWJlbCBzcGFuIHtcbiAgICAgICAgICBiYWNrZ3JvdW5kOiByZ2JhKDE0MiwgMCwgNTYsIDAuOCkgIWltcG9ydGFudDtcbiAgICAgICAgICBjb2xvcjogI2ZmZjtcblxuICAgICAgICAgICY6OmJlZm9yZSB7XG4gICAgICAgICAgICBiYWNrZ3JvdW5kOiB1cmwoLi4vLi4vc3Zncy9ibGFja19IYWVrY2hlbi5zdmcpIG5vLXJlcGVhdDtcbiAgICAgICAgICAgIGJhY2tncm91bmQtc2l6ZTogY29udGFpbjtcbiAgICAgICAgICAgIGNvbnRlbnQ6ICcnO1xuICAgICAgICAgICAgaGVpZ2h0OiAxNXB4O1xuICAgICAgICAgICAgbGVmdDogMTVweDtcbiAgICAgICAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgICAgICAgIHRvcDogMThweDtcbiAgICAgICAgICAgIHdpZHRoOiAxOHB4O1xuICAgICAgICAgICAgY29sb3I6ICNmZmY7XG5cbiAgICAgICAgICAgIHN2ZyBwYXRoIHtcbiAgICAgICAgICAgICAgZmlsbDogd2hpdGU7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuXG4gICAgLmFuc3dlci12YWxpZGF0aW9uIHtcbiAgICAgIGFuaW1hdGlvbjogZmFkZUluIDFzIGVhc2UtaW4tb3V0O1xuICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgIG1hcmdpbi1ib3R0b206IDEuMjVyZW07XG4gICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICAgIGdhcDogMC45Mzc1cmVtO1xuICAgIH1cblxuICAgIGZvcm0gLm5leHQtYnRuIHtcbiAgICAgIG1hcmdpbi10b3A6IDEuMjVyZW07XG4gICAgfVxuICB9XG5cbiAgJl9fYmFja2dyb3VuZCB7XG4gICAgaGVpZ2h0OiAxMDAlO1xuXG4gICAgLnJvdyB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICB9XG4gIH1cblxuICAmLS1tYXJnaW4tYmlnIHtcbiAgICBtYXJnaW4tYm90dG9tOiAxLjg3NXJlbTtcblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgbWFyZ2luLWJvdHRvbTogNi4yNXJlbTtcbiAgICB9XG4gIH1cbiAgJl9fb3V0cm8ge1xuICAgIG1pbi1oZWlnaHQ6IDEwMHN2aDtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgLmludGVyYWN0aW9uX193cmFwcGVyIHtcbiAgICAgIHBhZGRpbmc6IDA7XG4gICAgICBtYXJnaW46IDA7XG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkc20pIHtcbiAgICAgICAgcGFkZGluZzogMS44NzVyZW07XG4gICAgICAgIG1hcmdpbjogMS4yNXJlbSAwO1xuICAgICAgfVxuICAgIH1cbiAgfVxufVxuXG4uaW50cm8tY292ZXIge1xuICBoZWlnaHQ6IDEwMHZoO1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gIHBhZGRpbmc6IDAgMS4yNXJlbTtcbiAgbWFyZ2luLXRvcDogNi4yNXJlbTtcbn1cblxuYXNpZGUucHJvZ3Jlc3MtYmFyIHtcbiAgYmFja2dyb3VuZDogcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjcpO1xuICB0ZXh0LWFsaWduOiBsZWZ0O1xuICBoZWlnaHQ6IDIwcHg7XG4gIHdpZHRoOiAxMDAlO1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogc3RyZXRjaDtcblxuICBzcGFuIHtcbiAgICBiYWNrZ3JvdW5kOiAjOGUwMDM4O1xuICAgIGNvbG9yOiAjZmZmO1xuICAgIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgICBmb250LXNpemU6IDEwcHg7XG4gICAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gICAgbWluLXdpZHRoOiAxMTJweDtcbiAgICBoZWlnaHQ6IDEwMCU7XG4gICAgdHJhbnNpdGlvbjogMC41cyB3aWR0aDtcbiAgICBwYWRkaW5nOiAwLjI1cmVtIDFyZW07XG4gICAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcbiAgfVxufVxuXG4uaGlkZGVuLXN0ZXAge1xuICBkaXNwbGF5OiBub25lO1xuICB0cmFuc2l0aW9uOlxuICAgIGRpc3BsYXkgMC41cyBlYXNlLFxuICAgIHRyYW5zZm9ybSAwLjNzIGVhc2U7XG59XG5cbi5jdXJyZW50LXN0ZXAge1xuICBkaXNwbGF5OiBibG9jaztcbiAgdHJhbnNpdGlvbjpcbiAgICBkaXNwbGF5IDAuNXMgZWFzZSxcbiAgICB0cmFuc2Zvcm0gMC4zcyBlYXNlO1xufVxuXG5Aa2V5ZnJhbWVzIGZhZGVJbiB7XG4gIGZyb20ge1xuICAgIG9wYWNpdHk6IDA7XG4gIH1cbiAgdG8ge1xuICAgIG9wYWNpdHk6IDE7XG4gIH1cbn1cblxuZm9ybSB7XG4gIGFuaW1hdGlvbjogZmFkZUluIDFzIGVhc2UtaW4tb3V0O1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG59XG5cbkBrZXlmcmFtZXMgcG9wIHtcbiAgMCUge1xuICAgIC1tb3otdHJhbnNmb3JtOiBzY2FsZSgxLjEpO1xuICAgIHRyYW5zZm9ybTogc2NhbGUoMS4xKTtcbiAgfVxuXG4gIDEwMCUge1xuICAgIC1tb3otdHJhbnNmb3JtOiBub25lO1xuICAgIHRyYW5zZm9ybTogbm9uZTtcbiAgfVxufVxuXG4vLyBDdXN0b20gTUcgMjAyNCBUeG5kZXItc3BlY2lmaWMgc3R5bGVzXG4udHhuZGVyLWZvY3VzIHtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuXG4gIC50eG5kZXItYnV0dG9uLS1kZXNrdG9wIHtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgdG9wOiA1MCU7XG4gICAgcmlnaHQ6IDA7XG4gICAgei1pbmRleDogMjtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgYm9yZGVyLXJhZGl1czogNTAlO1xuICAgIG1hcmdpbi1sZWZ0OiAycmVtO1xuICAgIGRpc3BsYXk6IGlubGluZS1mbGV4O1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgtNTAlKTtcblxuICAgIC5idG4tbG9nbyB7XG4gICAgICBtYXJnaW46IC0wLjM3NXJlbSAwO1xuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICAgIG1hcmdpbjogMDtcbiAgICAgICAgd2lkdGg6IDIuNXJlbTtcbiAgICAgICAgaGVpZ2h0OiAyLjVyZW07XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgLnR4bmRlci1idXR0b24tLWRlc2t0b3AtbGVmdCB7XG4gICAgbWFyZ2luLWxlZnQ6IDA7XG4gICAgbGVmdDogMDtcbiAgICBtYXJnaW4tcmlnaHQ6IDJyZW07XG4gICAgcmlnaHQ6IGF1dG87XG4gICAgJjphY3RpdmUge1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogJGVyZ28td2hpdGU7XG4gICAgICBjb2xvcjogI2ZmMDAwMDtcbiAgICAgIC5idG4tbG9nbyB7XG4gICAgICAgIGZpbHRlcjogaW52ZXJ0KDE5JSkgc2VwaWEoOTUlKSBzYXR1cmF0ZSg2Mzk1JSkgaHVlLXJvdGF0ZSgzNTdkZWcpXG4gICAgICAgICAgYnJpZ2h0bmVzcygxMDAlKSBjb250cmFzdCgxMTMlKTtcbiAgICAgIH1cbiAgICB9XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHhsKSB7XG4gICAgICBsZWZ0OiAxMHZ3O1xuICAgIH1cbiAgfVxuICAudHhuZGVyLWJ1dHRvbi0tZGVza3RvcC1yaWdodCB7XG4gICAgJjphY3RpdmUge1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogJGVyZ28td2hpdGU7XG4gICAgICBjb2xvcjogIzAwYTY2MDtcbiAgICAgIC5idG4tbG9nbyB7XG4gICAgICAgIGZpbHRlcjogaW52ZXJ0KDQyJSkgc2VwaWEoNTQlKSBzYXR1cmF0ZSgxMjEwJSkgaHVlLXJvdGF0ZSgxMTdkZWcpXG4gICAgICAgICAgYnJpZ2h0bmVzcyg5NiUpIGNvbnRyYXN0KDEwNCUpO1xuICAgICAgfVxuICAgIH1cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICAgIHJpZ2h0OiAxMHZ3O1xuICAgIH1cbiAgfVxufVxuXG4udHhuZGVyLWJ1dHRvbiB7XG4gIHdpZHRoOiA0LjI1cmVtO1xuICBoZWlnaHQ6IDQuMjVyZW07XG4gIGJhY2tncm91bmQtY29sb3I6ICRlcmdvLXdoaXRlO1xuICBib3JkZXI6IHVuc2V0O1xuICBjb2xvcjogJGVyZ28td2FybWdyZXktZGFyazM7XG4gIHBhZGRpbmc6IDEuNXJlbTtcblxuICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICBwYWRkaW5nOiAycmVtO1xuICAgIHdpZHRoOiA3LjVyZW07XG4gICAgaGVpZ2h0OiA3LjVyZW07XG4gIH1cblxuICAmLmRpc2FibGVkIHtcbiAgICBwb2ludGVyLWV2ZW50czogbm9uZTtcbiAgfVxuXG4gIC5idG4tbG9nbyB7XG4gICAgZmlsdGVyOiBub25lO1xuICAgIHdpZHRoOiAyLjE4NzVyZW07XG4gICAgaGVpZ2h0OiAyLjE4NzVyZW07XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICB3aWR0aDogMS44NzVyZW07XG4gICAgICBoZWlnaHQ6IDEuODc1cmVtO1xuICAgIH1cbiAgfVxuICBzcGFuIHtcbiAgICBmb250LXNpemU6IDExcHg7XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICBmb250LXNpemU6IDE2cHg7XG4gICAgfVxuICB9XG5cbiAgJjpob3ZlcixcbiAgJjpmb2N1cyB7XG4gICAgcGFkZGluZzogMnJlbTtcbiAgICBib3JkZXI6IHVuc2V0O1xuICAgIGJhY2tncm91bmQ6IHJnYmEod2hpdGUsIDAuNyk7XG4gICAgY29sb3I6ICRlcmdvLWJsYWNrO1xuXG4gICAgLmJ0bi1sb2dvIHtcbiAgICAgIGZpbHRlcjogaW52ZXJ0KDApO1xuICAgIH1cbiAgfVxufVxuXG4udHhuZGVyLWNhcmRfX2VuZCB7XG4gIGhlaWdodDogMTAwJTtcbiAgbWF4LWhlaWdodDogMTAwJTtcblxuICAmLWZpcnN0IHtcbiAgICBtYXJnaW4tYm90dG9tOiAtNXJlbTtcbiAgICB6LWluZGV4OiAxO1xuICB9XG5cbiAgJi1zZWNvbmQge1xuICAgIG1hcmdpbi10b3A6IC0xcmVtO1xuICAgIHotaW5kZXg6IDE7XG4gIH1cblxuICAuaWNvbi1jYXJkcy0tZGVza3RvcCB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxuXG4gIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcblxuICAgIC5pY29uLWNhcmRzLS1tb2JpbGUge1xuICAgICAgZGlzcGxheTogbm9uZTtcbiAgICB9XG5cbiAgICAuaWNvbi1jYXJkcy0tZGVza3RvcCB7XG4gICAgICBkaXNwbGF5OiBibG9jaztcblxuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHhsKSB7XG4gICAgICAgIG1pbi13aWR0aDogNDIwcHg7XG4gICAgICB9XG4gICAgfVxuXG4gICAgJi1maXJzdCB7XG4gICAgICBtYXJnaW4tYm90dG9tOiAwO1xuICAgICAgbWFyZ2luLXJpZ2h0OiAtNHJlbTtcbiAgICAgIHotaW5kZXg6IDE7XG4gICAgfVxuXG4gICAgJi1zZWNvbmQge1xuICAgICAgbWFyZ2luLXRvcDogMDtcbiAgICAgIG1hcmdpbi1sZWZ0OiAtNHJlbTtcbiAgICAgIHotaW5kZXg6IDE7XG4gICAgfVxuICB9XG5cbiAgJi1jYXJkIHtcbiAgICBib3JkZXItcmFkaXVzOiA4cHg7XG4gICAgcGFkZGluZzogMXJlbTtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgIHotaW5kZXg6IDI7XG4gICAgaGVpZ2h0OiBmaXQtY29udGVudDtcbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgIHdpZHRoOiAxMDAlO1xuICAgIH1cblxuICAgIC5idG4ge1xuICAgICAgbWF4LXdpZHRoOiBmaXQtY29udGVudDtcbiAgICB9XG5cbiAgICAuaWNvbiB7XG4gICAgICBtYXJnaW46IDAgYXV0byAyMHB4IGF1dG87XG4gICAgICBtYXgtd2lkdGg6IDcwcHg7XG4gICAgICBtYXgtaGVpZ2h0OiA3MHB4O1xuICAgIH1cblxuICAgIC5oZWFkbGluZSB7XG4gICAgICBmb250LXdlaWdodDogYm9sZDtcbiAgICB9XG5cbiAgICAqIHtcbiAgICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICB9XG4gIH1cbn1cbiIsIiVpbWFnZS1kaW1lbnNpb25zIHtcbiAgbWluLXdpZHRoOiAzMjVweDtcbiAgLy8gICBtaW4taGVpZ2h0OiAzODBweDtcbiAgd2lkdGg6IDMyNXB4O1xuICBoZWlnaHQ6IDM4MHB4O1xuICBtYXgtd2lkdGg6IDMyNXB4O1xuICBtYXgtaGVpZ2h0OiA2MHN2aDtcbn1cblxuLmludGVyYWN0aW9uLWRlY2lzaW9uLXRyZWUtcXVpeiB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBwYWRkaW5nOiAxcmVtIDEuODc1cmVtO1xuICBtYXJnaW46IDA7XG4gIGdhcDogMS41cmVtO1xuICB0cmFuc2l0aW9uOiBiYWNrZ3JvdW5kLWNvbG9yIDAuMnMgZWFzZTtcbiAgbWluLWhlaWdodDogMTAwc3ZoO1xuXG4gIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRzbSkge1xuICAgIGdhcDogMnJlbTtcbiAgfVxuXG4gICYtLWJnIHtcbiAgICAmLWdyZWVuIHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICRlcmdvLWdyZWVuO1xuICAgIH1cblxuICAgICYtYmx1ZSB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkZXJnby1ibHVlO1xuICAgIH1cblxuICAgICYteWVsbG93IHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICRlcmdvLXllbGxvdztcbiAgICB9XG5cbiAgICAmLW9yYW5nZSB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkZXJnby1vcmFuZ2U7XG4gICAgfVxuXG4gICAgJi12aW9sZXQge1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogJGVyZ28tdmlvbGV0O1xuICAgIH1cbiAgfVxuXG4gICZfX2luc3RydWN0aW9uIHtcbiAgICAmLFxuICAgIHAge1xuICAgICAgbWFyZ2luOiAwO1xuICAgICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgICAgY29sb3I6ICRlcmdvLWJsYWNrO1xuICAgICAgZm9udC1zdHlsZTogbm9ybWFsO1xuICAgICAgZm9udC13ZWlnaHQ6IDQwMDtcbiAgICAgIGxpbmUtaGVpZ2h0OiAxNDAlO1xuICAgICAgZm9udC1zaXplOiAxcmVtO1xuICAgIH1cbiAgfVxuXG4gIC8vICZfX3JhZmZsZS1xdWVzdGlvbiB7XG4gIC8vICAgbWFyZ2luOiAwO1xuICAvLyAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgLy8gICBjb2xvcjogJGVyZ28tYmxhY2s7XG4gIC8vICAgZm9udC1zaXplOiAxLjI1cmVtO1xuICAvLyAgIGZvbnQtc3R5bGU6IG5vcm1hbDtcbiAgLy8gICBmb250LXdlaWdodDogNzAwO1xuICAvLyAgIGxpbmUtaGVpZ2h0OiAxNDAlXG4gIC8vIH1cbiAgJl9fcmFmZmxlLWluc3RydWN0aW9uIHtcbiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gIH1cblxuICAmX19xdWVzdGlvbnMge1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIH1cblxuICAmX19xdWVzdGlvbiB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgICB0cmFuc2l0aW9uOlxuICAgICAgZGlzcGxheSAwLjJzIGVhc2UsXG4gICAgICB0cmFuc2Zvcm0gMC4ycyBlYXNlO1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgZ2FwOiAycmVtO1xuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICBnYXA6IDIuNXJlbTtcbiAgICB9XG5cbiAgICAmLS1jdXJyZW50IHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgfVxuXG4gICAgLy8gJi0tcmFmZmxlLXF1ZXN0aW9uIHtcbiAgICAvLyAgIGdhcDogMDtcblxuICAgIC8vICAgLmludGVyYWN0aW9uLWRlY2lzaW9uLXRyZWUtcXVpel9fcXVlc3Rpb25fX3R4bmRlci1xdWVzdGlvbi1lbGVtZW50IHtcbiAgICAvLyAgICAgZGlzcGxheTogbm9uZTtcbiAgICAvLyAgIH1cblxuICAgIC8vICAgLmludGVyYWN0aW9uLWRlY2lzaW9uLXRyZWUtcXVpel9fcXVlc3Rpb25fX3R4bmRlci1pbWFnZS1lbGVtZW50IHtcbiAgICAvLyAgICAgb2JqZWN0LWZpdDogY29udGFpbjtcbiAgICAvLyAgIH1cbiAgICAvLyB9XG5cbiAgICAmX19idXR0b25zIHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1hcm91bmQ7XG4gICAgICBnYXA6IDFyZW07XG4gICAgfVxuXG4gICAgJl9fYnV0dG9uIHtcbiAgICAgIGJhY2tncm91bmQ6IHJnYmEoMjU1LCAyNTUsIDI1NSwgMC43KTtcbiAgICAgIGJvcmRlcjogMDtcbiAgICAgIGNvbG9yOiAjNTQ1MjQxO1xuICAgICAgbWFyZ2luOiAwO1xuICAgICAgZmxleC1ncm93OiAxO1xuXG4gICAgICAuYnRuLWxvZ28ge1xuICAgICAgICBtYXJnaW46IDA7XG4gICAgICB9XG5cbiAgICAgICYtLWRlc2t0b3Age1xuICAgICAgICBkaXNwbGF5OiBub25lO1xuICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgICAgICBib3JkZXItcmFkaXVzOiA1MCU7XG4gICAgICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgICAgIHRvcDogNTAlO1xuICAgICAgICAgIHdpZHRoOiAxMjBweDtcbiAgICAgICAgICBtaW4td2lkdGg6IDEyMHB4O1xuICAgICAgICAgIGhlaWdodDogMTIwcHg7XG4gICAgICAgICAgei1pbmRleDogMTtcbiAgICAgICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoLTUwJSk7XG4gICAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICAgIH1cblxuICAgICAgICAmLWxlZnQge1xuICAgICAgICAgIGxlZnQ6IDEwdnc7XG4gICAgICAgICAgcmlnaHQ6IGF1dG87XG4gICAgICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHhsKSB7XG4gICAgICAgICAgICBsZWZ0OiAyMHZ3O1xuICAgICAgICAgIH1cbiAgICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeHhsKSB7XG4gICAgICAgICAgICBsZWZ0OiAzMHZ3O1xuICAgICAgICAgIH1cblxuICAgICAgICAgID4gLmJ0bi1sb2dvLS1sZWZ0IHtcbiAgICAgICAgICAgIGZpbHRlcjogYnJpZ2h0bmVzcygwKSBzYXR1cmF0ZSgxMDAlKSBpbnZlcnQoMzElKSBzZXBpYSg3JSlcbiAgICAgICAgICAgICAgc2F0dXJhdGUoMTI3NCUpIGh1ZS1yb3RhdGUoMTZkZWcpIGJyaWdodG5lc3MoOTElKSBjb250cmFzdCg4NCUpO1xuICAgICAgICAgIH1cblxuICAgICAgICAgICY6aG92ZXIsXG4gICAgICAgICAgJjpmb2N1cyB7XG4gICAgICAgICAgICBiYWNrZ3JvdW5kOiByZ2JhKDI1NSwgMjU1LCAyNTUsIDAuNSk7XG4gICAgICAgICAgICBib3JkZXI6IDA7XG4gICAgICAgICAgICBjb2xvcjogJGVyZ28tYmxhY2s7XG4gICAgICAgICAgICBib3gtc2hhZG93OiBub25lO1xuICAgICAgICAgICAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xuXG4gICAgICAgICAgICA+IC5idG4tbG9nby0tbGVmdCB7XG4gICAgICAgICAgICAgIGZpbHRlcjogYnJpZ2h0bmVzcygwKSBzYXR1cmF0ZSgxMDAlKSBpbnZlcnQoMCUpIHNlcGlhKDEwMCUpXG4gICAgICAgICAgICAgICAgc2F0dXJhdGUoMCUpIGh1ZS1yb3RhdGUoMTEzZGVnKSBicmlnaHRuZXNzKDEwNiUpIGNvbnRyYXN0KDEwNiUpO1xuICAgICAgICAgICAgfVxuICAgICAgICAgIH1cblxuICAgICAgICAgICY6YWN0aXZlIHtcbiAgICAgICAgICAgIGJhY2tncm91bmQ6ICRlcmdvLXdoaXRlO1xuICAgICAgICAgICAgYm9yZGVyOiAwO1xuICAgICAgICAgICAgY29sb3I6ICNmZjAwMDA7XG4gICAgICAgICAgICBib3gtc2hhZG93OiBub25lO1xuICAgICAgICAgICAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xuXG4gICAgICAgICAgICA+IC5idG4tbG9nby0tbGVmdCB7XG4gICAgICAgICAgICAgIGZpbHRlcjogYnJpZ2h0bmVzcygwKSBzYXR1cmF0ZSgxMDAlKSBpbnZlcnQoMjclKSBzZXBpYSg5NSUpXG4gICAgICAgICAgICAgICAgc2F0dXJhdGUoNzQ4NyUpIGh1ZS1yb3RhdGUoMzU4ZGVnKSBicmlnaHRuZXNzKDk2JSlcbiAgICAgICAgICAgICAgICBjb250cmFzdCgxMTglKTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICB9XG4gICAgICAgIH1cblxuICAgICAgICAmLXJpZ2h0IHtcbiAgICAgICAgICByaWdodDogMTB2dztcbiAgICAgICAgICBsZWZ0OiBhdXRvO1xuICAgICAgICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW4tcmV2ZXJzZTtcbiAgICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICAgICAgICAgIHJpZ2h0OiAyMHZ3O1xuICAgICAgICAgIH1cbiAgICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeHhsKSB7XG4gICAgICAgICAgICByaWdodDogMzB2dztcbiAgICAgICAgICB9XG5cbiAgICAgICAgICA+IC5idG4tbG9nby0tcmlnaHQge1xuICAgICAgICAgICAgZmlsdGVyOiBicmlnaHRuZXNzKDApIHNhdHVyYXRlKDEwMCUpIGludmVydCgzMyUpIHNlcGlhKDk5JSlcbiAgICAgICAgICAgICAgc2F0dXJhdGUoNzM2JSkgaHVlLXJvdGF0ZSgxMzZkZWcpIGJyaWdodG5lc3MoMTAwJSkgY29udHJhc3QoMTA0JSk7XG4gICAgICAgICAgfVxuXG4gICAgICAgICAgJjpob3ZlcixcbiAgICAgICAgICAmOmZvY3VzIHtcbiAgICAgICAgICAgIGJhY2tncm91bmQ6IHJnYmEoMjU1LCAyNTUsIDI1NSwgMC41KTtcbiAgICAgICAgICAgIGJvcmRlcjogMDtcbiAgICAgICAgICAgIGNvbG9yOiAkZXJnby1ncmVlbi1kYXJrMztcbiAgICAgICAgICAgIGJveC1zaGFkb3c6IG5vbmU7XG4gICAgICAgICAgICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG4gICAgICAgICAgfVxuXG4gICAgICAgICAgJjphY3RpdmUge1xuICAgICAgICAgICAgYmFja2dyb3VuZDogJGVyZ28td2hpdGU7XG4gICAgICAgICAgICBib3JkZXI6IDA7XG4gICAgICAgICAgICBjb2xvcjogJGVyZ28tZ3JlZW4tZGFyazM7XG4gICAgICAgICAgICBib3gtc2hhZG93OiBub25lO1xuICAgICAgICAgICAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xuICAgICAgICAgIH1cbiAgICAgICAgfVxuICAgICAgfVxuXG4gICAgICAmLS1tb2JpbGUge1xuICAgICAgICBtYXgtd2lkdGg6IDUwJTtcbiAgICAgICAgd2lkdGg6IDUwJTtcbiAgICAgICAgcGFkZGluZzogMXJlbTtcbiAgICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICAgICAgZGlzcGxheTogbm9uZTtcbiAgICAgICAgfVxuXG4gICAgICAgICYtbGVmdCB7XG4gICAgICAgICAgPiAuYnRuLWxvZ28tLWxlZnQge1xuICAgICAgICAgICAgZmlsdGVyOiBicmlnaHRuZXNzKDApIHNhdHVyYXRlKDEwMCUpIGludmVydCgzMSUpIHNlcGlhKDclKVxuICAgICAgICAgICAgICBzYXR1cmF0ZSgxMjc0JSkgaHVlLXJvdGF0ZSgxNmRlZykgYnJpZ2h0bmVzcyg5MSUpIGNvbnRyYXN0KDg0JSk7XG4gICAgICAgICAgfVxuXG4gICAgICAgICAgLyptb2JpbGUgYnJlYWtwb2ludCBvbiBkZXNrdG9wIGRldmljZSovXG4gICAgICAgICAgJjpob3ZlcixcbiAgICAgICAgICAmOmZvY3VzIHtcbiAgICAgICAgICAgIGJhY2tncm91bmQ6IHJnYmEoMjU1LCAyNTUsIDI1NSwgMC41KTtcbiAgICAgICAgICAgIGJvcmRlcjogMDtcbiAgICAgICAgICAgIGNvbG9yOiAkZXJnby1ibGFjaztcbiAgICAgICAgICAgIGJveC1zaGFkb3c6IG5vbmU7XG4gICAgICAgICAgICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG5cbiAgICAgICAgICAgID4gLmJ0bi1sb2dvLS1sZWZ0IHtcbiAgICAgICAgICAgICAgZmlsdGVyOiBicmlnaHRuZXNzKDApIHNhdHVyYXRlKDEwMCUpIGludmVydCgwJSkgc2VwaWEoMTAwJSlcbiAgICAgICAgICAgICAgICBzYXR1cmF0ZSgwJSkgaHVlLXJvdGF0ZSgxMTNkZWcpIGJyaWdodG5lc3MoMTA2JSkgY29udHJhc3QoMTA2JSk7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgfVxuXG4gICAgICAgICAgLyptb2JpbGUgYnJlYWtwb2ludCBvbiBtb2JpbGUgZGV2aWNlKi9cbiAgICAgICAgICAmOmZvY3VzLFxuICAgICAgICAgICY6YWN0aXZlIHtcbiAgICAgICAgICAgIGJhY2tncm91bmQ6ICRlcmdvLXdoaXRlO1xuICAgICAgICAgICAgYm9yZGVyOiAwO1xuICAgICAgICAgICAgY29sb3I6ICNmZjAwMDA7XG4gICAgICAgICAgICBib3gtc2hhZG93OiBub25lO1xuICAgICAgICAgICAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xuXG4gICAgICAgICAgICA+IC5idG4tbG9nby0tbGVmdCB7XG4gICAgICAgICAgICAgIGZpbHRlcjogYnJpZ2h0bmVzcygwKSBzYXR1cmF0ZSgxMDAlKSBpbnZlcnQoMjclKSBzZXBpYSg5NSUpXG4gICAgICAgICAgICAgICAgc2F0dXJhdGUoNzQ4NyUpIGh1ZS1yb3RhdGUoMzU4ZGVnKSBicmlnaHRuZXNzKDk2JSlcbiAgICAgICAgICAgICAgICBjb250cmFzdCgxMTglKTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICB9XG4gICAgICAgIH1cblxuICAgICAgICAmLXJpZ2h0IHtcbiAgICAgICAgICA+IC5idG4tbG9nby0tcmlnaHQge1xuICAgICAgICAgICAgZmlsdGVyOiBicmlnaHRuZXNzKDApIHNhdHVyYXRlKDEwMCUpIGludmVydCgzMyUpIHNlcGlhKDk5JSlcbiAgICAgICAgICAgICAgc2F0dXJhdGUoNzM2JSkgaHVlLXJvdGF0ZSgxMzZkZWcpIGJyaWdodG5lc3MoMTAwJSkgY29udHJhc3QoMTA0JSk7XG4gICAgICAgICAgfVxuXG4gICAgICAgICAgLyptb2JpbGUgYnJlYWtwb2ludCBvbiBkZXNrdG9wIGRldmljZSovXG4gICAgICAgICAgJjpob3ZlcixcbiAgICAgICAgICAmOmZvY3VzIHtcbiAgICAgICAgICAgIGJhY2tncm91bmQ6IHJnYmEoMjU1LCAyNTUsIDI1NSwgMC41KTtcbiAgICAgICAgICAgIGJvcmRlcjogMDtcbiAgICAgICAgICAgIGNvbG9yOiAkZXJnby1ncmVlbi1kYXJrMztcbiAgICAgICAgICAgIGJveC1zaGFkb3c6IG5vbmU7XG4gICAgICAgICAgICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG4gICAgICAgICAgfVxuXG4gICAgICAgICAgLyptb2JpbGUgYnJlYWtwb2ludCBvbiBtb2JpbGUgZGV2aWNlKi9cbiAgICAgICAgICAmOmZvY3VzLFxuICAgICAgICAgICY6YWN0aXZlIHtcbiAgICAgICAgICAgIGJhY2tncm91bmQ6ICRlcmdvLXdoaXRlO1xuICAgICAgICAgICAgYm9yZGVyOiAwO1xuICAgICAgICAgICAgY29sb3I6ICRlcmdvLWdyZWVuLWRhcmszO1xuICAgICAgICAgICAgYm94LXNoYWRvdzogbm9uZTtcbiAgICAgICAgICAgIHRleHQtZGVjb3JhdGlvbjogbm9uZTtcbiAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG5cbiAgICAmX190eG5kZXIge1xuICAgICAgJi1jYXJkIHtcbiAgICAgICAgYXNwZWN0LXJhdGlvOiAzLzQ7XG4gICAgICAgIG92ZXJmbG93OiBoaWRkZW47XG4gICAgICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICAgICAgYm94LXNoYWRvdzogMCAxMHB4IDIwcHggMCByZ2JhKDAsIDAsIDAsIDAuMjUpO1xuICAgICAgICBib3JkZXItcmFkaXVzOiAwLjVyZW07XG4gICAgICAgIEBleHRlbmQgJWltYWdlLWRpbWVuc2lvbnM7XG5cbiAgICAgICAgLy8gJi0tcmFmZmxlLXF1ZXN0aW9uIHtcbiAgICAgICAgLy8gICBib3gtc2hhZG93OiBub25lO1xuICAgICAgICAvLyB9XG4gICAgICB9XG5cbiAgICAgICYtaW1hZ2Uge1xuICAgICAgICAmLXdyYXBwZXIge1xuICAgICAgICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICAgICAgICBib3JkZXItcmFkaXVzOiAwLjVyZW07XG4gICAgICAgICAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgICAgICAgICB0b3VjaC1hY3Rpb246IG5vbmU7XG4gICAgICAgICAgQGV4dGVuZCAlaW1hZ2UtZGltZW5zaW9ucztcbiAgICAgICAgfVxuXG4gICAgICAgICYtZWxlbWVudCB7XG4gICAgICAgICAgcG9pbnRlci1ldmVudHM6IG5vbmU7XG4gICAgICAgICAgb2JqZWN0LWZpdDogY292ZXI7XG4gICAgICAgICAgb2JqZWN0LXBvc2l0aW9uOiBjZW50ZXI7XG4gICAgICAgICAgaGVpZ2h0OiAxMDAlO1xuICAgICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICB9XG4gICAgICB9XG5cbiAgICAgICYtcXVlc3Rpb24ge1xuICAgICAgICAmLXdyYXBwZXIge1xuICAgICAgICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICAgICAgICBib3JkZXItcmFkaXVzOiAwLjVyZW07XG4gICAgICAgICAgQGV4dGVuZCAlaW1hZ2UtZGltZW5zaW9ucztcbiAgICAgICAgfVxuXG4gICAgICAgICYtZWxlbWVudCB7XG4gICAgICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgICAgIGJvdHRvbTogMDtcbiAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkZXJnby13aGl0ZTtcbiAgICAgICAgICBsZWZ0OiAwO1xuICAgICAgICAgIHJpZ2h0OiAwO1xuICAgICAgICAgIHBhZGRpbmc6IDEuMjVyZW0gMC43NXJlbTtcbiAgICAgICAgICBjb2xvcjogJGVyZ28tYmxhY2s7XG4gICAgICAgICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgICAgICAgIGZvbnQtZmVhdHVyZS1zZXR0aW5nczpcbiAgICAgICAgICAgICdjbGlnJyBvZmYsXG4gICAgICAgICAgICAnbGlnYScgb2ZmO1xuICAgICAgICAgIGZvbnQtc2l6ZTogMXJlbTtcbiAgICAgICAgICBmb250LXN0eWxlOiBub3JtYWw7XG4gICAgICAgICAgZm9udC13ZWlnaHQ6IDcwMDtcbiAgICAgICAgICBsaW5lLWhlaWdodDogMTQwJTtcbiAgICAgICAgICBtYXJnaW46IDAgMS41cmVtO1xuICAgICAgICAgIGJvcmRlci1yYWRpdXM6IDAuMjVyZW0gMC4yNXJlbSAwIDA7XG4gICAgICAgICAgaHlwaGVuczogYXV0bztcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cbiAgfVxufVxuIiwiLmludGVyYWN0aW9uIHtcbiAgJl9fcGVuc2lvbiB7XG4gICAgcGFkZGluZy1ib3R0b206IDFweDtcbiAgICAuc3RhZ2VzIHtcbiAgICAgIG1hcmdpbjogMS4yNXJlbSAwO1xuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICAgIG1hcmdpbjogMi41cmVtIDA7XG4gICAgICB9XG4gICAgICAuc3RlcCB7XG4gICAgICAgIEBpbmNsdWRlIGJvcmRlci1yYWRpdXM7XG4gICAgICAgIHBhZGRpbmc6IDEuODc1cmVtIDA7XG4gICAgICAgIC5yb3cge1xuICAgICAgICAgIHdpZHRoOiA5MCU7XG4gICAgICAgICAgbWFyZ2luOiAwIGF1dG87XG4gICAgICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICAgIC5zdGVwLTEge1xuICAgICAgICBpbWcge1xuICAgICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICAgIG1heC13aWR0aDogNDUwcHg7XG4gICAgICAgIH1cblxuICAgICAgICBsYWJlbCB7XG4gICAgICAgICAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICAgICAgICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgICAgICAgICBoZWlnaHQ6IDQ0cHg7XG4gICAgICAgICAgcGFkZGluZzogMTBweCA0MHB4O1xuICAgICAgICAgIG1hcmdpbjogMCBhdXRvO1xuICAgICAgICAgIGZvbnQtc2l6ZTogMTZweDtcbiAgICAgICAgICBsaW5lLWhlaWdodDogMjRweDtcbiAgICAgICAgICB3b3JkLWJyZWFrOiBrZWVwLWFsbDtcbiAgICAgICAgICBmb250LXdlaWdodDogNzAwO1xuICAgICAgICAgIGJvcmRlci1yYWRpdXM6IDE1MHB4O1xuICAgICAgICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICAgICAgICBjb2xvcjogJGVyZ28td2hpdGU7XG4gICAgICAgICAgYmFja2dyb3VuZDogJGVyZ28tbWFpbjtcbiAgICAgICAgICB0cmFuc2l0aW9uOiBiYWNrZ3JvdW5kLWNvbG9yIDAuM3MgZWFzZTtcbiAgICAgICAgICB3aWR0aDogODAlO1xuICAgICAgICAgIG1heC13aWR0aDogNDUwcHg7XG4gICAgICAgICAgbWFyZ2luLWJvdHRvbTogMjBweDtcbiAgICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICAgIH1cbiAgICAgICAgfVxuXG4gICAgICAgIGlucHV0W3R5cGU9J3JhZGlvJ10ge1xuICAgICAgICAgIGRpc3BsYXk6IG5vbmU7XG4gICAgICAgIH1cblxuICAgICAgICBpbnB1dFt0eXBlPSdyYWRpbyddOmNoZWNrZWQgKyBsYWJlbCB7XG4gICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogJGVyZ28td2hpdGU7XG4gICAgICAgICAgYm9yZGVyOiAxcHggc29saWQgJGVyZ28tbWFpbjtcbiAgICAgICAgfVxuXG4gICAgICAgIGxhYmVsW2Zvcj0neWVzJ10ge1xuICAgICAgICAgIGJvcmRlcjogMnB4IHNvbGlkICRlcmdvLW1haW47XG4gICAgICAgICAgJjpob3ZlcixcbiAgICAgICAgICAmOmZvY3VzIHtcbiAgICAgICAgICAgIGNvbG9yOiAkZXJnby1tYWluO1xuICAgICAgICAgICAgYmFja2dyb3VuZDogJGVyZ28td2hpdGU7XG4gICAgICAgICAgfVxuICAgICAgICB9XG5cbiAgICAgICAgbGFiZWxbZm9yPSdubyddIHtcbiAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkZXJnby13aGl0ZTtcbiAgICAgICAgICBjb2xvcjogJGVyZ28tbWFpbjtcbiAgICAgICAgICBib3JkZXI6IDJweCBzb2xpZCAkZXJnby1tYWluO1xuXG4gICAgICAgICAgJjpob3ZlcixcbiAgICAgICAgICAmOmZvY3VzIHtcbiAgICAgICAgICAgIGNvbG9yOiAkZXJnby13aGl0ZTtcbiAgICAgICAgICAgIGJhY2tncm91bmQ6ICRlcmdvLW1haW47XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICB9XG4gICAgICAuc3RlcC0yIHtcbiAgICAgICAgaW1nIHtcbiAgICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgICBtYXgtd2lkdGg6IDIzNXB4O1xuICAgICAgICAgIGhlaWdodDogMTAwJTtcbiAgICAgICAgfVxuICAgICAgICAuZXVyby13cmFwcGVyIHtcbiAgICAgICAgICBtYXJnaW4tdG9wOiAxLjI1cmVtO1xuICAgICAgICB9XG4gICAgICB9XG4gICAgICBoMyB7XG4gICAgICAgIGNvbG9yOiAkZXJnby1tYWluO1xuICAgICAgfVxuICAgICAgLnN0ZXAtMyB7XG4gICAgICAgIHBhZGRpbmc6IDEuODc1cmVtIDEuMjVyZW07XG4gICAgICB9XG4gICAgfVxuICB9XG59XG4uaW50ZXJhY3Rpb25fX3BlbnNpb24ge1xuICAmLmJnLWdyZWVuIHtcbiAgICBmb3JtIC5zdGVwIHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICRlcmdvLWdyZWVuLWxpZ2h0O1xuICAgIH1cbiAgfVxuICAmLmJnLW9yYW5nZSB7XG4gICAgZm9ybSAuc3RlcCB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkZXJnby1vcmFuZ2UtbGlnaHQ7XG4gICAgfVxuICB9XG4gICYuYmctYmx1ZSB7XG4gICAgZm9ybSAuc3RlcCB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkZXJnby1ibHVlLWxpZ2h0O1xuICAgIH1cbiAgfVxuICAmLmJnLXZpb2xldCB7XG4gICAgZm9ybSAuc3RlcCB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkZXJnby12aW9sZXQtbGlnaHQ7XG4gICAgfVxuICB9XG4gICYuYmcteWVsbG93IHtcbiAgICBmb3JtIC5zdGVwIHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICRlcmdvLXllbGxvdy1saWdodDtcbiAgICB9XG4gIH1cbn1cbi5zZWxlY3Qtd3JhcCB7XG4gIGJvcmRlci1yYWRpdXM6IDRweDtcbiAgd2lkdGg6IDEwMCU7XG4gIG1heC13aWR0aDogNDAwcHg7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgbWFyZ2luOiAwIGF1dG8gMjBweCBhdXRvO1xuXG4gIGxhYmVsIHtcbiAgICBjb2xvcjogIzc3NztcbiAgICBwYWRkaW5nOiAwIDhweDtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgdG9wOiA2cHg7XG4gICAgZm9udC1zaXplOiAxMnB4O1xuICAgIGZvbnQtd2VpZ2h0OiA0MDA7XG4gICAgbGluZS1oZWlnaHQ6IDE2cHg7XG4gICAgdGV4dC1hbGlnbjogbGVmdDtcbiAgfVxuXG4gIHNlbGVjdCB7XG4gICAgb3V0bGluZTogbm9uZTtcbiAgICBib3JkZXI6IG5vbmU7XG4gICAgYm9yZGVyLWJvdHRvbTogcmdiYSg1MSwgNTEsIDUxLCAwLjcpIHNvbGlkIDJweDtcbiAgICBib3JkZXItd2lkdGg6IDFweDtcbiAgICBib3JkZXItdG9wLWxlZnQtcmFkaXVzOiA0cHg7XG4gICAgYm9yZGVyLXRvcC1yaWdodC1yYWRpdXM6IDRweDtcbiAgICBoZWlnaHQ6IDQ4cHg7XG4gICAgZm9udC1zaXplOiAxNnB4O1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIHBhZGRpbmc6IDIwcHggMHB4IDAgNHB4O1xuICAgIGxpbmUtaGVpZ2h0OiAzMHB4O1xuICAgIHRleHQtaW5kZW50OiA0cHg7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogJGVyZ28td2hpdGUgIWltcG9ydGFudDtcbiAgICAvLyBBUlJPVyBTVFlMRVxuICAgIC13ZWJraXQtYXBwZWFyYW5jZTogbm9uZTtcbiAgICAtbW96LWFwcGVhcmFuY2U6IG5vbmU7XG4gICAgYXBwZWFyYW5jZTogbm9uZTtcbiAgICBiYWNrZ3JvdW5kOiB1cmwoJ2RhdGE6aW1hZ2Uvc3ZnK3htbCw8c3ZnIHdpZHRoPVwiMThcIiBoZWlnaHQ9XCIxOFwiIHZpZXdCb3g9XCIwIDAgMzIgMzJcIiBmaWxsPVwibm9uZVwiIHhtbG5zPVwiaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmdcIj48cGF0aCBkPVwiTTE2LjAyMzkgMjEuMTU0N0w3LjI5MDEyIDguOTYwOTRINS4xMjAxMkwxNC42MDE0IDIyLjE5OTdDMTQuOTEzNCAyMi42ODI1IDE1LjQ0OSAyMi45NzQgMTYuMDIzOSAyMi45NzRDMTYuNTk4NyAyMi45NzQgMTcuMTM0MyAyMi42ODI1IDE3LjQ0NjQgMjIuMTk5N0wyNi45MjY0IDguOTYwOTRIMjQuNzU3NkwxNi4wMjM5IDIxLjE1NDdaXCIgZmlsbD1cImJsYWNrXCIvPjwvc3ZnPicpXG4gICAgICBuby1yZXBlYXQ7XG4gICAgYmFja2dyb3VuZC1wb3NpdGlvbi14OiA5OCU7XG4gICAgYmFja2dyb3VuZC1wb3NpdGlvbi15OiAxNXB4O1xuICB9XG5cbiAgLmVycm9yLW1lc3NhZ2Uge1xuICAgIGNvbG9yOiAkZXJnby1lcnJvcjtcbiAgICBmb250LXNpemU6IDE0cHg7XG4gICAgZGlzcGxheTogYmxvY2s7XG4gICAgdGV4dC1hbGlnbjogbGVmdDtcbiAgfVxufVxuXG4uZXVyby13cmFwcGVyIHtcbiAgaW5wdXQge1xuICAgIG91dGxpbmU6IG5vbmU7XG4gICAgYm9yZGVyOiBub25lO1xuICAgIGJvcmRlci1ib3R0b206IHJnYmEoNTEsIDUxLCA1MSwgMC43KSBzb2xpZCAycHg7XG4gICAgYm9yZGVyLXdpZHRoOiAxcHg7XG4gICAgYm9yZGVyLXRvcC1sZWZ0LXJhZGl1czogNHB4O1xuICAgIGJvcmRlci10b3AtcmlnaHQtcmFkaXVzOiA0cHg7XG4gICAgaGVpZ2h0OiA0OHB4O1xuICAgIGZvbnQtc2l6ZTogMTZweDtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBwYWRkaW5nOiAyMHB4IDBweCAwIDRweDtcbiAgICBsaW5lLWhlaWdodDogMzBweDtcbiAgICB0ZXh0LWluZGVudDogNHB4O1xuICAgIGJhY2tncm91bmQ6ICRlcmdvLXdoaXRlO1xuICAgIC13ZWJraXQtYXBwZWFyYW5jZTogbm9uZTtcbiAgICAtbW96LWFwcGVhcmFuY2U6IG5vbmU7XG4gICAgYXBwZWFyYW5jZTogbm9uZTtcbiAgfVxuXG4gICY6YWZ0ZXIge1xuICAgIGNvbnRlbnQ6ICdFVVInO1xuICAgIGZvbnQtc2l6ZTogMTZweDtcbiAgICBoZWlnaHQ6IDYwJTtcbiAgICBwb2ludGVyLWV2ZW50czogbm9uZTtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgcmlnaHQ6IDI2cHg7XG4gICAgdG9wOiAyOSU7XG4gICAgd2lkdGg6IDE1cHg7XG4gIH1cbn1cblxuLnN0ZXAtdGhyZWUtdGV4dCB7XG4gIHBhZGRpbmc6IDAgMS41cmVtO1xufVxuIiwiLnJlc3VsdC1zdGFnZV9fdGFibGUge1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG5cbiAgJi10ZXh0IHtcbiAgICBwYWRkaW5nOiAwO1xuICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICBib3JkZXItcmFkaXVzOiA4cHg7XG4gICAgbWFyZ2luLXRvcDogLTQuMDYyNXJlbTtcbiAgICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudDtcblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICR4bCkge1xuICAgICAgbWFyZ2luLXRvcDogMDtcbiAgICB9XG5cbiAgICAuYWNjb3JkaW9uIHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6IHRyYW5zcGFyZW50O1xuICAgICAgYm9yZGVyLXJhZGl1czogNnB4O1xuICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICBtYXJnaW46IDAgYXV0bztcbiAgICAgIHBhZGRpbmc6IDEuMjVyZW0gMC42MjVyZW07XG4gICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBmbGV4LXdyYXA6IHdyYXA7XG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICAgICAgcGFkZGluZzogMS4yNXJlbSAzLjc1cmVtIDUwcHg7XG4gICAgICAgIGp1c3RpZnktY29udGVudDogc3BhY2UtYXJvdW5kO1xuICAgICAgfVxuXG4gICAgICAmX19tYWluIHtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICAgIHBhZGRpbmc6IDMwcHggMTBweCAxMHB4O1xuICAgICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICAgIGJhY2tncm91bmQtY29sb3I6ICRlcmdvLXdoaXRlO1xuICAgICAgICBAaW5jbHVkZSBib3JkZXItcmFkaXVzO1xuICAgICAgICBAaW5jbHVkZSBkcm9wLXNoYWRvdztcblxuICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICAgICAgICBtYXJnaW46IGF1dG8gMDtcbiAgICAgICAgICBwYWRkaW5nOiAxLjg3NXJlbTtcbiAgICAgICAgfVxuICAgICAgICBoMyB7XG4gICAgICAgICAgY29sb3I6ICRlcmdvLW1haW47XG4gICAgICAgIH1cbiAgICAgICAgc3BhbiB7XG4gICAgICAgICAgZm9udC1mYW1pbHk6ICdGU01lJywgc2Fucy1zZXJpZjtcbiAgICAgICAgICBmb250LXNpemU6IDM1cHg7XG4gICAgICAgICAgZm9udC13ZWlnaHQ6IDcwMDtcbiAgICAgICAgICBsaW5lLWhlaWdodDogNDVweDtcbiAgICAgICAgICBjb2xvcjogJGVyZ28tbWFpbjtcbiAgICAgICAgfVxuICAgICAgICAubGluZS1wcmVpcyB7XG4gICAgICAgICAgLy8gcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgICAgIG1hcmdpbi1sZWZ0OiBhdXRvO1xuICAgICAgICAgIG1hcmdpbi1yaWdodDogYXV0bztcbiAgICAgICAgICBsZWZ0OiAwO1xuICAgICAgICAgIHJpZ2h0OiAwO1xuICAgICAgICAgIGJvdHRvbTogMjAlO1xuICAgICAgICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICAgICAgICAgIGJhY2tncm91bmQtY29sb3I6IHRyYW5zcGFyZW50O1xuICAgICAgICAgIH1cbiAgICAgICAgfVxuXG4gICAgICAgIC5kaXN0dXJiZXIge1xuICAgICAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgICAgICB0b3A6IDA7XG4gICAgICAgICAgbGVmdDogMTAwJTtcbiAgICAgICAgICB0cmFuc2xhdGU6IC0xMDAlIC04MHB4O1xuXG4gICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogJGVyZ28tbWFpbjtcbiAgICAgICAgICBib3JkZXItcmFkaXVzOiA1MCU7XG4gICAgICAgICAgaGVpZ2h0OiAxMDBweDtcbiAgICAgICAgICB3aWR0aDogMTAwcHg7XG4gICAgICAgICAgYXNwZWN0LXJhdGlvOiAxIC8gMTtcblxuICAgICAgICAgICZfX3RleHQge1xuICAgICAgICAgICAgY29sb3I6ICRlcmdvLXdoaXRlO1xuICAgICAgICAgICAgZm9udC1zaXplOiAwLjc1cmVtO1xuICAgICAgICAgICAgbGluZS1oZWlnaHQ6IDAuOTc1cmVtO1xuICAgICAgICAgICAgZm9udC13ZWlnaHQ6IDcwMDtcbiAgICAgICAgICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICAgICAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgICAgICAgIHRvcDogNTAlO1xuICAgICAgICAgICAgbGVmdDogNTAlO1xuICAgICAgICAgICAgdHJhbnNsYXRlOiAtNTAlIC01MCU7XG4gICAgICAgICAgICByb3RhdGU6IC0xNWRlZztcbiAgICAgICAgICAgIHdpZHRoOiAxMDAlO1xuXG4gICAgICAgICAgICAmLS1yYXRlIHtcbiAgICAgICAgICAgICAgZm9udC1zaXplOiAwLjg3NXJlbTtcbiAgICAgICAgICAgICAgbGluZS1oZWlnaHQ6IDEuMTM3NXJlbTtcbiAgICAgICAgICAgICAgY29sb3I6ICRlcmdvLXdoaXRlO1xuICAgICAgICAgICAgfVxuICAgICAgICAgIH1cbiAgICAgICAgfVxuICAgICAgfVxuICAgICAgJl9fY29udGVudCB7XG4gICAgICAgIGJhY2tncm91bmQtY29sb3I6IHRyYW5zcGFyZW50O1xuICAgICAgICBtYXJnaW46IGF1dG87XG4gICAgICAgIHBhZGRpbmc6IDE1cHggMCAzMHB4O1xuICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICAgICAgICBtYXJnaW46IDEuODc1cmVtIDAgMCAtNXJlbTtcbiAgICAgICAgICBAaW5jbHVkZSBib3JkZXItcmFkaXVzO1xuICAgICAgICB9XG4gICAgICAgIHRhYmxlIHtcbiAgICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgICBmb250LWZhbWlseTogJ0ZTTWUnLCBzYW5zLXNlcmlmO1xuICAgICAgICAgIG1hcmdpbi1ib3R0b206IDFyZW07XG4gICAgICAgICAgdGhlYWQge1xuICAgICAgICAgICAgdGgge1xuICAgICAgICAgICAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gICAgICAgICAgICAgIHBhZGRpbmc6IDEwcHggMDtcbiAgICAgICAgICAgICAgZm9udC13ZWlnaHQ6IDcwMDtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICB9XG4gICAgICAgICAgdGQge1xuICAgICAgICAgICAgd2lkdGg6IDQ1JTtcbiAgICAgICAgICAgIHRleHQtYWxpZ246IHJpZ2h0O1xuICAgICAgICAgICAgZm9udC1zaXplOiAyMHB4O1xuICAgICAgICAgIH1cbiAgICAgICAgICB0aCB7XG4gICAgICAgICAgICB0ZXh0LWFsaWduOiBsZWZ0O1xuICAgICAgICAgICAgZm9udC1zaXplOiAxNHB4O1xuICAgICAgICAgICAgbGluZS1oZWlnaHQ6IDIwcHg7XG4gICAgICAgICAgICBmb250LWZhbWlseTogJ0ZTTWUnLCBzYW5zLXNlcmlmO1xuICAgICAgICAgICAgZm9udC13ZWlnaHQ6IDQwMDtcbiAgICAgICAgICB9XG4gICAgICAgICAgdGJvZHkge1xuICAgICAgICAgICAgdHIge1xuICAgICAgICAgICAgICAvLyBmb250LXdlaWdodDogNzAwO1xuICAgICAgICAgICAgICA+ICoge1xuICAgICAgICAgICAgICAgIHBhZGRpbmc6IDEwcHggMDtcbiAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAvLyB0aCB7XG4gICAgICAgICAgICAgIC8vIGZvbnQtd2VpZ2h0OiA3MDA7XG4gICAgICAgICAgICAgIC8vIH1cbiAgICAgICAgICAgIH1cbiAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgICAgLnJlYWQtbW9yZS1saW5rIHtcbiAgICAgICAgICBwYWRkaW5nOiA4cHg7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICAgIC5idG4tYmVyZWNobmVuIHtcbiAgICAgICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKC0xNzAlKTtcbiAgICAgIH1cbiAgICB9XG5cbiAgICB0YWJsZSB0ZCB7XG4gICAgICBwYWRkaW5nLXJpZ2h0OiAxMHB4ICFpbXBvcnRhbnQ7XG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgICAgcGFkZGluZy1yaWdodDogMzBweCAhaW1wb3J0YW50O1xuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gICYtaW1hZ2Uge1xuICAgIHBhZGRpbmc6IDA7XG4gICAgYXNwZWN0LXJhdGlvOiAyMSAvIDEwO1xuXG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHhsKSB7XG4gICAgICBhc3BlY3QtcmF0aW86IHVuc2V0O1xuICAgIH1cblxuICAgIGltZyB7XG4gICAgICBvYmplY3QtZml0OiBjb3ZlcjtcbiAgICB9XG4gIH1cblxuICAmLXN0aWNreS1idG4ge1xuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgbWFyZ2luLXRvcDogMS44NzVyZW07XG4gICAgfVxuICB9XG5cbiAgLnJlc3VsdC1kYXRhLWRheSB7XG4gICAgY29sb3I6ICRlcmdvLW1haW47XG4gICAgbGluZS1oZWlnaHQ6IDEuNDtcblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgbWFyZ2luLXRvcDogMS44NzVyZW07XG4gICAgfVxuICB9XG5cbiAgLnJlc3VsdC1kYXRhLWRpc2NsYWltZXIge1xuICAgIGZvbnQtc2l6ZTogMTJweDtcbiAgICBtYXJnaW4tdG9wOiA4cHg7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICB9XG59XG5cbi5yb3RhdGUge1xuICB0cmFuc2Zvcm06IHJvdGF0ZSgxODBkZWcpO1xufVxuIiwiLnJlc3VsdC1zdGFnZSB7XG4gICZfX2NvbnRlbnQge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICBwYWRkaW5nOiAzcmVtO1xuICB9XG5cbiAgJl9faGVhZGxpbmUge1xuICAgIG1hcmdpbi1ib3R0b206IDEuNXJlbTtcbiAgfVxuXG4gICZfX3RleHQge1xuICAgIG1hcmdpbi1ib3R0b206IDJyZW07XG4gIH1cblxuICAmX19pbWFnZSB7XG4gICAgcGFkZGluZzogM3JlbTtcblxuICAgIGltZyB7XG4gICAgICBvYmplY3QtZml0OiBjb250YWluO1xuICAgICAgbWFyZ2luOiAwIGF1dG87XG4gICAgICBtYXgtd2lkdGg6IDUwMHB4O1xuXG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgICAgbWFyZ2luOiAwIDAgMCBhdXRvO1xuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gIC5idG4ge1xuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgbWFyZ2luLWxlZnQ6IDA7XG4gICAgfVxuICB9XG59XG4iLCIuY29udGVudC12aWRlb3Zpc3VhbCB7XG4gIC8vIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRzbSkge1xuICAvLyBwYWRkaW5nOiAxLjg3NXJlbSAwO1xuICAvLyB9XG4gIC8vIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAvLyAgIHBhZGRpbmc6IDMuMTI1cmVtIDA7XG4gIC8vIH1cbiAgJl9fdGh1bWJuYWlsIHtcbiAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICAvLyBUSUNLRVQgMjExOCBLU08gMjVcbiAgICAgIHBhZGRpbmctcmlnaHQ6IDEuNjI1cmVtO1xuICAgICAgcGFkZGluZy1sZWZ0OiAxLjYyNXJlbTtcbiAgICB9XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgICBwYWRkaW5nLXJpZ2h0OiBjYWxjKHZhcigtLWJzLWd1dHRlci14KSAqIDAuNSk7XG4gICAgICBwYWRkaW5nLWxlZnQ6IGNhbGModmFyKC0tYnMtZ3V0dGVyLXgpICogMC41KTtcbiAgICB9XG5cbiAgICAmLWltZyB7XG4gICAgICBoZWlnaHQ6IDIyMHB4O1xuICAgICAgbWFyZ2luOiAwIC0yNnB4O1xuICAgICAgY3Vyc29yOiBwb2ludGVyO1xuICAgICAgb3ZlcmZsb3c6IGhpZGRlbjtcblxuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICAgIGhlaWdodDogMzAwcHg7XG4gICAgICAgIG1hcmdpbjogMDtcbiAgICAgICAgYm9yZGVyLXJhZGl1czogOHB4O1xuICAgICAgfVxuXG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgICAgaGVpZ2h0OiAzNDBweDtcbiAgICAgIH1cblxuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHhsKSB7XG4gICAgICAgIGhlaWdodDogNDAwcHg7XG4gICAgICB9XG5cbiAgICAgIGltZyB7XG4gICAgICAgIG9iamVjdC1maXQ6IGNvdmVyO1xuICAgICAgICB0cmFuc2l0aW9uOiB0cmFuc2Zvcm0gMXM7XG4gICAgICAgIHRyYW5zZm9ybTogc2NhbGUoMSk7XG5cbiAgICAgICAgJjpob3ZlcixcbiAgICAgICAgJjpmb2N1cyB7XG4gICAgICAgICAgdHJhbnNmb3JtOiBzY2FsZSgxLjEpO1xuICAgICAgICAgIHRyYW5zZm9ybS1vcmlnaW46IDUwJSA1MCU7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG4gICAgJi1saW5rIHtcbiAgICAgIHdpZHRoOiAtbW96LWZpdC1jb250ZW50O1xuICAgICAgd2lkdGg6IGZpdC1jb250ZW50O1xuICAgICAgZGlzcGxheTogYmxvY2s7XG4gICAgICBjdXJzb3I6IHBvaW50ZXI7XG4gICAgICBtYXJnaW46IDAuNjI1cmVtIDAgMCAxLjYyNXJlbTtcbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRzbSkge1xuICAgICAgICBtYXJnaW4tbGVmdDogMDtcbiAgICAgIH1cbiAgICB9XG4gICAgJi1idG4ge1xuICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgcmlnaHQ6IDMwcHg7XG4gICAgICBib3R0b206IDA7XG4gICAgICBjdXJzb3I6IHBvaW50ZXI7XG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkc20pIHtcbiAgICAgICAgcmlnaHQ6IDI1cHg7XG4gICAgICB9XG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgICAgYm90dG9tOiAwcHg7XG4gICAgICAgIHJpZ2h0OiAxNXB4O1xuICAgICAgfVxuICAgICAgc3ZnIHBhdGgge1xuICAgICAgICB0cmFuc2l0aW9uOiBmaWxsIDAuNXMgZWFzZTtcbiAgICAgIH1cbiAgICAgICY6Zm9jdXMsXG4gICAgICAmOmhvdmVyIHtcbiAgICAgICAgc3ZnID4gcGF0aDpudGgtb2YtdHlwZSgxKSB7XG4gICAgICAgICAgZmlsbDogIzhlMDAzODtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cbiAgfVxuICAmX190ZXh0IHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICBwYWRkaW5nLXJpZ2h0OiAxLjYyNXJlbTtcbiAgICAgIHBhZGRpbmctbGVmdDogMS42MjVyZW07XG4gICAgfVxuXG4gICAgLmNvbnRlbnQtdGV4dF9fd3JhcHBlciB7XG4gICAgICBwYWRkaW5nOiAxLjI1cmVtIDEuNjI1cmVtO1xuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICAgIHBhZGRpbmc6IDEuMjVyZW0gMDtcbiAgICAgIH1cbiAgICAgIGJ1dHRvbiB7XG4gICAgICAgIG1hcmdpbjogMDtcbiAgICAgIH1cbiAgICB9XG4gIH1cbn1cbiIsIi5jb250ZW50LWxpc3QtaWNvbl9fd3JhcHBlciB7XG4gIHBhZGRpbmc6IDEuODc1cmVtO1xuICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICBwYWRkaW5nOiAzLjEyNXJlbTtcbiAgfVxuXG4gICYtZmxleCB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgICAgIGdhcDogMS44NzVyZW07XG4gICAgfVxuXG4gICAgLmNvbnRlbnQtbGlzdC1pY29uIHtcbiAgICAgIGZsZXg6IDEgMSAwO1xuICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgIGdhcDogMDtcblxuICAgICAgJl9faW1nIHtcbiAgICAgICAgaW1nIHtcbiAgICAgICAgICBib3JkZXItcmFkaXVzOiA4cHg7XG4gICAgICAgIH1cbiAgICAgIH1cblxuICAgICAgJl9fdGV4dCB7XG4gICAgICAgICYtLWxlZnQge1xuICAgICAgICAgIHRleHQtYWxpZ246IGxlZnQ7XG4gICAgICAgIH1cblxuICAgICAgICAmLS1jZW50ZXIge1xuICAgICAgICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICAgICAgfVxuXG4gICAgICAgICYtLXJpZ2h0IHtcbiAgICAgICAgICB0ZXh0LWFsaWduOiByaWdodDtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gICYtaGVhZGxpbmUge1xuICAgIG1hcmdpbi1ib3R0b206IDEuODc1cmVtO1xuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICR4bCkge1xuICAgICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgIH1cbiAgfVxufVxuXG4uY29udGVudC1saXN0X193cmFwcGVyIHtcbiAgcGFkZGluZzogMS44NzVyZW0gMS42MjVyZW07XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcblxuICAuY29udGVudC1saXN0IHtcbiAgICB1bCxcbiAgICBvbCB7XG4gICAgICBkaXNwbGF5OiBncmlkO1xuICAgICAgZ2FwOiAxLjI1cmVtO1xuXG4gICAgICBsaSBwOmxhc3QtY2hpbGQge1xuICAgICAgICBtYXJnaW4tYm90dG9tOiAwO1xuICAgICAgfVxuXG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgICAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiByZXBlYXQoMiwgMWZyKTtcbiAgICAgIH1cblxuICAgICAgbGkge1xuICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgICAgICB3aWR0aDogNTAlO1xuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuXG4gICAgJl9faXRlbXMge1xuICAgICAgZGlzcGxheTogZ3JpZDtcbiAgICAgIGdyaWQtdGVtcGxhdGUtY29sdW1uczogcmVwZWF0KDEsIDFmcik7XG4gICAgICBnYXA6IDFyZW07XG5cbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IHJlcGVhdCgyLCAxZnIpO1xuICAgICAgfVxuXG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgICAgbWF4LXdpZHRoOiAxMjAwcHg7XG4gICAgICAgIG1hcmdpbjogMCBhdXRvO1xuICAgICAgfVxuXG4gICAgICAmLS1zaW5nbGVDb2wge1xuICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgICAgICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IHJlcGVhdCgxLCAxZnIpO1xuICAgICAgICB9XG4gICAgICB9XG5cbiAgICAgIGJ1dHRvbiB7XG4gICAgICAgIG1hcmdpbi10b3A6IDFyZW07XG4gICAgICAgIGdyaWQtY29sdW1uOiAxIC8gLTE7XG4gICAgICB9XG5cbiAgICAgIC5jb250ZW50LWxpc3Qge1xuICAgICAgICBncmlkLWNvbHVtbjogMSAvIC0xO1xuICAgICAgICBtYXJnaW4tYm90dG9tOiAwLjVyZW07XG5cbiAgICAgICAgbGkge1xuICAgICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuXG4gICAgJi1pY29uIHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgZ2FwOiAwLjc1cmVtO1xuICAgICAgbWFyZ2luOiAwO1xuXG4gICAgICAmX19pY29uIHtcbiAgICAgICAgbWluLXdpZHRoOiAzMnB4O1xuICAgICAgICB3aWR0aDogMzJweDtcbiAgICAgICAgbWF4LXdpZHRoOiAzMnB4O1xuICAgICAgICBtaW4taGVpZ2h0OiAzMnB4O1xuICAgICAgICBoZWlnaHQ6IDMycHg7XG4gICAgICAgIG1heC1oZWlnaHQ6IDMycHg7XG4gICAgICAgIHBhZGRpbmc6IDA7XG4gICAgICAgIG1hcmdpbjogMDtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAmX19oZWFkbGluZSB7XG4gICAgICBtYXJnaW4tYm90dG9tOiAyMHB4O1xuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICAgIH1cblxuICAgICAgJi1pY29uIHtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICAgIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogJGVyZ28td2hpdGU7XG4gICAgICAgIHdpZHRoOiA3MHB4O1xuICAgICAgICBoZWlnaHQ6IDcwcHg7XG4gICAgICAgIG1hcmdpbjogMHB4IGF1dG8gMzBweCBhdXRvO1xuXG4gICAgICAgIGltZyB7XG4gICAgICAgICAgd2lkdGg6IDQ4cHg7XG4gICAgICAgICAgaGVpZ2h0OiA0OHB4O1xuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuXG4gICAgJl9fZGlzdHVyYmVyIHtcbiAgICAgIGhlaWdodDogNi4yNXJlbTtcbiAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgIHJpZ2h0OiAxLjVyZW07XG4gICAgICB0b3A6IC00LjVyZW07XG4gICAgICB3aWR0aDogNi4yNXJlbTtcblxuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICAgIHJpZ2h0OiAxLjI1cmVtO1xuICAgICAgICB0b3A6IC0xLjVyZW07XG4gICAgICB9XG5cbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgICByaWdodDogM3JlbTtcbiAgICAgICAgdG9wOiAtMi41cmVtO1xuICAgICAgfVxuXG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgICAgaGVpZ2h0OiA3LjVyZW07XG4gICAgICAgIHdpZHRoOiA3LjVyZW07XG4gICAgICAgIHJpZ2h0OiA1cmVtO1xuICAgICAgICB0b3A6IC0yLjVyZW07XG4gICAgICB9XG5cbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICR4bCkge1xuICAgICAgICByaWdodDogNy41cmVtO1xuICAgICAgICB0b3A6IC0yLjVyZW07XG4gICAgICB9XG4gICAgfVxuICB9XG59XG4iLCIuY29udGVudC1jYXJvdXNlbCB7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgaGVpZ2h0OiAxMDAlO1xuICBtYXgtaGVpZ2h0OiA2NTBweDtcbiAgbWF4LXdpZHRoOiBjYWxjKDEwMHN2dyAtIDYwcHgpO1xuICBmbGV4LXdyYXA6IG5vd3JhcDtcbiAgbWFyZ2luLWJvdHRvbTogN3JlbTtcbiAgbWFyZ2luLWxlZnQ6IGF1dG87XG4gIG1hcmdpbi1yaWdodDogYXV0bztcblxuICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkc20pIHtcbiAgICBtYXgtd2lkdGg6IGNhbGMoMTAwc3Z3IC0gMTIwcHgpO1xuICB9XG5cbiAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgbWF4LXdpZHRoOiBjYWxjKDEwMHN2dyAtIDE2MHB4KTtcbiAgICBoZWlnaHQ6IDU4MHB4O1xuICB9XG5cbiAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgLy8gd2lkdGg6IDcyMHB4O1xuICAgIG1heC13aWR0aDogY2FsYygxMDBzdncgLSAyMDBweCk7XG4gICAgaGVpZ2h0OiA0MDBweDtcbiAgfVxuXG4gIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICR4bCkge1xuICAgIHdpZHRoOiAxMTEwcHg7XG4gICAgaGVpZ2h0OiA0MDBweDtcbiAgfVxuXG4gICYtLXZpc3VhbCB7XG4gICAgaGVpZ2h0OiA1ODBweDtcblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRzbSkge1xuICAgICAgaGVpZ2h0OiA1MDBweDtcbiAgICAgIHdpZHRoOiA0MjBweDtcbiAgICB9XG5cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgIHdpZHRoOiA1NzBweDtcbiAgICB9XG5cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgIHdpZHRoOiA5MjBweDtcbiAgICB9XG4gIH1cbiAgJl9fY29udHJvbCB7XG4gICAgJi1idXR0b25zIHtcbiAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgIGJvdHRvbTogNTMlO1xuICAgICAgei1pbmRleDogMTtcbiAgICB9XG4gICAgJi1idXR0b24ge1xuICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgd2lkdGg6IDI0cHg7XG4gICAgICBoZWlnaHQ6IDI0cHg7XG4gICAgICBjdXJzb3I6IHBvaW50ZXI7XG4gICAgICAmOmJlZm9yZSB7XG4gICAgICAgIGNvbnRlbnQ6ICcnO1xuICAgICAgICBkaXNwbGF5OiBibG9jaztcbiAgICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgICBoZWlnaHQ6IDQwMHB4O1xuICAgICAgICB3aWR0aDogMjAwcHg7XG4gICAgICAgIHRyYW5zbGF0ZTogLTUwJSAtNTAlO1xuICAgICAgfVxuICAgICAgJjphZnRlciB7XG4gICAgICAgIGNvbnRlbnQ6ICcnO1xuICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDI1MiwgMjUyLCAyNTIsIDAuMzgpO1xuICAgICAgICB3aWR0aDogNDBweDtcbiAgICAgICAgaGVpZ2h0OiA0MHB4O1xuICAgICAgICBtYXJnaW4tbGVmdDogLTAuNHJlbTtcbiAgICAgICAgbWFyZ2luLXRvcDogLTAuNHJlbTtcbiAgICAgICAgYm9yZGVyLXJhZGl1czogNTAlO1xuICAgICAgICBkaXNwbGF5OiBub25lO1xuICAgICAgfVxuICAgICAgJi0tcHJldiB7XG4gICAgICAgIGJhY2tncm91bmQtaW1hZ2U6IHVybCgnLi4vLi4vc3Zncy9wZmVpbF9saW5rcy5zdmcnKTtcbiAgICAgICAgbGVmdDogLTclO1xuXG4gICAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgICAgIGxlZnQ6IC05JTtcbiAgICAgICAgfVxuICAgICAgfVxuICAgICAgJi0tbmV4dCB7XG4gICAgICAgIGJhY2tncm91bmQtaW1hZ2U6IHVybCgnLi4vLi4vc3Zncy9wZmVpbF9yZWNodHMuc3ZnJyk7XG4gICAgICAgIHJpZ2h0OiAtNyU7XG5cbiAgICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICAgICAgcmlnaHQ6IC05JTtcbiAgICAgICAgfVxuICAgICAgICAmOmJlZm9yZSB7XG4gICAgICAgICAgbGVmdDogMTAwJTtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cbiAgICAmLXBhZ2luYXRpb24ge1xuICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgYm90dG9tOiAtMnJlbTtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcblxuICAgICAgJi1pbmRpY2F0b3Ige1xuICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkZXJnby13YXJtZ3JleS1kYXJrMTtcbiAgICAgICAgYm9yZGVyOiBub25lO1xuICAgICAgICBib3JkZXItcmFkaXVzOiA1MCU7XG4gICAgICAgIHdpZHRoOiAwLjVyZW07XG4gICAgICAgIGhlaWdodDogMC41cmVtO1xuICAgICAgICBtYXJnaW46IDAgMC43NXJlbTtcbiAgICAgICAgcGFkZGluZzogMDtcbiAgICAgICAgY3Vyc29yOiBwb2ludGVyO1xuICAgICAgICAmLmFjdGl2ZSB7XG4gICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogJGVyZ28tbWFpbjtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gICZfX2NvbnRyb2wtYnV0dG9uOmhvdmVyOjphZnRlciB7XG4gICAgZGlzcGxheTogYmxvY2s7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKC0xMDAwJSk7XG4gIH1cblxuICAmX19wYWdpbmF0aW9uLWluZGljYXRvci5hY3RpdmUge1xuICAgIGJhY2tncm91bmQtY29sb3I6ICRlcmdvLW1haW47XG4gIH1cbn1cbiIsIlxuLmNjX2RpYWxvZy5pbnRlcnN0aXRpYWwgLmNjX2Jfb2ssIC5jY19kaWFsb2cuaW50ZXJzdGl0aWFsIC5jY19jcF9mX3NhdmUge1xuICBiYWNrZ3JvdW5kOiAjOGUwMDM4ICFpbXBvcnRhbnQ7XG59XG5cbi5jY19kaWFsb2cuaW50ZXJzdGl0aWFsIC5jY19iX29rOmhvdmVyLCAuY2NfZGlhbG9nLmludGVyc3RpdGlhbCAuY2NfY3BfZl9zYXZlOmhvdmVyIHtcbiAgYmFja2dyb3VuZDogIzcxMDIyZSAhaW1wb3J0YW50O1xufVxuXG4uY2NfZGlhbG9nLmludGVyc3RpdGlhbCAuY2NfYl9jcCB7XG4gIGJvcmRlci1jb2xvcjogIzhlMDAzOCAhaW1wb3J0YW50O1xuICBjb2xvcjogIzhlMDAzOCAhaW1wb3J0YW50O1xufVxuXG4uY2NfZGlhbG9nLmludGVyc3RpdGlhbCBhOm5vdChbY2xhc3NdKSB7XG4gIGNvbG9yOiAjOGUwMDM4ICFpbXBvcnRhbnQ7XG4gIGZvbnQtd2VpZ2h0OiBib2xkO1xuICB0ZXh0LWRlY29yYXRpb246IHVuZGVybGluZTtcbn1cblxuLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLWRpYWxvZyBhOm5vdChbY2xhc3NdKSB7XG4gIGNvbG9yOiAjOGUwMDM4ICFpbXBvcnRhbnQ7XG4gIGZvbnQtd2VpZ2h0OiBib2xkO1xuICB0ZXh0LWRlY29yYXRpb246IHVuZGVybGluZTtcbn1cblxuLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLWRpYWxvZyAuY2NfY3BfZl9zYXZlIGJ1dHRvbiB7XG4gIGJhY2tncm91bmQ6ICM4ZTAwMzggIWltcG9ydGFudDtcbn1cblxuLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLWRpYWxvZyAuY2NfY3BfZl9zYXZlIGJ1dHRvbjpob3ZlciB7XG4gIGJhY2tncm91bmQ6ICM3MTAyMmUgIWltcG9ydGFudDtcbn1cblxuLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLWRpYWxvZyAuY2NfY3BfZl9zYXZlIGJ1dHRvbi5zZWNvbmRhcnkge1xuICBiYWNrZ3JvdW5kOiBub25lICFpbXBvcnRhbnQ7XG4gIGJvcmRlcjogMnB4IHNvbGlkICM4ZTAwMzg7XG4gIGNvbG9yOiAjOGUwMDM4ICFpbXBvcnRhbnQ7XG59XG5cbi5jb29raWUtY29uc2VudC1wcmVmZXJlbmNlcy1vdmVybGF5IC5jb29raWUtY29uc2VudC1wcmVmZXJlbmNlcy1kaWFsb2cgLmNjX2NwX2hlYWRfdGl0bGUgaDIge1xuICBjb2xvcjogIzhlMDAzOCAhaW1wb3J0YW50O1xufVxuXG4uY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtb3ZlcmxheSAuY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtZGlhbG9nIC5jY19jcF9oZWFkX3RpdGxlOjpiZWZvcmUge1xuICBiYWNrZ3JvdW5kOiB1cmwoXCIuLi9pbWcvZXJnby5zdmdcIikgbm8tcmVwZWF0O1xuICBiYWNrZ3JvdW5kLXNpemU6IGNvbnRhaW47XG4gIGNvbnRlbnQ6ICcnO1xuICBoZWlnaHQ6IDI4cHg7XG4gIG1hcmdpbi1yaWdodDogMjBweDtcbiAgbWFyZ2luLXRvcDogLTdweDtcbiAgd2lkdGg6IDEwMHB4O1xufVxuXG4uY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtb3ZlcmxheSAuY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtZGlhbG9nIC5jY19jcF9tX21lbnUge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZWZlN2VkICFpbXBvcnRhbnQ7XG59XG5cbi5jb29raWUtY29uc2VudC1wcmVmZXJlbmNlcy1vdmVybGF5IC5jb29raWUtY29uc2VudC1wcmVmZXJlbmNlcy1kaWFsb2cgLmNjX2NwX21fbWVudSBsaSB7XG4gIGJhY2tncm91bmQ6IG5vbmUgIWltcG9ydGFudDtcbiAgYm9yZGVyLWJvdHRvbTogMXB4IHNvbGlkICNmZmYgIWltcG9ydGFudDtcbn1cblxuLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLWRpYWxvZyAuY2NfY3BfbV9tZW51IGxpW2FjdGl2ZT10cnVlXSB7XG4gIGJhY2tncm91bmQ6ICNmZmYgIWltcG9ydGFudDtcbn1cblxuLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLWRpYWxvZyAuY2NfY3BfbV9tZW51IGxpW2FjdGl2ZT10cnVlXSBhIHtcbiAgYm9yZGVyLWxlZnQtY29sb3I6ICM4ZTAwMzggIWltcG9ydGFudDtcbn1cblxuLy8gTGFzY2hlIENvb2tpZSBiYW5uZXIgbGVmdFxuLy8gI2NoYW5nZUNvb2tpZXMge1xuLy8gICBiYWNrZ3JvdW5kOiByZ2JhKDI1NSwgMjU1LCAyNTUsIDAuOCk7XG4vLyAgIGJhY2tkcm9wLWZpbHRlcjogYmx1cig1cHgpO1xuLy8gICBwYWRkaW5nOiAwLjNlbSAxZW07XG4vLyAgIGZvbnQtc2l6ZTogMWVtO1xuLy8gICBsaW5lLWhlaWdodDogMS4yO1xuLy8gICBjdXJzb3I6IHBvaW50ZXI7XG4vLyAgIHdoaXRlLXNwYWNlOiBub3JtYWw7XG4vLyAgIGNvbG9yOiAjOGUwMDM4O1xuLy8gICBib3JkZXI6IDFweCBzb2xpZCAjOGUwMDM4O1xuLy8gICBib3JkZXItYm90dG9tOiAwO1xuLy8gICBib3JkZXItcmFkaXVzOiA1cHggNXB4IDAgMDtcbi8vICAgcG9zaXRpb246IGZpeGVkO1xuLy8gICBib3R0b206IDUwJTtcbi8vICAgaGVpZ2h0OiAzMHB4O1xuLy8gICB6LWluZGV4OiA5OTg7XG4vLyAgIHRyYW5zZm9ybTogcm90YXRlKDkwZGVnKTtcbi8vICAgdHJhbnNmb3JtLW9yaWdpbjogMTVweCBjZW50ZXIgMDtcbi8vICAgdGV4dC1kZWNvcmF0aW9uOiBub25lICFpbXBvcnRhbnQ7XG4vLyAgIHRyYW5zaXRpb246IC4xNXMgYmFja2dyb3VuZCwgLjE1cyBjb2xvcjtcbi8vIH1cblxuLy8gQG1lZGlhIChtYXgtd2lkdGg6IDU3NXB4KSB7XG4vLyAgICNjaGFuZ2VDb29raWVzIHtcbi8vICAgICAgIGZvbnQtc2l6ZTogLjhlbTtcbi8vICAgICAgIGhlaWdodDogMjRweDtcbi8vICAgICAgIGxlZnQ6IC01cHg7XG4vLyAgIH1cbi8vIH1cblxuLy8gI2NoYW5nZUNvb2tpZXM6aG92ZXIge1xuLy8gICBiYWNrZ3JvdW5kOiAjOGUwMDM4O1xuLy8gICBjb2xvcjogI2ZmZjtcbi8vIH1cblxuLyogIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMgY29va2llIG5vdGljZSAjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyAqL1xuLmNjX292ZXJsYXlfbG9jayB7XG4gIGJhY2tncm91bmQ6IHJnYmEoMjU1LCAyNTUsIDI1NSwgMC45KSAhaW1wb3J0YW50O1xuICBiYWNrZHJvcC1maWx0ZXI6IGJsdXIoNXB4KTtcbiAgYm94LXNoYWRvdzogMCAwIDUwcHggcmdiYSgwLCAwLCAwLCAwLjA3NSk7XG4gIGhlaWdodDogYXV0byAhaW1wb3J0YW50O1xuICB6LWluZGV4OiA5OTkgIWltcG9ydGFudDtcbn1cblxuLmNjX292ZXJsYXlfbG9jay5oaWRkZW4ge1xuICBkaXNwbGF5OiBub25lICFpbXBvcnRhbnQ7XG59XG5cbi5jY19vdmVybGF5X2xvY2sgLmNjX2RpYWxvZy5pbnRlcnN0aXRpYWwge1xuICBiYWNrZ3JvdW5kOiBub25lICFpbXBvcnRhbnQ7XG4gIGxlZnQ6IDAgIWltcG9ydGFudDtcbiAgbWFyZ2luOiBhdXRvO1xuICBtYXgtd2lkdGg6IDExNThweCAhaW1wb3J0YW50O1xuICBwYWRkaW5nOiAxLjVyZW0gIWltcG9ydGFudDtcbiAgcG9zaXRpb246IHN0YXRpYyAhaW1wb3J0YW50O1xuICByaWdodDogMCAhaW1wb3J0YW50O1xuICB0b3A6IDAgIWltcG9ydGFudDtcbn1cblxuQG1lZGlhIChtYXgtd2lkdGg6IDc2N3B4KSB7XG4gIC5jY19vdmVybGF5X2xvY2sgLmNjX2RpYWxvZy5pbnRlcnN0aXRpYWwge1xuICAgIG1heC13aWR0aDogOTAlICFpbXBvcnRhbnQ7XG4gICAgcGFkZGluZzogMS45cmVtO1xuICB9XG59XG5cbkBtZWRpYSAobWF4LXdpZHRoOiA1NzVweCkge1xuICAuY2Nfb3ZlcmxheV9sb2NrIC5jY19kaWFsb2cuaW50ZXJzdGl0aWFsIC5jY19kaWFsb2dfaGVhZGxpbmUge1xuICAgIGZvbnQtc2l6ZTogMThweCAhaW1wb3J0YW50O1xuICB9XG5cbiAgLmNjX292ZXJsYXlfbG9jayAuY2NfZGlhbG9nLmludGVyc3RpdGlhbCAuY2NfZGlhbG9nX3RleHQge1xuICAgIGZvbnQtc2l6ZTogMTRweCAhaW1wb3J0YW50O1xuICB9XG59XG5cbkBtZWRpYSAobWF4LXdpZHRoOiAzMjFweCkge1xuICAuY2Nfb3ZlcmxheV9sb2NrIC5jY19kaWFsb2cuaW50ZXJzdGl0aWFsIHtcbiAgICBwYWRkaW5nOiAxLjVyZW07XG4gIH1cbn1cblxuLmNjX292ZXJsYXlfbG9jayAuY2NfZGlhbG9nLmludGVyc3RpdGlhbCBidXR0b24sIC5jY19vdmVybGF5X2xvY2sgLmNjX2RpYWxvZy5pbnRlcnN0aXRpYWwgcCwgLmNjX292ZXJsYXlfbG9jayAuY2NfZGlhbG9nLmludGVyc3RpdGlhbCBoMSB7XG4gIGZvbnQtZmFtaWx5OiAnRlNNZSc7XG59XG5cbkBtZWRpYSAobWF4LXdpZHRoOiA5OTFweCkge1xuICAuY2Nfb3ZlcmxheV9sb2NrIC5jY19kaWFsb2cuaW50ZXJzdGl0aWFsIGJ1dHRvbiB7XG4gICAgZm9udC1zaXplOiAxOHB4ICFpbXBvcnRhbnQ7XG4gIH1cbn1cblxuQG1lZGlhIChtYXgtd2lkdGg6IDc2N3B4KSB7XG4gIC5jY19vdmVybGF5X2xvY2sgLmNjX2RpYWxvZy5pbnRlcnN0aXRpYWwgYnV0dG9uIHtcbiAgICBmb250LXNpemU6IDE2cHggIWltcG9ydGFudDtcbiAgICBwYWRkaW5nOiAwIDIwcHggIWltcG9ydGFudDtcbiAgfVxufVxuXG5AbWVkaWEgKG1heC13aWR0aDogMzIxcHgpIHtcbiAgLmNjX292ZXJsYXlfbG9jayAuY2NfZGlhbG9nLmludGVyc3RpdGlhbCBidXR0b24ge1xuICAgIGZvbnQtc2l6ZTogMTRweCAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmc6IDAgNXB4ICFpbXBvcnRhbnQ7XG4gIH1cbn1cblxuLmNjX292ZXJsYXlfbG9jayAuY2NfZGlhbG9nLmludGVyc3RpdGlhbCAuY2NfZGlhbG9nX3RleHQge1xuICBtYXJnaW4tYm90dG9tOiAyNXB4O1xufVxuXG4uY2Nfb3ZlcmxheV9sb2NrIC5jY19kaWFsb2cuaW50ZXJzdGl0aWFsIC5jY19kaWFsb2dfaGVhZGxpbmUgfiBkaXY6bGFzdC1jaGlsZCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiByb3ctcmV2ZXJzZTtcbiAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDtcbn1cblxuQG1lZGlhIChtYXgtd2lkdGg6IDU3NXB4KSB7XG4gIC5jY19vdmVybGF5X2xvY2sgLmNjX2RpYWxvZy5pbnRlcnN0aXRpYWwgLmNjX2RpYWxvZ19oZWFkbGluZSB+IGRpdjpsYXN0LWNoaWxkIHtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uLXJldmVyc2U7XG4gIH1cbn1cblxuLmNjX292ZXJsYXlfbG9jayAuY2NfZGlhbG9nLmludGVyc3RpdGlhbCAuY2NfYl9vayB7XG4gIGJvcmRlci1yYWRpdXM6IDI1cHg7XG4gIGZvbnQtd2VpZ2h0OiBib2xkO1xuICBmb250LXNpemU6IDIwcHg7XG4gIGhlaWdodDogNTRweDtcbiAgbWFyZ2luLWxlZnQ6IDMwcHg7XG4gIHBhZGRpbmc6IDEycHggNDBweDtcbn1cblxuQG1lZGlhIChtYXgtd2lkdGg6IDc2N3B4KSB7XG4gIC5jY19vdmVybGF5X2xvY2sgLmNjX2RpYWxvZy5pbnRlcnN0aXRpYWwgLmNjX2Jfb2sge1xuICAgIG1hcmdpbi1sZWZ0OiAxNXB4O1xuICB9XG59XG5cbkBtZWRpYSAobWF4LXdpZHRoOiA1NzVweCkge1xuICAuY2Nfb3ZlcmxheV9sb2NrIC5jY19kaWFsb2cuaW50ZXJzdGl0aWFsIC5jY19iX29rIHtcbiAgICBtYXJnaW46IDE1cHggMCAwIDA7XG4gIH1cbn1cblxuLmNjX292ZXJsYXlfbG9jayAuY2NfZGlhbG9nLmludGVyc3RpdGlhbCAuY2NfYl9jcCB7XG4gIGJhY2tncm91bmQ6IG5vbmUgIWltcG9ydGFudDtcbiAgYm9yZGVyLXJhZGl1czogMjVweDtcbiAgYm9yZGVyOiAycHggc29saWQgIzAwMDtcbiAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gIGZvbnQtc2l6ZTogMjBweDtcbiAgaGVpZ2h0OiA1NHB4O1xuICBwYWRkaW5nOiAxMXB4IDQwcHg7XG4gIG1hcmdpbi1sZWZ0OiAwICFpbXBvcnRhbnQ7XG59XG5cbkBtZWRpYSAobWF4LWhlaWdodDogNjk5cHgpIHtcbiAgLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkge1xuICAgIG92ZXJmbG93LXk6IHNjcm9sbDtcbiAgfVxufVxuXG4uY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtb3ZlcmxheS52aXNpYmxlIHtcbiAgZGlzcGxheTogYmxvY2s7XG59XG5cbkBtZWRpYSAobWluLWhlaWdodDogNzAwcHgpIGFuZCAobWluLXdpZHRoOiA5OTJweCkge1xuICAuY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtb3ZlcmxheS52aXNpYmxlIHtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gIH1cbn1cblxuLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXk6bm90KC52aXNpYmxlKSB7XG4gIGRpc3BsYXk6IG5vbmUgIWltcG9ydGFudDtcbn1cblxuLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLWRpYWxvZyB7XG4gIG1heC13aWR0aDogNzIwcHggIWltcG9ydGFudDtcbn1cblxuQG1lZGlhIChtaW4taGVpZ2h0OiA2NDBweCkgYW5kIChtaW4td2lkdGg6IDk5MnB4KSB7XG4gIC5jb29raWUtY29uc2VudC1wcmVmZXJlbmNlcy1vdmVybGF5IC5jb29raWUtY29uc2VudC1wcmVmZXJlbmNlcy1kaWFsb2cge1xuICAgIHBvc2l0aW9uOiByZWxhdGl2ZSAhaW1wb3J0YW50O1xuICB9XG59XG5cbkBtZWRpYSAobWF4LXdpZHRoOiA3NjdweCkge1xuICAuY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtb3ZlcmxheSAuY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtZGlhbG9nIHtcbiAgICBtYXgtd2lkdGg6IDkwJSAhaW1wb3J0YW50O1xuICB9XG59XG5cbkBtZWRpYSAobWF4LXdpZHRoOiA1NzVweCkge1xuICAuY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtb3ZlcmxheSAuY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtZGlhbG9nIC5jY19jcF9jb250ZW50IC5jY19jcF9tX2NvbnRlbnQgaDEge1xuICAgIGZvbnQtc2l6ZTogMThweCAhaW1wb3J0YW50O1xuICB9XG59XG5cbi5jb29raWUtY29uc2VudC1wcmVmZXJlbmNlcy1vdmVybGF5IC5jb29raWUtY29uc2VudC1wcmVmZXJlbmNlcy1kaWFsb2cgYnV0dG9uLCAuY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtb3ZlcmxheSAuY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtZGlhbG9nIHAsIC5jb29raWUtY29uc2VudC1wcmVmZXJlbmNlcy1vdmVybGF5IC5jb29raWUtY29uc2VudC1wcmVmZXJlbmNlcy1kaWFsb2cgaDEge1xuICBmb250LWZhbWlseTogJ0ZTTWUnO1xufVxuXG4uY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtb3ZlcmxheSAuY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtZGlhbG9nIC5jY19jcF9mX3NhdmUgYnV0dG9uIHtcbiAgYm9yZGVyLXJhZGl1czogMjVweDtcbiAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gIGZvbnQtc2l6ZTogMjBweCAhaW1wb3J0YW50O1xuICBoZWlnaHQ6IDU0cHggIWltcG9ydGFudDtcbiAgbWFyZ2luLWxlZnQ6IDMwcHg7XG4gIG9wYWNpdHk6IDEgIWltcG9ydGFudDtcbiAgcGFkZGluZzogMTJweCA0MHB4O1xufVxuXG4uY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtb3ZlcmxheSAuY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtZGlhbG9nIC5jY19jcF9mX3NhdmUgYnV0dG9uLnNlY29uZGFyeSB7XG4gIGJhY2tncm91bmQ6IG5vbmUgIWltcG9ydGFudDtcbiAgYm9yZGVyOiAycHggc29saWQgIzAwMDtcbiAgbWFyZ2luLXJpZ2h0OiAwICFpbXBvcnRhbnQ7XG4gIHBhZGRpbmc6IDEwcHggNDBweDtcbn1cblxuQG1lZGlhIChtYXgtd2lkdGg6IDc2N3B4KSB7XG4gIC5jb29raWUtY29uc2VudC1wcmVmZXJlbmNlcy1vdmVybGF5IC5jb29raWUtY29uc2VudC1wcmVmZXJlbmNlcy1kaWFsb2cgLmNjX2NwX2Zfc2F2ZSBidXR0b24uc2Vjb25kYXJ5IHtcbiAgICBwYWRkaW5nOiAxMHB4IDIwcHggIWltcG9ydGFudDtcbiAgfVxufVxuXG5AbWVkaWEgKG1heC13aWR0aDogNjAwcHgpIHtcbiAgLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLWRpYWxvZyAuY2NfY3BfZl9zYXZlIGJ1dHRvbi5zZWNvbmRhcnkge1xuICAgIG1hcmdpbi1ib3R0b206IDE1cHggIWltcG9ydGFudDtcbiAgfVxufVxuXG5AbWVkaWEgKG1heC13aWR0aDogOTkxcHgpIHtcbiAgLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLWRpYWxvZyAuY2NfY3BfZl9zYXZlIGJ1dHRvbiB7XG4gICAgZm9udC1zaXplOiAxOHB4ICFpbXBvcnRhbnQ7XG4gIH1cbn1cblxuQG1lZGlhIChtYXgtd2lkdGg6IDc2N3B4KSB7XG4gIC5jb29raWUtY29uc2VudC1wcmVmZXJlbmNlcy1vdmVybGF5IC5jb29raWUtY29uc2VudC1wcmVmZXJlbmNlcy1kaWFsb2cgLmNjX2NwX2Zfc2F2ZSBidXR0b24ge1xuICAgIGZvbnQtc2l6ZTogMTZweCAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmc6IDEycHggMjBweCAhaW1wb3J0YW50O1xuICB9XG59XG5cbkBtZWRpYSAobWF4LXdpZHRoOiAzMjFweCkge1xuICAuY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtb3ZlcmxheSAuY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtZGlhbG9nIC5jY19jcF9mX3NhdmUgYnV0dG9uIHtcbiAgICBmb250LXNpemU6IDE0cHg7XG4gIH1cbn1cblxuLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgLmNjX2NwX2ZfcG93ZXJlZF9ieSwgLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgLmNjX2NwX2hlYWRfbGFuZ19zZWxlY3RvciwgLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgW3Q9XCJjb250ZW50X2Z1bmN0aW9uYWxpdHlcIl0sIC5jb29raWUtY29uc2VudC1wcmVmZXJlbmNlcy1vdmVybGF5IFt0PVwiY29udGVudF90YXJnZXRpbmdcIl0ge1xuICBkaXNwbGF5OiBub25lICFpbXBvcnRhbnQ7XG59XG5cbi5jb29raWUtY29uc2VudC1wcmVmZXJlbmNlcy1vdmVybGF5IC5jY19jcF9mb290ZXIge1xuICBiYWNrZ3JvdW5kOiBub25lICFpbXBvcnRhbnQ7XG4gIGJvcmRlcjogbm9uZSAhaW1wb3J0YW50O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kICFpbXBvcnRhbnQ7XG4gIHBhZGRpbmc6IDJyZW07XG59XG5cbkBtZWRpYSAobWF4LXdpZHRoOiA2MDBweCkge1xuICAuY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtb3ZlcmxheSAuY2NfY3BfZm9vdGVyIHtcbiAgICBwYWRkaW5nOiAwIDEuNXJlbSAxLjVyZW07XG4gIH1cblxuICAuY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtb3ZlcmxheSAuY2NfY3BfZm9vdGVyIC5jY19jcF9mX3NhdmUge1xuICAgIHdpZHRoOiAxMDAlO1xuICB9XG5cbiAgLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgLmNjX2NwX2Zvb3RlciAuY2NfY3BfZl9zYXZlIGJ1dHRvbiB7XG4gICAgbWFyZ2luOiAwICFpbXBvcnRhbnQ7XG4gICAgd2lkdGg6IDEwMCU7XG4gIH1cbn1cblxuLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgLmNjX2NwX2NvbnRlbnQsIC5jb29raWUtY29uc2VudC1wcmVmZXJlbmNlcy1vdmVybGF5IC5jY19jcF9tX2NvbnRlbnQge1xuICBiYWNrZ3JvdW5kOiBub25lICFpbXBvcnRhbnQ7XG4gIGJvcmRlcjogbm9uZSAhaW1wb3J0YW50O1xufVxuXG4uY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtb3ZlcmxheSAuY2NfY3BfY29udGVudCBwLCAuY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtb3ZlcmxheSAuY2NfY3BfbV9jb250ZW50IHAge1xuICBmb250LXNpemU6IDE0cHggIWltcG9ydGFudDtcbn1cblxuQG1lZGlhIChtaW4td2lkdGg6IDYwMXB4KSB7XG4gIC5jb29raWUtY29uc2VudC1wcmVmZXJlbmNlcy1vdmVybGF5IC5jY19jcF9tX2NvbnRlbnQge1xuICAgIHdpZHRoOiBjYWxjKDEwMCUgLSAyNDBweCk7XG4gIH1cbn1cblxuLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgLmNjX2NwX21fY29udGVudCAuY2NfY3BfbV9jb250ZW50X2VudHJ5W2FjdGl2ZT10cnVlXSB7XG4gIGRpc3BsYXk6IGZsZXggIWltcG9ydGFudDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbn1cblxuLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgLmNjX2NwX21fY29udGVudCAuY2NfY3BfbV9jb250ZW50X2VudHJ5W2FjdGl2ZT10cnVlXSBoMSB7XG4gIG9yZGVyOiAtMjtcbn1cblxuLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgLmNjX2NwX21fY29udGVudCAuY2NfY3BfbV9jb250ZW50X2VudHJ5W2FjdGl2ZT10cnVlXSBkaXY6bm90KFtjbGFzc10pIHtcbiAgb3JkZXI6IC0xO1xufVxuXG4uY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtb3ZlcmxheSAuY2NfY3BfbV9tZW51IHtcbiAgbWluLXdpZHRoOiAyMjBweCAhaW1wb3J0YW50O1xufVxuXG5AbWVkaWEgKG1pbi13aWR0aDogNjAxcHgpIHtcbiAgLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgLmNjX2NwX21fbWVudSB7XG4gICAgd2lkdGg6IDIyMHB4ICFpbXBvcnRhbnQ7XG4gIH1cbn1cblxuLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgLmNjX2NwX21fbWVudSBsaSB7XG4gIGJvcmRlci1yaWdodDogMCAhaW1wb3J0YW50O1xufVxuXG4uY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtb3ZlcmxheSAuY2NfY3BfbV9tZW51IGxpIGEge1xuICBib3JkZXItbGVmdDogNXB4IHNvbGlkIHRyYW5zcGFyZW50O1xuICBjb2xvcjogIzAwMCAhaW1wb3J0YW50O1xuICBmb250LWZhbWlseTogJ0ZTTWUnO1xuICBmb250LXNpemU6IDE1cHggIWltcG9ydGFudDtcbiAgcGFkZGluZzogMTVweCAhaW1wb3J0YW50O1xufVxuXG5AbWVkaWEgKG1heC13aWR0aDogNjAwcHgpIHtcbiAgLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgLmNjX2NwX21fbWVudSBsaSBhIHtcbiAgICBwYWRkaW5nOiAxMHB4IDE1cHggIWltcG9ydGFudDtcbiAgfVxufVxuXG4uY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtb3ZlcmxheSAuY2NfY3BfaGVhZF90aXRsZSB7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXIgIWltcG9ydGFudDtcbiAgZmxleC1kaXJlY3Rpb246IHJvdyAhaW1wb3J0YW50O1xuICBwYWRkaW5nOiAycmVtIDAgMS41cmVtIDFyZW0gIWltcG9ydGFudDtcbiAgd2lkdGg6IDEwMCU7XG59XG5cbkBtZWRpYSAobWF4LXdpZHRoOiA2MDBweCkge1xuICAuY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtb3ZlcmxheSAuY2NfY3BfaGVhZF90aXRsZSB7XG4gICAgcGFkZGluZzogMTVweCAxNXB4IDEwcHggMjBweCAhaW1wb3J0YW50O1xuICB9XG59XG5cbi5jb29raWUtY29uc2VudC1wcmVmZXJlbmNlcy1vdmVybGF5IC5jY19jcF9oZWFkX3RpdGxlIGgyIHtcbiAgZm9udC1mYW1pbHk6IFwiRmVkcmFTZXJpZkFcIjtcbiAgZm9udC1zaXplOiAyNXB4ICFpbXBvcnRhbnQ7XG4gIHBhZGRpbmctcmlnaHQ6IDNyZW07XG59XG5cbkBtZWRpYSAobWF4LXdpZHRoOiA3NjdweCkge1xuICAuY29va2llLWNvbnNlbnQtcHJlZmVyZW5jZXMtb3ZlcmxheSAuY2NfY3BfaGVhZF90aXRsZSBoMiB7XG4gICAgZm9udC1zaXplOiAyM3B4ICFpbXBvcnRhbnQ7XG4gICAgcGFkZGluZy1yaWdodDogNXJlbTtcbiAgfVxufVxuXG5AbWVkaWEgKG1heC13aWR0aDogNjAwcHgpIHtcbiAgLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgLmNjX2NwX2hlYWRfdGl0bGUgaDIge1xuICAgIGZvbnQtc2l6ZTogMTZweCAhaW1wb3J0YW50O1xuICB9XG59XG5cbi5jb29raWUtY29uc2VudC1wcmVmZXJlbmNlcy1vdmVybGF5IC5jY19jcF9oZWFkX3RpdGxlIGgyOjphZnRlciB7XG4gIGJhY2tncm91bmQ6IHVybChcIi4uL2ltZy9jbG9zZS1ibGFjay5zdmdcIikgbm8tcmVwZWF0O1xuICBiYWNrZ3JvdW5kLXNpemU6IGNvbnRhaW47XG4gIGNvbnRlbnQ6ICcnO1xuICBjdXJzb3I6IHBvaW50ZXI7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgaGVpZ2h0OiAyOHB4O1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHJpZ2h0OiAycmVtO1xuICB0b3A6IDJyZW07XG4gIHdpZHRoOiAyOHB4O1xufVxuXG5AbWVkaWEgKG1heC13aWR0aDogNjAwcHgpIHtcbiAgLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgLmNjX2NwX2hlYWRfdGl0bGUgaDI6OmFmdGVyIHtcbiAgICByaWdodDogMXJlbTtcbiAgICB0b3A6IDFyZW07XG4gIH1cbn1cblxuLmNvb2tpZS1jb25zZW50LXByZWZlcmVuY2VzLW92ZXJsYXkgLmNjX2NwX2hlYWRfdGl0bGUgaDI6OmFmdGVyOmhvdmVyIHtcbiAgb3BhY2l0eTogLjc7XG59XG5cbi5jb29raWUtZGV0YWlscyB7XG4gIGN1cnNvcjogcG9pbnRlcjtcbiAgZGlzcGxheTogZmxleCAhaW1wb3J0YW50O1xuICBmbGV4LXdyYXA6IHdyYXA7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbn1cblxuLmNvb2tpZS1kZXRhaWxzIHN0cm9uZzpmaXJzdC1jaGlsZCB7XG4gIHBhZGRpbmctcmlnaHQ6IDIwcHg7XG4gIHBvaW50ZXItZXZlbnRzOiBub25lO1xuICB3aWR0aDogMTAwJTtcbn1cblxuLmNvb2tpZS1kZXRhaWxzID4gYXNpZGUge1xuICBkaXNwbGF5OiBub25lO1xuICB3aWR0aDogMTAwJTtcbn1cblxuLmNvb2tpZS1kZXRhaWxzID4gYXNpZGUgc3BhbiB7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICBtYXJnaW4tcmlnaHQ6IDEwcHg7XG59XG5cbi5jb29raWUtZGV0YWlscyA+IGFzaWRlIHNwYW4gZW0ge1xuICBmb250LXN0eWxlOiBub3JtYWw7XG4gIG1hcmdpbi1yaWdodDogM3B4O1xuICBvcGFjaXR5OiAuNjtcbn1cblxuLmNvb2tpZS1kZXRhaWxzOjphZnRlciB7XG4gIGNvbnRlbnQ6ICcrJztcbiAgZm9udC1zaXplOiAyNXB4O1xuICBmb250LXdlaWdodDogYm9sZDtcbiAgbGluZS1oZWlnaHQ6IDE7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgcmlnaHQ6IDA7XG4gIHRvcDogMDtcbn1cblxuLmNvb2tpZS1kZXRhaWxzLmFjdGl2ZTo6YWZ0ZXIge1xuICBjb250ZW50OiAnLSc7XG4gIHJpZ2h0OiA0cHg7XG59XG5cbi5jb29raWUtZGV0YWlscyArIC5jb29raWUtZGV0YWlscyB7XG4gIGJvcmRlci10b3A6IDFweCBzb2xpZCAjZGRkO1xuICBtYXJnaW4tdG9wOiA4cHg7XG4gIHBhZGRpbmctdG9wOiA0cHg7XG59XG5cbiNvcGVuQ29va2llU2V0dGluZ3Mge1xuICBjdXJzb3I6IHBvaW50ZXI7XG59XG5cblxuIiwiLnJlc3VsdC1zdGFnZV9fb3ZlcnZpZXcge1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG5cbiAgLmRpc3R1cmJlciB7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIHdpZHRoOiBhdXRvO1xuICAgIGhlaWdodDogYXV0bztcbiAgICB0b3A6IDEyMHB4O1xuICAgIHJpZ2h0OiA1JTtcblxuICAgIGltZyB7XG4gICAgICBtYXgtaGVpZ2h0OiAxMjBweDtcbiAgICAgIHdpZHRoOiBhdXRvO1xuICAgIH1cblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgdG9wOiAtODBweDtcbiAgICB9XG4gIH1cblxuICAmLWltYWdlIHtcbiAgICBwYWRkaW5nOiAwO1xuICAgIG1heC1oZWlnaHQ6IDIyMHB4O1xuXG4gICAgaW1nIHtcbiAgICAgIG9iamVjdC1maXQ6IGNvdmVyO1xuICAgIH1cbiAgfVxuXG4gICYtdGV4dCB7XG4gICAgcGFkZGluZzogMS44NzVyZW0gMS42MjVyZW07XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICBwYWRkaW5nOiAxLjg3NXJlbTtcbiAgICB9XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgICBwYWRkaW5nOiAzLjc1cmVtO1xuICAgIH1cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgIHBhZGRpbmc6IDMuNzVyZW0gMi41cmVtO1xuICAgIH1cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICAgIHBhZGRpbmc6IDVyZW0gMy43NXJlbTtcbiAgICB9XG4gICAgJi13cmFwcGVyIHtcbiAgICAgICYubm8taW1hZ2Uge1xuICAgICAgICAucmVzdWx0LXN0YWdlX19vdmVydmlldy10ZXh0IHtcbiAgICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkc20pIHtcbiAgICAgICAgICAgIHBhZGRpbmc6IDEuODc1cmVtIDEuODc1cmVtIDAgMS44NzVyZW07XG4gICAgICAgICAgfVxuICAgICAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgICAgICAgICAgcGFkZGluZzogMS44NzVyZW0gMy43NXJlbSAwIDMuNzVyZW07XG4gICAgICAgICAgfVxuICAgICAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgICAgICAgcGFkZGluZzogMS44NzVyZW0gMi41IDAgMi41cmVtO1xuICAgICAgICAgIH1cbiAgICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICAgICAgICAgIHBhZGRpbmc6IDEuODc1cmVtIDMuNzVyZW0gMCAzLjc1cmVtO1xuICAgICAgICAgIH1cbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gICYtd3JhcHBlciB7XG4gICAgJi1pdGVtcyB7XG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICAgICAgZGlzcGxheTogZ3JpZDtcbiAgICAgICAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiByZXBlYXQoMywgMWZyKTtcbiAgICAgICAgY29sdW1uLWdhcDogMS41cmVtO1xuICAgICAgfVxuXG4gICAgICBhIHtcbiAgICAgICAgZ3JpZC1jb2x1bW46IHNwYW4gMztcbiAgICAgIH1cbiAgICB9XG5cbiAgICAmLS10YWJsZXQge1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogI2ZkZmRmZDtcbiAgICB9XG4gIH1cblxuICAmLWl0ZW0ge1xuICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gICAgZmxleC13cmFwOiBub3dyYXA7XG4gICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICAgIG92ZXJmbG93OiBoaWRkZW47XG4gICAgYm94LXNoYWRvdzogMCAycHggN3B4IDAgcmdiYSgwLCAwLCAwLCAwLjEpO1xuICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgICBtYXJnaW4tYm90dG9tOiAyMHB4O1xuICAgIHBhZGRpbmc6IDA7XG4gICAgQGluY2x1ZGUgYm9yZGVyLXJhZGl1cztcblxuICAgICYtd3JhcHBlciB7XG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgY29sdW1uLWdhcDogMjBweDtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAmX2ltYWdlIHtcbiAgICAgIHdpZHRoOiA2MHB4O1xuICAgICAgaGVpZ2h0OiBhdXRvO1xuICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgIHBhZGRpbmc6IDFyZW07XG5cbiAgICAgIGltZyB7XG4gICAgICAgIHdpZHRoOiA0MHB4O1xuICAgICAgICBoZWlnaHQ6IDQwcHg7XG4gICAgICB9XG4gICAgfVxuXG4gICAgJl90ZXh0IHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgICBwYWRkaW5nOiAycmVtIDFyZW07XG4gICAgICB3aWR0aDogMTAwJTtcblxuICAgICAgcCB7XG4gICAgICAgIG1hcmdpbi1ib3R0b206IDA7XG4gICAgICB9XG4gICAgfVxuXG4gICAgc3ZnIHtcbiAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgIGJvdHRvbTogMTBweDtcbiAgICAgIHJpZ2h0OiAxMHB4O1xuXG4gICAgICBwYXRoIHtcbiAgICAgICAgZmlsbDogJGVyZ28tYmxhY2s7XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgLmRldGFpbC1tb2RhbCB7XG4gICAgJl9fdGFibGUge1xuICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuXG4gICAgICAmLS1LVCB7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuXG4gICAgICAgIHRyOmxhc3QtY2hpbGQge1xuICAgICAgICAgID4gKiB7XG4gICAgICAgICAgICBwYWRkaW5nLXRvcDogMzBweDtcbiAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgIH1cblxuICAgICAgJi0tQlUge1xuICAgICAgICB3aWR0aDogMTAwJTtcblxuICAgICAgICB0cjpsYXN0LWNoaWxkIHtcbiAgICAgICAgICA+ICoge1xuICAgICAgICAgICAgcGFkZGluZy10b3A6IDMwcHg7XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICB9XG5cbiAgICAgICYtLXVuZmFsbCB7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgfVxuXG4gICAgICAmLWxpbmUge1xuICAgICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICAgIGJvdHRvbTogMjUlO1xuICAgICAgICBsZWZ0OiAyMCU7XG4gICAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRzbSkge1xuICAgICAgICAgIGxlZnQ6IDMzJTtcbiAgICAgICAgfVxuICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbWQpIHtcbiAgICAgICAgICBsZWZ0OiAzNyU7XG4gICAgICAgIH1cbiAgICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHhsKSB7XG4gICAgICAgICAgbGVmdDogNDAlO1xuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgJiArIC5idG4ge1xuICAgIG1hcmdpbjogM3JlbSBhdXRvO1xuICB9XG59XG4iLCIuY291cG9uIHtcbiAgbWFyZ2luOiBhdXRvO1xuICBtYXgtd2lkdGg6IDEwMDBweDtcbiAgcGFkZGluZzogMS44NzVyZW0gMS42MjVyZW07XG5cbiAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgcGFkZGluZzogMS44NzVyZW07XG4gIH1cbiAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgcGFkZGluZzogMy4xMjVyZW0gMS44NzVyZW07XG4gIH1cblxuICAmX19mb3JtIHtcbiAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgdGV4dC1hbGlnbjogbGVmdDtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcblxuICAgICYtaGVhZGxpbmUge1xuICAgICAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gICAgfVxuXG4gICAgJi1pbWctd3JhcHBlciB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAganVzdGlmeS1jb250ZW50OiBmbGV4LXN0YXJ0O1xuICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuXG4gICAgICAuZGlzdHVyYmVyIHtcbiAgICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgICByaWdodDogMDtcbiAgICAgICAgdG9wOiAtMTVweDtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAmLWltZyB7XG4gICAgICBtYXgtd2lkdGg6IDUyMHB4O1xuICAgICAgbWF4LWhlaWdodDogMzAwcHg7XG4gICAgICBtaW4td2lkdGg6IDEyOHB4O1xuICAgICAgd2lkdGg6IGF1dG87XG4gICAgICBtYXJnaW46IGF1dG87XG4gICAgICBoZWlnaHQ6IDEwMCU7XG4gICAgICBib3JkZXItcmFkaXVzOiA4cHg7XG4gICAgICBvdmVyZmxvdzogaGlkZGVuO1xuICAgICAgb2JqZWN0LWZpdDogY292ZXI7XG4gICAgfVxuXG4gICAgJi10ZXh0IHtcbiAgICAgIHRleHQtYWxpZ246IGxlZnQ7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgICAgbWFyZ2luLXRvcDogMS4yNXJlbTtcbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgICBtYXJnaW4tdG9wOiAwO1xuICAgICAgfVxuXG4gICAgICAuY29udGVudC1saXN0LWljb24ge1xuICAgICAgICAmLS1hbGlnbmVkLWxlZnQge1xuICAgICAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICAgIH1cbiAgICAgICAgJl9faWNvbiB7XG4gICAgICAgICAgaGVpZ2h0OiA0OHB4O1xuICAgICAgICAgIHdpZHRoOiA0OHB4O1xuICAgICAgICAgIG1pbi13aWR0aDogNDhweDtcbiAgICAgICAgfVxuICAgICAgfVxuXG4gICAgICAuYzIge1xuICAgICAgICBmb250LXdlaWdodDogYm9sZDtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAmLWVtYWlsIHtcbiAgICAgIGlucHV0W3R5cGU9J2VtYWlsJ10ge1xuICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgcGFkZGluZzogMXJlbSAwLjYyNXJlbTtcbiAgICAgICAgYm9yZGVyLXJhZGl1czogNXB4IDVweCAwIDA7XG4gICAgICAgIG1hcmdpbi1ib3R0b206IDEuNjI1cmVtO1xuICAgICAgICBib3JkZXI6IG5vbmU7XG4gICAgICAgIGJvcmRlci1ib3R0b206IDJweCBzb2xpZCBncmF5O1xuICAgICAgfVxuXG4gICAgICAubm90aWNlIHtcbiAgICAgICAgdGV4dC1hbGlnbjogbGVmdDtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAmLWNoZWNrYm94IHtcbiAgICAgIG1hcmdpbi10b3A6IDEuMjVyZW07XG5cbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgICBtYXJnaW4tdG9wOiAxLjg3NXJlbTtcbiAgICAgIH1cblxuICAgICAgLmQtZmxleCB7XG4gICAgICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgICAgfVxuXG4gICAgICBsYWJlbCB7XG4gICAgICAgIG1hcmdpbi1sZWZ0OiA1cHg7XG4gICAgICB9XG5cbiAgICAgIC5ub3RpY2UtY29udGFpbmVyIHtcbiAgICAgICAgdGV4dC1hbGlnbjogbGVmdDtcbiAgICAgICAgbWFyZ2luLWxlZnQ6IDAuNXJlbTtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogMnJlbTtcblxuICAgICAgICBkaXYuYzIge1xuICAgICAgICAgIHAge1xuICAgICAgICAgICAgQGV4dGVuZCAuYzI7XG5cbiAgICAgICAgICAgIGEge1xuICAgICAgICAgICAgICBjb2xvcjogJGVyZ28tbWFpbjtcbiAgICAgICAgICAgICAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuXG4gICAgLmVycm9yIHtcbiAgICAgIGNvbG9yOiAkZXJnby1lcnJvcjtcbiAgICAgIGZvbnQtc2l6ZTogMTBweDtcbiAgICAgIGZvbnQtd2VpZ2h0OiA0MDA7XG4gICAgICBsaW5lLWhlaWdodDogMTRweDtcbiAgICAgIGxldHRlci1zcGFjaW5nOiAwcHg7XG4gICAgfVxuICB9XG5cbiAgJl9fZm9vdG5vdGUge1xuICAgIHRleHQtYWxpZ246IGxlZnQ7XG4gICAgcGFkZGluZzogMDtcbiAgfVxuXG4gICZfX2VtYWlsIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgZ2FwOiAxLjI1cmVtO1xuXG4gICAgJi1kaXN0dXJiZXIge1xuICAgICAgbWFyZ2luOiAwIGF1dG87XG4gICAgICB3aWR0aDogMTIwcHg7XG4gICAgICBoZWlnaHQ6IDEyMHB4O1xuICAgIH1cbiAgfVxuICAmX19zdWNjZXNzIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgJi1pbWcge1xuICAgICAgbWFyZ2luOiAwIGF1dG87XG4gICAgICB3aWR0aDogNi4yNXJlbTtcbiAgICB9XG4gIH1cbn1cblxuLnZlcmxvc3VuZyB7XG4gIC5jb3Vwb24ge1xuICAgIG1hcmdpbjogMDtcbiAgICBtYXgtd2lkdGg6IHVuc2V0O1xuXG4gICAgJl9fZm9ybSB7XG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgICAgd2lkdGg6IDcwJTtcbiAgICAgICAgbWFyZ2luOiBhdXRvO1xuICAgICAgfVxuICAgIH1cbiAgICAucmVhZC1tb3JlLWxpbmsge1xuICAgICAgbWFyZ2luLXRvcDogMi42NTYzcmVtO1xuICAgIH1cbiAgfVxufVxuIiwiLmZpbGUtcmVxdWVzdC1tdWx0aXBsZSB7XG4gICRzZWxmOiAmO1xuICBwYWRkaW5nOiAzMHB4IDI2cHg7XG5cbiAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgcGFkZGluZzogNTBweCAwIDUwcHg7XG4gICAgZGlzcGxheTogZ3JpZDtcbiAgICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IHJlcGVhdCgxMiwgMWZyKTtcblxuICAgICZfX2ludHJvLFxuICAgICZfX2Zvcm0ge1xuICAgICAgZ3JpZC1jb2x1bW46IDIgLyAxMjtcbiAgICB9XG4gIH1cblxuICAmLmJnLWdyZWVuIHtcbiAgICAjeyRzZWxmfV9fc3RlcENvdW50ZXIge1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogJGVyZ28td2hpdGU7XG4gICAgICBjb2xvcjogJGVyZ28tbWFpbjtcbiAgICB9XG4gIH1cbiAgJi5iZy13aGl0ZSB7XG4gICAgI3skc2VsZn1fX3N0ZXBDb3VudGVyIHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICRlcmdvLWdyZWVuLWRhcmszO1xuICAgICAgY29sb3I6ICRlcmdvLXdoaXRlO1xuICAgIH1cbiAgfVxuXG4gICZfX2ludHJvIHtcbiAgICBtYXJnaW4tYm90dG9tOiAzMHB4O1xuICB9XG5cbiAgJl9fZm9ybSB7XG4gICAgdGV4dC1hbGlnbjogc3RhcnQ7XG4gIH1cblxuICAuZXJyb3Ige1xuICAgIGNvbG9yOiAkZXJnby1lcnJvcjtcbiAgICBmb250LXNpemU6IDEwcHg7XG4gICAgZm9udC13ZWlnaHQ6IDQwMDtcbiAgICBsaW5lLWhlaWdodDogMTRweDtcbiAgICBsZXR0ZXItc3BhY2luZzogMHB4O1xuICB9XG5cbiAgJl9fc3RlcCB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgIGdhcDogMzBweDtcbiAgICBtYXJnaW46IDMwcHggMDtcblxuICAgICYtLXNlY29uZCB7XG4gICAgICBnYXA6IDIwcHg7XG4gICAgfVxuXG4gICAgLS1pY29uLXNpemU6IDRyZW07XG4gICAgLS1pY29uLWdhcDogMzBweDtcblxuICAgICZIZWFkaW5nIHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgZ2FwOiB2YXIoLS1pY29uLWdhcCk7XG5cbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgICBmbGV4LWRpcmVjdGlvbjogcm93O1xuICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgfVxuICAgIH1cblxuICAgICZIZWFkbGluZSB7XG4gICAgICBtYXJnaW4tYm90dG9tOiAwO1xuICAgICAgZm9udC13ZWlnaHQ6IDcwMDtcbiAgICB9XG5cbiAgICAmQ291bnRlciB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgd2lkdGg6IHZhcigtLWljb24tc2l6ZSk7XG4gICAgICBoZWlnaHQ6IHZhcigtLWljb24tc2l6ZSk7XG4gICAgICBhc3BlY3QtcmF0aW86IDEgLyAxO1xuICAgICAgYm9yZGVyLXJhZGl1czogNTAlO1xuICAgICAgZm9udC1zaXplOiAyLjEyNXJlbTtcbiAgICAgIG1hcmdpbjogMCBhdXRvO1xuXG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgICAgbWFyZ2luOiAwO1xuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gICZfX2NvbnRyb2wge1xuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgbWFyZ2luLWxlZnQ6IGNhbGModmFyKC0taWNvbi1zaXplKSArIHZhcigtLWljb24tZ2FwKSk7XG4gICAgfVxuICB9XG5cbiAgJl9fc2VsZWN0QWxsIHtcbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgIG1hcmdpbjogMDtcbiAgICB9XG4gIH1cblxuICAmX19jaGVjayB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWRpcmVjdGlvbjogcm93O1xuICAgIGp1c3RpZnktY29udGVudDogZmxleC1zdGFydDtcbiAgICBhbGlnbi1pdGVtczogYmFzZWxpbmU7XG4gICAgZ2FwOiAxMHB4O1xuXG4gICAgaW5wdXQge1xuICAgICAgaGVpZ2h0OiAyNHB4O1xuICAgICAgd2lkdGg6IDI0cHg7XG4gICAgICB2aXNpYmlsaXR5OiB2aXNpYmxlO1xuICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgICAgei1pbmRleDogMTtcbiAgICAgIG9wYWNpdHk6IDA7XG4gICAgfVxuXG4gICAgbGFiZWwge1xuICAgICAgdGV4dC1hbGlnbjogc3RhcnQ7XG4gICAgICBtYXJnaW4tYm90dG9tOiAwO1xuXG4gICAgICBwIHtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogMDtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAmX19pbnB1dCB7XG4gICAgaW5wdXQge1xuICAgICAgd2lkdGg6IDEwMCU7XG4gICAgfVxuICB9XG59XG4iLCIucmVzdWx0LWRpYWdyYW0ge1xuICAuYnRuIHtcbiAgICBtYXgtd2lkdGg6IG5vbmU7XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgICB3aWR0aDogZml0LWNvbnRlbnQ7XG4gICAgfVxuICB9XG4gIC5yZXN1bHQtc3RhZ2VfX3RleHQubGVhZCB7XG4gICAgbWFyZ2luLWJvdHRvbTogMDtcbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkbGcpIHtcbiAgICAgIG1hcmdpbi1ib3R0b206IDJyZW07XG4gICAgfVxuICAgIHAge1xuICAgICAgbWFyZ2luLWJvdHRvbTogMDtcbiAgICB9XG4gIH1cbiAgLnJlc3VsdC1zdGFnZV9faGVhZGxpbmUge1xuICAgIG1hcmdpbi1ib3R0b206IDFyZW07XG4gICAgaDIsXG4gICAgaDMge1xuICAgICAgbWFyZ2luLWJvdHRvbTogMDtcbiAgICB9XG4gIH1cbn1cbi5kb251dCB7XG4gICYtY2hhcnQge1xuICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBtYXgtd2lkdGg6IDQ1MHB4O1xuICAgIGhlaWdodDogYXV0bztcbiAgICBhc3BlY3QtcmF0aW86IDE7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgIG1hcmdpbjogMCBhdXRvO1xuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRzbSkge1xuICAgICAgd2lkdGg6IDcwJTtcbiAgICB9XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgICB3aWR0aDogMTAwJTtcbiAgICB9XG4gICAgJi1jb250YWluZXIge1xuICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICBwYWRkaW5nOiA2NXB4O1xuICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICAgIHBhZGRpbmc6IDQ1cHg7XG4gICAgICB9XG4gICAgfVxuICB9XG4gICYtZGVmYXVsdCB7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIGhlaWdodDogMTAwJTtcbiAgICBib3JkZXItcmFkaXVzOiA1MCU7XG4gICAgYmFja2dyb3VuZDogI2E5ZGFlMDtcbiAgfVxuICAmLXdoaXRlIHtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgd2lkdGg6IDM1JTtcbiAgICBoZWlnaHQ6IDM1JTtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgYm9yZGVyLXJhZGl1czogNTAlO1xuICAgIGJhY2tncm91bmQ6ICNlMmY2ZmE7XG4gICAgdG9wOiA1MCU7XG4gICAgbGVmdDogNTAlO1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlKC01MCUsIC01MCUpO1xuICAgIHotaW5kZXg6IDE7XG4gICAgYm9yZGVyOiA0cHggc29saWQgJGVyZ28td2hpdGU7XG4gICAgc3ZnIHtcbiAgICAgIGhlaWdodDogNDlweDtcbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRzbSkge1xuICAgICAgICBoZWlnaHQ6IDcwcHg7XG4gICAgICB9XG4gICAgfVxuICB9XG4gICYtbGluZSB7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIGhlaWdodDogMTAwJTtcbiAgICAmOjpiZWZvcmUsXG4gICAgJjo6YWZ0ZXIge1xuICAgICAgY29udGVudDogJyc7XG4gICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICBiYWNrZ3JvdW5kOiAkZXJnby13aGl0ZTtcbiAgICAgIHotaW5kZXg6IDE7XG4gICAgfVxuICAgICY6OmJlZm9yZSB7XG4gICAgICB3aWR0aDogNHB4O1xuICAgICAgaGVpZ2h0OiAxMDAlO1xuICAgICAgdG9wOiAwO1xuICAgICAgbGVmdDogNTAlO1xuICAgICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKC01MCUpO1xuICAgIH1cbiAgICAmOjphZnRlciB7XG4gICAgICB3aWR0aDogMTAwJTtcbiAgICAgIGhlaWdodDogNHB4O1xuICAgICAgdG9wOiA1MCU7XG4gICAgICBsZWZ0OiAwO1xuICAgICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKC01MCUpO1xuICAgIH1cbiAgfVxuICAmLXNlZ21lbnQge1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBoZWlnaHQ6IDEwMCU7XG4gICAgYm9yZGVyLXJhZGl1czogNTAlO1xuICB9XG4gICYtY2FzZSB7XG4gICAgd2lkdGg6IDEwMCU7XG4gICAgaGVpZ2h0OiAxMDAlO1xuICAgIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgdG9wOiAwO1xuICAgIGxlZnQ6IDA7XG4gICAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgfVxuICAmLWljb24ge1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICB3aWR0aDogM3JlbTtcbiAgICBoZWlnaHQ6IDNyZW07XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgIHotaW5kZXg6IDU7XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICB3aWR0aDogNHJlbTtcbiAgICAgIGhlaWdodDogNHJlbTtcbiAgICB9XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgICB3aWR0aDogNXJlbTtcbiAgICAgIGhlaWdodDogNXJlbTtcbiAgICB9XG4gIH1cbiAgJi10ZXh0IHtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgZm9udC1zaXplOiAwLjlyZW07XG4gICAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gICAgY29sb3I6ICRlcmdvLXdhcm1ncmV5LWRhcmsyO1xuICAgIHdoaXRlLXNwYWNlOiBwcmUtd3JhcDtcbiAgICB3b3JkLXdyYXA6IGJyZWFrLXdvcmQ7XG4gICAgbWF4LXdpZHRoOiA0OSU7XG4gICAgLXdlYmtpdC1oeXBoZW5zOiBhdXRvO1xuICAgIGh5cGhlbnM6IGF1dG87XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICBmb250LXNpemU6IDEuMXJlbTtcbiAgICAgIG1heC13aWR0aDogMjAwcHg7XG4gICAgICAtd2Via2l0LWh5cGhlbnM6IHVuc2V0O1xuICAgICAgaHlwaGVuczogdW5zZXQ7XG4gICAgfVxuICAgICYtY29udGFpbmVyIHtcbiAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgbWF4LXdpZHRoOiA2NTBweDtcbiAgICAgIGhlaWdodDogMTAwJTtcbiAgICAgIHRvcDogNTAlO1xuICAgICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKC01MCUpO1xuICAgICAgOm50aC1jaGlsZCgxKSB7XG4gICAgICAgIHRleHQtYWxpZ246IHJpZ2h0O1xuICAgICAgICByaWdodDogMDtcbiAgICAgICAgdG9wOiA1JTtcbiAgICAgIH1cbiAgICAgIDpudGgtY2hpbGQoMikge1xuICAgICAgICB0ZXh0LWFsaWduOiByaWdodDtcbiAgICAgICAgcmlnaHQ6IDA7XG4gICAgICAgIGJvdHRvbTogNSU7XG4gICAgICB9XG4gICAgICA6bnRoLWNoaWxkKDMpIHtcbiAgICAgICAgdGV4dC1hbGlnbjogbGVmdDtcbiAgICAgICAgbGVmdDogMDtcbiAgICAgICAgYm90dG9tOiA1JTtcbiAgICAgIH1cbiAgICAgIDpudGgtY2hpbGQoNCkge1xuICAgICAgICB0ZXh0LWFsaWduOiBsZWZ0O1xuICAgICAgICBsZWZ0OiAwO1xuICAgICAgICB0b3A6IDUlO1xuICAgICAgICBtYXgtd2lkdGg6IDEzNXB4O1xuICAgICAgfVxuICAgIH1cbiAgfVxufVxuXG4uc2VnbWVudC0xIHtcbiAgLyogVG9wIFJpZ2h0ICovXG4gIGNsaXAtcGF0aDogcG9seWdvbig1MCUgNTAlLCAxMDAlIDUwJSwgMTAwJSAwLCA1MCUgMCk7XG4gIC5kb251dC1pY29uIHtcbiAgICB0b3A6IDI1JTtcbiAgICBsZWZ0OiA3NSU7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGUoLTUwJSwgLTUwJSk7XG4gIH1cbn1cbi5zZWdtZW50LTIge1xuICAvKiBCb3R0b20gUmlnaHQgKi9cbiAgY2xpcC1wYXRoOiBwb2x5Z29uKDUwJSA1MCUsIDEwMCUgNTAlLCAxMDAlIDEwMCUsIDUwJSAxMDAlKTtcbiAgLmRvbnV0LWljb24ge1xuICAgIGJvdHRvbTogMjUlO1xuICAgIGxlZnQ6IDc1JTtcbiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSgtNTAlLCA1MCUpO1xuICB9XG59XG4uc2VnbWVudC0zIHtcbiAgLyogQm90dG9tIExlZnQgKi9cbiAgY2xpcC1wYXRoOiBwb2x5Z29uKDUwJSA1MCUsIDAlIDUwJSwgMCUgMTAwJSwgNTAlIDEwMCUpO1xuICAuZG9udXQtaWNvbiB7XG4gICAgYm90dG9tOiAyNSU7XG4gICAgbGVmdDogMjUlO1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlKC01MCUsIDUwJSk7XG4gIH1cbn1cbi5zZWdtZW50LTQge1xuICAvKiBUb3AgTGVmdCAqL1xuICBjbGlwLXBhdGg6IHBvbHlnb24oNTAlIDUwJSwgMCUgNTAlLCAwJSAwJSwgNTAlIDAlKTtcbiAgLmRvbnV0LWljb24ge1xuICAgIHRvcDogMjUlO1xuICAgIGxlZnQ6IDI1JTtcbiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSgtNTAlLCAtNTAlKTtcbiAgfVxufVxuXG4uaGlnaGxpZ2h0ZWQtc2VnbWVudCB7XG4gIGJhY2tncm91bmQtY29sb3I6ICNiMzE3Njc7XG59XG4uaGlnaGxpZ2h0ZWQtc2VnbWVudCArIC5kb251dC1pY29uIHtcbiAgZmlsdGVyOiBpbnZlcnQoMSk7XG59XG5cbi5oaWdobGlnaHRlZC10ZXh0IHtcbiAgY29sb3I6IGJsYWNrO1xuICBmb250LXdlaWdodDogYm9sZDtcbn1cbiIsIi5jb250ZW50LWljb24tdGV4dC1saXN0IHtcbiAgcGFkZGluZzogMS44NzVyZW0gMS42MjVyZW0gMC4yNXJlbTtcblxuICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkc20pIHtcbiAgICBwYWRkaW5nOiAxLjg3NXJlbSAxLjg3NXJlbSAwLjI1cmVtO1xuICB9XG5cbiAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJG1kKSB7XG4gICAgcGFkZGluZzogMS44NzVyZW0gMy43NXJlbSAwLjI1cmVtO1xuICB9XG5cbiAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJGxnKSB7XG4gICAgcGFkZGluZzogMS44NzVyZW0gMi41cmVtIDAuMjVyZW07XG4gIH1cblxuICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICBwYWRkaW5nOiA1cmVtIDMuNzVyZW0gMi41cmVtO1xuICB9XG4gICZfX2NvbnRlbnQtdGV4dCB7XG4gICAgbWFyZ2luLWJvdHRvbTogMTBweDtcbiAgfVxuICB1bCB7XG4gICAgbGlzdC1zdHlsZTogbm9uZTtcbiAgICBwYWRkaW5nOiAwO1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gICAgZ2FwOiAyMHB4O1xuICAgIG1hcmdpbi1ib3R0b206IDIwcHg7XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgICBnYXA6IDMwcHg7XG4gICAgfVxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICR4bCkge1xuICAgICAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgICB9XG4gIH1cblxuICBsaSB7XG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICR4bCkge1xuICAgICAgd2lkdGg6IGNhbGMoMTAwJSAvIDMpO1xuICAgIH1cbiAgfVxuXG4gICZfX2l0ZW0ge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgYmFja2dyb3VuZDogJGVyZ28td2hpdGU7XG4gICAgYm9yZGVyLXJhZGl1czogMTJweDtcbiAgICBvdmVyZmxvdzogaGlkZGVuO1xuICAgIGJveC1zaGFkb3c6IDAgMnB4IDZweCByZ2JhKDAsIDAsIDAsIDAuMDUpO1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIGhlaWdodDogMTAwJTtcbiAgfVxuICAmX19pY29uIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgcGFkZGluZzogOHB4O1xuICAgIGZsZXgtc2hyaW5rOiAwO1xuICAgIHdpZHRoOiA2NXB4O1xuXG4gICAgaW1nIHtcbiAgICAgIG1heC13aWR0aDogMTAwJTtcbiAgICAgIGhlaWdodDogYXV0bztcbiAgICB9XG4gIH1cblxuICAmX19jb250ZW50IHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgcGFkZGluZzogMTBweDtcbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkc20pIHtcbiAgICAgIHBhZGRpbmc6IDE1cHg7XG4gICAgfVxuICB9XG4gICZfX3RleHQge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgd29yZC1icmVhazogYnJlYWstd29yZDtcblxuICAgIDpsYXN0LWNoaWxkIHtcbiAgICAgIG1hcmdpbi1ib3R0b206IDA7XG4gICAgfVxuICB9XG4gICZfX2hlYWRsaW5lICoge1xuICAgIGZvbnQtc2l6ZTogMjRweDtcbiAgICBtYXJnaW4tYm90dG9tOiAwO1xuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICR4bCkge1xuICAgICAgZm9udC1zaXplOiAzMnB4O1xuICAgIH1cbiAgfVxuICAmX19kaXNjbGFpbWVyIHtcbiAgICAuYzMgcCB7XG4gICAgICBAZXh0ZW5kIC5jMztcbiAgICB9XG4gIH1cbn1cbiIsIi5jb250ZW50LWJhY2tncm91bmQtY29udGFpbmVyIHtcbiAgcGFkZGluZy1ib3R0b206IDEuODc1cmVtO1xuICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICBwYWRkaW5nLWJvdHRvbTogNXJlbTtcbiAgfVxuICAuc3RhZ2VfX2NvbnRlbnQge1xuICAgIG1hcmdpbi1sZWZ0OiAwO1xuICAgIG1hcmdpbi1yaWdodDogMDtcbiAgICBwYWRkaW5nLWxlZnQ6IDA7XG4gICAgcGFkZGluZy1yaWdodDogMDtcbiAgfVxuICAucm93LXJlc2V0ID4gKiB7XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1heC13aWR0aDogJGxnKSB7XG4gICAgICBwYWRkaW5nLXJpZ2h0OiAwO1xuICAgICAgcGFkZGluZy1sZWZ0OiAwO1xuICAgIH1cbiAgfVxufVxuIiwiLmNvbnRlbnQtaW1hZ2UtdGV4dCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIHBhZGRpbmc6IDAgMS42MjVyZW07XG5cbiAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHNtKSB7XG4gICAgcGFkZGluZzogMCAxLjg3NXJlbTtcbiAgfVxuXG4gIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRtZCkge1xuICAgIHBhZGRpbmc6IDAgMy43NXJlbTtcbiAgfVxuXG4gIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgIHBhZGRpbmc6IDAgMi41cmVtO1xuICB9XG5cbiAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHhsKSB7XG4gICAgcGFkZGluZzogMCAzLjc1cmVtO1xuICB9XG4gICZfX2NvbnRlbnQge1xuICAgIHBhZGRpbmc6IDIwcHg7XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHhsKSB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgICAgIGdhcDogNDBweDtcbiAgICAgIHBhZGRpbmc6IDAgNDBweDtcbiAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gICAgfVxuICB9XG4gICZfX2ltYWdlIHtcbiAgICBtYXgtd2lkdGg6IDUwJTtcbiAgICBtYXJnaW4tYm90dG9tOiAyMHB4O1xuICAgIG1hcmdpbjogMCBhdXRvO1xuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICR4bCkge1xuICAgICAgbWF4LXdpZHRoOiAyNjZweDtcbiAgICAgIG1hcmdpbi1ib3R0b206IDA7XG4gICAgfVxuICB9XG4gICZfX3RleHQge1xuICAgIG1hcmdpbi1ib3R0b206IDIwcHg7XG5cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkeGwpIHtcbiAgICAgIG1heC13aWR0aDogNTQ1cHg7XG4gICAgICBtYXJnaW4tYm90dG9tOiAwO1xuICAgICAgcGFkZGluZzogNDBweCAwO1xuICAgIH1cbiAgfVxuICAmX19jb250ZW50LWJveCB7XG4gICAgQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogJHhsKSB7XG4gICAgICB3aWR0aDogMTAwJTtcbiAgICB9XG4gIH1cbiAgLmJ0biB7XG4gICAgbWF4LXdpZHRoOiAxMDAlO1xuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRsZykge1xuICAgICAgbWF4LXdpZHRoOiBtYXgtY29udGVudDtcbiAgICB9XG4gIH1cbn1cbiIsIi50d29fc3RlcHNfbW9kdWxlIHtcbiAgcGFkZGluZzogMS44NzVyZW0gMS42MjVyZW07XG4gIG1heC13aWR0aDogNzMwcHg7XG4gIG1hcmdpbjogNTBweCBhdXRvO1xuXG4gICZfX2ltYWdlIHtcbiAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgbWF4LXdpZHRoOiA1NDBweDtcbiAgICBtYXJnaW46IDAgYXV0bztcblxuICAgIC5kaXN0dXJiZXIge1xuICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgcmlnaHQ6IDMwcHg7XG4gICAgICB0b3A6IDA7XG4gICAgICB6LWluZGV4OiAxO1xuICAgIH1cbiAgfVxuICAmX19zdGVwIHtcbiAgICBib3JkZXItcmFkaXVzOiA1MCU7XG4gICAgd2lkdGg6IDgwcHg7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgIG1hcmdpbi1ib3R0b206IDMwcHg7XG5cbiAgICBzcGFuIHtcbiAgICAgIGZvbnQtc2l6ZTogNTBweDtcbiAgICAgIGNvbG9yOiAkZXJnby13aGl0ZTtcbiAgICAgIG1hcmdpbjogMCBhdXRvO1xuICAgIH1cbiAgfVxuICAmX19jb250ZW50IHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcblxuICAgICYuZmlyc3Rfc3RlcCB7XG4gICAgICBtYXJnaW4tYm90dG9tOiAxMDBweDtcbiAgICB9XG4gICAgLmNvdXBvbiB7XG4gICAgICBwYWRkaW5nOiAwO1xuICAgIH1cbiAgfVxuICAuZGlzYWJsZWQge1xuICAgIG9wYWNpdHk6IDAuMztcbiAgICBjdXJzb3I6IG5vdC1hbGxvd2VkO1xuICAgIHBvaW50ZXItZXZlbnRzOiBub25lO1xuICB9XG59XG4iLCIuaW50ZXJhY3Rpb24tdGlsZSB7XG4gICYtcXVlc3Qge1xuICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICAmX19iZyB7XG4gICAgICBoZWlnaHQ6IGNhbGMoMTAwc3ZoIC0gNjVweCk7XG4gICAgICB3aWR0aDogMTAwJTtcbiAgICAgIGltZyB7XG4gICAgICAgIG9iamVjdC1maXQ6IGNvdmVyO1xuICAgICAgICBvYmplY3QtcG9zaXRpb246IGNlbnRlcjtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAmX19jb250ZW50IHtcbiAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgIHRvcDogNTAlO1xuICAgICAgdHJhbnNsYXRlOiAwIC01MCU7XG4gICAgICBsZWZ0OiAwO1xuICAgICAgcmlnaHQ6IDA7XG4gICAgICBtYXJnaW46IDAgMS42MjVyZW07XG4gICAgICBwYWRkaW5nOiAxcmVtO1xuICAgICAgYmFja2dyb3VuZDogcmFkaWFsLWdyYWRpZW50KFxuICAgICAgICAgIDc3Ljk1JSA3Ny45NSUgYXQgNDkuODUlIDMuMTIlLFxuICAgICAgICAgIHJnYmEoMjU1LCAyNTUsIDI1NSwgMC42KSAwJSxcbiAgICAgICAgICByZ2JhKDI1NSwgMjU1LCAyNTUsIDApIDEwMCVcbiAgICAgICAgKSxcbiAgICAgICAgcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjIpO1xuICAgICAgLXdlYmtpdC1iYWNrZHJvcC1maWx0ZXI6IGJsdXIoMTJweCk7XG4gICAgICBiYWNrZHJvcC1maWx0ZXI6IGJsdXIoMTJweCk7XG4gICAgICBib3JkZXItcmFkaXVzOiA4cHg7XG4gICAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiAkc20pIHtcbiAgICAgICAgd2lkdGg6IDQ2MHB4O1xuICAgICAgICBtYXJnaW46IDAgYXV0bztcbiAgICAgIH1cblxuICAgICAgJi1pbnRybyxcbiAgICAgICYtcXVlc3Rpb24ge1xuICAgICAgICBtYXgtd2lkdGg6IDgwMHB4O1xuICAgICAgICBtYXJnaW46IDAgYXV0bztcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAmLWN0YSB7XG4gICAgJi5pbmFjdGl2ZSB7XG4gICAgICBjdXJzb3I6IG5vdC1hbGxvd2VkO1xuICAgIH1cbiAgfVxuXG4gIC50aWxlcyB7XG4gICAgZGlzcGxheTogZ3JpZDtcbiAgICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IHJlcGVhdCgyLCA4LjM3NXJlbSk7XG4gICAgZ2FwOiAxNnB4O1xuICAgIG1hcmdpbjogMS41cmVtIDA7XG4gICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgJi0tZXhwYW5kZWQge1xuICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgICBhbGlnbi1pdGVtczogc3RyZXRjaDtcbiAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6ICRzbSkge1xuICAgICAgICBtYXgtd2lkdGg6IDMwMHB4O1xuICAgICAgICBtYXJnaW46IDEuNXJlbSBhdXRvO1xuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gIC50aWxlIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICBtaW4taGVpZ2h0OiAxMzRweDtcbiAgICBwYWRkaW5nOiAxcmVtO1xuICAgIGJhY2tncm91bmQ6ICRlcmdvLXdoaXRlO1xuICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgICB0cmFuc2l0aW9uOiBhbGwgMC4ycyBlYXNlO1xuICAgIGJvcmRlci1yYWRpdXM6IDhweDtcbiAgICBmb250LXdlaWdodDogNzAwO1xuICAgIGxpbmUtaGVpZ2h0OiAxLjM7XG4gICAgYm94LXNoYWRvdzogMHB4IDJweCA4cHggMHB4IHJnYmEoMCwgMCwgMCwgMC4xNSk7XG4gICAgJi52aXNpdGVkIHtcbiAgICAgIGJvcmRlci1jb2xvcjogJGVyZ28td2FybWdyZXktbGlnaHQ7XG4gICAgICBvcGFjaXR5OiAwLjU7XG4gICAgfVxuICAgIGltZyB7XG4gICAgICBtYXgtd2lkdGg6IDY0cHg7XG4gICAgfVxuICB9XG5cbiAgLnRpbGUtZXhwYW5kZWQge1xuICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICBwYWRkaW5nOiAxLjVyZW07XG4gICAgYmFja2dyb3VuZDogJGVyZ28td2hpdGU7XG4gICAgYm9yZGVyLXJhZGl1czogOHB4O1xuXG4gICAgLmNsb3NlIHtcbiAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgIHRvcDogMTJweDtcbiAgICAgIHJpZ2h0OiAxMnB4O1xuICAgICAgYmFja2dyb3VuZDogbm9uZTtcbiAgICAgIGJvcmRlcjogbm9uZTtcbiAgICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgICAgIHdpZHRoOiAyNHB4O1xuICAgICAgaGVpZ2h0OiAyNHB4O1xuICAgICAgcGFkZGluZzogMDtcbiAgICAgIHN2ZyB7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICBoZWlnaHQ6IDEwMCU7XG4gICAgICB9XG4gICAgfVxuICAgIC50aWxlLWJhY2sge1xuICAgICAgJi1pY29uIHtcbiAgICAgICAgd2lkdGg6IDU2cHg7XG4gICAgICAgIGhlaWdodDogNTZweDtcbiAgICAgICAgbWFyZ2luOiAwIGF1dG87XG4gICAgICB9XG4gICAgICAmLXRpdGxlIHtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogMS4yNXJlbTtcbiAgICAgICAgJi5ncmVlbiB7XG4gICAgICAgICAgY29sb3I6ICRlcmdvLWdyZWVuLWRhcmszO1xuICAgICAgICB9XG4gICAgICAgICYucmVkIHtcbiAgICAgICAgICBjb2xvcjogJGVyZ28tYWNjZW50MjtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cbiAgfVxufVxuIl19 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
